var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "CIUDAD DE MÉXICO": {
    "ÁLVARO OBREGÓN": {
      "01000": true,
      "01010": true,
      "01020": true,
      "01028": true,
      "01029": true,
      "01030": true,
      "01040": true,
      "01048": true,
      "01049": true,
      "01050": true,
      "01060": true,
      "01070": true,
      "01080": true,
      "01089": true,
      "01090": true,
      "01100": true,
      "01109": true,
      "01110": true,
      "01115": true,
      "01116": true,
      "01120": true,
      "01125": true,
      "01130": true,
      "01139": true,
      "01140": true,
      "01150": true,
      "01159": true,
      "01160": true,
      "01170": true,
      "01180": true,
      "01183": true,
      "01184": true,
      "01200": true,
      "01209": true,
      "01210": true,
      "01219": true,
      "01220": true,
      "01230": true,
      "01235": true,
      "01239": true,
      "01240": true,
      "01250": true,
      "01259": true,
      "01260": true,
      "01268": true,
      "01269": true,
      "01270": true,
      "01275": true,
      "01276": true,
      "01278": true,
      "01279": true,
      "01280": true,
      "01285": true,
      "01289": true,
      "01290": true,
      "01296": true,
      "01297": true,
      "01298": true,
      "01299": true,
      "01300": true,
      "01310": true,
      "01320": true,
      "01329": true,
      "01330": true,
      "01339": true,
      "01340": true,
      "01376": true,
      "01377": true,
      "01378": true,
      "01379": true,
      "01388": true,
      "01389": true,
      "01390": true,
      "01400": true,
      "01407": true,
      "01408": true,
      "01409": true,
      "01410": true,
      "01419": true,
      "01420": true,
      "01430": true,
      "01440": true,
      "01450": true,
      "01460": true,
      "01470": true,
      "01480": true,
      "01490": true,
      "01500": true,
      "01504": true,
      "01505": true,
      "01506": true,
      "01507": true,
      "01508": true,
      "01509": true,
      "01510": true,
      "01520": true,
      "01529": true,
      "01530": true,
      "01537": true,
      "01538": true,
      "01539": true,
      "01540": true,
      "01548": true,
      "01549": true,
      "01550": true,
      "01559": true,
      "01560": true,
      "01566": true,
      "01567": true,
      "01568": true,
      "01569": true,
      "01580": true,
      "01585": true,
      "01586": true,
      "01587": true,
      "01588": true,
      "01589": true,
      "01590": true,
      "01600": true,
      "01610": true,
      "01618": true,
      "01619": true,
      "01620": true,
      "01630": true,
      "01640": true,
      "01645": true,
      "01650": true,
      "01700": true,
      "01706": true,
      "01707": true,
      "01708": true,
      "01709": true,
      "01710": true,
      "01720": true,
      "01729": true,
      "01730": true,
      "01739": true,
      "01740": true,
      "01750": true,
      "01759": true,
      "01760": true,
      "01769": true,
      "01770": true,
      "01779": true,
      "01780": true,
      "01787": true,
      "01788": true,
      "01789": true,
      "01790": true,
      "01799": true,
      "01800": true,
      "01807": true,
      "01809": true,
      "01810": true,
      "01820": true,
      "01830": true,
      "01840": true,
      "01848": true,
      "01849": true,
      "01850": true,
      "01856": true,
      "01857": true,
      "01858": true,
      "01859": true,
      "01860": true,
      "01863": true,
      "01870": true,
      "01880": true,
      "01900": true,
      "01904": true
    },
    "AZCAPOTZALCO": {
      "02000": true,
      "02008": true,
      "02009": true,
      "02010": true,
      "02020": true,
      "02040": true,
      "02050": true,
      "02060": true,
      "02070": true,
      "02080": true,
      "02090": true,
      "02099": true,
      "02100": true,
      "02102": true,
      "02109": true,
      "02110": true,
      "02120": true,
      "02125": true,
      "02127": true,
      "02128": true,
      "02129": true,
      "02130": true,
      "02140": true,
      "02150": true,
      "02160": true,
      "02169": true,
      "02200": true,
      "02230": true,
      "02240": true,
      "02250": true,
      "02260": true,
      "02300": true,
      "02310": true,
      "02320": true,
      "02330": true,
      "02340": true,
      "02350": true,
      "02360": true,
      "02400": true,
      "02409": true,
      "02410": true,
      "02419": true,
      "02420": true,
      "02430": true,
      "02440": true,
      "02450": true,
      "02459": true,
      "02460": true,
      "02470": true,
      "02479": true,
      "02480": true,
      "02490": true,
      "02500": true,
      "02510": true,
      "02519": true,
      "02520": true,
      "02521": true,
      "02523": true,
      "02525": true,
      "02526": true,
      "02528": true,
      "02529": true,
      "02530": true,
      "02540": true,
      "02600": true,
      "02630": true,
      "02640": true,
      "02650": true,
      "02660": true,
      "02670": true,
      "02680": true,
      "02700": true,
      "02710": true,
      "02718": true,
      "02719": true,
      "02720": true,
      "02729": true,
      "02730": true,
      "02739": true,
      "02750": true,
      "02760": true,
      "02770": true,
      "02780": true,
      "02790": true,
      "02800": true,
      "02810": true,
      "02820": true,
      "02830": true,
      "02840": true,
      "02850": true,
      "02860": true,
      "02870": true,
      "02900": true,
      "02910": true,
      "02920": true,
      "02930": true,
      "02940": true,
      "02950": true,
      "02960": true,
      "02970": true,
      "02980": true,
      "02990": true
    },
    "BENITO JUÁREZ": {
      "03000": true,
      "03010": true,
      "03020": true,
      "03023": true,
      "03027": true,
      "03028": true,
      "03100": true,
      "03103": true,
      "03104": true,
      "03105": true,
      "03109": true,
      "03199": true,
      "03200": true,
      "03210": true,
      "03219": true,
      "03220": true,
      "03229": true,
      "03230": true,
      "03240": true,
      "03300": true,
      "03303": true,
      "03310": true,
      "03313": true,
      "03319": true,
      "03320": true,
      "03330": true,
      "03339": true,
      "03340": true,
      "03400": true,
      "03410": true,
      "03420": true,
      "03430": true,
      "03440": true,
      "03500": true,
      "03501": true,
      "03510": true,
      "03520": true,
      "03530": true,
      "03540": true,
      "03550": true,
      "03560": true,
      "03570": true,
      "03580": true,
      "03590": true,
      "03600": true,
      "03610": true,
      "03620": true,
      "03630": true,
      "03640": true,
      "03650": true,
      "03660": true,
      "03700": true,
      "03710": true,
      "03720": true,
      "03730": true,
      "03740": true,
      "03800": true,
      "03809": true,
      "03810": true,
      "03811": true,
      "03812": true,
      "03818": true,
      "03819": true,
      "03820": true,
      "03830": true,
      "03840": true,
      "03849": true,
      "03900": true,
      "03910": true,
      "03920": true,
      "03930": true,
      "03940": true
    },
    "COYOACÁN": {
      "04000": true,
      "04009": true,
      "04010": true,
      "04020": true,
      "04030": true,
      "04040": true,
      "04100": true,
      "04109": true,
      "04110": true,
      "04120": true,
      "04129": true,
      "04200": true,
      "04210": true,
      "04220": true,
      "04230": true,
      "04239": true,
      "04240": true,
      "04250": true,
      "04259": true,
      "04260": true,
      "04269": true,
      "04270": true,
      "04280": true,
      "04300": true,
      "04307": true,
      "04309": true,
      "04310": true,
      "04317": true,
      "04318": true,
      "04319": true,
      "04320": true,
      "04326": true,
      "04327": true,
      "04330": true,
      "04336": true,
      "04337": true,
      "04338": true,
      "04340": true,
      "04350": true,
      "04359": true,
      "04360": true,
      "04368": true,
      "04369": true,
      "04370": true,
      "04380": true,
      "04389": true,
      "04390": true,
      "04400": true,
      "04410": true,
      "04420": true,
      "04430": true,
      "04440": true,
      "04450": true,
      "04460": true,
      "04470": true,
      "04480": true,
      "04484": true,
      "04489": true,
      "04490": true,
      "04500": true,
      "04510": true,
      "04513": true,
      "04515": true,
      "04519": true,
      "04530": true,
      "04535": true,
      "04539": true,
      "04600": true,
      "04610": true,
      "04620": true,
      "04630": true,
      "04640": true,
      "04650": true,
      "04660": true,
      "04700": true,
      "04710": true,
      "04718": true,
      "04719": true,
      "04720": true,
      "04729": true,
      "04730": true,
      "04737": true,
      "04738": true,
      "04739": true,
      "04800": true,
      "04809": true,
      "04810": true,
      "04815": true,
      "04830": true,
      "04840": true,
      "04843": true,
      "04849": true,
      "04850": true,
      "04851": true,
      "04859": true,
      "04870": true,
      "04890": true,
      "04899": true,
      "04900": true,
      "04908": true,
      "04909": true,
      "04910": true,
      "04918": true,
      "04919": true,
      "04920": true,
      "04921": true,
      "04929": true,
      "04930": true,
      "04938": true,
      "04939": true,
      "04940": true,
      "04950": true,
      "04960": true,
      "04970": true,
      "04980": true
    },
    "CUAJIMALPA DE MORELOS": {
      "05000": true,
      "05008": true,
      "05009": true,
      "05010": true,
      "05020": true,
      "05030": true,
      "05039": true,
      "05040": true,
      "05050": true,
      "05060": true,
      "05080": true,
      "05086": true,
      "05088": true,
      "05089": true,
      "05100": true,
      "05109": true,
      "05110": true,
      "05118": true,
      "05119": true,
      "05120": true,
      "05122": true,
      "05126": true,
      "05127": true,
      "05128": true,
      "05129": true,
      "05130": true,
      "05180": true,
      "05200": true,
      "05210": true,
      "05214": true,
      "05219": true,
      "05220": true,
      "05230": true,
      "05238": true,
      "05240": true,
      "05248": true,
      "05249": true,
      "05260": true,
      "05268": true,
      "05269": true,
      "05270": true,
      "05280": true,
      "05300": true,
      "05310": true,
      "05320": true,
      "05330": true,
      "05340": true,
      "05348": true,
      "05349": true,
      "05360": true,
      "05370": true,
      "05379": true,
      "05400": true,
      "05410": true,
      "05480": true,
      "05500": true,
      "05509": true,
      "05510": true,
      "05520": true,
      "05530": true,
      "05600": true,
      "05610": true,
      "05619": true,
      "05620": true,
      "05630": true,
      "05639": true,
      "05700": true,
      "05710": true,
      "05719": true,
      "05720": true,
      "05730": true,
      "05740": true,
      "05750": true
    },
    "CUAUHTÉMOC": {
      "06000": true,
      "06006": true,
      "06007": true,
      "06008": true,
      "06009": true,
      "06010": true,
      "06012": true,
      "06018": true,
      "06020": true,
      "06030": true,
      "06035": true,
      "06037": true,
      "06038": true,
      "06039": true,
      "06040": true,
      "06049": true,
      "06050": true,
      "06057": true,
      "06058": true,
      "06059": true,
      "06060": true,
      "06062": true,
      "06065": true,
      "06066": true,
      "06067": true,
      "06068": true,
      "06070": true,
      "06079": true,
      "06080": true,
      "06082": true,
      "06090": true,
      "06100": true,
      "06140": true,
      "06170": true,
      "06171": true,
      "06179": true,
      "06199": true,
      "06200": true,
      "06220": true,
      "06240": true,
      "06250": true,
      "06270": true,
      "06280": true,
      "06300": true,
      "06309": true,
      "06350": true,
      "06357": true,
      "06358": true,
      "06359": true,
      "06400": true,
      "06430": true,
      "06450": true,
      "06470": true,
      "06479": true,
      "06500": true,
      "06570": true,
      "06589": true,
      "06597": true,
      "06598": true,
      "06599": true,
      "06600": true,
      "06606": true,
      "06609": true,
      "06691": true,
      "06692": true,
      "06693": true,
      "06694": true,
      "06695": true,
      "06696": true,
      "06698": true,
      "06699": true,
      "06700": true,
      "06701": true,
      "06702": true,
      "06703": true,
      "06704": true,
      "06707": true,
      "06708": true,
      "06720": true,
      "06723": true,
      "06724": true,
      "06725": true,
      "06726": true,
      "06727": true,
      "06728": true,
      "06729": true,
      "06740": true,
      "06760": true,
      "06770": true,
      "06780": true,
      "06796": true,
      "06797": true,
      "06798": true,
      "06800": true,
      "06802": true,
      "06820": true,
      "06840": true,
      "06850": true,
      "06860": true,
      "06870": true,
      "06880": true,
      "06890": true,
      "06900": true,
      "06920": true
    },
    "GUSTAVO A. MADERO": {
      "07000": true,
      "07001": true,
      "07010": true,
      "07020": true,
      "07040": true,
      "07049": true,
      "07050": true,
      "07058": true,
      "07059": true,
      "07060": true,
      "07069": true,
      "07070": true,
      "07080": true,
      "07089": true,
      "07090": true,
      "07100": true,
      "07109": true,
      "07110": true,
      "07119": true,
      "07130": true,
      "07135": true,
      "07140": true,
      "07144": true,
      "07145": true,
      "07146": true,
      "07148": true,
      "07149": true,
      "07150": true,
      "07155": true,
      "07160": true,
      "07164": true,
      "07170": true,
      "07180": true,
      "07183": true,
      "07187": true,
      "07188": true,
      "07189": true,
      "07190": true,
      "07199": true,
      "07200": true,
      "07206": true,
      "07207": true,
      "07208": true,
      "07209": true,
      "07210": true,
      "07214": true,
      "07219": true,
      "07220": true,
      "07224": true,
      "07230": true,
      "07239": true,
      "07240": true,
      "07248": true,
      "07249": true,
      "07250": true,
      "07255": true,
      "07258": true,
      "07259": true,
      "07260": true,
      "07268": true,
      "07269": true,
      "07270": true,
      "07279": true,
      "07280": true,
      "07290": true,
      "07295": true,
      "07300": true,
      "07309": true,
      "07310": true,
      "07320": true,
      "07323": true,
      "07326": true,
      "07327": true,
      "07328": true,
      "07329": true,
      "07330": true,
      "07340": true,
      "07348": true,
      "07349": true,
      "07350": true,
      "07359": true,
      "07360": true,
      "07363": true,
      "07369": true,
      "07370": true,
      "07380": true,
      "07400": true,
      "07410": true,
      "07420": true,
      "07430": true,
      "07440": true,
      "07450": true,
      "07455": true,
      "07456": true,
      "07457": true,
      "07458": true,
      "07459": true,
      "07460": true,
      "07469": true,
      "07470": true,
      "07480": true,
      "07490": true,
      "07500": true,
      "07509": true,
      "07510": true,
      "07520": true,
      "07530": true,
      "07540": true,
      "07548": true,
      "07549": true,
      "07550": true,
      "07560": true,
      "07570": true,
      "07573": true,
      "07580": true,
      "07600": true,
      "07620": true,
      "07630": true,
      "07640": true,
      "07650": true,
      "07660": true,
      "07670": true,
      "07680": true,
      "07700": true,
      "07707": true,
      "07708": true,
      "07709": true,
      "07710": true,
      "07720": true,
      "07729": true,
      "07730": true,
      "07738": true,
      "07739": true,
      "07740": true,
      "07750": true,
      "07754": true,
      "07755": true,
      "07760": true,
      "07770": true,
      "07780": true,
      "07790": true,
      "07800": true,
      "07810": true,
      "07820": true,
      "07830": true,
      "07838": true,
      "07839": true,
      "07840": true,
      "07850": true,
      "07858": true,
      "07859": true,
      "07860": true,
      "07869": true,
      "07870": true,
      "07880": true,
      "07889": true,
      "07890": true,
      "07899": true,
      "07900": true,
      "07909": true,
      "07910": true,
      "07918": true,
      "07919": true,
      "07920": true,
      "07930": true,
      "07939": true,
      "07940": true,
      "07950": true,
      "07958": true,
      "07959": true,
      "07960": true,
      "07969": true,
      "07970": true,
      "07979": true,
      "07980": true,
      "07990": true
    },
    "IZTACALCO": {
      "08000": true,
      "08009": true,
      "08010": true,
      "08020": true,
      "08029": true,
      "08030": true,
      "08040": true,
      "08100": true,
      "08160": true,
      "08170": true,
      "08180": true,
      "08188": true,
      "08189": true,
      "08200": true,
      "08210": true,
      "08220": true,
      "08230": true,
      "08240": true,
      "08300": true,
      "08310": true,
      "08320": true,
      "08400": true,
      "08420": true,
      "08500": true,
      "08510": true,
      "08520": true,
      "08560": true,
      "08580": true,
      "08600": true,
      "08610": true,
      "08619": true,
      "08620": true,
      "08630": true,
      "08640": true,
      "08650": true,
      "08700": true,
      "08710": true,
      "08720": true,
      "08730": true,
      "08740": true,
      "08750": true,
      "08760": true,
      "08770": true,
      "08800": true,
      "08810": true,
      "08820": true,
      "08830": true,
      "08840": true,
      "08900": true,
      "08910": true,
      "08920": true,
      "08930": true
    },
    "IZTAPALAPA": {
      "09000": true,
      "09009": true,
      "09010": true,
      "09020": true,
      "09030": true,
      "09040": true,
      "09060": true,
      "09070": true,
      "09079": true,
      "09080": true,
      "09089": true,
      "09090": true,
      "09099": true,
      "09100": true,
      "09110": true,
      "09120": true,
      "09130": true,
      "09140": true,
      "09150": true,
      "09160": true,
      "09170": true,
      "09180": true,
      "09200": true,
      "09207": true,
      "09208": true,
      "09209": true,
      "09210": true,
      "09219": true,
      "09220": true,
      "09225": true,
      "09226": true,
      "09227": true,
      "09228": true,
      "09229": true,
      "09230": true,
      "09233": true,
      "09239": true,
      "09240": true,
      "09249": true,
      "09250": true,
      "09260": true,
      "09270": true,
      "09280": true,
      "09290": true,
      "09300": true,
      "09309": true,
      "09310": true,
      "09319": true,
      "09320": true,
      "09330": true,
      "09340": true,
      "09350": true,
      "09359": true,
      "09360": true,
      "09366": true,
      "09367": true,
      "09368": true,
      "09369": true,
      "09400": true,
      "09410": true,
      "09414": true,
      "09420": true,
      "09429": true,
      "09430": true,
      "09437": true,
      "09438": true,
      "09439": true,
      "09440": true,
      "09449": true,
      "09450": true,
      "09460": true,
      "09470": true,
      "09479": true,
      "09480": true,
      "09500": true,
      "09510": true,
      "09519": true,
      "09520": true,
      "09530": true,
      "09540": true,
      "09550": true,
      "09560": true,
      "09570": true,
      "09577": true,
      "09578": true,
      "09579": true,
      "09600": true,
      "09608": true,
      "09609": true,
      "09620": true,
      "09630": true,
      "09636": true,
      "09637": true,
      "09638": true,
      "09640": true,
      "09648": true,
      "09649": true,
      "09660": true,
      "09670": true,
      "09680": true,
      "09685": true,
      "09688": true,
      "09689": true,
      "09690": true,
      "09695": true,
      "09696": true,
      "09697": true,
      "09698": true,
      "09699": true,
      "09700": true,
      "09704": true,
      "09705": true,
      "09706": true,
      "09707": true,
      "09708": true,
      "09709": true,
      "09710": true,
      "09719": true,
      "09720": true,
      "09730": true,
      "09739": true,
      "09740": true,
      "09750": true,
      "09759": true,
      "09760": true,
      "09767": true,
      "09768": true,
      "09769": true,
      "09770": true,
      "09779": true,
      "09780": true,
      "09789": true,
      "09790": true,
      "09800": true,
      "09809": true,
      "09810": true,
      "09819": true,
      "09820": true,
      "09828": true,
      "09829": true,
      "09830": true,
      "09836": true,
      "09837": true,
      "09838": true,
      "09839": true,
      "09840": true,
      "09849": true,
      "09850": true,
      "09856": true,
      "09857": true,
      "09858": true,
      "09859": true,
      "09860": true,
      "09864": true,
      "09868": true,
      "09869": true,
      "09870": true,
      "09880": true,
      "09885": true,
      "09889": true,
      "09890": true,
      "09897": true,
      "09898": true,
      "09899": true,
      "09900": true,
      "09910": true,
      "09919": true,
      "09920": true,
      "09930": true,
      "09940": true,
      "09960": true,
      "09968": true,
      "09969": true,
      "09970": true,
      "09979": true
    },
    "LA MAGDALENA CONTRERAS": {
      "10000": true,
      "10010": true,
      "10020": true,
      "10100": true,
      "10110": true,
      "10119": true,
      "10120": true,
      "10130": true,
      "10200": true,
      "10210": true,
      "10290": true,
      "10300": true,
      "10309": true,
      "10310": true,
      "10320": true,
      "10330": true,
      "10340": true,
      "10350": true,
      "10360": true,
      "10368": true,
      "10369": true,
      "10370": true,
      "10378": true,
      "10379": true,
      "10380": true,
      "10400": true,
      "10500": true,
      "10508": true,
      "10509": true,
      "10580": true,
      "10589": true,
      "10600": true,
      "10610": true,
      "10620": true,
      "10630": true,
      "10640": true,
      "10650": true,
      "10660": true,
      "10700": true,
      "10710": true,
      "10720": true,
      "10730": true,
      "10740": true,
      "10800": true,
      "10810": true,
      "10820": true,
      "10830": true,
      "10840": true,
      "10900": true,
      "10910": true,
      "10920": true
    },
    "MIGUEL HIDALGO": {
      "11000": true,
      "11006": true,
      "11009": true,
      "11010": true,
      "11040": true,
      "11100": true,
      "11109": true,
      "11111": true,
      "11200": true,
      "11209": true,
      "11210": true,
      "11219": true,
      "11220": true,
      "11230": true,
      "11239": true,
      "11240": true,
      "11250": true,
      "11259": true,
      "11260": true,
      "11270": true,
      "11280": true,
      "11289": true,
      "11290": true,
      "11300": true,
      "11305": true,
      "11310": true,
      "11311": true,
      "11320": true,
      "11330": true,
      "11340": true,
      "11350": true,
      "11360": true,
      "11370": true,
      "11379": true,
      "11400": true,
      "11410": true,
      "11420": true,
      "11430": true,
      "11440": true,
      "11450": true,
      "11460": true,
      "11470": true,
      "11479": true,
      "11480": true,
      "11489": true,
      "11490": true,
      "11500": true,
      "11501": true,
      "11510": true,
      "11511": true,
      "11520": true,
      "11529": true,
      "11530": true,
      "11540": true,
      "11550": true,
      "11560": true,
      "11570": true,
      "11580": true,
      "11587": true,
      "11588": true,
      "11590": true,
      "11595": true,
      "11600": true,
      "11610": true,
      "11618": true,
      "11619": true,
      "11620": true,
      "11640": true,
      "11641": true,
      "11649": true,
      "11650": true,
      "11700": true,
      "11800": true,
      "11810": true,
      "11820": true,
      "11830": true,
      "11840": true,
      "11850": true,
      "11860": true,
      "11869": true,
      "11870": true,
      "11900": true,
      "11910": true,
      "11920": true,
      "11930": true,
      "11940": true,
      "11950": true
    },
    "MILPA ALTA": {
      "12000": true,
      "12003": true,
      "12004": true,
      "12005": true,
      "12009": true,
      "12010": true,
      "12020": true,
      "12070": true,
      "12100": true,
      "12110": true,
      "12113": true,
      "12114": true,
      "12115": true,
      "12116": true,
      "12200": true,
      "12205": true,
      "12210": true,
      "12220": true,
      "12230": true,
      "12240": true,
      "12250": true,
      "12252": true,
      "12303": true,
      "12305": true,
      "12306": true,
      "12400": true,
      "12410": true,
      "12420": true,
      "12544": true,
      "12547": true,
      "12600": true,
      "12610": true,
      "12700": true,
      "12710": true,
      "12800": true,
      "12810": true,
      "12900": true,
      "12910": true,
      "12913": true,
      "12914": true,
      "12920": true,
      "12923": true,
      "12924": true
    },
    "TLÁHUAC": {
      "13000": true,
      "13009": true,
      "13010": true,
      "13020": true,
      "13030": true,
      "13040": true,
      "13050": true,
      "13060": true,
      "13063": true,
      "13070": true,
      "13080": true,
      "13090": true,
      "13093": true,
      "13094": true,
      "13099": true,
      "13100": true,
      "13110": true,
      "13115": true,
      "13116": true,
      "13119": true,
      "13120": true,
      "13123": true,
      "13129": true,
      "13150": true,
      "13180": true,
      "13200": true,
      "13209": true,
      "13210": true,
      "13219": true,
      "13220": true,
      "13229": true,
      "13230": true,
      "13240": true,
      "13250": true,
      "13270": true,
      "13273": true,
      "13278": true,
      "13280": true,
      "13300": true,
      "13310": true,
      "13314": true,
      "13315": true,
      "13316": true,
      "13317": true,
      "13318": true,
      "13319": true,
      "13360": true,
      "13363": true,
      "13364": true,
      "13400": true,
      "13410": true,
      "13419": true,
      "13420": true,
      "13429": true,
      "13430": true,
      "13440": true,
      "13450": true,
      "13460": true,
      "13463": true,
      "13465": true,
      "13466": true,
      "13467": true,
      "13500": true,
      "13508": true,
      "13509": true,
      "13510": true,
      "13520": true,
      "13529": true,
      "13530": true,
      "13540": true,
      "13545": true,
      "13546": true,
      "13547": true,
      "13549": true,
      "13550": true,
      "13559": true,
      "13570": true,
      "13600": true,
      "13610": true,
      "13625": true,
      "13630": true,
      "13640": true
    },
    "TLALPAN": {
      "14000": true,
      "14009": true,
      "14010": true,
      "14017": true,
      "14018": true,
      "14020": true,
      "14030": true,
      "14038": true,
      "14039": true,
      "14040": true,
      "14049": true,
      "14050": true,
      "14060": true,
      "14070": true,
      "14080": true,
      "14090": true,
      "14097": true,
      "14098": true,
      "14099": true,
      "14100": true,
      "14108": true,
      "14109": true,
      "14110": true,
      "14120": true,
      "14129": true,
      "14130": true,
      "14140": true,
      "14141": true,
      "14148": true,
      "14149": true,
      "14150": true,
      "14160": true,
      "14200": true,
      "14208": true,
      "14209": true,
      "14210": true,
      "14219": true,
      "14220": true,
      "14230": true,
      "14239": true,
      "14240": true,
      "14248": true,
      "14249": true,
      "14250": true,
      "14260": true,
      "14264": true,
      "14265": true,
      "14266": true,
      "14267": true,
      "14268": true,
      "14269": true,
      "14270": true,
      "14273": true,
      "14275": true,
      "14276": true,
      "14300": true,
      "14306": true,
      "14307": true,
      "14308": true,
      "14309": true,
      "14310": true,
      "14320": true,
      "14324": true,
      "14325": true,
      "14326": true,
      "14327": true,
      "14328": true,
      "14329": true,
      "14330": true,
      "14334": true,
      "14335": true,
      "14336": true,
      "14337": true,
      "14338": true,
      "14339": true,
      "14340": true,
      "14350": true,
      "14356": true,
      "14357": true,
      "14358": true,
      "14359": true,
      "14360": true,
      "14370": true,
      "14376": true,
      "14377": true,
      "14378": true,
      "14380": true,
      "14386": true,
      "14387": true,
      "14388": true,
      "14389": true,
      "14390": true,
      "14399": true,
      "14400": true,
      "14404": true,
      "14405": true,
      "14406": true,
      "14408": true,
      "14409": true,
      "14410": true,
      "14420": true,
      "14426": true,
      "14427": true,
      "14428": true,
      "14429": true,
      "14430": true,
      "14438": true,
      "14439": true,
      "14440": true,
      "14449": true,
      "14450": true,
      "14456": true,
      "14460": true,
      "14470": true,
      "14475": true,
      "14476": true,
      "14477": true,
      "14478": true,
      "14479": true,
      "14480": true,
      "14490": true,
      "14492": true,
      "14493": true,
      "14500": true,
      "14505": true,
      "14520": true,
      "14529": true,
      "14540": true,
      "14543": true,
      "14545": true,
      "14550": true,
      "14560": true,
      "14600": true,
      "14607": true,
      "14608": true,
      "14609": true,
      "14610": true,
      "14620": true,
      "14629": true,
      "14630": true,
      "14639": true,
      "14640": true,
      "14643": true,
      "14645": true,
      "14646": true,
      "14647": true,
      "14648": true,
      "14649": true,
      "14650": true,
      "14651": true,
      "14653": true,
      "14654": true,
      "14655": true,
      "14656": true,
      "14657": true,
      "14658": true,
      "14659": true,
      "14700": true,
      "14710": true,
      "14712": true,
      "14713": true,
      "14714": true,
      "14715": true,
      "14720": true,
      "14730": true,
      "14734": true,
      "14735": true,
      "14737": true,
      "14738": true,
      "14739": true,
      "14740": true,
      "14748": true,
      "14749": true,
      "14750": true,
      "14760": true,
      "14780": true,
      "14790": true,
      "14820": true,
      "14829": true,
      "14830": true,
      "14839": true,
      "14900": true
    },
    "VENUSTIANO CARRANZA": {
      "15000": true,
      "15010": true,
      "15020": true,
      "15100": true,
      "15120": true,
      "15200": true,
      "15210": true,
      "15220": true,
      "15230": true,
      "15240": true,
      "15250": true,
      "15260": true,
      "15270": true,
      "15280": true,
      "15290": true,
      "15299": true,
      "15300": true,
      "15309": true,
      "15310": true,
      "15320": true,
      "15330": true,
      "15339": true,
      "15340": true,
      "15350": true,
      "15360": true,
      "15370": true,
      "15380": true,
      "15390": true,
      "15400": true,
      "15410": true,
      "15420": true,
      "15430": true,
      "15440": true,
      "15450": true,
      "15460": true,
      "15470": true,
      "15500": true,
      "15510": true,
      "15520": true,
      "15530": true,
      "15540": true,
      "15600": true,
      "15610": true,
      "15620": true,
      "15630": true,
      "15640": true,
      "15650": true,
      "15660": true,
      "15669": true,
      "15670": true,
      "15680": true,
      "15690": true,
      "15700": true,
      "15710": true,
      "15720": true,
      "15730": true,
      "15740": true,
      "15750": true,
      "15800": true,
      "15810": true,
      "15820": true,
      "15829": true,
      "15830": true,
      "15840": true,
      "15850": true,
      "15860": true,
      "15870": true,
      "15900": true,
      "15909": true,
      "15940": true,
      "15950": true,
      "15960": true,
      "15968": true,
      "15969": true,
      "15970": true,
      "15980": true,
      "15990": true
    },
    "XOCHIMILCO": {
      "16000": true,
      "16010": true,
      "16016": true,
      "16018": true,
      "16019": true,
      "16020": true,
      "16028": true,
      "16029": true,
      "16030": true,
      "16034": true,
      "16035": true,
      "16036": true,
      "16038": true,
      "16039": true,
      "16040": true,
      "16043": true,
      "16050": true,
      "16057": true,
      "16058": true,
      "16059": true,
      "16060": true,
      "16070": true,
      "16080": true,
      "16090": true,
      "16093": true,
      "16095": true,
      "16096": true,
      "16098": true,
      "16099": true,
      "16100": true,
      "16105": true,
      "16106": true,
      "16109": true,
      "16200": true,
      "16210": true,
      "16215": true,
      "16216": true,
      "16220": true,
      "16230": true,
      "16240": true,
      "16243": true,
      "16244": true,
      "16246": true,
      "16247": true,
      "16248": true,
      "16249": true,
      "16300": true,
      "16310": true,
      "16320": true,
      "16330": true,
      "16340": true,
      "16350": true,
      "16400": true,
      "16410": true,
      "16420": true,
      "16428": true,
      "16429": true,
      "16430": true,
      "16440": true,
      "16443": true,
      "16450": true,
      "16457": true,
      "16459": true,
      "16480": true,
      "16500": true,
      "16510": true,
      "16513": true,
      "16514": true,
      "16515": true,
      "16516": true,
      "16517": true,
      "16518": true,
      "16520": true,
      "16530": true,
      "16533": true,
      "16540": true,
      "16550": true,
      "16555": true,
      "16556": true,
      "16600": true,
      "16604": true,
      "16605": true,
      "16606": true,
      "16607": true,
      "16609": true,
      "16610": true,
      "16614": true,
      "16615": true,
      "16616": true,
      "16617": true,
      "16618": true,
      "16620": true,
      "16623": true,
      "16624": true,
      "16628": true,
      "16629": true,
      "16630": true,
      "16633": true,
      "16634": true,
      "16640": true,
      "16650": true,
      "16653": true,
      "16654": true,
      "16700": true,
      "16710": true,
      "16720": true,
      "16730": true,
      "16739": true,
      "16740": true,
      "16749": true,
      "16750": true,
      "16770": true,
      "16776": true,
      "16780": true,
      "16783": true,
      "16784": true,
      "16785": true,
      "16790": true,
      "16797": true,
      "16799": true,
      "16800": true,
      "16808": true,
      "16809": true,
      "16810": true,
      "16813": true,
      "16819": true,
      "16820": true,
      "16840": true,
      "16850": true,
      "16860": true,
      "16866": true,
      "16869": true,
      "16870": true,
      "16880": true,
      "16888": true,
      "16889": true,
      "16900": true
    }
  },
  "AGUASCALIENTES": {
    "AGUASCALIENTES": {
      "20000": true,
      "20010": true,
      "20016": true,
      "20018": true,
      "20020": true,
      "20029": true,
      "20030": true,
      "20040": true,
      "20049": true,
      "20050": true,
      "20059": true,
      "20060": true,
      "20064": true,
      "20070": true,
      "20078": true,
      "20080": true,
      "20089": true,
      "20100": true,
      "20110": true,
      "20115": true,
      "20116": true,
      "20117": true,
      "20118": true,
      "20119": true,
      "20120": true,
      "20123": true,
      "20124": true,
      "20126": true,
      "20127": true,
      "20129": true,
      "20130": true,
      "20135": true,
      "20136": true,
      "20137": true,
      "20138": true,
      "20140": true,
      "20146": true,
      "20149": true,
      "20150": true,
      "20157": true,
      "20158": true,
      "20159": true,
      "20160": true,
      "20164": true,
      "20169": true,
      "20170": true,
      "20172": true,
      "20174": true,
      "20175": true,
      "20177": true,
      "20179": true,
      "20180": true,
      "20190": true,
      "20196": true,
      "20198": true,
      "20199": true,
      "20200": true,
      "20205": true,
      "20206": true,
      "20207": true,
      "20208": true,
      "20210": true,
      "20216": true,
      "20217": true,
      "20218": true,
      "20219": true,
      "20220": true,
      "20229": true,
      "20230": true,
      "20234": true,
      "20235": true,
      "20236": true,
      "20237": true,
      "20238": true,
      "20239": true,
      "20240": true,
      "20247": true,
      "20248": true,
      "20249": true,
      "20250": true,
      "20255": true,
      "20256": true,
      "20257": true,
      "20259": true,
      "20260": true,
      "20263": true,
      "20264": true,
      "20265": true,
      "20266": true,
      "20267": true,
      "20268": true,
      "20269": true,
      "20270": true,
      "20276": true,
      "20277": true,
      "20278": true,
      "20280": true,
      "20283": true,
      "20284": true,
      "20285": true,
      "20286": true,
      "20287": true,
      "20288": true,
      "20289": true,
      "20290": true,
      "20291": true,
      "20296": true,
      "20297": true,
      "20298": true,
      "20299": true,
      "20310": true,
      "20311": true,
      "20313": true,
      "20314": true,
      "20315": true,
      "20316": true,
      "20317": true,
      "20319": true,
      "20320": true,
      "20321": true,
      "20323": true,
      "20324": true,
      "20326": true,
      "20328": true,
      "20329": true,
      "20340": true,
      "20341": true,
      "20342": true,
      "20344": true,
      "20345": true,
      "20346": true,
      "20348": true,
      "20349": true,
      "20363": true,
      "20364": true,
      "20366": true,
      "20367": true,
      "20369": true,
      "20370": true,
      "20371": true,
      "20372": true,
      "20373": true,
      "20375": true,
      "20376": true,
      "20377": true,
      "20379": true,
      "20384": true,
      "20385": true,
      "20386": true,
      "20388": true,
      "20389": true,
      "20390": true,
      "20391": true,
      "20392": true,
      "20393": true,
      "20394": true,
      "20395": true,
      "20396": true,
      "20399": true
    },
    "SAN FRANCISCO DE LOS ROMO": {
      "20300": true,
      "20303": true,
      "20304": true,
      "20305": true,
      "20350": true,
      "20353": true,
      "20355": true,
      "20356": true,
      "20357": true,
      "20358": true
    },
    "EL LLANO": {
      "20330": true,
      "20333": true,
      "20334": true,
      "20335": true,
      "20336": true,
      "20337": true,
      "20338": true,
      "20339": true
    },
    "RINCON DE ROMOS": {
      "20400": true,
      "20403": true,
      "20404": true,
      "20405": true,
      "20406": true,
      "20410": true,
      "20414": true,
      "20415": true,
      "20416": true,
      "20417": true,
      "20420": true,
      "20423": true,
      "20424": true,
      "20425": true,
      "20426": true,
      "20427": true,
      "20430": true,
      "20434": true,
      "20435": true,
      "20436": true,
      "20437": true,
      "20440": true,
      "20444": true,
      "20445": true,
      "20446": true,
      "20447": true,
      "20450": true,
      "20454": true,
      "20456": true,
      "20457": true
    },
    "COSIO": {
      "20460": true,
      "20462": true,
      "20466": true,
      "20467": true,
      "20468": true,
      "20469": true,
      "20470": true,
      "20472": true,
      "20476": true,
      "20478": true
    },
    "SAN JOSE DE GRACIA": {
      "20500": true,
      "20501": true,
      "20502": true,
      "20503": true,
      "20504": true,
      "20506": true,
      "20508": true,
      "20510": true,
      "20516": true,
      "20520": true,
      "20530": true,
      "20534": true,
      "20538": true,
      "20540": true,
      "20545": true,
      "20550": true,
      "20560": true,
      "20564": true,
      "20567": true,
      "20570": true,
      "20574": true,
      "20576": true,
      "20578": true,
      "20580": true,
      "20584": true,
      "20590": true
    },
    "TEPEZALA": {
      "20600": true,
      "20602": true,
      "20603": true,
      "20604": true,
      "20605": true,
      "20607": true,
      "20608": true,
      "20610": true,
      "20612": true,
      "20613": true,
      "20614": true,
      "20615": true,
      "20616": true,
      "20620": true,
      "20634": true,
      "20637": true,
      "20645": true,
      "20650": true,
      "20656": true,
      "20657": true,
      "20658": true,
      "20659": true
    },
    "PABELLON DE ARTEAGA": {
      "20663": true,
      "20664": true,
      "20665": true,
      "20666": true,
      "20667": true,
      "20668": true,
      "20670": true,
      "20673": true,
      "20674": true,
      "20675": true,
      "20676": true,
      "20677": true,
      "20678": true,
      "20680": true,
      "20683": true,
      "20684": true,
      "20686": true,
      "20687": true
    },
    "ASIENTOS": {
      "20700": true,
      "20704": true,
      "20705": true,
      "20708": true,
      "20709": true,
      "20710": true,
      "20712": true,
      "20713": true,
      "20714": true,
      "20715": true,
      "20717": true,
      "20720": true,
      "20721": true,
      "20722": true,
      "20723": true,
      "20724": true,
      "20727": true,
      "20728": true,
      "20729": true,
      "20730": true,
      "20732": true,
      "20734": true,
      "20736": true,
      "20738": true,
      "20739": true,
      "20740": true,
      "20741": true,
      "20742": true,
      "20744": true,
      "20746": true,
      "20748": true,
      "20749": true,
      "20750": true,
      "20760": true,
      "20765": true,
      "20768": true,
      "20770": true,
      "20771": true,
      "20773": true,
      "20775": true,
      "20777": true,
      "20779": true,
      "20780": true,
      "20782": true,
      "20785": true,
      "20790": true,
      "20792": true,
      "20794": true,
      "20795": true,
      "20796": true,
      "20799": true
    },
    "CALVILLO": {
      "20800": true,
      "20802": true,
      "20803": true,
      "20804": true,
      "20805": true,
      "20810": true,
      "20814": true,
      "20816": true,
      "20820": true,
      "20824": true,
      "20830": true,
      "20832": true,
      "20834": true,
      "20840": true,
      "20842": true,
      "20844": true,
      "20850": true,
      "20852": true,
      "20854": true,
      "20856": true,
      "20860": true,
      "20862": true,
      "20864": true,
      "20870": true,
      "20872": true,
      "20874": true,
      "20880": true,
      "20882": true,
      "20884": true,
      "20890": true,
      "20892": true
    },
    "JESUS MARIA": {
      "20900": true,
      "20901": true,
      "20902": true,
      "20903": true,
      "20904": true,
      "20905": true,
      "20907": true,
      "20908": true,
      "20909": true,
      "20910": true,
      "20913": true,
      "20914": true,
      "20916": true,
      "20917": true,
      "20920": true,
      "20922": true,
      "20923": true,
      "20924": true,
      "20925": true,
      "20926": true,
      "20927": true,
      "20928": true,
      "20933": true,
      "20934": true,
      "20943": true,
      "20947": true,
      "20953": true,
      "20955": true,
      "20956": true,
      "20957": true,
      "20970": true,
      "20974": true,
      "20983": true,
      "20984": true,
      "20986": true,
      "20990": true,
      "20994": true,
      "20995": true,
      "20996": true,
      "20997": true
    }
  },
  "BAJA CALIFORNIA": {
    "MEXICALI": {
      "21000": true,
      "21001": true,
      "21002": true,
      "21003": true,
      "21004": true,
      "21005": true,
      "21006": true,
      "21007": true,
      "21008": true,
      "21009": true,
      "21010": true,
      "21011": true,
      "21012": true,
      "21013": true,
      "21014": true,
      "21015": true,
      "21016": true,
      "21017": true,
      "21018": true,
      "21019": true,
      "21020": true,
      "21021": true,
      "21022": true,
      "21023": true,
      "21024": true,
      "21025": true,
      "21026": true,
      "21027": true,
      "21028": true,
      "21029": true,
      "21030": true,
      "21031": true,
      "21032": true,
      "21033": true,
      "21034": true,
      "21035": true,
      "21036": true,
      "21037": true,
      "21038": true,
      "21039": true,
      "21040": true,
      "21041": true,
      "21042": true,
      "21043": true,
      "21044": true,
      "21045": true,
      "21046": true,
      "21047": true,
      "21048": true,
      "21049": true,
      "21050": true,
      "21051": true,
      "21052": true,
      "21053": true,
      "21054": true,
      "21055": true,
      "21056": true,
      "21057": true,
      "21058": true,
      "21059": true,
      "21060": true,
      "21061": true,
      "21062": true,
      "21063": true,
      "21064": true,
      "21065": true,
      "21066": true,
      "21067": true,
      "21068": true,
      "21069": true,
      "21070": true,
      "21071": true,
      "21072": true,
      "21073": true,
      "21074": true,
      "21075": true,
      "21076": true,
      "21077": true,
      "21078": true,
      "21079": true,
      "21080": true,
      "21081": true,
      "21082": true,
      "21083": true,
      "21084": true,
      "21085": true,
      "21086": true,
      "21087": true,
      "21088": true,
      "21089": true,
      "21090": true,
      "21091": true,
      "21092": true,
      "21093": true,
      "21094": true,
      "21095": true,
      "21096": true,
      "21097": true,
      "21098": true,
      "21099": true,
      "21100": true,
      "21101": true,
      "21102": true,
      "21103": true,
      "21104": true,
      "21105": true,
      "21106": true,
      "21107": true,
      "21108": true,
      "21109": true,
      "21110": true,
      "21111": true,
      "21112": true,
      "21113": true,
      "21114": true,
      "21115": true,
      "21116": true,
      "21118": true,
      "21119": true,
      "21120": true,
      "21121": true,
      "21122": true,
      "21123": true,
      "21124": true,
      "21125": true,
      "21126": true,
      "21127": true,
      "21128": true,
      "21129": true,
      "21130": true,
      "21131": true,
      "21132": true,
      "21133": true,
      "21134": true,
      "21135": true,
      "21136": true,
      "21137": true,
      "21138": true,
      "21139": true,
      "21140": true,
      "21141": true,
      "21142": true,
      "21143": true,
      "21144": true,
      "21145": true,
      "21146": true,
      "21147": true,
      "21148": true,
      "21149": true,
      "21150": true,
      "21151": true,
      "21152": true,
      "21153": true,
      "21154": true,
      "21155": true,
      "21156": true,
      "21157": true,
      "21158": true,
      "21159": true,
      "21160": true,
      "21161": true,
      "21162": true,
      "21163": true,
      "21164": true,
      "21165": true,
      "21166": true,
      "21167": true,
      "21168": true,
      "21169": true,
      "21170": true,
      "21171": true,
      "21172": true,
      "21173": true,
      "21174": true,
      "21175": true,
      "21176": true,
      "21177": true,
      "21178": true,
      "21179": true,
      "21180": true,
      "21181": true,
      "21182": true,
      "21183": true,
      "21184": true,
      "21185": true,
      "21186": true,
      "21187": true,
      "21188": true,
      "21189": true,
      "21190": true,
      "21191": true,
      "21192": true,
      "21193": true,
      "21194": true,
      "21195": true,
      "21196": true,
      "21197": true,
      "21198": true,
      "21199": true,
      "21200": true,
      "21201": true,
      "21202": true,
      "21203": true,
      "21204": true,
      "21205": true,
      "21206": true,
      "21207": true,
      "21208": true,
      "21209": true,
      "21210": true,
      "21211": true,
      "21212": true,
      "21213": true,
      "21214": true,
      "21215": true,
      "21216": true,
      "21217": true,
      "21218": true,
      "21219": true,
      "21220": true,
      "21221": true,
      "21222": true,
      "21223": true,
      "21224": true,
      "21225": true,
      "21226": true,
      "21227": true,
      "21228": true,
      "21229": true,
      "21230": true,
      "21231": true,
      "21232": true,
      "21233": true,
      "21234": true,
      "21235": true,
      "21236": true,
      "21237": true,
      "21238": true,
      "21239": true,
      "21240": true,
      "21241": true,
      "21242": true,
      "21243": true,
      "21244": true,
      "21245": true,
      "21246": true,
      "21247": true,
      "21248": true,
      "21249": true,
      "21250": true,
      "21251": true,
      "21252": true,
      "21253": true,
      "21254": true,
      "21255": true,
      "21256": true,
      "21257": true,
      "21258": true,
      "21259": true,
      "21260": true,
      "21261": true,
      "21262": true,
      "21263": true,
      "21264": true,
      "21265": true,
      "21266": true,
      "21267": true,
      "21268": true,
      "21269": true,
      "21270": true,
      "21271": true,
      "21272": true,
      "21273": true,
      "21274": true,
      "21275": true,
      "21276": true,
      "21277": true,
      "21278": true,
      "21279": true,
      "21280": true,
      "21281": true,
      "21282": true,
      "21283": true,
      "21284": true,
      "21285": true,
      "21286": true,
      "21287": true,
      "21288": true,
      "21289": true,
      "21290": true,
      "21291": true,
      "21292": true,
      "21293": true,
      "21294": true,
      "21295": true,
      "21296": true,
      "21297": true,
      "21298": true,
      "21299": true,
      "21300": true,
      "21301": true,
      "21302": true,
      "21303": true,
      "21304": true,
      "21305": true,
      "21306": true,
      "21307": true,
      "21308": true,
      "21309": true,
      "21310": true,
      "21311": true,
      "21312": true,
      "21313": true,
      "21314": true,
      "21315": true,
      "21316": true,
      "21317": true,
      "21318": true,
      "21319": true,
      "21320": true,
      "21321": true,
      "21322": true,
      "21323": true,
      "21324": true,
      "21325": true,
      "21326": true,
      "21327": true,
      "21328": true,
      "21329": true,
      "21330": true,
      "21331": true,
      "21332": true,
      "21333": true,
      "21334": true,
      "21335": true,
      "21336": true,
      "21337": true,
      "21338": true,
      "21339": true,
      "21340": true,
      "21341": true,
      "21342": true,
      "21343": true,
      "21344": true,
      "21345": true,
      "21346": true,
      "21347": true,
      "21348": true,
      "21349": true,
      "21350": true,
      "21351": true,
      "21352": true,
      "21353": true,
      "21354": true,
      "21355": true,
      "21356": true,
      "21357": true,
      "21358": true,
      "21359": true,
      "21360": true,
      "21361": true,
      "21362": true,
      "21363": true,
      "21364": true,
      "21365": true,
      "21366": true,
      "21367": true,
      "21368": true,
      "21369": true,
      "21370": true,
      "21371": true,
      "21372": true,
      "21373": true,
      "21374": true,
      "21375": true,
      "21376": true,
      "21377": true,
      "21378": true,
      "21379": true,
      "21380": true,
      "21381": true,
      "21382": true,
      "21383": true,
      "21384": true,
      "21385": true,
      "21386": true,
      "21387": true,
      "21388": true,
      "21389": true,
      "21390": true,
      "21391": true,
      "21392": true,
      "21393": true,
      "21394": true,
      "21395": true,
      "21396": true,
      "21397": true,
      "21398": true,
      "21399": true,
      "21600": true,
      "21601": true,
      "21602": true,
      "21603": true,
      "21604": true,
      "21605": true,
      "21606": true,
      "21607": true,
      "21608": true,
      "21609": true,
      "21610": true,
      "21611": true,
      "21612": true,
      "21613": true,
      "21614": true,
      "21615": true,
      "21616": true,
      "21617": true,
      "21618": true,
      "21619": true,
      "21620": true,
      "21621": true,
      "21622": true,
      "21623": true,
      "21624": true,
      "21625": true,
      "21626": true,
      "21627": true,
      "21628": true,
      "21629": true,
      "21630": true,
      "21631": true,
      "21632": true,
      "21633": true,
      "21634": true,
      "21635": true,
      "21636": true,
      "21637": true,
      "21638": true,
      "21639": true,
      "21640": true,
      "21641": true,
      "21642": true,
      "21643": true,
      "21644": true,
      "21645": true,
      "21646": true,
      "21647": true,
      "21648": true,
      "21649": true,
      "21650": true,
      "21651": true,
      "21652": true,
      "21653": true,
      "21654": true,
      "21655": true,
      "21656": true,
      "21657": true,
      "21658": true,
      "21659": true,
      "21660": true,
      "21661": true,
      "21662": true,
      "21663": true,
      "21664": true,
      "21665": true,
      "21666": true,
      "21667": true,
      "21668": true,
      "21669": true,
      "21670": true,
      "21671": true,
      "21672": true,
      "21673": true,
      "21674": true,
      "21675": true,
      "21676": true,
      "21677": true,
      "21678": true,
      "21679": true,
      "21680": true,
      "21681": true,
      "21682": true,
      "21683": true,
      "21684": true,
      "21685": true,
      "21686": true,
      "21687": true,
      "21688": true,
      "21689": true,
      "21690": true,
      "21691": true,
      "21692": true,
      "21693": true,
      "21694": true,
      "21695": true,
      "21696": true,
      "21697": true,
      "21698": true,
      "21699": true,
      "21700": true,
      "21701": true,
      "21702": true,
      "21703": true,
      "21704": true,
      "21705": true,
      "21706": true,
      "21707": true,
      "21708": true,
      "21709": true,
      "21710": true,
      "21711": true,
      "21712": true,
      "21713": true,
      "21714": true,
      "21715": true,
      "21716": true,
      "21717": true,
      "21718": true,
      "21719": true,
      "21721": true,
      "21722": true,
      "21723": true,
      "21724": true,
      "21725": true,
      "21726": true,
      "21727": true,
      "21728": true,
      "21729": true,
      "21730": true,
      "21731": true,
      "21732": true,
      "21733": true,
      "21734": true,
      "21735": true,
      "21736": true,
      "21737": true,
      "21738": true,
      "21739": true,
      "21740": true,
      "21741": true,
      "21742": true,
      "21743": true,
      "21744": true,
      "21745": true,
      "21746": true,
      "21747": true,
      "21748": true,
      "21749": true,
      "21750": true,
      "21751": true,
      "21752": true,
      "21753": true,
      "21754": true,
      "21755": true,
      "21756": true,
      "21757": true,
      "21758": true,
      "21759": true,
      "21760": true,
      "21761": true,
      "21762": true,
      "21763": true,
      "21764": true,
      "21765": true,
      "21766": true,
      "21767": true,
      "21768": true,
      "21769": true,
      "21770": true,
      "21771": true,
      "21772": true,
      "21773": true,
      "21774": true,
      "21775": true,
      "21776": true,
      "21777": true,
      "21778": true,
      "21779": true,
      "21780": true,
      "21781": true,
      "21782": true,
      "21783": true,
      "21784": true,
      "21785": true,
      "21786": true,
      "21787": true,
      "21788": true,
      "21789": true,
      "21790": true,
      "21791": true,
      "21792": true,
      "21793": true,
      "21794": true,
      "21795": true,
      "21796": true,
      "21797": true,
      "21798": true,
      "21799": true,
      "21800": true,
      "21801": true,
      "21802": true,
      "21803": true,
      "21804": true,
      "21805": true,
      "21806": true,
      "21807": true,
      "21808": true,
      "21809": true,
      "21810": true,
      "21811": true,
      "21812": true,
      "21813": true,
      "21814": true,
      "21815": true,
      "21816": true,
      "21817": true,
      "21818": true,
      "21819": true,
      "21820": true,
      "21821": true,
      "21822": true,
      "21823": true,
      "21824": true,
      "21825": true,
      "21826": true,
      "21827": true,
      "21828": true,
      "21829": true,
      "21830": true,
      "21831": true,
      "21832": true,
      "21833": true,
      "21834": true,
      "21835": true,
      "21836": true,
      "21837": true,
      "21838": true,
      "21839": true,
      "21840": true,
      "21841": true,
      "21842": true,
      "21843": true,
      "21844": true,
      "21845": true,
      "21846": true,
      "21847": true,
      "21848": true,
      "21849": true,
      "21850": true,
      "21851": true,
      "21852": true,
      "21853": true,
      "21854": true,
      "21855": true,
      "21856": true,
      "21857": true,
      "21858": true,
      "21859": true,
      "21860": true,
      "21861": true,
      "21862": true,
      "21863": true,
      "21864": true,
      "21865": true,
      "21866": true,
      "21867": true,
      "21868": true,
      "21869": true,
      "21870": true,
      "21871": true,
      "21872": true,
      "21873": true,
      "21874": true,
      "21875": true,
      "21876": true,
      "21877": true,
      "21878": true,
      "21879": true,
      "21880": true,
      "21881": true,
      "21882": true,
      "21883": true,
      "21884": true,
      "21885": true,
      "21886": true,
      "21887": true,
      "21888": true,
      "21889": true,
      "21890": true,
      "21891": true,
      "21892": true,
      "21893": true,
      "21894": true,
      "21895": true,
      "21896": true,
      "21897": true,
      "21898": true,
      "21899": true,
      "21900": true,
      "21901": true,
      "21902": true,
      "21903": true,
      "21904": true,
      "21905": true,
      "21906": true,
      "21907": true,
      "21908": true,
      "21909": true,
      "21910": true,
      "21911": true,
      "21912": true,
      "21913": true,
      "21914": true,
      "21915": true,
      "21916": true,
      "21917": true,
      "21918": true,
      "21919": true,
      "21920": true,
      "21921": true,
      "21922": true,
      "21923": true,
      "21924": true,
      "21925": true,
      "21926": true,
      "21927": true,
      "21928": true,
      "21929": true,
      "21930": true,
      "21931": true,
      "21932": true,
      "21933": true,
      "21934": true,
      "21935": true,
      "21936": true,
      "21937": true,
      "21938": true,
      "21939": true,
      "21940": true,
      "21941": true,
      "21942": true,
      "21943": true,
      "21944": true,
      "21945": true,
      "21946": true,
      "21947": true,
      "21948": true,
      "21949": true,
      "21950": true,
      "21951": true,
      "21952": true,
      "21953": true,
      "21954": true,
      "21955": true,
      "21956": true,
      "21957": true,
      "21958": true,
      "21959": true,
      "21960": true,
      "21961": true,
      "21962": true,
      "21963": true,
      "21964": true,
      "21965": true,
      "21966": true,
      "21967": true,
      "21968": true,
      "21969": true,
      "21970": true,
      "21971": true,
      "21972": true,
      "21973": true,
      "21974": true,
      "21975": true,
      "21976": true,
      "21977": true,
      "21978": true,
      "21979": true,
      "21980": true,
      "21981": true,
      "21982": true,
      "21983": true,
      "21984": true,
      "21985": true,
      "21986": true,
      "21987": true,
      "21988": true,
      "21989": true,
      "21990": true,
      "21991": true,
      "21992": true,
      "21993": true,
      "21994": true,
      "21995": true,
      "21996": true,
      "21997": true,
      "21998": true,
      "21999": true
    },
    "TIJUANA": {
      "21400": true,
      "22000": true,
      "22001": true,
      "22002": true,
      "22003": true,
      "22004": true,
      "22005": true,
      "22006": true,
      "22007": true,
      "22008": true,
      "22009": true,
      "22010": true,
      "22011": true,
      "22012": true,
      "22013": true,
      "22014": true,
      "22015": true,
      "22016": true,
      "22017": true,
      "22018": true,
      "22019": true,
      "22020": true,
      "22021": true,
      "22022": true,
      "22023": true,
      "22024": true,
      "22025": true,
      "22026": true,
      "22027": true,
      "22028": true,
      "22029": true,
      "22030": true,
      "22031": true,
      "22032": true,
      "22033": true,
      "22034": true,
      "22035": true,
      "22036": true,
      "22037": true,
      "22038": true,
      "22039": true,
      "22040": true,
      "22041": true,
      "22042": true,
      "22043": true,
      "22044": true,
      "22045": true,
      "22046": true,
      "22047": true,
      "22048": true,
      "22049": true,
      "22050": true,
      "22051": true,
      "22052": true,
      "22053": true,
      "22054": true,
      "22055": true,
      "22056": true,
      "22057": true,
      "22058": true,
      "22059": true,
      "22060": true,
      "22061": true,
      "22062": true,
      "22063": true,
      "22064": true,
      "22065": true,
      "22066": true,
      "22067": true,
      "22068": true,
      "22069": true,
      "22070": true,
      "22071": true,
      "22072": true,
      "22073": true,
      "22074": true,
      "22075": true,
      "22076": true,
      "22077": true,
      "22078": true,
      "22079": true,
      "22080": true,
      "22081": true,
      "22082": true,
      "22083": true,
      "22084": true,
      "22085": true,
      "22086": true,
      "22087": true,
      "22088": true,
      "22089": true,
      "22090": true,
      "22091": true,
      "22092": true,
      "22093": true,
      "22094": true,
      "22095": true,
      "22096": true,
      "22097": true,
      "22098": true,
      "22099": true,
      "22100": true,
      "22101": true,
      "22102": true,
      "22103": true,
      "22104": true,
      "22105": true,
      "22106": true,
      "22107": true,
      "22108": true,
      "22109": true,
      "22110": true,
      "22111": true,
      "22112": true,
      "22113": true,
      "22114": true,
      "22115": true,
      "22116": true,
      "22117": true,
      "22118": true,
      "22119": true,
      "22120": true,
      "22121": true,
      "22122": true,
      "22123": true,
      "22124": true,
      "22125": true,
      "22126": true,
      "22127": true,
      "22128": true,
      "22129": true,
      "22130": true,
      "22131": true,
      "22132": true,
      "22133": true,
      "22134": true,
      "22135": true,
      "22136": true,
      "22137": true,
      "22138": true,
      "22139": true,
      "22140": true,
      "22141": true,
      "22142": true,
      "22143": true,
      "22144": true,
      "22145": true,
      "22146": true,
      "22147": true,
      "22148": true,
      "22149": true,
      "22150": true,
      "22151": true,
      "22152": true,
      "22153": true,
      "22154": true,
      "22155": true,
      "22156": true,
      "22157": true,
      "22158": true,
      "22159": true,
      "22160": true,
      "22161": true,
      "22162": true,
      "22163": true,
      "22164": true,
      "22165": true,
      "22166": true,
      "22167": true,
      "22168": true,
      "22169": true,
      "22170": true,
      "22171": true,
      "22172": true,
      "22173": true,
      "22174": true,
      "22175": true,
      "22176": true,
      "22177": true,
      "22178": true,
      "22179": true,
      "22180": true,
      "22181": true,
      "22182": true,
      "22183": true,
      "22184": true,
      "22185": true,
      "22186": true,
      "22187": true,
      "22188": true,
      "22189": true,
      "22190": true,
      "22191": true,
      "22192": true,
      "22193": true,
      "22194": true,
      "22195": true,
      "22196": true,
      "22197": true,
      "22198": true,
      "22199": true,
      "22200": true,
      "22201": true,
      "22202": true,
      "22203": true,
      "22204": true,
      "22205": true,
      "22206": true,
      "22207": true,
      "22208": true,
      "22209": true,
      "22210": true,
      "22211": true,
      "22212": true,
      "22213": true,
      "22214": true,
      "22215": true,
      "22216": true,
      "22217": true,
      "22218": true,
      "22219": true,
      "22220": true,
      "22221": true,
      "22222": true,
      "22223": true,
      "22224": true,
      "22225": true,
      "22226": true,
      "22227": true,
      "22228": true,
      "22229": true,
      "22230": true,
      "22231": true,
      "22232": true,
      "22233": true,
      "22234": true,
      "22235": true,
      "22236": true,
      "22237": true,
      "22238": true,
      "22239": true,
      "22240": true,
      "22241": true,
      "22242": true,
      "22243": true,
      "22244": true,
      "22245": true,
      "22246": true,
      "22247": true,
      "22248": true,
      "22249": true,
      "22250": true,
      "22251": true,
      "22252": true,
      "22253": true,
      "22254": true,
      "22255": true,
      "22256": true,
      "22257": true,
      "22258": true,
      "22259": true,
      "22260": true,
      "22261": true,
      "22262": true,
      "22263": true,
      "22264": true,
      "22265": true,
      "22266": true,
      "22267": true,
      "22268": true,
      "22269": true,
      "22270": true,
      "22271": true,
      "22272": true,
      "22273": true,
      "22274": true,
      "22275": true,
      "22276": true,
      "22277": true,
      "22278": true,
      "22279": true,
      "22280": true,
      "22281": true,
      "22282": true,
      "22283": true,
      "22284": true,
      "22285": true,
      "22286": true,
      "22287": true,
      "22288": true,
      "22289": true,
      "22290": true,
      "22291": true,
      "22292": true,
      "22293": true,
      "22294": true,
      "22295": true,
      "22296": true,
      "22297": true,
      "22298": true,
      "22299": true,
      "22300": true,
      "22301": true,
      "22302": true,
      "22303": true,
      "22304": true,
      "22305": true,
      "22306": true,
      "22307": true,
      "22308": true,
      "22309": true,
      "22310": true,
      "22311": true,
      "22312": true,
      "22313": true,
      "22314": true,
      "22315": true,
      "22316": true,
      "22317": true,
      "22318": true,
      "22319": true,
      "22320": true,
      "22321": true,
      "22322": true,
      "22323": true,
      "22324": true,
      "22325": true,
      "22326": true,
      "22327": true,
      "22328": true,
      "22329": true,
      "22330": true,
      "22331": true,
      "22332": true,
      "22333": true,
      "22334": true,
      "22335": true,
      "22336": true,
      "22337": true,
      "22338": true,
      "22339": true,
      "22340": true,
      "22341": true,
      "22342": true,
      "22343": true,
      "22344": true,
      "22345": true,
      "22346": true,
      "22347": true,
      "22348": true,
      "22349": true,
      "22350": true,
      "22351": true,
      "22352": true,
      "22353": true,
      "22354": true,
      "22355": true,
      "22356": true,
      "22357": true,
      "22358": true,
      "22359": true,
      "22360": true,
      "22361": true,
      "22362": true,
      "22363": true,
      "22364": true,
      "22365": true,
      "22366": true,
      "22367": true,
      "22368": true,
      "22369": true,
      "22370": true,
      "22371": true,
      "22372": true,
      "22373": true,
      "22374": true,
      "22375": true,
      "22376": true,
      "22377": true,
      "22378": true,
      "22379": true,
      "22380": true,
      "22381": true,
      "22382": true,
      "22383": true,
      "22384": true,
      "22385": true,
      "22386": true,
      "22387": true,
      "22388": true,
      "22389": true,
      "22390": true,
      "22391": true,
      "22392": true,
      "22393": true,
      "22394": true,
      "22395": true,
      "22396": true,
      "22397": true,
      "22398": true,
      "22399": true,
      "22400": true,
      "22401": true,
      "22402": true,
      "22403": true,
      "22404": true,
      "22405": true,
      "22406": true,
      "22407": true,
      "22408": true,
      "22409": true,
      "22410": true,
      "22411": true,
      "22412": true,
      "22413": true,
      "22414": true,
      "22415": true,
      "22416": true,
      "22417": true,
      "22418": true,
      "22419": true,
      "22420": true,
      "22421": true,
      "22422": true,
      "22423": true,
      "22424": true,
      "22425": true,
      "22426": true,
      "22427": true,
      "22428": true,
      "22429": true,
      "22430": true,
      "22431": true,
      "22432": true,
      "22433": true,
      "22434": true,
      "22435": true,
      "22436": true,
      "22437": true,
      "22438": true,
      "22439": true,
      "22440": true,
      "22441": true,
      "22442": true,
      "22443": true,
      "22444": true,
      "22445": true,
      "22446": true,
      "22447": true,
      "22448": true,
      "22449": true,
      "22450": true,
      "22451": true,
      "22452": true,
      "22453": true,
      "22454": true,
      "22455": true,
      "22456": true,
      "22457": true,
      "22458": true,
      "22459": true,
      "22460": true,
      "22461": true,
      "22462": true,
      "22463": true,
      "22464": true,
      "22465": true,
      "22466": true,
      "22467": true,
      "22468": true,
      "22469": true,
      "22470": true,
      "22471": true,
      "22472": true,
      "22473": true,
      "22474": true,
      "22475": true,
      "22476": true,
      "22477": true,
      "22478": true,
      "22479": true,
      "22481": true,
      "22482": true,
      "22483": true,
      "22484": true,
      "22485": true,
      "22486": true,
      "22487": true,
      "22488": true,
      "22489": true,
      "22490": true,
      "22491": true,
      "22492": true,
      "22493": true,
      "22494": true,
      "22495": true,
      "22496": true,
      "22497": true,
      "22498": true,
      "22499": true,
      "22500": true,
      "22501": true,
      "22502": true,
      "22503": true,
      "22504": true,
      "22505": true,
      "22506": true,
      "22507": true,
      "22508": true,
      "22509": true,
      "22510": true,
      "22511": true,
      "22512": true,
      "22513": true,
      "22514": true,
      "22515": true,
      "22516": true,
      "22517": true,
      "22518": true,
      "22519": true,
      "22520": true,
      "22521": true,
      "22522": true,
      "22523": true,
      "22524": true,
      "22525": true,
      "22526": true,
      "22527": true,
      "22528": true,
      "22529": true,
      "22530": true,
      "22531": true,
      "22532": true,
      "22533": true,
      "22534": true,
      "22535": true,
      "22536": true,
      "22537": true,
      "22538": true,
      "22539": true,
      "22540": true,
      "22541": true,
      "22542": true,
      "22543": true,
      "22544": true,
      "22545": true,
      "22546": true,
      "22547": true,
      "22548": true,
      "22549": true,
      "22550": true,
      "22551": true,
      "22552": true,
      "22553": true,
      "22554": true,
      "22555": true,
      "22556": true,
      "22557": true,
      "22558": true,
      "22559": true,
      "22560": true,
      "22561": true,
      "22562": true,
      "22563": true,
      "22564": true,
      "22565": true,
      "22566": true,
      "22567": true,
      "22568": true,
      "22569": true,
      "22570": true,
      "22571": true,
      "22572": true,
      "22573": true,
      "22574": true,
      "22575": true,
      "22576": true,
      "22577": true,
      "22578": true,
      "22579": true,
      "22580": true,
      "22581": true,
      "22582": true,
      "22583": true,
      "22584": true,
      "22585": true,
      "22586": true,
      "22587": true,
      "22588": true,
      "22589": true,
      "22590": true,
      "22591": true,
      "22592": true,
      "22593": true,
      "22594": true,
      "22595": true,
      "22596": true,
      "22597": true,
      "22598": true,
      "22599": true,
      "22600": true,
      "22601": true,
      "22602": true,
      "22603": true,
      "22604": true,
      "22605": true,
      "22606": true,
      "22607": true,
      "22608": true,
      "22609": true,
      "22610": true,
      "22611": true,
      "22612": true,
      "22613": true,
      "22614": true,
      "22615": true,
      "22616": true,
      "22617": true,
      "22618": true,
      "22619": true,
      "22620": true,
      "22621": true,
      "22622": true,
      "22623": true,
      "22624": true,
      "22625": true,
      "22626": true,
      "22627": true,
      "22628": true,
      "22629": true,
      "22630": true,
      "22631": true,
      "22632": true,
      "22633": true,
      "22634": true,
      "22635": true,
      "22636": true,
      "22637": true,
      "22638": true,
      "22639": true,
      "22640": true,
      "22641": true,
      "22642": true,
      "22643": true,
      "22644": true,
      "22645": true,
      "22646": true,
      "22647": true,
      "22648": true,
      "22649": true,
      "22650": true,
      "22651": true,
      "22652": true,
      "22653": true,
      "22654": true,
      "22655": true,
      "22656": true,
      "22657": true,
      "22658": true,
      "22659": true,
      "22660": true,
      "22661": true,
      "22662": true,
      "22663": true,
      "22664": true,
      "22665": true,
      "22666": true,
      "22667": true,
      "22668": true,
      "22669": true,
      "22670": true,
      "22671": true,
      "22672": true,
      "22673": true,
      "22674": true,
      "22675": true,
      "22676": true,
      "22677": true,
      "22678": true,
      "22679": true,
      "22680": true,
      "22681": true,
      "22682": true,
      "22683": true,
      "22684": true,
      "22685": true,
      "22686": true,
      "22687": true,
      "22688": true,
      "22689": true,
      "22690": true,
      "22691": true,
      "22692": true,
      "22693": true,
      "22694": true,
      "22695": true,
      "22696": true,
      "22697": true,
      "22698": true,
      "22699": true,
      "22847": true
    },
    "TECATE": {
      "21401": true,
      "21402": true,
      "21403": true,
      "21404": true,
      "21405": true,
      "21406": true,
      "21407": true,
      "21408": true,
      "21409": true,
      "21410": true,
      "21411": true,
      "21412": true,
      "21413": true,
      "21414": true,
      "21415": true,
      "21416": true,
      "21417": true,
      "21418": true,
      "21419": true,
      "21420": true,
      "21421": true,
      "21422": true,
      "21423": true,
      "21424": true,
      "21425": true,
      "21426": true,
      "21427": true,
      "21428": true,
      "21429": true,
      "21430": true,
      "21431": true,
      "21432": true,
      "21433": true,
      "21434": true,
      "21435": true,
      "21436": true,
      "21437": true,
      "21438": true,
      "21439": true,
      "21440": true,
      "21441": true,
      "21442": true,
      "21443": true,
      "21444": true,
      "21445": true,
      "21446": true,
      "21447": true,
      "21448": true,
      "21449": true,
      "21450": true,
      "21451": true,
      "21452": true,
      "21453": true,
      "21454": true,
      "21455": true,
      "21456": true,
      "21457": true,
      "21458": true,
      "21459": true,
      "21460": true,
      "21461": true,
      "21462": true,
      "21463": true,
      "21464": true,
      "21465": true,
      "21466": true,
      "21467": true,
      "21468": true,
      "21469": true,
      "21470": true,
      "21471": true,
      "21472": true,
      "21473": true,
      "21474": true,
      "21475": true,
      "21476": true,
      "21477": true,
      "21478": true,
      "21479": true,
      "21480": true,
      "21481": true,
      "21482": true,
      "21483": true,
      "21484": true,
      "21485": true,
      "21486": true,
      "21487": true,
      "21488": true,
      "21489": true,
      "21490": true,
      "21491": true,
      "21492": true,
      "21493": true,
      "21494": true,
      "21495": true,
      "21496": true,
      "21497": true,
      "21498": true,
      "21499": true,
      "21500": true,
      "21501": true,
      "21502": true,
      "21503": true,
      "21504": true,
      "21505": true,
      "21506": true,
      "21507": true,
      "21508": true,
      "21509": true,
      "21510": true,
      "21511": true,
      "21512": true,
      "21513": true,
      "21514": true,
      "21515": true,
      "21516": true,
      "21517": true,
      "21518": true,
      "21519": true,
      "21520": true,
      "21521": true,
      "21522": true,
      "21523": true,
      "21524": true,
      "21525": true,
      "21526": true,
      "21527": true,
      "21528": true,
      "21529": true,
      "21530": true,
      "21531": true,
      "21532": true,
      "21533": true,
      "21534": true,
      "21535": true,
      "21536": true,
      "21537": true,
      "21538": true,
      "21539": true,
      "21540": true,
      "21541": true,
      "21542": true,
      "21543": true,
      "21544": true,
      "21545": true,
      "21546": true,
      "21547": true,
      "21548": true,
      "21549": true,
      "21550": true,
      "21551": true,
      "21552": true,
      "21553": true,
      "21554": true,
      "21555": true,
      "21556": true,
      "21557": true,
      "21558": true,
      "21559": true,
      "21560": true,
      "21561": true,
      "21562": true,
      "21563": true,
      "21564": true,
      "21565": true,
      "21566": true,
      "21567": true,
      "21568": true,
      "21569": true,
      "21570": true,
      "21571": true,
      "21572": true,
      "21573": true,
      "21574": true,
      "21575": true,
      "21576": true,
      "21577": true,
      "21578": true,
      "21579": true,
      "21580": true,
      "21581": true,
      "21582": true,
      "21583": true,
      "21584": true,
      "21585": true,
      "21586": true,
      "21587": true,
      "21588": true,
      "21589": true,
      "21590": true,
      "21591": true,
      "21592": true,
      "21593": true,
      "21594": true,
      "21595": true,
      "21596": true,
      "21597": true,
      "21598": true,
      "21599": true
    },
    "ENSENADA": {
      "22480": true,
      "22750": true,
      "22751": true,
      "22752": true,
      "22753": true,
      "22754": true,
      "22755": true,
      "22756": true,
      "22757": true,
      "22758": true,
      "22759": true,
      "22760": true,
      "22761": true,
      "22762": true,
      "22763": true,
      "22764": true,
      "22765": true,
      "22766": true,
      "22767": true,
      "22768": true,
      "22769": true,
      "22770": true,
      "22771": true,
      "22772": true,
      "22773": true,
      "22774": true,
      "22775": true,
      "22776": true,
      "22777": true,
      "22778": true,
      "22779": true,
      "22780": true,
      "22781": true,
      "22782": true,
      "22783": true,
      "22784": true,
      "22785": true,
      "22786": true,
      "22787": true,
      "22788": true,
      "22789": true,
      "22790": true,
      "22791": true,
      "22792": true,
      "22793": true,
      "22794": true,
      "22795": true,
      "22796": true,
      "22797": true,
      "22798": true,
      "22799": true,
      "22800": true,
      "22801": true,
      "22802": true,
      "22803": true,
      "22804": true,
      "22805": true,
      "22806": true,
      "22807": true,
      "22808": true,
      "22809": true,
      "22810": true,
      "22811": true,
      "22812": true,
      "22813": true,
      "22814": true,
      "22815": true,
      "22816": true,
      "22817": true,
      "22818": true,
      "22819": true,
      "22820": true,
      "22821": true,
      "22822": true,
      "22823": true,
      "22824": true,
      "22825": true,
      "22826": true,
      "22827": true,
      "22828": true,
      "22829": true,
      "22830": true,
      "22831": true,
      "22832": true,
      "22833": true,
      "22834": true,
      "22835": true,
      "22836": true,
      "22837": true,
      "22838": true,
      "22839": true,
      "22840": true,
      "22841": true,
      "22842": true,
      "22843": true,
      "22844": true,
      "22845": true,
      "22846": true,
      "22848": true,
      "22849": true,
      "22850": true,
      "22851": true,
      "22852": true,
      "22853": true,
      "22854": true,
      "22855": true,
      "22856": true,
      "22857": true,
      "22858": true,
      "22859": true,
      "22860": true,
      "22861": true,
      "22862": true,
      "22863": true,
      "22864": true,
      "22865": true,
      "22866": true,
      "22867": true,
      "22868": true,
      "22869": true,
      "22870": true,
      "22871": true,
      "22872": true,
      "22873": true,
      "22874": true,
      "22875": true,
      "22876": true,
      "22877": true,
      "22878": true,
      "22879": true,
      "22880": true,
      "22881": true,
      "22882": true,
      "22883": true,
      "22884": true,
      "22885": true,
      "22886": true,
      "22887": true,
      "22888": true,
      "22889": true,
      "22890": true,
      "22891": true,
      "22892": true,
      "22893": true,
      "22894": true,
      "22895": true,
      "22896": true,
      "22897": true,
      "22898": true,
      "22899": true,
      "22900": true,
      "22901": true,
      "22902": true,
      "22903": true,
      "22904": true,
      "22905": true,
      "22906": true,
      "22907": true,
      "22908": true,
      "22909": true,
      "22910": true,
      "22917": true,
      "22920": true,
      "22930": true,
      "22934": true,
      "22940": true
    },
    "PLAYAS DE ROSARITO": {
      "22700": true,
      "22701": true,
      "22702": true,
      "22703": true,
      "22704": true,
      "22705": true,
      "22706": true,
      "22707": true,
      "22708": true,
      "22709": true,
      "22710": true,
      "22711": true,
      "22712": true,
      "22713": true,
      "22714": true,
      "22715": true,
      "22716": true,
      "22717": true,
      "22718": true,
      "22719": true,
      "22720": true,
      "22721": true,
      "22722": true,
      "22723": true,
      "22724": true,
      "22725": true,
      "22726": true,
      "22727": true,
      "22728": true,
      "22729": true,
      "22730": true,
      "22731": true,
      "22732": true,
      "22733": true,
      "22734": true,
      "22735": true,
      "22736": true,
      "22737": true,
      "22738": true,
      "22739": true,
      "22740": true,
      "22741": true,
      "22742": true,
      "22743": true,
      "22744": true,
      "22745": true,
      "22746": true,
      "22747": true,
      "22748": true,
      "22749": true
    },
    "SAN QUINTÍN": {
      "22911": true,
      "22912": true,
      "22913": true,
      "22914": true,
      "22915": true,
      "22916": true,
      "22918": true,
      "22919": true,
      "22921": true,
      "22922": true,
      "22923": true,
      "22924": true,
      "22925": true,
      "22926": true,
      "22927": true,
      "22928": true,
      "22929": true,
      "22931": true,
      "22932": true,
      "22933": true,
      "22935": true,
      "22936": true,
      "22937": true,
      "22938": true,
      "22939": true,
      "22941": true,
      "22942": true,
      "22943": true,
      "22944": true,
      "22945": true,
      "22946": true,
      "22947": true,
      "22948": true,
      "22949": true,
      "22950": true,
      "22951": true,
      "22952": true,
      "22953": true,
      "22954": true,
      "22955": true,
      "22956": true,
      "22957": true,
      "22958": true,
      "22959": true,
      "22960": true,
      "22961": true,
      "22962": true,
      "22963": true,
      "22964": true,
      "22965": true,
      "22966": true,
      "22967": true,
      "22968": true,
      "22969": true,
      "22970": true,
      "22971": true,
      "22972": true,
      "22973": true,
      "22974": true,
      "22975": true,
      "22976": true,
      "22977": true,
      "22978": true,
      "22979": true,
      "22980": true,
      "22981": true,
      "22982": true,
      "22983": true,
      "22984": true,
      "22985": true,
      "22986": true,
      "22987": true,
      "22988": true,
      "22989": true,
      "22990": true,
      "22991": true,
      "22992": true,
      "22993": true,
      "22994": true,
      "22995": true,
      "22996": true,
      "22997": true,
      "22998": true,
      "22999": true
    }
  },
  "BAJA CALIFORNIA SUR": {
    "LA PAZ": {
      "23000": true,
      "23001": true,
      "23004": true,
      "23005": true,
      "23006": true,
      "23007": true,
      "23008": true,
      "23009": true,
      "23010": true,
      "23011": true,
      "23014": true,
      "23016": true,
      "23017": true,
      "23018": true,
      "23019": true,
      "23020": true,
      "23023": true,
      "23025": true,
      "23026": true,
      "23029": true,
      "23030": true,
      "23034": true,
      "23037": true,
      "23038": true,
      "23039": true,
      "23040": true,
      "23041": true,
      "23045": true,
      "23046": true,
      "23048": true,
      "23049": true,
      "23050": true,
      "23051": true,
      "23052": true,
      "23054": true,
      "23055": true,
      "23056": true,
      "23057": true,
      "23060": true,
      "23066": true,
      "23068": true,
      "23069": true,
      "23070": true,
      "23071": true,
      "23072": true,
      "23075": true,
      "23076": true,
      "23077": true,
      "23078": true,
      "23079": true,
      "23080": true,
      "23081": true,
      "23082": true,
      "23083": true,
      "23084": true,
      "23085": true,
      "23086": true,
      "23087": true,
      "23088": true,
      "23089": true,
      "23090": true,
      "23091": true,
      "23092": true,
      "23093": true,
      "23094": true,
      "23095": true,
      "23096": true,
      "23097": true,
      "23098": true,
      "23099": true,
      "23205": true,
      "23300": true,
      "23330": true
    },
    "LOS CABOS": {
      "23400": true,
      "23401": true,
      "23402": true,
      "23403": true,
      "23404": true,
      "23405": true,
      "23406": true,
      "23407": true,
      "23410": true,
      "23420": true,
      "23421": true,
      "23423": true,
      "23425": true,
      "23426": true,
      "23427": true,
      "23428": true,
      "23429": true,
      "23430": true,
      "23433": true,
      "23434": true,
      "23435": true,
      "23436": true,
      "23437": true,
      "23438": true,
      "23439": true,
      "23440": true,
      "23441": true,
      "23443": true,
      "23444": true,
      "23445": true,
      "23446": true,
      "23447": true,
      "23448": true,
      "23449": true,
      "23450": true,
      "23451": true,
      "23452": true,
      "23453": true,
      "23454": true,
      "23455": true,
      "23456": true,
      "23457": true,
      "23458": true,
      "23459": true,
      "23460": true,
      "23462": true,
      "23463": true,
      "23464": true,
      "23467": true,
      "23468": true,
      "23469": true,
      "23470": true,
      "23471": true,
      "23472": true,
      "23473": true,
      "23474": true,
      "23475": true,
      "23476": true,
      "23477": true,
      "23478": true,
      "23570": true
    },
    "COMONDÚ": {
      "23600": true,
      "23601": true,
      "23604": true,
      "23606": true,
      "23608": true,
      "23610": true,
      "23620": true,
      "23630": true,
      "23631": true,
      "23640": true,
      "23641": true,
      "23650": true,
      "23651": true,
      "23653": true,
      "23658": true,
      "23660": true,
      "23670": true,
      "23674": true,
      "23675": true,
      "23676": true,
      "23677": true,
      "23678": true,
      "23680": true,
      "23683": true,
      "23685": true,
      "23690": true,
      "23692": true,
      "23695": true,
      "23696": true,
      "23697": true,
      "23700": true
    },
    "LORETO": {
      "23880": true,
      "23889": true
    },
    "MULEGÉ": {
      "23920": true,
      "23938": true,
      "23940": true
    }
  },
  "CAMPECHE": {
    "CAMPECHE": {
      "24000": true,
      "24010": true,
      "24014": true,
      "24020": true,
      "24022": true,
      "24023": true,
      "24024": true,
      "24025": true,
      "24026": true,
      "24027": true,
      "24028": true,
      "24029": true,
      "24030": true,
      "24035": true,
      "24036": true,
      "24037": true,
      "24038": true,
      "24039": true,
      "24040": true,
      "24044": true,
      "24049": true,
      "24050": true,
      "24058": true,
      "24060": true,
      "24063": true,
      "24069": true,
      "24070": true,
      "24073": true,
      "24075": true,
      "24079": true,
      "24080": true,
      "24083": true,
      "24084": true,
      "24085": true,
      "24086": true,
      "24087": true,
      "24088": true,
      "24089": true,
      "24090": true,
      "24093": true,
      "24094": true,
      "24095": true,
      "24096": true,
      "24097": true,
      "24098": true,
      "24099": true,
      "24500": true,
      "24517": true,
      "24520": true,
      "24532": true,
      "24564": true,
      "24570": true,
      "24572": true,
      "24573": true,
      "24574": true,
      "24575": true,
      "24576": true
    },
    "CARMEN": {
      "24100": true,
      "24108": true,
      "24110": true,
      "24114": true,
      "24115": true,
      "24116": true,
      "24117": true,
      "24118": true,
      "24119": true,
      "24120": true,
      "24129": true,
      "24130": true,
      "24139": true,
      "24140": true,
      "24150": true,
      "24153": true,
      "24154": true,
      "24155": true,
      "24156": true,
      "24157": true,
      "24158": true,
      "24160": true,
      "24166": true,
      "24167": true,
      "24169": true,
      "24170": true,
      "24178": true,
      "24179": true,
      "24180": true,
      "24185": true,
      "24186": true,
      "24187": true,
      "24188": true,
      "24189": true,
      "24190": true,
      "24195": true,
      "24197": true,
      "24198": true,
      "24199": true,
      "24300": true,
      "24304": true,
      "24310": true,
      "24326": true,
      "24327": true,
      "24328": true
    },
    "PALIZADA": {
      "24200": true
    },
    "CANDELARIA": {
      "24330": true
    },
    "ESCÁRCEGA": {
      "24350": true,
      "24354": true,
      "24374": true
    },
    "CHAMPOTÓN": {
      "24400": true,
      "24402": true,
      "24403": true,
      "24404": true,
      "24410": true,
      "24413": true,
      "24414": true,
      "24415": true,
      "24416": true,
      "24440": true,
      "24450": true,
      "24451": true,
      "24459": true,
      "24482": true,
      "24495": true
    },
    "HOPELCHÉN": {
      "24600": true,
      "24603": true,
      "24604": true
    },
    "CALAKMUL": {
      "24640": true,
      "24643": true,
      "24644": true,
      "24646": true,
      "24648": true
    },
    "TENABO": {
      "24700": true,
      "24703": true,
      "24704": true,
      "24705": true,
      "24706": true,
      "24707": true
    },
    "HECELCHAKÁN": {
      "24800": true,
      "24810": true
    },
    "CALKINÍ": {
      "24900": true,
      "24902": true,
      "24903": true,
      "24904": true,
      "24905": true,
      "24910": true,
      "24914": true,
      "24915": true,
      "24916": true,
      "24917": true,
      "24919": true,
      "24920": true,
      "24921": true,
      "24922": true,
      "24923": true,
      "24925": true,
      "24929": true,
      "24930": true,
      "24933": true,
      "24934": true,
      "24935": true,
      "24936": true
    }
  },
  "COLIMA": {
    "COLIMA": {
      "28000": true,
      "28001": true,
      "28002": true,
      "28003": true,
      "28004": true,
      "28005": true,
      "28006": true,
      "28007": true,
      "28008": true,
      "28009": true,
      "28010": true,
      "28014": true,
      "28016": true,
      "28017": true,
      "28018": true,
      "28019": true,
      "28020": true,
      "28023": true,
      "28025": true,
      "28028": true,
      "28030": true,
      "28035": true,
      "28037": true,
      "28040": true,
      "28043": true,
      "28044": true,
      "28045": true,
      "28046": true,
      "28047": true,
      "28048": true,
      "28050": true,
      "28060": true,
      "28063": true,
      "28067": true,
      "28068": true,
      "28069": true,
      "28070": true,
      "28071": true,
      "28075": true,
      "28076": true,
      "28077": true,
      "28078": true,
      "28079": true,
      "28080": true,
      "28085": true,
      "28089": true,
      "28090": true,
      "28600": true,
      "28610": true,
      "28613": true,
      "28614": true,
      "28619": true,
      "28620": true,
      "28624": true,
      "28626": true,
      "28627": true,
      "28628": true,
      "28629": true,
      "28630": true,
      "28633": true,
      "28634": true,
      "28635": true,
      "28636": true,
      "28640": true,
      "28645": true,
      "28646": true,
      "28647": true,
      "28653": true,
      "28655": true,
      "28656": true
    },
    "TECOMÁN": {
      "28100": true,
      "28110": true,
      "28113": true,
      "28114": true,
      "28120": true,
      "28123": true,
      "28130": true,
      "28133": true,
      "28134": true,
      "28140": true,
      "28143": true,
      "28150": true,
      "28159": true,
      "28160": true,
      "28170": true,
      "28180": true,
      "28184": true,
      "28189": true,
      "28190": true,
      "28900": true,
      "28910": true,
      "28915": true,
      "28920": true,
      "28923": true,
      "28924": true,
      "28929": true,
      "28930": true,
      "28934": true,
      "28935": true,
      "28937": true,
      "28938": true,
      "28940": true,
      "28944": true,
      "28945": true,
      "28947": true
    },
    "MANZANILLO": {
      "28200": true,
      "28209": true,
      "28210": true,
      "28218": true,
      "28219": true,
      "28230": true,
      "28236": true,
      "28237": true,
      "28238": true,
      "28239": true,
      "28240": true,
      "28250": true,
      "28259": true,
      "28260": true,
      "28269": true,
      "28270": true,
      "28278": true,
      "28279": true,
      "28280": true,
      "28800": true,
      "28807": true,
      "28808": true,
      "28809": true,
      "28810": true,
      "28812": true,
      "28813": true,
      "28814": true,
      "28815": true,
      "28820": true,
      "28823": true,
      "28826": true,
      "28830": true,
      "28833": true,
      "28834": true,
      "28836": true,
      "28838": true,
      "28840": true,
      "28850": true,
      "28855": true,
      "28860": true,
      "28863": true,
      "28864": true,
      "28865": true,
      "28867": true,
      "28868": true,
      "28869": true,
      "28870": true,
      "28872": true,
      "28876": true,
      "28877": true,
      "28878": true,
      "28879": true,
      "28880": true
    },
    "ARMERÍA": {
      "28300": true,
      "28304": true,
      "28305": true,
      "28306": true,
      "28307": true,
      "28310": true,
      "28314": true,
      "28317": true,
      "28320": true,
      "28330": true,
      "28333": true,
      "28335": true,
      "28340": true,
      "28350": true
    },
    "COQUIMATLÁN": {
      "28400": true,
      "28402": true,
      "28403": true,
      "28405": true,
      "28406": true,
      "28407": true,
      "28410": true,
      "28413": true,
      "28414": true,
      "28418": true,
      "28420": true,
      "28424": true,
      "28425": true,
      "28426": true
    },
    "COMALA": {
      "28450": true,
      "28452": true,
      "28454": true,
      "28455": true,
      "28456": true,
      "28459": true,
      "28460": true,
      "28461": true,
      "28462": true,
      "28463": true,
      "28464": true,
      "28465": true,
      "28466": true,
      "28467": true,
      "28469": true
    },
    "CUAUHTÉMOC": {
      "28500": true,
      "28504": true,
      "28506": true,
      "28507": true,
      "28509": true,
      "28510": true,
      "28513": true,
      "28514": true,
      "28515": true,
      "28516": true,
      "28517": true,
      "28520": true,
      "28521": true,
      "28523": true,
      "28530": true,
      "28550": true,
      "28553": true,
      "28554": true,
      "28555": true,
      "28556": true,
      "28557": true,
      "28590": true,
      "28597": true,
      "28599": true
    },
    "IXTLAHUACÁN": {
      "28700": true,
      "28703": true,
      "28704": true,
      "28705": true,
      "28720": true,
      "28724": true,
      "28730": true,
      "28733": true,
      "28734": true,
      "28735": true,
      "28736": true
    },
    "MINATITLÁN": {
      "28750": true,
      "28760": true,
      "28764": true,
      "28765": true,
      "28766": true,
      "28767": true,
      "28770": true,
      "28772": true,
      "28773": true,
      "28774": true,
      "28780": true,
      "28782": true,
      "28784": true
    },
    "VILLA DE ÁLVAREZ": {
      "28950": true,
      "28952": true,
      "28955": true,
      "28958": true,
      "28959": true,
      "28960": true,
      "28963": true,
      "28964": true,
      "28965": true,
      "28968": true,
      "28970": true,
      "28972": true,
      "28973": true,
      "28974": true,
      "28975": true,
      "28976": true,
      "28977": true,
      "28978": true,
      "28979": true,
      "28980": true,
      "28982": true,
      "28983": true,
      "28984": true,
      "28985": true,
      "28986": true,
      "28987": true,
      "28988": true,
      "28989": true
    }
  },
  "CHIAPAS": {
    "TUXTLA GUTIÉRREZ": {
      "29000": true,
      "29007": true,
      "29008": true,
      "29009": true,
      "29010": true,
      "29014": true,
      "29016": true,
      "29017": true,
      "29018": true,
      "29019": true,
      "29020": true,
      "29023": true,
      "29024": true,
      "29025": true,
      "29026": true,
      "29027": true,
      "29028": true,
      "29030": true,
      "29034": true,
      "29037": true,
      "29038": true,
      "29039": true,
      "29040": true,
      "29043": true,
      "29044": true,
      "29045": true,
      "29047": true,
      "29049": true,
      "29050": true,
      "29054": true,
      "29055": true,
      "29056": true,
      "29057": true,
      "29058": true,
      "29059": true,
      "29060": true,
      "29064": true,
      "29065": true,
      "29066": true,
      "29067": true,
      "29070": true,
      "29073": true,
      "29075": true,
      "29076": true,
      "29077": true,
      "29078": true,
      "29079": true,
      "29080": true,
      "29086": true,
      "29087": true,
      "29089": true,
      "29090": true,
      "29094": true,
      "29096": true,
      "29098": true,
      "29100": true,
      "29112": true
    },
    "SAN FERNANDO": {
      "29120": true,
      "29124": true,
      "29127": true,
      "29129": true
    },
    "BERRIOZÁBAL": {
      "29130": true,
      "29133": true,
      "29136": true
    },
    "OCOZOCOAUTLA DE ESPINOSA": {
      "29140": true,
      "29142": true,
      "29143": true,
      "29144": true
    },
    "SUCHIAPA": {
      "29150": true,
      "29151": true
    },
    "CHIAPA DE CORZO": {
      "29160": true,
      "29163": true,
      "29164": true,
      "29165": true,
      "29166": true,
      "29167": true,
      "29169": true,
      "29170": true,
      "29174": true,
      "29176": true,
      "29177": true,
      "29178": true,
      "29180": true
    },
    "OSUMACINTA": {
      "29190": true,
      "29191": true
    },
    "SAN CRISTÓBAL DE LAS CASAS": {
      "29200": true,
      "29210": true,
      "29213": true,
      "29214": true,
      "29215": true,
      "29216": true,
      "29217": true,
      "29218": true,
      "29220": true,
      "29223": true,
      "29227": true,
      "29228": true,
      "29230": true,
      "29233": true,
      "29235": true,
      "29236": true,
      "29239": true,
      "29240": true,
      "29242": true,
      "29243": true,
      "29244": true,
      "29246": true,
      "29247": true,
      "29249": true,
      "29250": true,
      "29254": true,
      "29255": true,
      "29256": true,
      "29258": true,
      "29259": true,
      "29260": true,
      "29263": true,
      "29264": true,
      "29265": true,
      "29266": true,
      "29267": true,
      "29269": true,
      "29270": true,
      "29277": true,
      "29278": true,
      "29279": true,
      "29280": true,
      "29286": true,
      "29288": true,
      "29289": true,
      "29290": true,
      "29292": true,
      "29293": true,
      "29294": true,
      "29295": true,
      "29296": true,
      "29297": true,
      "29298": true,
      "29299": true,
      "29300": true,
      "29310": true,
      "29314": true,
      "29316": true
    },
    "CHAMULA": {
      "29320": true,
      "29321": true,
      "29322": true,
      "29323": true,
      "29324": true,
      "29325": true,
      "29326": true,
      "29327": true,
      "29328": true,
      "29329": true,
      "29330": true,
      "29332": true,
      "29333": true,
      "29334": true,
      "29335": true,
      "29336": true,
      "29337": true
    },
    "IXTAPA": {
      "29340": true,
      "29341": true,
      "29342": true,
      "29345": true,
      "29346": true,
      "29347": true,
      "29348": true,
      "29349": true
    },
    "ZINACANTÁN": {
      "29350": true,
      "29353": true,
      "29355": true,
      "29360": true,
      "29364": true,
      "29365": true,
      "29367": true,
      "29369": true
    },
    "ACALA": {
      "29370": true,
      "29372": true,
      "29373": true,
      "29374": true,
      "29376": true,
      "29377": true,
      "29384": true,
      "29385": true,
      "29387": true
    },
    "EMILIANO ZAPATA": {
      "29380": true,
      "29382": true,
      "29383": true,
      "29386": true
    },
    "CHIAPILLA": {
      "29390": true,
      "29395": true
    },
    "SAN LUCAS": {
      "29400": true,
      "29403": true,
      "29405": true
    },
    "TEOPISCA": {
      "29410": true,
      "29412": true,
      "29414": true,
      "29415": true,
      "29416": true,
      "29417": true,
      "29419": true,
      "29420": true
    },
    "AMATENANGO DEL VALLE": {
      "29430": true,
      "29432": true,
      "29433": true,
      "29434": true,
      "29435": true,
      "29439": true
    },
    "CHANAL": {
      "29440": true,
      "29441": true,
      "29444": true,
      "29446": true
    },
    "OXCHUC": {
      "29450": true,
      "29451": true,
      "29453": true,
      "29454": true,
      "29455": true,
      "29460": true,
      "29461": true,
      "29462": true,
      "29463": true
    },
    "HUIXTÁN": {
      "29470": true,
      "29471": true,
      "29472": true,
      "29473": true,
      "29474": true,
      "29475": true,
      "29477": true
    },
    "TENEJAPA": {
      "29480": true,
      "29481": true,
      "29482": true,
      "29483": true,
      "29486": true,
      "29487": true,
      "29489": true
    },
    "MITONTIC": {
      "29490": true,
      "29493": true,
      "29494": true,
      "29495": true
    },
    "REFORMA": {
      "29500": true,
      "29503": true,
      "29504": true,
      "29506": true,
      "29507": true,
      "29508": true,
      "29509": true
    },
    "JUÁREZ": {
      "29510": true,
      "29513": true,
      "29519": true
    },
    "PICHUCALCO": {
      "29520": true
    },
    "IXTACOMITÁN": {
      "29570": true,
      "29571": true,
      "29575": true
    },
    "SOLOSUCHIAPA": {
      "29580": true,
      "29587": true
    },
    "MEZCALAPA": {
      "29600": true,
      "29603": true,
      "29604": true,
      "29605": true,
      "29606": true,
      "29608": true,
      "29609": true
    },
    "TECPATÁN": {
      "29610": true,
      "29613": true,
      "29614": true,
      "29615": true,
      "29616": true,
      "29617": true,
      "29618": true,
      "29619": true
    },
    "COPAINALÁ": {
      "29620": true,
      "29623": true,
      "29624": true,
      "29625": true,
      "29626": true,
      "29627": true,
      "29630": true,
      "29633": true,
      "29634": true,
      "29635": true,
      "29636": true
    },
    "CHICOASÉN": {
      "29640": true
    },
    "COAPILLA": {
      "29650": true
    },
    "HUITIUPÁN": {
      "29710": true
    },
    "PUEBLO NUEVO SOLISTAHUACÁN": {
      "29750": true
    },
    "JITOTOL": {
      "29760": true
    },
    "BOCHIL": {
      "29770": true
    },
    "SOYALÓ": {
      "29780": true,
      "29782": true,
      "29783": true
    },
    "SIMOJOVEL": {
      "29820": true
    },
    "EL BOSQUE": {
      "29840": true
    },
    "YAJALÓN": {
      "29930": true
    },
    "CHILÓN": {
      "29940": true,
      "29942": true,
      "29943": true,
      "29944": true,
      "29945": true,
      "29946": true,
      "29947": true,
      "29948": true,
      "29949": true
    },
    "OCOSINGO": {
      "29950": true
    },
    "COMITÁN DE DOMÍNGUEZ": {
      "30000": true,
      "30010": true,
      "30013": true,
      "30015": true,
      "30017": true,
      "30018": true,
      "30019": true,
      "30020": true,
      "30023": true,
      "30028": true,
      "30029": true,
      "30030": true,
      "30033": true,
      "30034": true,
      "30036": true,
      "30037": true,
      "30038": true,
      "30039": true,
      "30040": true,
      "30043": true,
      "30060": true,
      "30063": true,
      "30064": true,
      "30065": true,
      "30067": true,
      "30068": true,
      "30069": true,
      "30070": true,
      "30073": true,
      "30074": true,
      "30075": true,
      "30076": true,
      "30077": true,
      "30078": true,
      "30090": true,
      "30093": true,
      "30096": true,
      "30099": true,
      "30100": true
    },
    "TZIMOL": {
      "30110": true
    },
    "LA TRINITARIA": {
      "30160": true
    },
    "LA INDEPENDENCIA": {
      "30170": true
    },
    "LAS MARGARITAS": {
      "30187": true
    },
    "ALTAMIRANO": {
      "30190": true
    },
    "VENUSTIANO CARRANZA": {
      "30200": true,
      "30202": true,
      "30203": true
    },
    "TOTOLAPA": {
      "30330": true
    },
    "LAS ROSAS": {
      "30350": true,
      "30352": true,
      "30353": true,
      "30354": true,
      "30356": true
    },
    "LA CONCORDIA": {
      "30363": true,
      "30364": true,
      "30365": true,
      "30369": true
    },
    "ÁNGEL ALBINO CORZO": {
      "30370": true
    },
    "SOCOLTENANGO": {
      "30390": true
    },
    "CINTALAPA": {
      "30400": true,
      "30406": true
    },
    "JIQUIPILAS": {
      "30430": true,
      "30431": true,
      "30433": true,
      "30434": true,
      "30438": true,
      "30448": true,
      "30449": true
    },
    "ARRIAGA": {
      "30450": true,
      "30453": true,
      "30454": true,
      "30455": true,
      "30456": true,
      "30457": true,
      "30458": true,
      "30461": true,
      "30462": true
    },
    "VILLAFLORES": {
      "30470": true,
      "30474": true,
      "30475": true,
      "30476": true,
      "30478": true,
      "30479": true,
      "30480": true,
      "30484": true,
      "30485": true,
      "30492": true,
      "30495": true
    },
    "TONALÁ": {
      "30500": true,
      "30507": true,
      "30509": true
    },
    "VILLA CORZO": {
      "30520": true,
      "30533": true,
      "30535": true
    },
    "EL PARRAL": {
      "30530": true
    },
    "PIJIJIAPAN": {
      "30540": true,
      "30550": true
    },
    "MAPASTEPEC": {
      "30560": true,
      "30563": true,
      "30570": true
    },
    "ACAPETAHUA": {
      "30580": true,
      "30583": true
    },
    "ACACOYAGUA": {
      "30590": true
    },
    "ESCUINTLA": {
      "30600": true
    },
    "VILLA COMALTITLÁN": {
      "30620": true,
      "30623": true,
      "30624": true,
      "30625": true,
      "30626": true,
      "30627": true,
      "30630": true,
      "30633": true,
      "30634": true,
      "30635": true,
      "30636": true,
      "30637": true
    },
    "HUIXTLA": {
      "30640": true,
      "30643": true,
      "30645": true,
      "30649": true
    },
    "MAZATÁN": {
      "30650": true,
      "30651": true,
      "30654": true,
      "30655": true,
      "30656": true
    },
    "HUEHUETÁN": {
      "30660": true,
      "30662": true,
      "30664": true,
      "30665": true,
      "30666": true,
      "30667": true,
      "30670": true,
      "30675": true,
      "30676": true,
      "30677": true
    },
    "TUZANTÁN": {
      "30680": true,
      "30686": true,
      "30689": true,
      "30690": true
    },
    "TAPACHULA": {
      "30700": true,
      "30705": true,
      "30709": true,
      "30710": true,
      "30716": true,
      "30718": true,
      "30719": true,
      "30720": true,
      "30723": true,
      "30724": true,
      "30725": true,
      "30726": true,
      "30729": true,
      "30730": true,
      "30734": true,
      "30735": true,
      "30736": true,
      "30737": true,
      "30738": true,
      "30739": true,
      "30740": true,
      "30745": true,
      "30747": true,
      "30748": true,
      "30749": true,
      "30750": true,
      "30755": true,
      "30757": true,
      "30760": true,
      "30763": true,
      "30766": true,
      "30767": true,
      "30768": true,
      "30769": true,
      "30770": true,
      "30778": true,
      "30779": true,
      "30780": true,
      "30783": true,
      "30784": true,
      "30785": true,
      "30786": true,
      "30787": true,
      "30788": true,
      "30789": true,
      "30790": true,
      "30792": true,
      "30793": true,
      "30794": true,
      "30795": true,
      "30796": true,
      "30797": true,
      "30798": true,
      "30799": true,
      "30800": true,
      "30802": true,
      "30803": true,
      "30804": true,
      "30805": true,
      "30806": true,
      "30807": true,
      "30808": true,
      "30809": true,
      "30810": true,
      "30812": true,
      "30813": true,
      "30814": true,
      "30815": true,
      "30816": true,
      "30817": true,
      "30818": true,
      "30820": true,
      "30823": true,
      "30824": true,
      "30825": true,
      "30826": true,
      "30827": true,
      "30828": true,
      "30829": true,
      "30832": true,
      "30833": true,
      "30834": true,
      "30835": true,
      "30836": true,
      "30837": true,
      "30838": true,
      "30839": true
    },
    "SUCHIATE": {
      "30840": true,
      "30845": true,
      "30846": true,
      "30847": true,
      "30849": true
    },
    "FRONTERA HIDALGO": {
      "30850": true,
      "30851": true,
      "30852": true,
      "30853": true,
      "30854": true,
      "30855": true,
      "30858": true
    },
    "METAPA": {
      "30860": true,
      "30861": true,
      "30862": true
    },
    "TUXTLA CHICO": {
      "30866": true,
      "30867": true,
      "30868": true,
      "30869": true,
      "30870": true,
      "30871": true,
      "30875": true,
      "30877": true
    },
    "UNIÓN JUÁREZ": {
      "30880": true,
      "30881": true,
      "30883": true,
      "30884": true,
      "30885": true
    },
    "CACAHOATÁN": {
      "30890": true,
      "30892": true,
      "30893": true,
      "30894": true,
      "30895": true,
      "30896": true,
      "30897": true,
      "30898": true
    },
    "MOTOZINTLA": {
      "30900": true,
      "30902": true
    },
    "AMATENANGO DE LA FRONTERA": {
      "30933": true,
      "30934": true
    }
  },
  "CHIHUAHUA": {
    "CHIHUAHUA": {
      "31000": true,
      "31020": true,
      "31029": true,
      "31030": true,
      "31034": true,
      "31050": true,
      "31054": true,
      "31060": true,
      "31063": true,
      "31064": true,
      "31065": true,
      "31066": true,
      "31067": true,
      "31074": true,
      "31075": true,
      "31076": true,
      "31100": true,
      "31104": true,
      "31105": true,
      "31106": true,
      "31107": true,
      "31110": true,
      "31114": true,
      "31115": true,
      "31116": true,
      "31120": true,
      "31122": true,
      "31123": true,
      "31124": true,
      "31125": true,
      "31126": true,
      "31127": true,
      "31130": true,
      "31134": true,
      "31135": true,
      "31136": true,
      "31137": true,
      "31140": true,
      "31143": true,
      "31144": true,
      "31146": true,
      "31150": true,
      "31153": true,
      "31160": true,
      "31170": true,
      "31180": true,
      "31183": true,
      "31184": true,
      "31186": true,
      "31200": true,
      "31203": true,
      "31204": true,
      "31205": true,
      "31206": true,
      "31207": true,
      "31208": true,
      "31210": true,
      "31213": true,
      "31214": true,
      "31215": true,
      "31216": true,
      "31217": true,
      "31220": true,
      "31223": true,
      "31300": true,
      "31304": true,
      "31310": true,
      "31313": true,
      "31314": true,
      "31350": true,
      "31370": true,
      "31375": true,
      "31376": true,
      "31380": true,
      "31384": true,
      "31385": true,
      "31390": true,
      "31410": true,
      "31414": true,
      "31415": true,
      "31416": true,
      "31450": true,
      "31453": true,
      "31455": true,
      "31456": true,
      "31460": true,
      "31470": true
    },
    "CUAUHTÉMOC": {
      "31500": true,
      "31510": true,
      "31512": true,
      "31513": true,
      "31515": true,
      "31516": true,
      "31517": true,
      "31520": true,
      "31522": true,
      "31523": true,
      "31524": true,
      "31526": true,
      "31527": true,
      "31528": true,
      "31529": true,
      "31530": true,
      "31532": true,
      "31533": true,
      "31540": true,
      "31542": true,
      "31543": true,
      "31544": true,
      "31550": true,
      "31552": true,
      "31555": true,
      "31560": true,
      "31570": true,
      "31572": true,
      "31573": true,
      "31579": true,
      "31580": true,
      "31590": true,
      "31600": true,
      "31604": true,
      "31605": true,
      "31606": true,
      "31607": true,
      "31608": true,
      "31609": true,
      "31610": true,
      "31611": true,
      "31612": true,
      "31613": true,
      "31614": true,
      "31615": true
    },
    "AQUILES SERDÁN": {
      "31650": true,
      "31652": true,
      "31653": true,
      "31657": true
    },
    "BACHÍNIVA": {
      "31660": true,
      "31663": true,
      "31665": true,
      "31667": true,
      "31670": true,
      "31671": true,
      "31672": true,
      "31673": true,
      "31674": true,
      "31675": true,
      "31676": true
    },
    "GUERRERO": {
      "31680": true,
      "31681": true,
      "31683": true,
      "31684": true,
      "31685": true,
      "31686": true,
      "31687": true,
      "31688": true,
      "31689": true,
      "31690": true,
      "31691": true,
      "31693": true,
      "31694": true,
      "31695": true,
      "31696": true,
      "31697": true,
      "31698": true,
      "31699": true
    },
    "NUEVO CASAS GRANDES": {
      "31700": true,
      "31704": true,
      "31710": true,
      "31719": true,
      "31720": true,
      "31730": true,
      "31735": true,
      "31750": true,
      "31755": true,
      "31758": true,
      "31760": true,
      "31770": true,
      "31777": true,
      "31778": true,
      "31780": true,
      "31783": true,
      "31789": true,
      "31803": true,
      "31806": true,
      "31807": true,
      "31810": true
    },
    "ASCENSIÓN": {
      "31820": true,
      "31821": true,
      "31822": true,
      "31823": true,
      "31825": true,
      "31828": true,
      "31829": true,
      "31830": true,
      "31831": true,
      "31832": true,
      "31837": true
    },
    "JANOS": {
      "31840": true,
      "31842": true,
      "31843": true,
      "31844": true,
      "31845": true,
      "31846": true,
      "31847": true,
      "31848": true,
      "31849": true
    },
    "CASAS GRANDES": {
      "31850": true,
      "31851": true,
      "31854": true,
      "31855": true,
      "31856": true,
      "31857": true,
      "31858": true,
      "31859": true,
      "31860": true,
      "31861": true,
      "31862": true,
      "31863": true
    },
    "GALEANA": {
      "31870": true,
      "31874": true
    },
    "BUENAVENTURA": {
      "31880": true,
      "31881": true,
      "31883": true,
      "31884": true,
      "31885": true,
      "31886": true,
      "31890": true,
      "31891": true,
      "31894": true,
      "31896": true,
      "31897": true,
      "31898": true,
      "31899": true
    },
    "GÓMEZ FARÍAS": {
      "31900": true,
      "31901": true,
      "31902": true,
      "31908": true,
      "31910": true,
      "31911": true,
      "31915": true
    },
    "MADERA": {
      "31940": true,
      "31942": true,
      "31943": true,
      "31944": true,
      "31945": true,
      "31950": true,
      "31953": true,
      "31954": true,
      "31955": true,
      "31956": true,
      "31957": true,
      "31958": true,
      "31959": true
    },
    "TEMÓSACHIC": {
      "31980": true,
      "31983": true,
      "31984": true,
      "31985": true,
      "31986": true,
      "31987": true
    },
    "MATACHÍ": {
      "31990": true,
      "31991": true,
      "31992": true,
      "31994": true,
      "31995": true,
      "31996": true,
      "31997": true
    },
    "JUAREZ": {
      "32000": true,
      "32010": true,
      "32020": true,
      "32030": true,
      "32040": true,
      "32050": true,
      "32060": true,
      "32070": true,
      "32080": true,
      "32090": true,
      "32100": true,
      "32107": true,
      "32108": true,
      "32109": true,
      "32110": true,
      "32120": true,
      "32127": true,
      "32130": true,
      "32140": true,
      "32150": true,
      "32153": true,
      "32159": true,
      "32160": true,
      "32170": true,
      "32177": true,
      "32178": true,
      "32180": true,
      "32190": true,
      "32200": true,
      "32210": true,
      "32215": true,
      "32290": true,
      "32295": true,
      "32299": true,
      "32330": true,
      "32540": true,
      "32544": true,
      "32546": true,
      "32550": true,
      "32553": true,
      "32557": true,
      "32560": true,
      "32563": true,
      "32565": true,
      "32573": true,
      "32574": true,
      "32575": true,
      "32579": true,
      "32580": true,
      "32583": true,
      "32584": true,
      "32585": true,
      "32586": true,
      "32587": true,
      "32590": true,
      "32594": true,
      "32598": true,
      "32599": true,
      "32600": true,
      "32605": true,
      "32606": true,
      "32607": true,
      "32609": true,
      "32616": true,
      "32617": true,
      "32618": true,
      "32620": true,
      "32625": true,
      "32628": true,
      "32629": true,
      "32630": true,
      "32640": true,
      "32647": true,
      "32648": true,
      "32649": true,
      "32650": true,
      "32651": true,
      "32652": true,
      "32653": true,
      "32654": true,
      "32658": true,
      "32659": true,
      "32660": true,
      "32662": true,
      "32663": true,
      "32664": true,
      "32665": true,
      "32667": true,
      "32668": true,
      "32670": true,
      "32677": true,
      "32679": true,
      "32680": true,
      "32685": true,
      "32688": true,
      "32690": true,
      "32692": true,
      "32693": true,
      "32694": true,
      "32695": true,
      "32696": true,
      "32697": true,
      "32698": true,
      "32699": true
    },
    "PRAXEDIS G. GUERRERO": {
      "32780": true,
      "32783": true,
      "32785": true,
      "32789": true,
      "32790": true,
      "32793": true,
      "32794": true,
      "32797": true
    },
    "AHUMADA": {
      "32800": true,
      "32812": true,
      "32813": true,
      "32814": true,
      "32815": true,
      "32816": true,
      "32818": true,
      "32820": true,
      "32823": true,
      "32830": true,
      "32832": true,
      "32833": true,
      "32840": true,
      "32845": true,
      "32847": true
    },
    "OJINAGA": {
      "32880": true,
      "32882": true,
      "32883": true,
      "32884": true,
      "32885": true,
      "32886": true,
      "32887": true,
      "32888": true,
      "32889": true,
      "32890": true,
      "32891": true,
      "32893": true,
      "32894": true,
      "32895": true,
      "32896": true,
      "32897": true
    },
    "ALDAMA": {
      "32900": true,
      "32902": true,
      "32903": true,
      "32907": true,
      "32910": true,
      "32912": true,
      "32913": true,
      "32914": true,
      "32917": true,
      "32918": true,
      "32920": true,
      "32925": true,
      "32930": true,
      "32932": true,
      "32933": true,
      "32934": true,
      "32939": true,
      "32940": true,
      "32944": true,
      "32945": true,
      "32947": true,
      "32948": true,
      "32949": true
    },
    "DELICIAS": {
      "33000": true,
      "33010": true,
      "33013": true,
      "33014": true,
      "33016": true,
      "33017": true,
      "33018": true,
      "33019": true,
      "33020": true,
      "33023": true,
      "33029": true,
      "33030": true,
      "33038": true,
      "33039": true,
      "33040": true,
      "33050": true,
      "33058": true,
      "33059": true,
      "33060": true,
      "33063": true,
      "33065": true,
      "33066": true,
      "33067": true,
      "33068": true,
      "33069": true,
      "33070": true,
      "33076": true,
      "33077": true,
      "33078": true,
      "33080": true,
      "33084": true,
      "33085": true,
      "33086": true,
      "33087": true,
      "33088": true,
      "33089": true,
      "33090": true,
      "33093": true,
      "33100": true,
      "33103": true,
      "33104": true,
      "33105": true,
      "33106": true,
      "33107": true,
      "33108": true,
      "33110": true,
      "33113": true,
      "33114": true,
      "33115": true,
      "33116": true,
      "33117": true
    },
    "MEOQUI": {
      "33130": true,
      "33131": true,
      "33132": true,
      "33133": true,
      "33135": true,
      "33136": true,
      "33137": true,
      "33138": true,
      "33139": true
    },
    "GUACHOCHI": {
      "33180": true,
      "33183": true,
      "33184": true,
      "33185": true,
      "33186": true,
      "33187": true,
      "33188": true,
      "33190": true,
      "33193": true,
      "33194": true,
      "33195": true,
      "33196": true,
      "33197": true,
      "33198": true
    },
    "SANTA ISABEL": {
      "33270": true,
      "33273": true,
      "33274": true,
      "33275": true,
      "33276": true,
      "33277": true
    },
    "CAMARGO": {
      "33600": true,
      "33601": true,
      "33604": true,
      "33605": true,
      "33610": true,
      "33618": true,
      "33700": true,
      "33710": true,
      "33720": true,
      "33730": true,
      "33737": true,
      "33739": true,
      "33740": true,
      "33748": true,
      "33749": true,
      "33750": true,
      "33759": true,
      "33760": true,
      "33765": true,
      "33768": true,
      "33769": true,
      "33770": true,
      "33777": true,
      "33778": true,
      "33779": true
    },
    "SAUCILLO": {
      "33620": true,
      "33623": true,
      "33624": true,
      "33625": true,
      "33626": true,
      "33627": true,
      "33630": true,
      "33633": true,
      "33634": true,
      "33635": true,
      "33636": true,
      "33637": true,
      "33640": true,
      "33643": true,
      "33644": true,
      "33645": true,
      "33646": true,
      "33647": true
    },
    "HIDALGO DEL PARRAL": {
      "33800": true,
      "33810": true,
      "33814": true,
      "33815": true,
      "33816": true,
      "33818": true,
      "33820": true,
      "33823": true,
      "33824": true,
      "33825": true,
      "33826": true,
      "33827": true,
      "33830": true,
      "33834": true,
      "33839": true,
      "33840": true,
      "33846": true,
      "33848": true,
      "33850": true,
      "33856": true,
      "33857": true,
      "33858": true,
      "33860": true,
      "33863": true,
      "33870": true,
      "33873": true,
      "33879": true,
      "33880": true,
      "33884": true,
      "33885": true,
      "33886": true,
      "33890": true,
      "33896": true,
      "33898": true,
      "33900": true,
      "33902": true,
      "33903": true,
      "33904": true,
      "33905": true,
      "33906": true,
      "33907": true,
      "33908": true,
      "33910": true,
      "33913": true,
      "33914": true,
      "33915": true,
      "33916": true,
      "33917": true,
      "33918": true
    },
    "JIMÉNEZ": {
      "33970": true,
      "33973": true,
      "33974": true,
      "33975": true,
      "33976": true,
      "33977": true,
      "33978": true,
      "33980": true,
      "33983": true,
      "33984": true,
      "33985": true,
      "33986": true,
      "33987": true
    }
  },
  "GUANAJUATO": {
    "GUANAJUATO": {
      "36000": true,
      "36003": true,
      "36008": true,
      "36009": true,
      "36010": true,
      "36013": true,
      "36014": true,
      "36015": true,
      "36016": true,
      "36020": true,
      "36023": true,
      "36024": true,
      "36030": true,
      "36033": true,
      "36040": true,
      "36043": true,
      "36044": true,
      "36050": true,
      "36053": true,
      "36059": true,
      "36060": true,
      "36080": true,
      "36086": true,
      "36089": true,
      "36090": true,
      "36093": true,
      "36094": true,
      "36220": true,
      "36223": true,
      "36224": true,
      "36225": true,
      "36227": true,
      "36228": true,
      "36230": true,
      "36233": true,
      "36234": true,
      "36235": true,
      "36236": true,
      "36237": true,
      "36240": true,
      "36243": true,
      "36244": true,
      "36245": true,
      "36246": true,
      "36247": true,
      "36250": true,
      "36253": true,
      "36254": true,
      "36255": true,
      "36256": true,
      "36257": true,
      "36258": true,
      "36259": true,
      "36260": true,
      "36262": true,
      "36263": true,
      "36264": true,
      "36265": true,
      "36266": true,
      "36267": true,
      "36268": true
    },
    "SILAO DE LA VICTORIA": {
      "36100": true,
      "36103": true,
      "36110": true,
      "36112": true,
      "36113": true,
      "36118": true,
      "36119": true,
      "36120": true,
      "36122": true,
      "36125": true,
      "36126": true,
      "36127": true,
      "36128": true,
      "36129": true,
      "36130": true,
      "36132": true,
      "36133": true,
      "36135": true,
      "36140": true,
      "36142": true,
      "36143": true,
      "36149": true,
      "36150": true,
      "36155": true,
      "36156": true,
      "36158": true,
      "36159": true,
      "36160": true,
      "36169": true,
      "36170": true,
      "36172": true,
      "36270": true,
      "36273": true,
      "36274": true,
      "36275": true,
      "36276": true,
      "36277": true,
      "36278": true,
      "36279": true,
      "36280": true,
      "36283": true,
      "36284": true,
      "36285": true,
      "36286": true,
      "36287": true,
      "36288": true,
      "36290": true,
      "36293": true,
      "36294": true,
      "36295": true,
      "36296": true,
      "36297": true,
      "36298": true
    },
    "ROMITA": {
      "36200": true,
      "36203": true,
      "36204": true,
      "36205": true,
      "36206": true,
      "36207": true,
      "36212": true,
      "36213": true,
      "36215": true,
      "36216": true,
      "36217": true,
      "36218": true
    },
    "SAN FRANCISCO DEL RINCÓN": {
      "36300": true,
      "36310": true,
      "36312": true,
      "36313": true,
      "36314": true,
      "36315": true,
      "36320": true,
      "36322": true,
      "36330": true,
      "36333": true,
      "36340": true,
      "36342": true,
      "36350": true,
      "36352": true,
      "36353": true,
      "36354": true,
      "36360": true,
      "36361": true,
      "36364": true,
      "36365": true,
      "36369": true,
      "36370": true,
      "36372": true,
      "36373": true,
      "36379": true,
      "36380": true,
      "36390": true,
      "36394": true,
      "36440": true,
      "36441": true,
      "36442": true,
      "36443": true,
      "36444": true,
      "36445": true,
      "36446": true,
      "36447": true,
      "36449": true,
      "36450": true,
      "36452": true,
      "36453": true,
      "36454": true,
      "36455": true,
      "36456": true,
      "36457": true,
      "36458": true,
      "36459": true,
      "36460": true,
      "36462": true,
      "36463": true,
      "36464": true,
      "36465": true,
      "36466": true,
      "36467": true,
      "36468": true,
      "36469": true
    },
    "PURÍSIMA DEL RINCÓN": {
      "36400": true,
      "36403": true,
      "36404": true,
      "36405": true,
      "36406": true,
      "36407": true,
      "36410": true,
      "36413": true,
      "36414": true,
      "36415": true,
      "36416": true,
      "36417": true,
      "36418": true,
      "36420": true,
      "36423": true,
      "36424": true,
      "36425": true,
      "36426": true,
      "36427": true,
      "36430": true,
      "36433": true,
      "36434": true,
      "36435": true,
      "36436": true,
      "36437": true
    },
    "MANUEL DOBLADO": {
      "36470": true,
      "36473": true,
      "36474": true,
      "36475": true,
      "36476": true,
      "36477": true,
      "36480": true,
      "36483": true,
      "36484": true,
      "36485": true,
      "36486": true,
      "36487": true,
      "36490": true,
      "36493": true,
      "36494": true,
      "36495": true,
      "36496": true,
      "36497": true
    },
    "IRAPUATO": {
      "36500": true,
      "36501": true,
      "36510": true,
      "36511": true,
      "36512": true,
      "36513": true,
      "36514": true,
      "36515": true,
      "36520": true,
      "36524": true,
      "36525": true,
      "36526": true,
      "36530": true,
      "36540": true,
      "36541": true,
      "36542": true,
      "36544": true,
      "36545": true,
      "36546": true,
      "36547": true,
      "36550": true,
      "36554": true,
      "36555": true,
      "36556": true,
      "36557": true,
      "36558": true,
      "36559": true,
      "36560": true,
      "36566": true,
      "36567": true,
      "36568": true,
      "36570": true,
      "36576": true,
      "36577": true,
      "36578": true,
      "36580": true,
      "36583": true,
      "36584": true,
      "36585": true,
      "36586": true,
      "36587": true,
      "36588": true,
      "36589": true,
      "36590": true,
      "36591": true,
      "36593": true,
      "36595": true,
      "36597": true,
      "36599": true,
      "36600": true,
      "36610": true,
      "36611": true,
      "36612": true,
      "36613": true,
      "36614": true,
      "36615": true,
      "36620": true,
      "36624": true,
      "36625": true,
      "36626": true,
      "36630": true,
      "36631": true,
      "36633": true,
      "36640": true,
      "36643": true,
      "36644": true,
      "36645": true,
      "36646": true,
      "36648": true,
      "36649": true,
      "36650": true,
      "36659": true,
      "36660": true,
      "36666": true,
      "36667": true,
      "36668": true,
      "36669": true,
      "36670": true,
      "36673": true,
      "36680": true,
      "36683": true,
      "36687": true,
      "36690": true,
      "36691": true,
      "36698": true,
      "36699": true,
      "36800": true,
      "36803": true,
      "36804": true,
      "36805": true,
      "36806": true,
      "36807": true,
      "36810": true,
      "36813": true,
      "36814": true,
      "36815": true,
      "36816": true,
      "36817": true,
      "36818": true,
      "36820": true,
      "36821": true,
      "36822": true,
      "36823": true,
      "36824": true,
      "36825": true,
      "36826": true,
      "36827": true,
      "36830": true,
      "36833": true,
      "36834": true,
      "36835": true,
      "36836": true,
      "36837": true,
      "36840": true,
      "36843": true,
      "36844": true,
      "36845": true,
      "36846": true,
      "36847": true,
      "36849": true
    },
    "SALAMANCA": {
      "36700": true,
      "36704": true,
      "36710": true,
      "36714": true,
      "36715": true,
      "36716": true,
      "36717": true,
      "36720": true,
      "36722": true,
      "36723": true,
      "36724": true,
      "36726": true,
      "36730": true,
      "36732": true,
      "36733": true,
      "36740": true,
      "36743": true,
      "36744": true,
      "36747": true,
      "36748": true,
      "36749": true,
      "36750": true,
      "36752": true,
      "36753": true,
      "36754": true,
      "36759": true,
      "36760": true,
      "36764": true,
      "36765": true,
      "36766": true,
      "36770": true,
      "36772": true,
      "36773": true,
      "36774": true,
      "36775": true,
      "36776": true,
      "36777": true,
      "36778": true,
      "36780": true,
      "36782": true,
      "36783": true,
      "36784": true,
      "36785": true,
      "36786": true,
      "36787": true,
      "36790": true,
      "36793": true,
      "36850": true,
      "36853": true,
      "36854": true,
      "36855": true,
      "36856": true,
      "36857": true,
      "36860": true,
      "36863": true,
      "36864": true,
      "36865": true,
      "36866": true,
      "36867": true,
      "36870": true,
      "36873": true,
      "36874": true,
      "36875": true,
      "36876": true,
      "36877": true,
      "36878": true,
      "36880": true,
      "36883": true,
      "36884": true,
      "36885": true,
      "36886": true,
      "36887": true,
      "36888": true
    },
    "PUEBLO NUEVO": {
      "36890": true,
      "36893": true,
      "36894": true,
      "36895": true,
      "36896": true,
      "36897": true
    },
    "PÉNJAMO": {
      "36900": true,
      "36903": true,
      "36904": true,
      "36905": true,
      "36906": true,
      "36907": true,
      "36910": true,
      "36913": true,
      "36914": true,
      "36915": true,
      "36916": true,
      "36917": true,
      "36920": true,
      "36923": true,
      "36924": true,
      "36925": true,
      "36926": true,
      "36927": true,
      "36930": true,
      "36933": true,
      "36934": true,
      "36935": true,
      "36936": true,
      "36937": true,
      "36938": true,
      "36940": true,
      "36943": true,
      "36944": true,
      "36945": true,
      "36946": true,
      "36947": true,
      "36948": true,
      "36950": true,
      "36953": true,
      "36955": true
    },
    "CUERÁMARO": {
      "36960": true,
      "36963": true,
      "36964": true,
      "36965": true,
      "36966": true,
      "36967": true,
      "36968": true,
      "36969": true
    },
    "ABASOLO": {
      "36970": true,
      "36973": true,
      "36974": true,
      "36975": true,
      "36976": true,
      "36977": true,
      "36980": true,
      "36983": true,
      "36984": true,
      "36985": true,
      "36986": true,
      "36987": true
    },
    "HUANÍMARO": {
      "36990": true,
      "36993": true,
      "36994": true,
      "36995": true,
      "36996": true,
      "36997": true,
      "36998": true
    },
    "LEÓN": {
      "37000": true,
      "37004": true,
      "37010": true,
      "37020": true,
      "37100": true,
      "37104": true,
      "37105": true,
      "37106": true,
      "37107": true,
      "37108": true,
      "37109": true,
      "37110": true,
      "37118": true,
      "37119": true,
      "37120": true,
      "37123": true,
      "37125": true,
      "37128": true,
      "37129": true,
      "37130": true,
      "37134": true,
      "37138": true,
      "37140": true,
      "37147": true,
      "37148": true,
      "37149": true,
      "37150": true,
      "37156": true,
      "37157": true,
      "37160": true,
      "37168": true,
      "37170": true,
      "37178": true,
      "37179": true,
      "37180": true,
      "37187": true,
      "37188": true,
      "37189": true,
      "37190": true,
      "37199": true,
      "37200": true,
      "37204": true,
      "37205": true,
      "37206": true,
      "37207": true,
      "37208": true,
      "37209": true,
      "37210": true,
      "37217": true,
      "37218": true,
      "37219": true,
      "37220": true,
      "37225": true,
      "37227": true,
      "37230": true,
      "37233": true,
      "37234": true,
      "37235": true,
      "37236": true,
      "37237": true,
      "37238": true,
      "37239": true,
      "37240": true,
      "37249": true,
      "37250": true,
      "37257": true,
      "37258": true,
      "37259": true,
      "37260": true,
      "37266": true,
      "37267": true,
      "37268": true,
      "37269": true,
      "37270": true,
      "37276": true,
      "37277": true,
      "37278": true,
      "37279": true,
      "37280": true,
      "37287": true,
      "37288": true,
      "37289": true,
      "37290": true,
      "37293": true,
      "37294": true,
      "37295": true,
      "37296": true,
      "37297": true,
      "37298": true,
      "37299": true,
      "37300": true,
      "37306": true,
      "37310": true,
      "37315": true,
      "37316": true,
      "37317": true,
      "37318": true,
      "37319": true,
      "37320": true,
      "37327": true,
      "37328": true,
      "37330": true,
      "37340": true,
      "37350": true,
      "37353": true,
      "37354": true,
      "37355": true,
      "37357": true,
      "37358": true,
      "37359": true,
      "37360": true,
      "37364": true,
      "37366": true,
      "37368": true,
      "37369": true,
      "37380": true,
      "37390": true,
      "37399": true,
      "37400": true,
      "37407": true,
      "37408": true,
      "37410": true,
      "37414": true,
      "37415": true,
      "37416": true,
      "37417": true,
      "37418": true,
      "37419": true,
      "37420": true,
      "37425": true,
      "37426": true,
      "37427": true,
      "37428": true,
      "37430": true,
      "37433": true,
      "37434": true,
      "37436": true,
      "37438": true,
      "37439": true,
      "37440": true,
      "37443": true,
      "37444": true,
      "37446": true,
      "37448": true,
      "37450": true,
      "37455": true,
      "37456": true,
      "37457": true,
      "37458": true,
      "37459": true,
      "37460": true,
      "37468": true,
      "37470": true,
      "37477": true,
      "37478": true,
      "37479": true,
      "37480": true,
      "37487": true,
      "37490": true,
      "37499": true,
      "37500": true,
      "37510": true,
      "37520": true,
      "37526": true,
      "37530": true,
      "37536": true,
      "37537": true,
      "37538": true,
      "37539": true,
      "37544": true,
      "37545": true,
      "37547": true,
      "37548": true,
      "37549": true,
      "37550": true,
      "37555": true,
      "37557": true,
      "37560": true,
      "37564": true,
      "37566": true,
      "37570": true,
      "37580": true,
      "37590": true,
      "37653": true,
      "37660": true,
      "37665": true,
      "37666": true,
      "37667": true,
      "37668": true,
      "37669": true,
      "37670": true,
      "37672": true,
      "37673": true,
      "37674": true,
      "37677": true,
      "37680": true,
      "37683": true,
      "37684": true,
      "37685": true,
      "37687": true,
      "37688": true,
      "37689": true,
      "37690": true,
      "37693": true,
      "37696": true
    },
    "SAN FELIPE": {
      "37600": true,
      "37601": true,
      "37602": true,
      "37603": true,
      "37604": true,
      "37605": true,
      "37606": true,
      "37608": true,
      "37610": true,
      "37611": true,
      "37613": true,
      "37614": true,
      "37615": true,
      "37616": true,
      "37620": true,
      "37622": true,
      "37623": true,
      "37624": true,
      "37625": true,
      "37629": true
    },
    "OCAMPO": {
      "37630": true,
      "37631": true,
      "37632": true,
      "37633": true,
      "37634": true,
      "37635": true,
      "37636": true,
      "37640": true,
      "37641": true,
      "37642": true,
      "37643": true,
      "37644": true,
      "37645": true,
      "37646": true,
      "37647": true
    },
    "SAN MIGUEL DE ALLENDE": {
      "37700": true,
      "37710": true,
      "37713": true,
      "37715": true,
      "37716": true,
      "37717": true,
      "37718": true,
      "37720": true,
      "37725": true,
      "37727": true,
      "37728": true,
      "37729": true,
      "37730": true,
      "37732": true,
      "37733": true,
      "37734": true,
      "37736": true,
      "37737": true,
      "37738": true,
      "37740": true,
      "37745": true,
      "37746": true,
      "37747": true,
      "37748": true,
      "37749": true,
      "37750": true,
      "37753": true,
      "37754": true,
      "37755": true,
      "37756": true,
      "37759": true,
      "37760": true,
      "37765": true,
      "37766": true,
      "37769": true,
      "37770": true,
      "37773": true,
      "37774": true,
      "37775": true,
      "37776": true,
      "37777": true,
      "37790": true,
      "37793": true,
      "37795": true,
      "37796": true,
      "37797": true,
      "37880": true,
      "37883": true,
      "37884": true,
      "37885": true,
      "37886": true,
      "37887": true,
      "37888": true,
      "37890": true,
      "37892": true,
      "37893": true,
      "37894": true,
      "37895": true,
      "37896": true,
      "37897": true,
      "37898": true
    },
    "DOLORES HIDALGO CUNA DE LA INDEPENDENCIA NACIONAL": {
      "37800": true,
      "37802": true,
      "37803": true,
      "37804": true,
      "37805": true,
      "37806": true,
      "37807": true,
      "37808": true,
      "37810": true,
      "37812": true,
      "37813": true,
      "37814": true,
      "37815": true,
      "37816": true,
      "37817": true,
      "37819": true,
      "37820": true,
      "37821": true,
      "37823": true,
      "37824": true,
      "37825": true,
      "37826": true,
      "37828": true,
      "37829": true,
      "37830": true,
      "37832": true,
      "37834": true,
      "37838": true,
      "37840": true,
      "37842": true,
      "37843": true,
      "37844": true,
      "37846": true,
      "37848": true,
      "37849": true
    },
    "SAN DIEGO DE LA UNIÓN": {
      "37850": true,
      "37853": true,
      "37854": true,
      "37855": true,
      "37856": true,
      "37857": true,
      "37860": true,
      "37864": true,
      "37866": true,
      "37867": true,
      "37870": true,
      "37873": true,
      "37874": true,
      "37875": true,
      "37876": true,
      "37877": true
    },
    "SAN LUIS DE LA PAZ": {
      "37900": true,
      "37903": true,
      "37904": true,
      "37905": true,
      "37906": true,
      "37907": true,
      "37913": true,
      "37914": true,
      "37915": true,
      "37916": true,
      "37917": true,
      "37918": true,
      "37919": true
    },
    "VICTORIA": {
      "37920": true,
      "37923": true,
      "37927": true,
      "37928": true
    },
    "SANTA CATARINA": {
      "37950": true,
      "37957": true
    },
    "DOCTOR MORA": {
      "37960": true,
      "37963": true,
      "37964": true,
      "37965": true,
      "37966": true,
      "37967": true
    },
    "TIERRA BLANCA": {
      "37970": true,
      "37973": true,
      "37974": true,
      "37975": true,
      "37976": true
    },
    "SAN JOSÉ ITURBIDE": {
      "37980": true,
      "37983": true,
      "37984": true,
      "37985": true,
      "37986": true,
      "37987": true,
      "37988": true,
      "37990": true,
      "37991": true,
      "37993": true,
      "37994": true,
      "37995": true,
      "37996": true,
      "37997": true,
      "37998": true
    },
    "CELAYA": {
      "38000": true,
      "38010": true,
      "38013": true,
      "38014": true,
      "38015": true,
      "38016": true,
      "38017": true,
      "38018": true,
      "38019": true,
      "38020": true,
      "38022": true,
      "38024": true,
      "38027": true,
      "38028": true,
      "38030": true,
      "38033": true,
      "38034": true,
      "38035": true,
      "38036": true,
      "38037": true,
      "38039": true,
      "38040": true,
      "38046": true,
      "38047": true,
      "38048": true,
      "38050": true,
      "38057": true,
      "38060": true,
      "38063": true,
      "38065": true,
      "38067": true,
      "38068": true,
      "38070": true,
      "38078": true,
      "38079": true,
      "38080": true,
      "38083": true,
      "38085": true,
      "38086": true,
      "38088": true,
      "38089": true,
      "38090": true,
      "38094": true,
      "38095": true,
      "38096": true,
      "38097": true,
      "38098": true,
      "38099": true,
      "38100": true,
      "38104": true,
      "38105": true,
      "38106": true,
      "38110": true,
      "38113": true,
      "38114": true,
      "38115": true,
      "38116": true,
      "38117": true,
      "38119": true,
      "38120": true,
      "38123": true,
      "38124": true,
      "38125": true,
      "38126": true,
      "38127": true,
      "38130": true,
      "38133": true,
      "38134": true,
      "38135": true,
      "38136": true,
      "38137": true,
      "38140": true,
      "38143": true,
      "38144": true,
      "38145": true,
      "38146": true,
      "38147": true,
      "38150": true,
      "38152": true,
      "38153": true,
      "38154": true,
      "38155": true,
      "38156": true,
      "38157": true,
      "38158": true,
      "38159": true
    },
    "APASEO EL GRANDE": {
      "38160": true,
      "38163": true,
      "38164": true,
      "38165": true,
      "38166": true,
      "38167": true,
      "38168": true,
      "38170": true,
      "38173": true,
      "38174": true,
      "38175": true,
      "38176": true,
      "38177": true,
      "38180": true,
      "38183": true,
      "38184": true,
      "38185": true,
      "38186": true,
      "38187": true,
      "38188": true,
      "38190": true,
      "38194": true,
      "38195": true,
      "38196": true,
      "38197": true,
      "38198": true,
      "38199": true
    },
    "COMONFORT": {
      "38200": true,
      "38202": true,
      "38203": true,
      "38204": true,
      "38205": true,
      "38206": true,
      "38207": true,
      "38210": true,
      "38213": true,
      "38214": true,
      "38215": true,
      "38216": true,
      "38217": true,
      "38220": true,
      "38223": true,
      "38224": true,
      "38225": true,
      "38226": true,
      "38227": true
    },
    "SANTA CRUZ DE JUVENTINO ROSAS": {
      "38240": true,
      "38243": true,
      "38244": true,
      "38245": true,
      "38246": true,
      "38247": true,
      "38250": true,
      "38253": true,
      "38254": true,
      "38255": true,
      "38256": true,
      "38257": true
    },
    "VILLAGRÁN": {
      "38260": true,
      "38263": true,
      "38265": true,
      "38269": true,
      "38271": true,
      "38272": true,
      "38273": true,
      "38280": true,
      "38294": true
    },
    "CORTAZAR": {
      "38300": true,
      "38309": true,
      "38310": true,
      "38312": true,
      "38314": true,
      "38315": true,
      "38317": true,
      "38320": true,
      "38322": true,
      "38324": true,
      "38325": true,
      "38329": true,
      "38330": true,
      "38332": true,
      "38333": true,
      "38334": true,
      "38335": true,
      "38337": true,
      "38338": true,
      "38342": true,
      "38343": true,
      "38344": true,
      "38345": true,
      "38346": true,
      "38349": true,
      "38350": true,
      "38356": true,
      "38357": true,
      "38358": true,
      "38359": true,
      "38360": true,
      "38362": true,
      "38363": true,
      "38373": true,
      "38374": true,
      "38375": true,
      "38383": true,
      "38390": true,
      "38395": true,
      "38493": true,
      "38494": true,
      "38495": true,
      "38496": true,
      "38497": true,
      "38499": true
    },
    "VALLE DE SANTIAGO": {
      "38400": true,
      "38403": true,
      "38404": true,
      "38405": true,
      "38406": true,
      "38407": true,
      "38410": true,
      "38413": true,
      "38414": true,
      "38416": true,
      "38417": true,
      "38420": true,
      "38423": true,
      "38424": true,
      "38425": true,
      "38426": true,
      "38427": true,
      "38430": true,
      "38433": true,
      "38434": true,
      "38435": true,
      "38440": true,
      "38445": true,
      "38446": true,
      "38447": true,
      "38450": true,
      "38453": true,
      "38454": true,
      "38455": true,
      "38456": true,
      "38457": true,
      "38460": true,
      "38463": true,
      "38464": true,
      "38467": true
    },
    "JARAL DEL PROGRESO": {
      "38470": true,
      "38473": true,
      "38474": true,
      "38475": true,
      "38476": true,
      "38477": true,
      "38480": true,
      "38484": true,
      "38486": true,
      "38487": true,
      "38488": true,
      "38490": true
    },
    "APASEO EL ALTO": {
      "38500": true,
      "38503": true,
      "38504": true,
      "38505": true,
      "38506": true,
      "38507": true,
      "38510": true,
      "38513": true,
      "38514": true,
      "38515": true,
      "38516": true,
      "38517": true,
      "38520": true,
      "38523": true,
      "38524": true,
      "38525": true,
      "38526": true,
      "38527": true,
      "38530": true,
      "38533": true,
      "38534": true,
      "38535": true,
      "38536": true,
      "38537": true
    },
    "JERÉCUARO": {
      "38540": true,
      "38542": true,
      "38543": true,
      "38544": true,
      "38545": true,
      "38550": true,
      "38553": true,
      "38554": true,
      "38555": true,
      "38556": true,
      "38557": true,
      "38560": true,
      "38563": true,
      "38564": true,
      "38565": true,
      "38566": true,
      "38567": true,
      "38570": true,
      "38573": true,
      "38574": true,
      "38575": true,
      "38576": true,
      "38577": true,
      "38578": true,
      "38580": true,
      "38583": true,
      "38584": true,
      "38585": true,
      "38586": true,
      "38587": true
    },
    "CORONEO": {
      "38590": true,
      "38593": true,
      "38594": true,
      "38595": true,
      "38596": true,
      "38597": true
    },
    "ACÁMBARO": {
      "38600": true,
      "38610": true,
      "38612": true,
      "38613": true,
      "38614": true,
      "38615": true,
      "38620": true,
      "38623": true,
      "38624": true,
      "38625": true,
      "38630": true,
      "38640": true,
      "38642": true,
      "38650": true,
      "38652": true,
      "38653": true,
      "38654": true,
      "38660": true,
      "38663": true,
      "38664": true,
      "38670": true,
      "38672": true,
      "38673": true,
      "38674": true,
      "38675": true,
      "38676": true,
      "38679": true,
      "38680": true,
      "38682": true,
      "38683": true,
      "38684": true,
      "38689": true,
      "38730": true,
      "38733": true,
      "38734": true,
      "38735": true,
      "38736": true,
      "38737": true,
      "38740": true,
      "38743": true,
      "38745": true,
      "38746": true,
      "38747": true,
      "38750": true,
      "38753": true,
      "38754": true,
      "38755": true,
      "38756": true,
      "38757": true,
      "38758": true,
      "38760": true,
      "38763": true,
      "38764": true,
      "38765": true,
      "38766": true,
      "38767": true,
      "38770": true,
      "38773": true,
      "38774": true,
      "38775": true,
      "38776": true,
      "38777": true,
      "38780": true,
      "38783": true,
      "38784": true,
      "38785": true,
      "38786": true,
      "38787": true
    },
    "TARIMORO": {
      "38700": true,
      "38701": true,
      "38702": true,
      "38703": true,
      "38704": true,
      "38705": true,
      "38706": true,
      "38708": true,
      "38709": true,
      "38710": true,
      "38712": true,
      "38713": true,
      "38714": true,
      "38715": true,
      "38716": true,
      "38717": true,
      "38720": true,
      "38724": true,
      "38725": true,
      "38727": true
    },
    "TARANDACUAO": {
      "38790": true,
      "38793": true,
      "38794": true,
      "38795": true,
      "38796": true,
      "38797": true,
      "38798": true
    },
    "MOROLEÓN": {
      "38800": true,
      "38810": true,
      "38817": true,
      "38820": true,
      "38823": true,
      "38825": true,
      "38826": true,
      "38827": true,
      "38830": true,
      "38833": true,
      "38834": true,
      "38835": true,
      "38836": true,
      "38837": true,
      "38838": true,
      "38839": true,
      "38840": true,
      "38844": true,
      "38845": true,
      "38848": true,
      "38850": true,
      "38853": true,
      "38854": true,
      "38855": true,
      "38860": true,
      "38863": true,
      "38864": true,
      "38865": true,
      "38866": true,
      "38867": true,
      "38868": true,
      "38870": true,
      "38873": true,
      "38874": true,
      "38880": true,
      "38887": true,
      "38990": true,
      "38993": true,
      "38994": true,
      "38995": true,
      "38996": true,
      "38997": true
    },
    "SALVATIERRA": {
      "38900": true,
      "38903": true,
      "38904": true,
      "38905": true,
      "38906": true,
      "38909": true,
      "38910": true,
      "38911": true,
      "38912": true,
      "38913": true,
      "38914": true,
      "38915": true,
      "38919": true,
      "38920": true,
      "38921": true,
      "38927": true,
      "38930": true,
      "38931": true,
      "38932": true,
      "38933": true,
      "38938": true
    },
    "YURIRIA": {
      "38940": true,
      "38943": true,
      "38944": true,
      "38945": true,
      "38946": true,
      "38947": true,
      "38950": true,
      "38953": true,
      "38954": true,
      "38955": true,
      "38956": true,
      "38957": true,
      "38958": true,
      "38960": true,
      "38961": true,
      "38963": true,
      "38964": true,
      "38965": true,
      "38966": true,
      "38967": true
    },
    "SANTIAGO MARAVATÍO": {
      "38970": true,
      "38973": true,
      "38974": true,
      "38975": true,
      "38977": true,
      "38978": true
    },
    "URIANGATO": {
      "38980": true,
      "38982": true,
      "38983": true,
      "38984": true,
      "38985": true,
      "38986": true,
      "38987": true,
      "38988": true,
      "38989": true
    }
  },
  "HIDALGO": {
    "PACHUCA DE SOTO": {
      "42000": true,
      "42004": true,
      "42010": true,
      "42014": true,
      "42015": true,
      "42018": true,
      "42020": true,
      "42026": true,
      "42027": true,
      "42029": true,
      "42030": true,
      "42032": true,
      "42033": true,
      "42034": true,
      "42035": true,
      "42036": true,
      "42037": true,
      "42039": true,
      "42040": true,
      "42050": true,
      "42055": true,
      "42056": true,
      "42057": true,
      "42058": true,
      "42060": true,
      "42064": true,
      "42070": true,
      "42075": true,
      "42078": true,
      "42079": true,
      "42080": true,
      "42082": true,
      "42083": true,
      "42084": true,
      "42086": true,
      "42088": true,
      "42090": true,
      "42092": true,
      "42094": true,
      "42095": true,
      "42097": true,
      "42098": true,
      "42099": true,
      "42100": true,
      "42101": true,
      "42102": true,
      "42110": true,
      "42111": true,
      "42113": true,
      "42115": true,
      "42116": true,
      "42117": true,
      "42119": true
    },
    "MINERAL DEL MONTE": {
      "42130": true,
      "42133": true,
      "42134": true,
      "42135": true,
      "42136": true,
      "42137": true,
      "42138": true,
      "42139": true,
      "42140": true,
      "42143": true,
      "42144": true,
      "42145": true,
      "42146": true,
      "42149": true
    },
    "AJACUBA": {
      "42150": true,
      "42151": true,
      "42152": true,
      "42153": true,
      "42154": true,
      "42155": true,
      "42156": true,
      "42157": true
    },
    "SAN AGUSTÍN TLAXIACA": {
      "42160": true,
      "42162": true,
      "42163": true,
      "42164": true,
      "42165": true,
      "42171": true,
      "42175": true,
      "42176": true,
      "42177": true,
      "42178": true,
      "42179": true
    },
    "MINERAL DE LA REFORMA": {
      "42180": true,
      "42181": true,
      "42182": true,
      "42183": true,
      "42184": true,
      "42185": true,
      "42186": true,
      "42187": true,
      "42188": true
    },
    "ZAPOTLÁN DE JUÁREZ": {
      "42190": true,
      "42191": true,
      "42192": true,
      "42194": true,
      "42195": true,
      "42196": true,
      "42198": true
    },
    "IXMIQUILPAN": {
      "42300": true,
      "42302": true,
      "42303": true,
      "42304": true,
      "42305": true,
      "42306": true,
      "42310": true,
      "42313": true,
      "42315": true,
      "42316": true,
      "42317": true,
      "42320": true,
      "42321": true,
      "42323": true,
      "42324": true,
      "42325": true,
      "42326": true,
      "42327": true
    },
    "ZIMAPÁN": {
      "42330": true,
      "42332": true,
      "42333": true,
      "42334": true,
      "42335": true,
      "42336": true,
      "42337": true,
      "42338": true,
      "42339": true,
      "42340": true,
      "42341": true,
      "42342": true,
      "42343": true,
      "42344": true,
      "42345": true,
      "42346": true,
      "42348": true,
      "42351": true,
      "42352": true,
      "42353": true,
      "42354": true,
      "42355": true,
      "42356": true,
      "42357": true,
      "42359": true
    },
    "CARDONAL": {
      "42370": true,
      "42372": true,
      "42373": true,
      "42374": true,
      "42375": true,
      "42376": true,
      "42377": true,
      "42379": true
    },
    "TASQUILLO": {
      "42380": true,
      "42381": true,
      "42382": true,
      "42383": true,
      "42384": true,
      "42386": true,
      "42387": true,
      "42389": true
    },
    "ALFAJAYUCAN": {
      "42390": true,
      "42392": true,
      "42393": true,
      "42394": true,
      "42395": true,
      "42396": true,
      "42397": true,
      "42399": true
    },
    "HUICHAPAN": {
      "42400": true,
      "42403": true,
      "42404": true,
      "42405": true,
      "42410": true,
      "42412": true,
      "42414": true,
      "42416": true,
      "42420": true,
      "42422": true,
      "42423": true,
      "42430": true,
      "42433": true,
      "42434": true,
      "42435": true,
      "42436": true,
      "42438": true
    },
    "TECOZAUTLA": {
      "42440": true,
      "42443": true,
      "42444": true,
      "42445": true,
      "42446": true,
      "42447": true,
      "42448": true,
      "42450": true,
      "42453": true,
      "42457": true,
      "42459": true,
      "42460": true,
      "42461": true,
      "42462": true,
      "42466": true
    },
    "NOPALA DE VILLAGRÁN": {
      "42470": true,
      "42473": true,
      "42474": true,
      "42475": true,
      "42480": true,
      "42481": true,
      "42485": true,
      "42486": true,
      "42488": true,
      "42490": true,
      "42491": true,
      "42492": true,
      "42493": true,
      "42494": true,
      "42495": true
    },
    "ACTOPAN": {
      "42500": true,
      "42503": true,
      "42504": true,
      "42505": true,
      "42506": true,
      "42507": true,
      "42510": true,
      "42512": true,
      "42523": true,
      "42524": true,
      "42600": true,
      "42601": true,
      "42602": true,
      "42603": true,
      "42604": true,
      "42607": true,
      "42608": true,
      "42610": true,
      "42613": true,
      "42616": true
    },
    "SANTIAGO DE ANAYA": {
      "42620": true,
      "42621": true,
      "42622": true,
      "42623": true,
      "42624": true,
      "42625": true,
      "42626": true,
      "42627": true,
      "42629": true,
      "42630": true
    },
    "SAN SALVADOR": {
      "42640": true,
      "42642": true,
      "42643": true,
      "42644": true,
      "42645": true,
      "42646": true,
      "42647": true,
      "42650": true,
      "42651": true,
      "42653": true,
      "42654": true,
      "42655": true,
      "42656": true
    },
    "FRANCISCO I. MADERO": {
      "42660": true,
      "42663": true,
      "42664": true,
      "42665": true,
      "42666": true,
      "42667": true,
      "42670": true,
      "42671": true,
      "42672": true,
      "42673": true
    },
    "EL ARENAL": {
      "42680": true,
      "42682": true,
      "42683": true,
      "42684": true,
      "42685": true,
      "42686": true,
      "42689": true,
      "42690": true,
      "42693": true,
      "42694": true,
      "42695": true
    },
    "MIXQUIAHUALA DE JUÁREZ": {
      "42700": true,
      "42710": true,
      "42718": true,
      "42719": true,
      "42723": true,
      "42724": true,
      "42725": true,
      "42727": true,
      "42728": true,
      "42729": true
    },
    "PROGRESO DE OBREGÓN": {
      "42730": true,
      "42733": true,
      "42734": true,
      "42740": true,
      "42743": true,
      "42745": true,
      "42746": true,
      "42747": true,
      "42748": true
    },
    "TEZONTEPEC DE ALDAMA": {
      "42760": true,
      "42763": true,
      "42764": true,
      "42765": true,
      "42766": true,
      "42767": true,
      "42768": true,
      "42770": true,
      "42771": true,
      "42772": true,
      "42773": true,
      "42774": true,
      "42775": true,
      "42776": true,
      "42777": true
    },
    "TLAHUELILPAN": {
      "42780": true,
      "42783": true,
      "42784": true,
      "42785": true,
      "42789": true,
      "42790": true,
      "42793": true,
      "42794": true,
      "42795": true,
      "42796": true
    },
    "TULA DE ALLENDE": {
      "42800": true,
      "42803": true,
      "42804": true,
      "42805": true,
      "42806": true,
      "42807": true,
      "42808": true,
      "42809": true,
      "42810": true,
      "42812": true,
      "42813": true,
      "42814": true,
      "42815": true,
      "42816": true,
      "42820": true,
      "42823": true,
      "42824": true,
      "42825": true,
      "42826": true,
      "42827": true,
      "42830": true,
      "42831": true,
      "42832": true,
      "42833": true,
      "42834": true,
      "42835": true,
      "42836": true,
      "42837": true,
      "42838": true,
      "42840": true,
      "42842": true,
      "42843": true,
      "42844": true,
      "42845": true,
      "42846": true,
      "42847": true,
      "42848": true,
      "42849": true
    },
    "TEPEJI DEL RÍO DE OCAMPO": {
      "42852": true,
      "42853": true,
      "42854": true,
      "42855": true,
      "42858": true,
      "42860": true,
      "42863": true,
      "42865": true,
      "42870": true,
      "42873": true,
      "42874": true,
      "42875": true,
      "42876": true,
      "42880": true,
      "42883": true,
      "42884": true,
      "42885": true,
      "42890": true,
      "42893": true,
      "42894": true,
      "42895": true
    },
    "TEPETITLÁN": {
      "42920": true,
      "42921": true,
      "42923": true,
      "42924": true,
      "42925": true,
      "42926": true,
      "42928": true,
      "42930": true,
      "42931": true,
      "42933": true,
      "42934": true
    },
    "TETEPANGO": {
      "42940": true,
      "42943": true,
      "42944": true,
      "42945": true
    },
    "TLAXCOAPAN": {
      "42950": true,
      "42952": true,
      "42953": true,
      "42954": true,
      "42955": true,
      "42956": true,
      "42957": true,
      "42960": true,
      "42963": true,
      "42964": true,
      "42965": true,
      "42967": true
    },
    "ATITALAQUIA": {
      "42970": true,
      "42974": true,
      "42975": true,
      "42976": true,
      "42977": true,
      "42978": true,
      "42979": true
    },
    "ATOTONILCO DE TULA": {
      "42980": true,
      "42982": true,
      "42985": true,
      "42986": true,
      "42987": true,
      "42988": true,
      "42990": true,
      "42992": true,
      "42994": true,
      "42995": true
    },
    "HUEJUTLA DE REYES": {
      "43000": true,
      "43001": true,
      "43002": true,
      "43003": true,
      "43004": true,
      "43005": true,
      "43006": true,
      "43010": true,
      "43011": true,
      "43014": true,
      "43015": true,
      "43016": true,
      "43017": true,
      "43018": true,
      "43019": true
    },
    "SAN FELIPE ORIZATLÁN": {
      "43020": true,
      "43021": true,
      "43022": true,
      "43023": true,
      "43024": true,
      "43025": true,
      "43029": true,
      "43030": true,
      "43033": true,
      "43034": true,
      "43035": true,
      "43036": true,
      "43037": true,
      "43038": true,
      "43039": true
    },
    "JALTOCÁN": {
      "43040": true,
      "43041": true,
      "43042": true,
      "43043": true,
      "43044": true,
      "43045": true,
      "43046": true,
      "43047": true
    },
    "MOLANGO DE ESCAMILLA": {
      "43100": true,
      "43101": true,
      "43103": true,
      "43104": true,
      "43105": true,
      "43106": true,
      "43108": true,
      "43109": true,
      "43110": true,
      "43111": true,
      "43112": true,
      "43113": true,
      "43114": true
    },
    "LOLOTLA": {
      "43140": true
    },
    "TLANCHINOL": {
      "43150": true
    },
    "ZACUALTIPÁN DE ÁNGELES": {
      "43200": true,
      "43201": true,
      "43202": true,
      "43203": true,
      "43204": true,
      "43205": true,
      "43206": true,
      "43210": true,
      "43212": true,
      "43218": true,
      "43219": true,
      "43220": true,
      "43221": true,
      "43222": true,
      "43223": true,
      "43224": true,
      "43225": true
    },
    "ATOTONILCO EL GRANDE": {
      "43300": true,
      "43301": true,
      "43302": true,
      "43304": true,
      "43305": true,
      "43306": true,
      "43307": true,
      "43308": true,
      "43309": true,
      "43310": true,
      "43311": true,
      "43313": true,
      "43320": true,
      "43321": true,
      "43323": true,
      "43324": true,
      "43326": true,
      "43327": true,
      "43328": true,
      "43329": true
    },
    "METZTITLÁN": {
      "43350": true,
      "43353": true,
      "43354": true,
      "43355": true,
      "43356": true,
      "43357": true,
      "43358": true,
      "43359": true,
      "43362": true,
      "43364": true,
      "43370": true,
      "43373": true,
      "43374": true,
      "43375": true,
      "43379": true
    },
    "SAN AGUSTÍN METZQUITITLÁN": {
      "43380": true,
      "43381": true,
      "43382": true,
      "43383": true,
      "43385": true,
      "43387": true
    },
    "METEPEC": {
      "43400": true,
      "43401": true,
      "43403": true,
      "43404": true,
      "43406": true,
      "43407": true,
      "43408": true,
      "43409": true,
      "43410": true,
      "43411": true,
      "43412": true
    },
    "SAN BARTOLO TUTOTEPEC": {
      "43440": true,
      "43443": true,
      "43444": true,
      "43445": true,
      "43446": true,
      "43447": true,
      "43448": true,
      "43449": true,
      "43450": true,
      "43451": true,
      "43452": true,
      "43453": true,
      "43454": true,
      "43455": true,
      "43456": true,
      "43459": true
    },
    "AGUA BLANCA DE ITURBIDE": {
      "43460": true,
      "43463": true,
      "43464": true,
      "43468": true,
      "43469": true,
      "43470": true,
      "43472": true,
      "43473": true,
      "43474": true
    },
    "TENANGO DE DORIA": {
      "43480": true,
      "43483": true,
      "43484": true,
      "43485": true,
      "43486": true,
      "43487": true,
      "43488": true,
      "43490": true,
      "43491": true,
      "43493": true,
      "43494": true,
      "43495": true,
      "43496": true
    },
    "HUASCA DE OCAMPO": {
      "43502": true,
      "43503": true,
      "43505": true,
      "43508": true,
      "43510": true,
      "43514": true,
      "43515": true,
      "43516": true,
      "43517": true,
      "43523": true,
      "43525": true,
      "43527": true,
      "43530": true,
      "43538": true
    },
    "ACATLÁN": {
      "43540": true,
      "43542": true,
      "43543": true,
      "43544": true,
      "43545": true,
      "43546": true,
      "43547": true,
      "43550": true,
      "43553": true,
      "43554": true,
      "43558": true,
      "43559": true
    },
    "OMITLÁN DE JUÁREZ": {
      "43560": true,
      "43563": true,
      "43564": true,
      "43565": true,
      "43567": true,
      "43568": true,
      "43569": true,
      "43570": true,
      "43573": true,
      "43574": true,
      "43575": true,
      "43576": true
    },
    "EPAZOYUCAN": {
      "43580": true,
      "43583": true,
      "43584": true,
      "43585": true,
      "43586": true,
      "43587": true,
      "43590": true,
      "43592": true,
      "43593": true,
      "43594": true,
      "43595": true,
      "43596": true
    },
    "TULANCINGO DE BRAVO": {
      "43600": true,
      "43612": true,
      "43629": true,
      "43630": true,
      "43632": true,
      "43642": true,
      "43650": true,
      "43667": true,
      "43680": true,
      "43699": true,
      "43703": true,
      "43704": true,
      "43705": true,
      "43707": true,
      "43710": true,
      "43713": true,
      "43715": true
    },
    "ACAXOCHITLÁN": {
      "43720": true,
      "43721": true,
      "43723": true,
      "43724": true,
      "43725": true,
      "43726": true,
      "43727": true,
      "43728": true,
      "43730": true,
      "43733": true,
      "43734": true,
      "43735": true,
      "43736": true,
      "43739": true
    },
    "CUAUTEPEC DE HINOJOSA": {
      "43740": true,
      "43745": true,
      "43746": true,
      "43747": true,
      "43748": true,
      "43749": true,
      "43750": true,
      "43753": true,
      "43754": true,
      "43759": true,
      "43760": true
    },
    "SANTIAGO TULANTEPEC DE LUGO GUERRERO": {
      "43767": true,
      "43770": true,
      "43773": true,
      "43774": true,
      "43775": true
    },
    "SINGUILUCAN": {
      "43780": true,
      "43782": true,
      "43783": true,
      "43784": true,
      "43785": true,
      "43786": true,
      "43787": true,
      "43788": true,
      "43790": true,
      "43793": true,
      "43794": true,
      "43795": true,
      "43797": true
    },
    "TIZAYUCA": {
      "43800": true,
      "43803": true,
      "43806": true,
      "43810": true,
      "43815": true,
      "43816": true
    },
    "ZEMPOALA": {
      "43834": true,
      "43835": true,
      "43837": true,
      "43838": true,
      "43840": true,
      "43845": true,
      "43848": true
    },
    "TOLCAYUCA": {
      "43860": true,
      "43862": true,
      "43863": true,
      "43864": true,
      "43865": true,
      "43866": true,
      "43870": true,
      "43873": true,
      "43874": true,
      "43875": true,
      "43876": true
    },
    "VILLA DE TEZONTEPEC": {
      "43880": true,
      "43882": true,
      "43883": true,
      "43884": true,
      "43885": true,
      "43890": true,
      "43893": true,
      "43894": true,
      "43895": true,
      "43896": true,
      "43897": true
    },
    "APAN": {
      "43900": true,
      "43902": true,
      "43903": true,
      "43904": true,
      "43905": true,
      "43906": true,
      "43907": true,
      "43908": true,
      "43909": true,
      "43915": true,
      "43916": true,
      "43917": true,
      "43918": true,
      "43919": true,
      "43920": true,
      "43921": true,
      "43922": true,
      "43923": true,
      "43924": true
    },
    "TLANALAPA": {
      "43930": true,
      "43933": true,
      "43934": true,
      "43935": true,
      "43937": true
    },
    "ALMOLOYA": {
      "43940": true,
      "43943": true,
      "43944": true,
      "43945": true,
      "43946": true,
      "43947": true,
      "43948": true,
      "43949": true,
      "43950": true,
      "43953": true,
      "43954": true,
      "43955": true,
      "43956": true
    },
    "EMILIANO ZAPATA": {
      "43960": true,
      "43961": true,
      "43963": true,
      "43964": true,
      "43965": true,
      "43966": true,
      "43968": true
    },
    "TEPEAPULCO": {
      "43970": true,
      "43973": true,
      "43974": true,
      "43975": true,
      "43976": true,
      "43977": true,
      "43980": true,
      "43983": true,
      "43984": true,
      "43985": true,
      "43986": true,
      "43987": true,
      "43988": true,
      "43990": true,
      "43991": true,
      "43993": true,
      "43994": true,
      "43995": true,
      "43996": true,
      "43997": true,
      "43998": true
    }
  },
  "JALISCO": {
    "GUADALAJARA": {
      "44100": true,
      "44101": true,
      "44104": true,
      "44105": true,
      "44106": true,
      "44107": true,
      "44108": true,
      "44109": true,
      "44110": true,
      "44111": true,
      "44116": true,
      "44118": true,
      "44119": true,
      "44120": true,
      "44125": true,
      "44126": true,
      "44128": true,
      "44129": true,
      "44130": true,
      "44132": true,
      "44133": true,
      "44135": true,
      "44136": true,
      "44138": true,
      "44140": true,
      "44142": true,
      "44144": true,
      "44145": true,
      "44146": true,
      "44149": true,
      "44150": true,
      "44151": true,
      "44156": true,
      "44158": true,
      "44159": true,
      "44160": true,
      "44161": true,
      "44162": true,
      "44164": true,
      "44165": true,
      "44166": true,
      "44169": true,
      "44170": true,
      "44171": true,
      "44176": true,
      "44179": true,
      "44180": true,
      "44181": true,
      "44185": true,
      "44188": true,
      "44189": true,
      "44190": true,
      "44191": true,
      "44192": true,
      "44195": true,
      "44196": true,
      "44198": true,
      "44199": true,
      "44200": true,
      "44205": true,
      "44208": true,
      "44210": true,
      "44214": true,
      "44215": true,
      "44216": true,
      "44217": true,
      "44218": true,
      "44219": true,
      "44220": true,
      "44221": true,
      "44226": true,
      "44227": true,
      "44228": true,
      "44229": true,
      "44230": true,
      "44233": true,
      "44235": true,
      "44236": true,
      "44238": true,
      "44239": true,
      "44240": true,
      "44241": true,
      "44246": true,
      "44247": true,
      "44248": true,
      "44249": true,
      "44250": true,
      "44257": true,
      "44258": true,
      "44259": true,
      "44260": true,
      "44261": true,
      "44265": true,
      "44266": true,
      "44267": true,
      "44268": true,
      "44269": true,
      "44270": true,
      "44271": true,
      "44275": true,
      "44277": true,
      "44278": true,
      "44280": true,
      "44281": true,
      "44282": true,
      "44286": true,
      "44288": true,
      "44289": true,
      "44290": true,
      "44291": true,
      "44292": true,
      "44293": true,
      "44296": true,
      "44297": true,
      "44298": true,
      "44299": true,
      "44300": true,
      "44301": true,
      "44304": true,
      "44306": true,
      "44307": true,
      "44308": true,
      "44309": true,
      "44310": true,
      "44319": true,
      "44320": true,
      "44329": true,
      "44330": true,
      "44332": true,
      "44334": true,
      "44339": true,
      "44340": true,
      "44344": true,
      "44348": true,
      "44349": true,
      "44350": true,
      "44359": true,
      "44360": true,
      "44362": true,
      "44363": true,
      "44366": true,
      "44367": true,
      "44368": true,
      "44369": true,
      "44370": true,
      "44377": true,
      "44379": true,
      "44380": true,
      "44381": true,
      "44382": true,
      "44386": true,
      "44390": true,
      "44394": true,
      "44395": true,
      "44396": true,
      "44398": true,
      "44399": true,
      "44400": true,
      "44404": true,
      "44405": true,
      "44408": true,
      "44409": true,
      "44410": true,
      "44415": true,
      "44416": true,
      "44418": true,
      "44419": true,
      "44420": true,
      "44421": true,
      "44429": true,
      "44430": true,
      "44432": true,
      "44434": true,
      "44436": true,
      "44437": true,
      "44438": true,
      "44439": true,
      "44440": true,
      "44444": true,
      "44446": true,
      "44447": true,
      "44449": true,
      "44450": true,
      "44455": true,
      "44459": true,
      "44460": true,
      "44462": true,
      "44466": true,
      "44467": true,
      "44468": true,
      "44469": true,
      "44470": true,
      "44471": true,
      "44473": true,
      "44478": true,
      "44480": true,
      "44483": true,
      "44487": true,
      "44489": true,
      "44490": true,
      "44491": true,
      "44492": true,
      "44493": true,
      "44496": true,
      "44497": true,
      "44499": true,
      "44500": true,
      "44501": true,
      "44503": true,
      "44504": true,
      "44505": true,
      "44506": true,
      "44508": true,
      "44509": true,
      "44510": true,
      "44514": true,
      "44517": true,
      "44519": true,
      "44520": true,
      "44522": true,
      "44523": true,
      "44524": true,
      "44525": true,
      "44528": true,
      "44529": true,
      "44530": true,
      "44531": true,
      "44532": true,
      "44533": true,
      "44534": true,
      "44535": true,
      "44536": true,
      "44537": true,
      "44538": true,
      "44539": true,
      "44540": true,
      "44541": true,
      "44543": true,
      "44546": true,
      "44548": true,
      "44549": true,
      "44550": true,
      "44552": true,
      "44555": true,
      "44556": true,
      "44557": true,
      "44558": true,
      "44559": true,
      "44560": true,
      "44563": true,
      "44565": true,
      "44566": true,
      "44567": true,
      "44569": true,
      "44570": true,
      "44575": true,
      "44580": true,
      "44588": true,
      "44589": true,
      "44590": true,
      "44597": true,
      "44599": true,
      "44600": true,
      "44601": true,
      "44602": true,
      "44603": true,
      "44605": true,
      "44606": true,
      "44607": true,
      "44608": true,
      "44609": true,
      "44610": true,
      "44611": true,
      "44612": true,
      "44615": true,
      "44616": true,
      "44619": true,
      "44620": true,
      "44622": true,
      "44626": true,
      "44629": true,
      "44630": true,
      "44631": true,
      "44632": true,
      "44633": true,
      "44634": true,
      "44635": true,
      "44636": true,
      "44637": true,
      "44638": true,
      "44639": true,
      "44640": true,
      "44642": true,
      "44643": true,
      "44645": true,
      "44646": true,
      "44647": true,
      "44648": true,
      "44649": true,
      "44650": true,
      "44651": true,
      "44652": true,
      "44654": true,
      "44655": true,
      "44656": true,
      "44657": true,
      "44658": true,
      "44659": true,
      "44660": true,
      "44662": true,
      "44663": true,
      "44664": true,
      "44665": true,
      "44666": true,
      "44667": true,
      "44668": true,
      "44669": true,
      "44670": true,
      "44673": true,
      "44675": true,
      "44676": true,
      "44678": true,
      "44679": true,
      "44680": true,
      "44681": true,
      "44683": true,
      "44684": true,
      "44685": true,
      "44686": true,
      "44687": true,
      "44688": true,
      "44689": true,
      "44690": true,
      "44691": true,
      "44692": true,
      "44695": true,
      "44696": true,
      "44697": true,
      "44698": true,
      "44699": true,
      "44700": true,
      "44701": true,
      "44705": true,
      "44706": true,
      "44709": true,
      "44710": true,
      "44713": true,
      "44714": true,
      "44715": true,
      "44716": true,
      "44717": true,
      "44718": true,
      "44719": true,
      "44720": true,
      "44721": true,
      "44723": true,
      "44724": true,
      "44725": true,
      "44726": true,
      "44727": true,
      "44728": true,
      "44729": true,
      "44730": true,
      "44731": true,
      "44735": true,
      "44736": true,
      "44737": true,
      "44739": true,
      "44740": true,
      "44742": true,
      "44748": true,
      "44749": true,
      "44750": true,
      "44755": true,
      "44756": true,
      "44757": true,
      "44758": true,
      "44760": true,
      "44761": true,
      "44763": true,
      "44765": true,
      "44766": true,
      "44767": true,
      "44768": true,
      "44769": true,
      "44770": true,
      "44776": true,
      "44777": true,
      "44780": true,
      "44789": true,
      "44790": true,
      "44799": true,
      "44800": true,
      "44801": true,
      "44807": true,
      "44808": true,
      "44809": true,
      "44810": true,
      "44814": true,
      "44815": true,
      "44816": true,
      "44817": true,
      "44818": true,
      "44819": true,
      "44820": true,
      "44821": true,
      "44824": true,
      "44825": true,
      "44826": true,
      "44827": true,
      "44828": true,
      "44829": true,
      "44830": true,
      "44837": true,
      "44840": true,
      "44844": true,
      "44848": true,
      "44849": true,
      "44850": true,
      "44860": true,
      "44869": true,
      "44870": true,
      "44876": true,
      "44878": true,
      "44879": true,
      "44880": true,
      "44885": true,
      "44890": true,
      "44891": true,
      "44893": true,
      "44895": true,
      "44896": true,
      "44897": true,
      "44898": true,
      "44899": true,
      "44900": true,
      "44901": true,
      "44902": true,
      "44904": true,
      "44906": true,
      "44907": true,
      "44908": true,
      "44909": true,
      "44910": true,
      "44911": true,
      "44915": true,
      "44918": true,
      "44919": true,
      "44920": true,
      "44921": true,
      "44926": true,
      "44929": true,
      "44930": true,
      "44940": true,
      "44941": true,
      "44943": true,
      "44944": true,
      "44945": true,
      "44946": true,
      "44947": true,
      "44948": true,
      "44949": true,
      "44950": true,
      "44954": true,
      "44955": true,
      "44956": true,
      "44957": true,
      "44958": true,
      "44959": true,
      "44960": true,
      "44964": true,
      "44965": true,
      "44966": true,
      "44967": true,
      "44968": true,
      "44969": true,
      "44970": true,
      "44971": true,
      "44974": true,
      "44977": true,
      "44978": true,
      "44979": true,
      "44980": true,
      "44981": true,
      "44982": true,
      "44983": true,
      "44984": true,
      "44985": true,
      "44986": true,
      "44987": true,
      "44988": true,
      "44989": true,
      "44990": true,
      "45000": true
    },
    "ZAPOPAN": {
      "45010": true,
      "45011": true,
      "45012": true,
      "45013": true,
      "45014": true,
      "45015": true,
      "45016": true,
      "45017": true,
      "45018": true,
      "45019": true,
      "45020": true,
      "45021": true,
      "45022": true,
      "45024": true,
      "45025": true,
      "45026": true,
      "45027": true,
      "45028": true,
      "45029": true,
      "45030": true,
      "45031": true,
      "45032": true,
      "45033": true,
      "45034": true,
      "45035": true,
      "45036": true,
      "45037": true,
      "45038": true,
      "45039": true,
      "45040": true,
      "45041": true,
      "45042": true,
      "45043": true,
      "45044": true,
      "45045": true,
      "45046": true,
      "45047": true,
      "45048": true,
      "45049": true,
      "45050": true,
      "45051": true,
      "45052": true,
      "45053": true,
      "45054": true,
      "45055": true,
      "45056": true,
      "45057": true,
      "45058": true,
      "45059": true,
      "45060": true,
      "45061": true,
      "45062": true,
      "45063": true,
      "45064": true,
      "45065": true,
      "45066": true,
      "45067": true,
      "45068": true,
      "45069": true,
      "45070": true,
      "45071": true,
      "45072": true,
      "45074": true,
      "45075": true,
      "45076": true,
      "45077": true,
      "45078": true,
      "45079": true,
      "45080": true,
      "45081": true,
      "45082": true,
      "45083": true,
      "45084": true,
      "45085": true,
      "45086": true,
      "45087": true,
      "45088": true,
      "45089": true,
      "45090": true,
      "45091": true,
      "45093": true,
      "45094": true,
      "45095": true,
      "45098": true,
      "45099": true,
      "45100": true,
      "45101": true,
      "45103": true,
      "45104": true,
      "45105": true,
      "45106": true,
      "45107": true,
      "45108": true,
      "45109": true,
      "45110": true,
      "45111": true,
      "45113": true,
      "45115": true,
      "45116": true,
      "45117": true,
      "45118": true,
      "45119": true,
      "45120": true,
      "45121": true,
      "45123": true,
      "45124": true,
      "45125": true,
      "45126": true,
      "45127": true,
      "45128": true,
      "45129": true,
      "45130": true,
      "45131": true,
      "45132": true,
      "45133": true,
      "45134": true,
      "45135": true,
      "45136": true,
      "45137": true,
      "45138": true,
      "45139": true,
      "45140": true,
      "45141": true,
      "45145": true,
      "45146": true,
      "45147": true,
      "45148": true,
      "45149": true,
      "45150": true,
      "45151": true,
      "45152": true,
      "45154": true,
      "45155": true,
      "45156": true,
      "45157": true,
      "45158": true,
      "45159": true,
      "45160": true,
      "45161": true,
      "45162": true,
      "45163": true,
      "45165": true,
      "45166": true,
      "45167": true,
      "45168": true,
      "45169": true,
      "45170": true,
      "45171": true,
      "45173": true,
      "45176": true,
      "45177": true,
      "45178": true,
      "45179": true,
      "45180": true,
      "45181": true,
      "45182": true,
      "45183": true,
      "45184": true,
      "45185": true,
      "45186": true,
      "45187": true,
      "45188": true,
      "45189": true,
      "45190": true,
      "45191": true,
      "45192": true,
      "45194": true,
      "45195": true,
      "45196": true,
      "45197": true,
      "45198": true,
      "45199": true,
      "45200": true,
      "45201": true,
      "45202": true,
      "45203": true,
      "45204": true,
      "45205": true,
      "45206": true,
      "45207": true,
      "45208": true,
      "45209": true,
      "45210": true,
      "45211": true,
      "45212": true,
      "45213": true,
      "45215": true,
      "45216": true,
      "45217": true,
      "45218": true,
      "45219": true,
      "45220": true,
      "45221": true,
      "45222": true,
      "45225": true,
      "45226": true,
      "45227": true,
      "45229": true,
      "45230": true,
      "45231": true,
      "45232": true,
      "45233": true,
      "45234": true,
      "45235": true,
      "45236": true,
      "45237": true,
      "45238": true,
      "45239": true,
      "45242": true,
      "45245": true
    },
    "SAN CRISTÓBAL DE LA BARRANCA": {
      "45250": true,
      "45255": true,
      "45256": true,
      "45257": true,
      "45259": true
    },
    "IXTLAHUACÁN DEL RÍO": {
      "45260": true,
      "45265": true,
      "45269": true,
      "45270": true,
      "45271": true,
      "45274": true,
      "45275": true,
      "45276": true,
      "45277": true,
      "45279": true,
      "45280": true,
      "45281": true,
      "45283": true,
      "45284": true,
      "45285": true,
      "45286": true,
      "45287": true,
      "45290": true,
      "45291": true,
      "45298": true,
      "45299": true
    },
    "TALA": {
      "45300": true,
      "45301": true,
      "45302": true,
      "45303": true,
      "45305": true,
      "45306": true,
      "45307": true,
      "45308": true,
      "45309": true,
      "45310": true,
      "45313": true,
      "45314": true,
      "45315": true,
      "45319": true,
      "45320": true,
      "45321": true,
      "45325": true,
      "45326": true,
      "45327": true,
      "45328": true,
      "45329": true,
      "45330": true,
      "45331": true,
      "45335": true,
      "45340": true,
      "45341": true,
      "45345": true,
      "45346": true,
      "45347": true,
      "45348": true,
      "45349": true
    },
    "EL ARENAL": {
      "45350": true,
      "45353": true,
      "45355": true,
      "45359": true,
      "45360": true,
      "45364": true,
      "45368": true
    },
    "AMATITÁN": {
      "45380": true,
      "45390": true,
      "45395": true,
      "45398": true,
      "45399": true
    },
    "TONALÁ": {
      "45400": true,
      "45401": true,
      "45402": true,
      "45403": true,
      "45404": true,
      "45405": true,
      "45406": true,
      "45407": true,
      "45408": true,
      "45409": true,
      "45410": true,
      "45411": true,
      "45412": true,
      "45413": true,
      "45414": true,
      "45415": true,
      "45416": true,
      "45417": true,
      "45418": true,
      "45419": true,
      "45420": true,
      "45421": true,
      "45422": true,
      "45424": true,
      "45425": true,
      "45426": true,
      "45427": true,
      "45428": true,
      "45429": true
    },
    "ZAPOTLANEJO": {
      "45430": true,
      "45432": true,
      "45433": true,
      "45434": true,
      "45435": true,
      "45436": true,
      "45437": true,
      "45438": true,
      "45439": true,
      "45440": true,
      "45442": true,
      "45443": true,
      "45444": true,
      "45445": true,
      "45446": true,
      "45447": true,
      "45448": true,
      "45449": true,
      "45450": true,
      "45452": true,
      "45453": true,
      "45454": true,
      "45455": true,
      "45460": true,
      "45462": true,
      "45463": true,
      "45464": true,
      "45465": true,
      "45466": true
    },
    "ACATIC": {
      "45470": true,
      "45473": true,
      "45474": true,
      "45475": true,
      "45476": true,
      "45477": true,
      "45478": true,
      "45479": true
    },
    "CUQUÍO": {
      "45480": true,
      "45482": true,
      "45483": true,
      "45484": true,
      "45485": true,
      "45486": true,
      "45487": true,
      "45488": true,
      "45490": true,
      "45492": true,
      "45493": true,
      "45494": true,
      "45495": true,
      "45496": true
    },
    "SAN PEDRO TLAQUEPAQUE": {
      "45500": true,
      "45501": true,
      "45502": true,
      "45503": true,
      "45505": true,
      "45506": true,
      "45509": true,
      "45510": true,
      "45515": true,
      "45516": true,
      "45519": true,
      "45520": true,
      "45521": true,
      "45525": true,
      "45526": true,
      "45527": true,
      "45528": true,
      "45529": true,
      "45530": true,
      "45531": true,
      "45532": true,
      "45534": true,
      "45535": true,
      "45536": true,
      "45540": true,
      "45542": true,
      "45543": true,
      "45544": true,
      "45545": true,
      "45550": true,
      "45555": true,
      "45556": true,
      "45559": true,
      "45560": true,
      "45561": true,
      "45567": true,
      "45568": true,
      "45569": true,
      "45570": true,
      "45578": true,
      "45579": true,
      "45580": true,
      "45581": true,
      "45582": true,
      "45583": true,
      "45584": true,
      "45585": true,
      "45588": true,
      "45589": true,
      "45590": true,
      "45591": true,
      "45592": true,
      "45593": true,
      "45594": true,
      "45595": true,
      "45596": true,
      "45597": true,
      "45598": true,
      "45599": true,
      "45600": true,
      "45601": true,
      "45602": true,
      "45603": true,
      "45604": true,
      "45605": true,
      "45606": true,
      "45607": true,
      "45608": true,
      "45609": true,
      "45610": true,
      "45611": true,
      "45613": true,
      "45615": true,
      "45616": true,
      "45618": true,
      "45619": true,
      "45620": true,
      "45622": true,
      "45623": true,
      "45624": true,
      "45625": true,
      "45626": true,
      "45627": true,
      "45628": true,
      "45629": true,
      "45630": true,
      "45634": true,
      "45635": true,
      "45637": true,
      "45638": true
    },
    "TLAJOMULCO DE ZÚÑIGA": {
      "45640": true,
      "45641": true,
      "45643": true,
      "45644": true,
      "45645": true,
      "45646": true,
      "45647": true,
      "45649": true,
      "45650": true,
      "45651": true,
      "45652": true,
      "45653": true,
      "45654": true,
      "45655": true,
      "45656": true,
      "45657": true,
      "45659": true,
      "45660": true,
      "45663": true,
      "45664": true,
      "45665": true,
      "45666": true,
      "45667": true,
      "45668": true,
      "45669": true,
      "45670": true,
      "45671": true,
      "45672": true,
      "45673": true,
      "45674": true,
      "45675": true,
      "45676": true,
      "45677": true,
      "45678": true,
      "45679": true
    },
    "EL SALTO": {
      "45680": true,
      "45681": true,
      "45683": true,
      "45684": true,
      "45685": true,
      "45686": true,
      "45687": true,
      "45690": true,
      "45692": true,
      "45693": true,
      "45694": true,
      "45696": true
    },
    "ACATLÁN DE JUÁREZ": {
      "45700": true,
      "45701": true,
      "45706": true,
      "45710": true,
      "45712": true,
      "45713": true,
      "45718": true,
      "45720": true,
      "45723": true,
      "45724": true
    },
    "VILLA CORONA": {
      "45730": true,
      "45732": true,
      "45737": true,
      "45740": true,
      "45744": true,
      "45745": true,
      "45746": true
    },
    "ZACOALCO DE TORRES": {
      "45750": true,
      "45751": true,
      "45752": true,
      "45753": true,
      "45754": true,
      "45755": true,
      "45756": true,
      "45757": true,
      "45758": true,
      "45760": true,
      "45763": true,
      "45764": true,
      "45765": true,
      "45766": true,
      "45767": true,
      "45770": true,
      "45773": true,
      "45774": true,
      "45775": true,
      "45776": true,
      "45777": true,
      "45780": true,
      "45783": true,
      "45784": true,
      "45785": true,
      "45786": true,
      "45787": true,
      "45788": true,
      "45789": true
    },
    "ATEMAJAC DE BRIZUELA": {
      "45790": true,
      "45796": true,
      "45798": true,
      "45799": true
    },
    "JOCOTEPEC": {
      "45800": true,
      "45801": true,
      "45802": true,
      "45803": true,
      "45804": true,
      "45805": true,
      "45806": true,
      "45810": true,
      "45811": true,
      "45812": true,
      "45815": true,
      "45816": true,
      "45820": true,
      "45822": true,
      "45825": true,
      "45830": true,
      "45840": true
    },
    "IXTLAHUACÁN DE LOS MEMBRILLOS": {
      "45850": true,
      "45852": true,
      "45853": true,
      "45854": true,
      "45855": true,
      "45856": true,
      "45857": true,
      "45860": true,
      "45861": true,
      "45862": true,
      "45863": true,
      "45864": true,
      "45865": true,
      "45866": true,
      "45870": true,
      "45871": true,
      "45872": true,
      "45873": true,
      "45874": true,
      "45875": true,
      "45876": true,
      "45877": true
    },
    "JUANACATLÁN": {
      "45880": true,
      "45882": true,
      "45883": true,
      "45884": true,
      "45885": true,
      "45886": true,
      "45887": true,
      "45890": true,
      "45895": true,
      "45896": true,
      "45897": true,
      "45898": true,
      "45899": true
    },
    "CHAPALA": {
      "45900": true,
      "45902": true,
      "45903": true,
      "45905": true,
      "45906": true,
      "45907": true,
      "45908": true,
      "45915": true,
      "45920": true,
      "45922": true,
      "45925": true,
      "45927": true,
      "45930": true,
      "45933": true,
      "45934": true,
      "45935": true,
      "45936": true,
      "45940": true,
      "45943": true,
      "45944": true,
      "45945": true,
      "45946": true
    },
    "PONCITLÁN": {
      "45950": true,
      "45954": true,
      "45955": true,
      "45956": true,
      "45957": true,
      "45958": true,
      "45959": true,
      "45960": true,
      "45961": true,
      "45963": true,
      "45964": true,
      "45965": true,
      "45966": true,
      "45967": true,
      "45968": true,
      "45970": true,
      "45973": true,
      "45974": true,
      "45975": true,
      "45976": true,
      "45977": true,
      "45978": true,
      "45979": true
    },
    "ZAPOTLÁN DEL REY": {
      "45980": true,
      "45981": true,
      "45982": true,
      "45983": true,
      "45984": true,
      "45985": true,
      "45986": true,
      "45987": true,
      "45988": true,
      "45989": true,
      "45990": true,
      "45992": true,
      "45993": true,
      "45994": true,
      "45995": true,
      "45996": true,
      "45997": true,
      "45998": true,
      "45999": true
    },
    "TOTATICHE": {
      "46170": true,
      "46174": true,
      "46175": true,
      "46176": true,
      "46177": true,
      "46180": true,
      "46188": true,
      "46190": true,
      "46194": true,
      "46196": true,
      "46197": true
    },
    "COLOTLÁN": {
      "46200": true,
      "46202": true,
      "46203": true,
      "46204": true,
      "46205": true,
      "46206": true,
      "46207": true,
      "46208": true,
      "46210": true,
      "46213": true,
      "46214": true,
      "46215": true,
      "46220": true,
      "46222": true,
      "46223": true,
      "46224": true,
      "46225": true,
      "46226": true,
      "46227": true,
      "46228": true,
      "46229": true,
      "46230": true,
      "46232": true,
      "46233": true,
      "46234": true,
      "46235": true,
      "46236": true,
      "46237": true,
      "46238": true,
      "46239": true
    },
    "SANTA MARÍA DE LOS ÁNGELES": {
      "46240": true,
      "46243": true,
      "46245": true,
      "46248": true,
      "46249": true,
      "46250": true,
      "46255": true,
      "46256": true,
      "46259": true
    },
    "TEQUILA": {
      "46400": true,
      "46402": true,
      "46403": true,
      "46404": true,
      "46405": true,
      "46407": true,
      "46409": true,
      "46410": true,
      "46411": true,
      "46420": true,
      "46430": true,
      "46433": true
    },
    "HOSTOTIPAQUILLO": {
      "46440": true,
      "46445": true,
      "46446": true,
      "46448": true,
      "46450": true,
      "46454": true,
      "46455": true,
      "46457": true,
      "46460": true,
      "46463": true,
      "46466": true
    },
    "MAGDALENA": {
      "46470": true,
      "46472": true,
      "46473": true,
      "46474": true,
      "46475": true,
      "46476": true,
      "46477": true,
      "46479": true,
      "46480": true,
      "46483": true,
      "46484": true,
      "46485": true,
      "46486": true,
      "46487": true,
      "46488": true,
      "46489": true,
      "46490": true,
      "46493": true,
      "46494": true,
      "46495": true,
      "46496": true
    },
    "ETZATLÁN": {
      "46500": true,
      "46501": true,
      "46502": true,
      "46503": true,
      "46506": true,
      "46507": true,
      "46509": true,
      "46510": true,
      "46520": true,
      "46525": true,
      "46530": true,
      "46532": true,
      "46535": true
    },
    "SAN MARCOS": {
      "46540": true,
      "46545": true
    },
    "SAN JUANITO DE ESCOBEDO": {
      "46560": true,
      "46565": true,
      "46566": true,
      "46570": true,
      "46572": true,
      "46573": true,
      "46574": true,
      "46580": true
    },
    "AMECA": {
      "46600": true,
      "46601": true,
      "46602": true,
      "46608": true,
      "46610": true,
      "46614": true,
      "46615": true,
      "46616": true,
      "46620": true,
      "46625": true,
      "46626": true,
      "46627": true,
      "46628": true,
      "46629": true,
      "46630": true,
      "46639": true,
      "46640": true,
      "46645": true,
      "46649": true,
      "46650": true,
      "46660": true,
      "46662": true,
      "46670": true,
      "46679": true,
      "46680": true,
      "46681": true,
      "46686": true,
      "46687": true,
      "46688": true,
      "46689": true,
      "46690": true,
      "46695": true,
      "46700": true,
      "46706": true,
      "46707": true,
      "46708": true,
      "46709": true,
      "46710": true,
      "46715": true,
      "46716": true,
      "46717": true,
      "46718": true,
      "46719": true,
      "46720": true,
      "46723": true,
      "46724": true,
      "46725": true,
      "46726": true,
      "46728": true,
      "46729": true
    },
    "AHUALULCO DE MERCADO": {
      "46730": true,
      "46732": true,
      "46733": true,
      "46734": true,
      "46735": true,
      "46736": true,
      "46737": true,
      "46738": true,
      "46740": true,
      "46745": true,
      "46746": true,
      "46749": true,
      "46750": true,
      "46756": true,
      "46757": true,
      "46758": true
    },
    "TEUCHITLÁN": {
      "46760": true,
      "46762": true,
      "46763": true,
      "46764": true,
      "46765": true
    },
    "SAN MARTÍN HIDALGO": {
      "46770": true,
      "46772": true,
      "46775": true,
      "46776": true,
      "46777": true,
      "46780": true,
      "46781": true,
      "46783": true,
      "46785": true,
      "46790": true,
      "46792": true,
      "46794": true,
      "46797": true,
      "46798": true,
      "46799": true
    },
    "GUACHINANGO": {
      "46800": true,
      "46810": true,
      "46815": true,
      "46820": true,
      "46826": true,
      "46827": true,
      "46829": true,
      "46830": true,
      "46840": true,
      "46845": true,
      "46846": true
    },
    "MIXTLÁN": {
      "46850": true,
      "46854": true,
      "46855": true,
      "46856": true,
      "46857": true,
      "46858": true,
      "46860": true,
      "46862": true,
      "46863": true,
      "46864": true,
      "46865": true,
      "46866": true,
      "46867": true
    },
    "MASCOTA": {
      "46900": true,
      "46903": true,
      "46904": true,
      "46905": true,
      "46906": true,
      "46907": true,
      "46908": true,
      "46909": true,
      "46910": true,
      "46912": true,
      "46913": true,
      "46914": true,
      "46915": true,
      "46916": true,
      "46917": true,
      "46920": true,
      "46922": true,
      "46923": true,
      "46924": true,
      "46925": true,
      "46926": true,
      "46930": true,
      "46933": true,
      "46934": true,
      "46935": true,
      "46936": true,
      "46937": true,
      "46940": true,
      "46942": true,
      "46943": true,
      "46944": true,
      "46945": true,
      "46946": true,
      "46947": true,
      "46950": true,
      "46953": true,
      "46954": true,
      "46955": true,
      "46956": true
    },
    "SAN SEBASTIÁN DEL OESTE": {
      "46960": true,
      "46990": true
    },
    "SAN JUAN DE LOS LAGOS": {
      "47000": true,
      "47001": true,
      "47002": true,
      "47007": true,
      "47009": true,
      "47010": true,
      "47011": true,
      "47013": true,
      "47014": true,
      "47015": true,
      "47020": true,
      "47023": true,
      "47030": true,
      "47040": true,
      "47050": true,
      "47059": true,
      "47060": true,
      "47069": true,
      "47070": true,
      "47073": true,
      "47078": true,
      "47079": true,
      "47080": true,
      "47087": true,
      "47088": true,
      "47089": true,
      "47090": true,
      "47093": true,
      "47094": true,
      "47095": true,
      "47100": true,
      "47103": true,
      "47105": true,
      "47106": true,
      "47107": true,
      "47109": true,
      "47110": true,
      "47116": true,
      "47117": true,
      "47118": true,
      "47119": true
    },
    "JALOSTOTITLÁN": {
      "47120": true,
      "47121": true,
      "47122": true,
      "47123": true,
      "47124": true,
      "47125": true,
      "47126": true,
      "47127": true,
      "47128": true,
      "47129": true,
      "47130": true,
      "47133": true,
      "47134": true,
      "47135": true,
      "47136": true,
      "47137": true,
      "47138": true,
      "47139": true
    },
    "SAN MIGUEL EL ALTO": {
      "47140": true,
      "47141": true,
      "47142": true,
      "47143": true,
      "47144": true,
      "47146": true,
      "47147": true,
      "47150": true,
      "47154": true,
      "47157": true,
      "47160": true
    },
    "SAN JULIÁN": {
      "47170": true,
      "47172": true,
      "47173": true,
      "47174": true,
      "47175": true,
      "47179": true
    },
    "ARANDAS": {
      "47180": true,
      "47181": true,
      "47182": true,
      "47183": true,
      "47184": true,
      "47185": true,
      "47186": true,
      "47187": true,
      "47188": true,
      "47189": true,
      "47196": true,
      "47197": true,
      "47199": true
    },
    "SAN IGNACIO CERRO GORDO": {
      "47190": true,
      "47192": true,
      "47193": true,
      "47194": true,
      "47195": true
    },
    "VILLA HIDALGO": {
      "47255": true,
      "47257": true,
      "47261": true,
      "47262": true,
      "47266": true
    },
    "ENCARNACIÓN DE DÍAZ": {
      "47270": true,
      "47272": true,
      "47273": true,
      "47274": true,
      "47275": true,
      "47276": true,
      "47277": true,
      "47280": true,
      "47281": true,
      "47282": true,
      "47283": true,
      "47284": true,
      "47285": true,
      "47286": true,
      "47287": true,
      "47288": true,
      "47290": true,
      "47293": true,
      "47294": true,
      "47295": true,
      "47296": true,
      "47297": true,
      "47298": true
    },
    "YAHUALICA DE GONZÁLEZ GALLO": {
      "47300": true,
      "47302": true,
      "47303": true,
      "47308": true,
      "47309": true,
      "47310": true,
      "47313": true,
      "47314": true,
      "47315": true,
      "47320": true,
      "47325": true,
      "47327": true,
      "47330": true,
      "47334": true,
      "47335": true,
      "47336": true,
      "47337": true,
      "47338": true,
      "47339": true
    },
    "MEXTICACÁN": {
      "47340": true,
      "47343": true,
      "47344": true,
      "47345": true,
      "47346": true,
      "47347": true,
      "47348": true,
      "47350": true,
      "47353": true,
      "47354": true,
      "47355": true,
      "47356": true,
      "47357": true,
      "47359": true
    },
    "CAÑADAS DE OBREGÓN": {
      "47360": true,
      "47368": true,
      "47369": true,
      "47370": true,
      "47373": true,
      "47374": true,
      "47378": true
    },
    "VALLE DE GUADALUPE": {
      "47380": true,
      "47383": true,
      "47384": true,
      "47386": true,
      "47398": true
    },
    "LAGOS DE MORENO": {
      "47400": true,
      "47401": true,
      "47406": true,
      "47408": true,
      "47410": true,
      "47411": true,
      "47420": true,
      "47423": true,
      "47425": true,
      "47430": true,
      "47431": true,
      "47432": true,
      "47433": true,
      "47436": true,
      "47438": true,
      "47440": true,
      "47443": true,
      "47450": true,
      "47457": true,
      "47459": true,
      "47460": true,
      "47463": true,
      "47470": true,
      "47472": true,
      "47473": true,
      "47474": true,
      "47475": true,
      "47476": true,
      "47478": true,
      "47479": true,
      "47480": true,
      "47483": true,
      "47487": true,
      "47490": true,
      "47500": true,
      "47502": true,
      "47503": true,
      "47504": true,
      "47505": true,
      "47506": true,
      "47507": true,
      "47510": true,
      "47512": true,
      "47513": true,
      "47514": true,
      "47515": true,
      "47516": true,
      "47517": true,
      "47519": true,
      "47520": true,
      "47522": true,
      "47523": true,
      "47524": true,
      "47525": true,
      "47526": true,
      "47527": true,
      "47528": true,
      "47530": true,
      "47532": true,
      "47533": true,
      "47534": true,
      "47535": true,
      "47536": true,
      "47537": true,
      "47538": true,
      "47539": true
    },
    "OJUELOS DE JALISCO": {
      "47540": true,
      "47542": true,
      "47543": true,
      "47544": true,
      "47545": true,
      "47546": true,
      "47547": true,
      "47548": true,
      "47549": true,
      "47550": true,
      "47553": true,
      "47554": true,
      "47555": true,
      "47557": true,
      "47560": true,
      "47563": true,
      "47564": true,
      "47565": true,
      "47566": true
    },
    "UNIÓN DE SAN ANTONIO": {
      "47570": true,
      "47572": true,
      "47573": true,
      "47574": true,
      "47575": true,
      "47576": true,
      "47577": true,
      "47580": true,
      "47583": true,
      "47584": true,
      "47585": true,
      "47586": true,
      "47587": true,
      "47588": true
    },
    "SAN DIEGO DE ALEJANDRÍA": {
      "47590": true,
      "47592": true,
      "47593": true,
      "47595": true,
      "47596": true,
      "47597": true,
      "47599": true
    },
    "TEPATITLÁN DE MORELOS": {
      "47600": true,
      "47601": true,
      "47608": true,
      "47610": true,
      "47614": true,
      "47620": true,
      "47622": true,
      "47624": true,
      "47627": true,
      "47630": true,
      "47634": true,
      "47635": true,
      "47636": true,
      "47637": true,
      "47639": true,
      "47640": true,
      "47645": true,
      "47649": true,
      "47650": true,
      "47655": true,
      "47656": true,
      "47657": true,
      "47660": true,
      "47664": true,
      "47670": true,
      "47674": true,
      "47675": true,
      "47676": true,
      "47680": true,
      "47684": true,
      "47685": true,
      "47689": true,
      "47690": true,
      "47693": true,
      "47694": true,
      "47696": true,
      "47698": true,
      "47700": true,
      "47707": true,
      "47710": true,
      "47714": true,
      "47715": true,
      "47716": true,
      "47720": true,
      "47723": true,
      "47724": true,
      "47725": true,
      "47726": true,
      "47727": true,
      "47728": true,
      "47729": true
    },
    "TOTOTLÁN": {
      "47730": true,
      "47732": true,
      "47733": true,
      "47734": true,
      "47736": true,
      "47737": true,
      "47740": true,
      "47741": true,
      "47742": true,
      "47743": true,
      "47744": true,
      "47746": true,
      "47747": true,
      "47748": true,
      "47749": true
    },
    "ATOTONILCO EL ALTO": {
      "47750": true,
      "47751": true,
      "47752": true,
      "47753": true,
      "47754": true,
      "47755": true,
      "47756": true,
      "47759": true,
      "47760": true,
      "47762": true,
      "47764": true,
      "47765": true,
      "47766": true,
      "47767": true,
      "47768": true,
      "47769": true,
      "47770": true,
      "47775": true,
      "47777": true,
      "47778": true,
      "47779": true
    },
    "OCOTLÁN": {
      "47780": true,
      "47782": true,
      "47783": true,
      "47784": true,
      "47785": true,
      "47786": true,
      "47787": true,
      "47793": true,
      "47794": true,
      "47795": true,
      "47796": true,
      "47797": true,
      "47798": true,
      "47799": true,
      "47800": true,
      "47801": true,
      "47803": true,
      "47806": true,
      "47810": true,
      "47819": true,
      "47820": true,
      "47824": true,
      "47829": true,
      "47830": true,
      "47840": true,
      "47849": true,
      "47850": true,
      "47860": true,
      "47862": true,
      "47868": true,
      "47870": true,
      "47879": true,
      "47880": true,
      "47882": true,
      "47890": true,
      "47892": true,
      "47894": true,
      "47898": true,
      "47899": true
    },
    "JAMAY": {
      "47900": true,
      "47902": true,
      "47903": true,
      "47904": true,
      "47905": true,
      "47906": true,
      "47907": true,
      "47909": true
    },
    "LA BARCA": {
      "47910": true,
      "47912": true,
      "47913": true,
      "47914": true,
      "47915": true,
      "47916": true,
      "47917": true,
      "47918": true,
      "47920": true,
      "47924": true,
      "47925": true,
      "47926": true,
      "47927": true
    },
    "AYOTLÁN": {
      "47930": true,
      "47931": true,
      "47934": true,
      "47935": true,
      "47936": true,
      "47937": true,
      "47938": true,
      "47939": true,
      "47940": true,
      "47944": true,
      "47945": true,
      "47946": true,
      "47947": true,
      "47948": true,
      "47949": true
    },
    "JESÚS MARÍA": {
      "47950": true,
      "47952": true,
      "47953": true,
      "47954": true,
      "47955": true,
      "47956": true,
      "47957": true,
      "47958": true,
      "47959": true,
      "47960": true,
      "47962": true,
      "47964": true,
      "47965": true,
      "47966": true,
      "47970": true,
      "47972": true,
      "47973": true,
      "47974": true,
      "47975": true,
      "47976": true,
      "47977": true
    },
    "DEGOLLADO": {
      "47980": true,
      "47983": true,
      "47984": true,
      "47985": true,
      "47986": true,
      "47987": true,
      "47988": true,
      "47989": true,
      "47990": true,
      "47993": true,
      "47994": true,
      "47995": true,
      "47996": true,
      "47997": true,
      "47998": true
    },
    "UNIÓN DE TULA": {
      "48000": true,
      "48010": true,
      "48017": true,
      "48020": true,
      "48026": true,
      "48030": true,
      "48035": true,
      "48040": true,
      "48047": true,
      "48048": true
    },
    "AYUTLA": {
      "48050": true,
      "48060": true,
      "48064": true,
      "48065": true,
      "48068": true,
      "48070": true,
      "48075": true,
      "48076": true,
      "48077": true,
      "48078": true,
      "48080": true,
      "48084": true,
      "48085": true,
      "48086": true,
      "48087": true,
      "48089": true,
      "48090": true,
      "48093": true,
      "48095": true,
      "48096": true,
      "48098": true
    },
    "ATENGUILLO": {
      "48100": true,
      "48110": true,
      "48120": true,
      "48130": true,
      "48135": true,
      "48136": true,
      "48139": true,
      "48140": true,
      "48145": true,
      "48146": true
    },
    "CUAUTLA": {
      "48150": true,
      "48153": true,
      "48155": true,
      "48159": true
    },
    "ATENGO": {
      "48160": true,
      "48165": true,
      "48166": true,
      "48170": true,
      "48175": true,
      "48180": true,
      "48185": true,
      "48190": true,
      "48193": true,
      "48199": true
    },
    "TALPA DE ALLENDE": {
      "48200": true,
      "48202": true,
      "48203": true,
      "48205": true,
      "48207": true,
      "48210": true,
      "48211": true,
      "48212": true,
      "48213": true,
      "48214": true,
      "48215": true,
      "48216": true,
      "48217": true,
      "48220": true,
      "48222": true,
      "48223": true,
      "48224": true,
      "48225": true,
      "48226": true,
      "48230": true,
      "48232": true,
      "48233": true,
      "48234": true,
      "48235": true,
      "48236": true,
      "48237": true,
      "48238": true,
      "48240": true,
      "48242": true,
      "48243": true,
      "48244": true,
      "48245": true,
      "48246": true,
      "48247": true,
      "48250": true,
      "48254": true,
      "48255": true,
      "48256": true,
      "48257": true,
      "48258": true,
      "48259": true
    },
    "PUERTO VALLARTA": {
      "48260": true,
      "48265": true,
      "48272": true,
      "48274": true,
      "48280": true,
      "48282": true,
      "48283": true,
      "48284": true,
      "48285": true,
      "48286": true,
      "48287": true,
      "48290": true,
      "48291": true,
      "48292": true,
      "48294": true,
      "48295": true,
      "48296": true,
      "48298": true,
      "48300": true,
      "48301": true,
      "48302": true,
      "48303": true,
      "48304": true,
      "48305": true,
      "48306": true,
      "48308": true,
      "48309": true,
      "48310": true,
      "48311": true,
      "48312": true,
      "48313": true,
      "48314": true,
      "48315": true,
      "48316": true,
      "48317": true,
      "48318": true,
      "48319": true,
      "48320": true,
      "48321": true,
      "48322": true,
      "48323": true,
      "48324": true,
      "48325": true,
      "48326": true,
      "48327": true,
      "48328": true,
      "48329": true,
      "48330": true,
      "48332": true,
      "48333": true,
      "48334": true,
      "48335": true,
      "48336": true,
      "48337": true,
      "48338": true,
      "48339": true,
      "48340": true,
      "48343": true,
      "48344": true,
      "48345": true,
      "48348": true,
      "48350": true,
      "48351": true,
      "48352": true,
      "48353": true,
      "48354": true,
      "48355": true,
      "48356": true,
      "48357": true,
      "48358": true,
      "48359": true,
      "48360": true,
      "48361": true,
      "48364": true,
      "48365": true,
      "48370": true,
      "48373": true,
      "48377": true,
      "48380": true,
      "48381": true,
      "48383": true,
      "48384": true,
      "48385": true,
      "48386": true,
      "48388": true,
      "48389": true,
      "48390": true,
      "48391": true,
      "48392": true,
      "48394": true,
      "48395": true,
      "48399": true
    },
    "CABO CORRIENTES": {
      "48400": true
    },
    "TOMATLÁN": {
      "48450": true,
      "48456": true,
      "48465": true,
      "48466": true,
      "48495": true
    },
    "COCULA": {
      "48500": true,
      "48502": true,
      "48503": true,
      "48504": true,
      "48506": true,
      "48507": true,
      "48508": true,
      "48509": true,
      "48510": true,
      "48512": true,
      "48520": true,
      "48525": true,
      "48526": true,
      "48530": true,
      "48532": true
    },
    "TECOLOTLÁN": {
      "48540": true,
      "48542": true,
      "48546": true,
      "48550": true,
      "48553": true,
      "48554": true,
      "48555": true,
      "48556": true,
      "48558": true,
      "48559": true,
      "48560": true,
      "48563": true,
      "48564": true,
      "48565": true,
      "48568": true,
      "48569": true
    },
    "TENAMAXTLÁN": {
      "48570": true,
      "48575": true,
      "48577": true,
      "48580": true,
      "48585": true,
      "48590": true,
      "48592": true,
      "48595": true
    },
    "JUCHITLÁN": {
      "48600": true,
      "48605": true,
      "48610": true,
      "48615": true,
      "48620": true,
      "48625": true,
      "48628": true,
      "48630": true,
      "48634": true,
      "48635": true
    },
    "CHIQUILISTLÁN": {
      "48640": true,
      "48643": true,
      "48644": true,
      "48645": true,
      "48646": true,
      "48647": true,
      "48649": true,
      "48650": true,
      "48653": true,
      "48654": true,
      "48655": true,
      "48656": true,
      "48657": true
    },
    "EJUTLA": {
      "48670": true,
      "48679": true,
      "48680": true,
      "48685": true,
      "48686": true,
      "48687": true
    },
    "EL LIMÓN": {
      "48700": true,
      "48708": true,
      "48710": true,
      "48715": true,
      "48720": true,
      "48725": true,
      "48730": true,
      "48739": true
    },
    "EL GRULLO": {
      "48740": true,
      "48742": true,
      "48743": true,
      "48744": true,
      "48745": true,
      "48747": true,
      "48748": true,
      "48749": true,
      "48750": true,
      "48753": true
    },
    "TONAYA": {
      "48760": true,
      "48763": true,
      "48764": true,
      "48765": true,
      "48766": true,
      "48767": true,
      "48768": true,
      "48769": true
    },
    "TUXCACUESCO": {
      "48770": true,
      "48775": true,
      "48777": true,
      "48778": true,
      "48780": true,
      "48785": true,
      "48786": true,
      "48788": true,
      "48790": true,
      "48793": true,
      "48795": true,
      "48799": true
    },
    "VILLA PURIFICACIÓN": {
      "48800": true,
      "48802": true,
      "48803": true,
      "48804": true,
      "48805": true,
      "48806": true,
      "48813": true,
      "48814": true,
      "48815": true,
      "48816": true,
      "48817": true,
      "48820": true,
      "48823": true,
      "48824": true,
      "48825": true,
      "48826": true,
      "48827": true,
      "48830": true,
      "48833": true,
      "48834": true,
      "48835": true,
      "48836": true,
      "48837": true,
      "48840": true,
      "48843": true,
      "48844": true,
      "48845": true,
      "48846": true,
      "48847": true
    },
    "LA HUERTA": {
      "48850": true,
      "48854": true,
      "48860": true,
      "48862": true,
      "48863": true,
      "48864": true,
      "48865": true,
      "48866": true,
      "48867": true,
      "48868": true,
      "48869": true,
      "48870": true,
      "48872": true,
      "48873": true,
      "48874": true,
      "48875": true,
      "48876": true,
      "48877": true,
      "48878": true,
      "48879": true,
      "48880": true,
      "48883": true,
      "48884": true,
      "48885": true,
      "48886": true,
      "48887": true,
      "48889": true,
      "48890": true,
      "48892": true,
      "48893": true,
      "48894": true,
      "48895": true,
      "48896": true,
      "48897": true,
      "48898": true
    },
    "AUTLÁN DE NAVARRO": {
      "48900": true,
      "48902": true,
      "48903": true,
      "48904": true,
      "48905": true,
      "48906": true,
      "48907": true,
      "48908": true,
      "48909": true,
      "48910": true,
      "48914": true,
      "48915": true,
      "48916": true,
      "48917": true,
      "48918": true,
      "48919": true,
      "48920": true,
      "48922": true,
      "48923": true,
      "48926": true,
      "48929": true
    },
    "CASIMIRO CASTILLO": {
      "48930": true,
      "48936": true,
      "48938": true,
      "48939": true,
      "48940": true,
      "48942": true,
      "48943": true,
      "48944": true,
      "48945": true,
      "48946": true,
      "48947": true,
      "48948": true
    },
    "CUAUTITLÁN DE GARCÍA BARRAGÁN": {
      "48950": true,
      "48953": true,
      "48954": true,
      "48955": true,
      "48956": true,
      "48959": true,
      "48960": true,
      "48962": true,
      "48963": true,
      "48964": true,
      "48965": true,
      "48966": true,
      "48967": true,
      "48969": true
    },
    "CIHUATLÁN": {
      "48970": true,
      "48972": true,
      "48974": true,
      "48976": true,
      "48980": true,
      "48983": true,
      "48985": true,
      "48986": true,
      "48987": true,
      "48989": true,
      "48990": true,
      "48995": true
    },
    "ZAPOTLÁN EL GRANDE": {
      "49000": true,
      "49001": true,
      "49002": true,
      "49010": true,
      "49011": true,
      "49012": true,
      "49013": true,
      "49014": true,
      "49015": true,
      "49016": true,
      "49019": true,
      "49020": true,
      "49023": true,
      "49024": true,
      "49026": true,
      "49027": true,
      "49028": true,
      "49029": true,
      "49030": true,
      "49031": true,
      "49032": true,
      "49033": true,
      "49035": true,
      "49040": true,
      "49050": true,
      "49051": true,
      "49052": true,
      "49053": true,
      "49054": true,
      "49055": true,
      "49056": true,
      "49057": true,
      "49059": true,
      "49060": true,
      "49063": true,
      "49064": true,
      "49065": true,
      "49066": true,
      "49067": true,
      "49068": true,
      "49070": true,
      "49074": true,
      "49075": true,
      "49076": true,
      "49077": true,
      "49078": true,
      "49079": true,
      "49080": true,
      "49085": true,
      "49086": true,
      "49087": true,
      "49088": true,
      "49089": true,
      "49090": true,
      "49092": true,
      "49093": true,
      "49094": true,
      "49095": true,
      "49096": true,
      "49097": true,
      "49098": true,
      "49099": true,
      "49100": true,
      "49106": true,
      "49109": true,
      "49110": true,
      "49112": true,
      "49113": true
    },
    "GÓMEZ FARÍAS": {
      "49120": true,
      "49123": true,
      "49124": true,
      "49125": true,
      "49126": true,
      "49130": true,
      "49140": true,
      "49150": true
    },
    "CONCEPCIÓN DE BUENOS AIRES": {
      "49170": true,
      "49175": true,
      "49176": true,
      "49177": true,
      "49178": true
    },
    "ATOYAC": {
      "49200": true,
      "49220": true,
      "49223": true,
      "49224": true,
      "49225": true,
      "49228": true,
      "49229": true
    },
    "TECHALUTA DE MONTENEGRO": {
      "49230": true,
      "49236": true,
      "49239": true,
      "49240": true
    },
    "TEOCUITATLÁN DE CORONA": {
      "49250": true,
      "49253": true,
      "49255": true,
      "49260": true,
      "49265": true,
      "49270": true,
      "49274": true,
      "49275": true,
      "49276": true,
      "49277": true,
      "49280": true,
      "49285": true,
      "49286": true,
      "49290": true,
      "49295": true,
      "49296": true
    },
    "SAYULA": {
      "49300": true,
      "49302": true,
      "49303": true,
      "49304": true,
      "49305": true,
      "49306": true,
      "49310": true,
      "49312": true,
      "49313": true,
      "49314": true,
      "49315": true,
      "49316": true,
      "49317": true,
      "49318": true,
      "49328": true,
      "49330": true,
      "49333": true,
      "49334": true,
      "49336": true,
      "49338": true,
      "49339": true
    },
    "TAPALPA": {
      "49340": true,
      "49344": true,
      "49345": true,
      "49346": true,
      "49350": true,
      "49355": true,
      "49356": true,
      "49358": true,
      "49360": true,
      "49369": true
    },
    "AMACUECA": {
      "49370": true,
      "49375": true,
      "49380": true,
      "49388": true
    },
    "TIZAPÁN EL ALTO": {
      "49400": true,
      "49404": true,
      "49410": true,
      "49413": true,
      "49414": true,
      "49415": true,
      "49416": true,
      "49417": true,
      "49420": true,
      "49421": true,
      "49422": true,
      "49423": true,
      "49424": true,
      "49425": true,
      "49426": true,
      "49427": true
    },
    "TUXCUECA": {
      "49430": true,
      "49432": true,
      "49436": true,
      "49439": true,
      "49440": true,
      "49446": true,
      "49450": true
    },
    "LA MANZANILLA DE LA PAZ": {
      "49460": true,
      "49462": true,
      "49463": true,
      "49470": true,
      "49490": true
    },
    "MAZAMITLA": {
      "49500": true,
      "49510": true,
      "49512": true,
      "49513": true,
      "49514": true,
      "49515": true,
      "49516": true,
      "49517": true,
      "49519": true,
      "49520": true,
      "49522": true,
      "49523": true,
      "49524": true,
      "49525": true,
      "49526": true,
      "49527": true,
      "49530": true,
      "49532": true,
      "49533": true,
      "49534": true,
      "49535": true,
      "49536": true,
      "49537": true,
      "49538": true,
      "49539": true
    },
    "VALLE DE JUÁREZ": {
      "49540": true,
      "49542": true,
      "49544": true,
      "49547": true,
      "49548": true,
      "49550": true
    },
    "QUITUPAN": {
      "49570": true,
      "49572": true,
      "49573": true,
      "49574": true,
      "49575": true,
      "49576": true,
      "49577": true,
      "49578": true,
      "49580": true,
      "49582": true,
      "49583": true,
      "49584": true,
      "49585": true,
      "49586": true,
      "49587": true,
      "49589": true,
      "49590": true,
      "49592": true,
      "49593": true,
      "49594": true,
      "49595": true,
      "49596": true,
      "49597": true,
      "49598": true
    },
    "ZAPOTILTIC": {
      "49600": true,
      "49602": true,
      "49603": true,
      "49604": true,
      "49605": true,
      "49606": true,
      "49607": true,
      "49608": true,
      "49610": true,
      "49612": true,
      "49613": true,
      "49614": true,
      "49615": true,
      "49616": true,
      "49617": true,
      "49618": true,
      "49619": true,
      "49620": true,
      "49622": true,
      "49623": true,
      "49624": true,
      "49625": true,
      "49635": true,
      "49636": true,
      "49637": true,
      "49638": true,
      "49639": true,
      "49640": true,
      "49642": true,
      "49643": true,
      "49644": true,
      "49645": true,
      "49646": true,
      "49647": true
    },
    "TAMAZULA DE GORDIANO": {
      "49650": true,
      "49652": true,
      "49653": true,
      "49654": true,
      "49655": true,
      "49656": true,
      "49657": true,
      "49658": true,
      "49659": true,
      "49660": true,
      "49663": true,
      "49664": true,
      "49665": true,
      "49666": true,
      "49667": true,
      "49669": true,
      "49670": true,
      "49672": true,
      "49673": true,
      "49674": true,
      "49675": true,
      "49676": true,
      "49677": true,
      "49678": true,
      "49679": true,
      "49680": true,
      "49683": true,
      "49684": true,
      "49685": true,
      "49686": true,
      "49687": true,
      "49690": true,
      "49693": true,
      "49694": true,
      "49695": true
    },
    "SAN GABRIEL": {
      "49700": true,
      "49705": true,
      "49710": true,
      "49714": true,
      "49720": true,
      "49728": true,
      "49730": true,
      "49735": true,
      "49738": true,
      "49740": true,
      "49744": true
    },
    "TOLIMÁN": {
      "49750": true,
      "49754": true,
      "49755": true,
      "49756": true,
      "49757": true,
      "49758": true,
      "49759": true,
      "49760": true,
      "49764": true,
      "49765": true,
      "49767": true,
      "49769": true
    },
    "ZAPOTITLÁN DE VADILLO": {
      "49770": true,
      "49775": true,
      "49779": true,
      "49780": true,
      "49783": true,
      "49784": true,
      "49786": true,
      "49789": true
    },
    "TUXPAN": {
      "49800": true,
      "49805": true,
      "49806": true,
      "49807": true,
      "49808": true,
      "49810": true,
      "49815": true,
      "49816": true,
      "49817": true,
      "49818": true,
      "49820": true,
      "49822": true,
      "49823": true,
      "49824": true,
      "49825": true,
      "49826": true,
      "49827": true,
      "49828": true,
      "49829": true,
      "49830": true,
      "49832": true,
      "49833": true,
      "49834": true,
      "49835": true,
      "49836": true,
      "49837": true,
      "49838": true,
      "49839": true
    },
    "TONILA": {
      "49840": true,
      "49848": true,
      "49850": true,
      "49860": true,
      "49867": true,
      "49868": true,
      "49869": true
    },
    "PIHUAMO": {
      "49870": true,
      "49873": true,
      "49874": true,
      "49875": true,
      "49876": true,
      "49877": true,
      "49883": true,
      "49884": true,
      "49885": true,
      "49886": true,
      "49887": true,
      "49893": true,
      "49894": true,
      "49895": true,
      "49896": true,
      "49897": true
    },
    "TECALITLÁN": {
      "49900": true,
      "49902": true,
      "49903": true,
      "49904": true,
      "49905": true,
      "49906": true,
      "49907": true,
      "49910": true,
      "49912": true,
      "49913": true,
      "49914": true,
      "49915": true,
      "49916": true,
      "49920": true,
      "49922": true,
      "49923": true,
      "49924": true,
      "49925": true,
      "49926": true,
      "49927": true,
      "49928": true,
      "49930": true,
      "49932": true,
      "49933": true,
      "49934": true,
      "49935": true,
      "49936": true,
      "49937": true,
      "49938": true,
      "49940": true,
      "49942": true,
      "49943": true,
      "49944": true,
      "49945": true,
      "49946": true,
      "49947": true,
      "49949": true
    }
  },
  "MÉXICO": {
    "TOLUCA": {
      "50000": true,
      "50010": true,
      "50016": true,
      "50017": true,
      "50018": true,
      "50020": true,
      "50026": true,
      "50040": true,
      "50050": true,
      "50060": true,
      "50070": true,
      "50071": true,
      "50075": true,
      "50080": true,
      "50090": true,
      "50100": true,
      "50103": true,
      "50110": true,
      "50115": true,
      "50120": true,
      "50122": true,
      "50130": true,
      "50140": true,
      "50150": true,
      "50160": true,
      "50168": true,
      "50170": true,
      "50180": true,
      "50190": true,
      "50200": true,
      "50205": true,
      "50206": true,
      "50209": true,
      "50210": true,
      "50214": true,
      "50220": true,
      "50223": true,
      "50225": true,
      "50226": true,
      "50227": true,
      "50228": true,
      "50230": true,
      "50233": true,
      "50235": true,
      "50236": true,
      "50240": true,
      "50245": true,
      "50246": true,
      "50250": true,
      "50253": true,
      "50254": true,
      "50255": true,
      "50256": true,
      "50257": true,
      "50258": true,
      "50260": true,
      "50263": true,
      "50264": true,
      "50265": true,
      "50266": true,
      "50280": true,
      "50290": true,
      "50294": true,
      "51670": true,
      "51675": true,
      "51676": true
    },
    "TEMOAYA": {
      "50850": true,
      "50860": true,
      "50867": true,
      "50870": true,
      "50880": true,
      "50883": true,
      "50884": true,
      "50885": true,
      "50886": true,
      "50890": true,
      "50894": true,
      "50896": true
    },
    "ALMOLOYA DE JUÁREZ": {
      "50900": true,
      "50903": true,
      "50904": true,
      "50906": true,
      "50920": true,
      "50940": true,
      "50943": true
    },
    "SAN MATEO ATENCO": {
      "51052": true,
      "52100": true,
      "52104": true,
      "52105": true,
      "52106": true,
      "52107": true,
      "52110": true,
      "52120": true
    },
    "SANTO TOMÁS DE LOS PLATANOS": {
      "51100": true,
      "51105": true,
      "51106": true
    },
    "VALLE DE BRAVO": {
      "51200": true
    },
    "VALLE DE BRAVO 51200 51204": {
      "51207": true,
      "51209": true,
      "51217": true,
      "51220": true,
      "51225": true,
      "51226": true,
      "51230": true,
      "51248": true
    },
    "AMANALCO": {
      "51260": true
    },
    "TEMASCALTEPEC": {
      "51300": true,
      "51325": true
    },
    "ZINACANTEPEC": {
      "51350": true,
      "51354": true,
      "51355": true,
      "51356": true,
      "51357": true,
      "51360": true,
      "51364": true,
      "51367": true,
      "51370": true,
      "51375": true,
      "51380": true,
      "51383": true
    },
    "TEJUPILCO": {
      "51400": true,
      "51410": true,
      "51412": true,
      "51415": true,
      "51418": true,
      "51426": true
    },
    "AMATEPEC": {
      "51500": true,
      "51530": true
    },
    "TLATLAYA": {
      "51550": true,
      "51579": true,
      "51580": true
    },
    "COATEPEC HARINAS": {
      "51700": true,
      "51716": true
    },
    "VILLA GUERRERO": {
      "51760": true,
      "51765": true,
      "51766": true,
      "51767": true,
      "51775": true,
      "51776": true,
      "51783": true,
      "51784": true
    },
    "IXTAPAN DE LA SAL": {
      "51900": true,
      "51904": true,
      "51905": true,
      "51906": true,
      "51907": true,
      "51915": true,
      "51916": true,
      "51924": true,
      "51933": true
    },
    "TONATICO": {
      "51950": true,
      "51953": true,
      "51964": true
    },
    "ZUMPAHUACÁN": {
      "51980": true,
      "51989": true
    },
    "LERMA": {
      "52000": true,
      "52004": true,
      "52005": true,
      "52006": true,
      "52030": true
    },
    "XONACATLÁN": {
      "52060": true,
      "52064": true,
      "52070": true,
      "52073": true
    },
    "OTZOLOTEPEC": {
      "52080": true,
      "52082": true,
      "52083": true,
      "52084": true,
      "52085": true,
      "52086": true,
      "52090": true,
      "52094": true,
      "52096": true
    },
    "METEPEC": {
      "52140": true,
      "52141": true,
      "52143": true,
      "52144": true,
      "52145": true,
      "52146": true,
      "52147": true,
      "52148": true,
      "52149": true,
      "52150": true,
      "52154": true,
      "52155": true,
      "52156": true,
      "52157": true,
      "52158": true,
      "52159": true,
      "52160": true,
      "52161": true,
      "52164": true,
      "52165": true,
      "52166": true,
      "52167": true,
      "52168": true,
      "52169": true,
      "52170": true,
      "52172": true,
      "52175": true,
      "52176": true,
      "52177": true,
      "52178": true,
      "52179": true
    },
    "MEXICALTZINGO": {
      "52180": true,
      "52182": true,
      "52183": true,
      "52185": true
    },
    "CALIMAYA": {
      "52200": true,
      "52203": true,
      "52204": true,
      "52205": true,
      "52210": true,
      "52213": true,
      "52220": true,
      "52223": true,
      "52224": true,
      "52226": true,
      "52227": true,
      "52230": true,
      "52233": true,
      "52234": true
    },
    "CHAPULTEPEC": {
      "52240": true,
      "52243": true,
      "52244": true
    },
    "SAN ANTONIO LA ISLA": {
      "52280": true,
      "52282": true
    },
    "TENANGO DEL VALLE": {
      "52300": true,
      "52303": true,
      "52304": true,
      "52305": true,
      "52307": true,
      "52310": true,
      "52315": true,
      "52320": true,
      "52330": true,
      "52333": true,
      "52340": true,
      "52343": true,
      "52345": true,
      "52346": true,
      "52350": true
    },
    "RAYÓN": {
      "52360": true,
      "52362": true,
      "52363": true,
      "52365": true,
      "52366": true
    },
    "TENANCINGO": {
      "52400": true,
      "52410": true,
      "52414": true,
      "52416": true,
      "52420": true,
      "52423": true,
      "52425": true,
      "52430": true,
      "52433": true,
      "52435": true,
      "52436": true
    },
    "MALINALCO": {
      "52440": true,
      "52444": true,
      "52460": true,
      "52464": true
    },
    "OCUILAN": {
      "52480": true,
      "52483": true,
      "52484": true,
      "52490": true,
      "52494": true,
      "52495": true
    },
    "ATIZAPÁN": {
      "52500": true,
      "52506": true
    },
    "ALMOLOYA DEL RÍO": {
      "52540": true
    },
    "TEXCALYACAC": {
      "52570": true
    },
    "TIANGUISTENCO": {
      "52600": true,
      "52603": true,
      "52605": true,
      "52607": true,
      "52613": true,
      "52614": true,
      "52640": true,
      "52644": true,
      "52645": true,
      "52650": true,
      "52653": true,
      "52654": true,
      "52660": true
    },
    "XALATLACO": {
      "52680": true,
      "52688": true
    },
    "CAPULHUAC": {
      "52700": true,
      "52710": true,
      "52720": true,
      "52730": true,
      "52733": true
    },
    "OCOYOACAC": {
      "52740": true,
      "52743": true,
      "52753": true,
      "52754": true,
      "52755": true,
      "52756": true,
      "52757": true
    },
    "HUIXQUILUCAN": {
      "52760": true,
      "52763": true,
      "52764": true,
      "52765": true,
      "52766": true,
      "52767": true,
      "52768": true,
      "52770": true,
      "52773": true,
      "52774": true,
      "52775": true,
      "52776": true,
      "52777": true,
      "52778": true,
      "52779": true,
      "52780": true,
      "52783": true,
      "52784": true,
      "52785": true,
      "52786": true,
      "52787": true,
      "52788": true,
      "52789": true,
      "52790": true,
      "52793": true,
      "52796": true,
      "52797": true,
      "52798": true
    },
    "ATIZAPÁN DE ZARAGOZA": {
      "52900": true,
      "52909": true,
      "52910": true,
      "52915": true,
      "52916": true,
      "52918": true,
      "52919": true,
      "52920": true,
      "52923": true,
      "52924": true,
      "52925": true,
      "52926": true,
      "52927": true,
      "52928": true,
      "52929": true,
      "52930": true,
      "52934": true,
      "52936": true,
      "52937": true,
      "52938": true,
      "52939": true,
      "52940": true,
      "52945": true,
      "52946": true,
      "52947": true,
      "52948": true,
      "52949": true,
      "52950": true,
      "52953": true,
      "52956": true,
      "52957": true,
      "52958": true,
      "52959": true,
      "52960": true,
      "52965": true,
      "52966": true,
      "52967": true,
      "52968": true,
      "52970": true,
      "52975": true,
      "52976": true,
      "52977": true,
      "52978": true,
      "52979": true,
      "52980": true,
      "52985": true,
      "52986": true,
      "52987": true,
      "52988": true,
      "52989": true,
      "52990": true,
      "52994": true,
      "52995": true,
      "52996": true,
      "52997": true,
      "52998": true
    },
    "NAUCALPAN DE JUÁREZ": {
      "53000": true,
      "53010": true,
      "53030": true,
      "53040": true,
      "53050": true,
      "53060": true,
      "53070": true,
      "53100": true,
      "53110": true,
      "53115": true,
      "53116": true,
      "53117": true,
      "53119": true,
      "53120": true,
      "53124": true,
      "53125": true,
      "53126": true,
      "53127": true,
      "53128": true,
      "53129": true,
      "53130": true,
      "53138": true,
      "53140": true,
      "53150": true,
      "53160": true,
      "53170": true,
      "53177": true,
      "53178": true,
      "53179": true,
      "53200": true,
      "53210": true,
      "53215": true,
      "53217": true,
      "53218": true,
      "53219": true,
      "53220": true,
      "53224": true,
      "53227": true,
      "53228": true,
      "53230": true,
      "53237": true,
      "53239": true,
      "53240": true,
      "53247": true,
      "53248": true,
      "53250": true,
      "53260": true,
      "53270": true,
      "53278": true,
      "53279": true,
      "53280": true,
      "53283": true,
      "53290": true,
      "53296": true,
      "53297": true,
      "53298": true,
      "53300": true,
      "53309": true,
      "53310": true,
      "53320": true,
      "53329": true,
      "53330": true,
      "53338": true,
      "53339": true,
      "53340": true,
      "53348": true,
      "53350": true,
      "53370": true,
      "53378": true,
      "53390": true,
      "53398": true,
      "53400": true,
      "53410": true,
      "53420": true,
      "53425": true,
      "53426": true,
      "53427": true,
      "53428": true,
      "53430": true,
      "53440": true,
      "53450": true,
      "53458": true,
      "53459": true,
      "53460": true,
      "53470": true,
      "53489": true,
      "53490": true,
      "53500": true,
      "53519": true,
      "53520": true,
      "53529": true,
      "53530": true,
      "53533": true,
      "53550": true,
      "53560": true,
      "53569": true,
      "53570": true,
      "53580": true,
      "53598": true,
      "53618": true,
      "53620": true,
      "53630": true,
      "53640": true,
      "53653": true,
      "53654": true,
      "53655": true,
      "53660": true,
      "53664": true,
      "53670": true,
      "53680": true,
      "53687": true,
      "53688": true,
      "53689": true,
      "53690": true,
      "53694": true,
      "53695": true,
      "53696": true,
      "53697": true,
      "53698": true,
      "53700": true,
      "53708": true,
      "53710": true,
      "53713": true,
      "53714": true,
      "53716": true,
      "53717": true,
      "53718": true,
      "53719": true,
      "53730": true,
      "53760": true,
      "53770": true,
      "53780": true,
      "53787": true,
      "53788": true,
      "53790": true,
      "53798": true,
      "53799": true,
      "53800": true,
      "53809": true,
      "53810": true,
      "53819": true,
      "53820": true,
      "53830": true,
      "53839": true,
      "53840": true,
      "53900": true,
      "53909": true,
      "53910": true,
      "53930": true,
      "53940": true,
      "53950": true,
      "53960": true,
      "53970": true
    },
    "TLALNEPANTLA DE BAZ": {
      "54000": true,
      "54009": true,
      "54010": true,
      "54015": true,
      "54016": true,
      "54017": true,
      "54020": true,
      "54021": true,
      "54022": true,
      "54023": true,
      "54025": true,
      "54026": true,
      "54028": true,
      "54030": true,
      "54033": true,
      "54037": true,
      "54038": true,
      "54040": true,
      "54049": true,
      "54050": true,
      "54054": true,
      "54055": true,
      "54057": true,
      "54059": true,
      "54060": true,
      "54063": true,
      "54067": true,
      "54068": true,
      "54069": true,
      "54070": true,
      "54073": true,
      "54075": true,
      "54076": true,
      "54080": true,
      "54090": true,
      "54092": true,
      "54093": true,
      "54094": true,
      "54098": true,
      "54100": true,
      "54108": true,
      "54109": true,
      "54110": true,
      "54118": true,
      "54119": true,
      "54120": true,
      "54124": true,
      "54126": true,
      "54127": true,
      "54128": true,
      "54130": true,
      "54134": true,
      "54135": true,
      "54136": true,
      "54140": true,
      "54142": true,
      "54143": true,
      "54145": true,
      "54146": true,
      "54147": true,
      "54149": true,
      "54150": true,
      "54152": true,
      "54158": true,
      "54160": true,
      "54162": true,
      "54168": true,
      "54170": true,
      "54172": true,
      "54173": true,
      "54180": true,
      "54187": true,
      "54189": true,
      "54190": true,
      "54193": true,
      "54195": true,
      "54196": true,
      "54197": true,
      "54198": true
    },
    "NICOLÁS ROMERO": {
      "54400": true,
      "54402": true,
      "54405": true,
      "54409": true,
      "54410": true,
      "54413": true,
      "54414": true,
      "54416": true,
      "54420": true,
      "54425": true,
      "54426": true,
      "54434": true,
      "54435": true,
      "54457": true,
      "54466": true,
      "54467": true,
      "54469": true,
      "54470": true,
      "54473": true,
      "54474": true,
      "54475": true,
      "54476": true,
      "54477": true
    },
    "TEPOTZOTLÁN": {
      "54600": true,
      "54605": true,
      "54607": true,
      "54614": true,
      "54616": true,
      "54655": true
    },
    "COYOTEPEC": {
      "54660": true,
      "54666": true,
      "54667": true,
      "54668": true
    },
    "HUEHUETOCA": {
      "54680": true,
      "54681": true,
      "54683": true,
      "54685": true,
      "54686": true,
      "54687": true,
      "54693": true,
      "54694": true,
      "54696": true
    },
    "CUAUTITLÁN IZCALLI": {
      "54700": true,
      "54710": true,
      "54712": true,
      "54713": true,
      "54714": true,
      "54715": true,
      "54716": true,
      "54719": true,
      "54720": true,
      "54725": true,
      "54729": true,
      "54730": true,
      "54740": true,
      "54743": true,
      "54744": true,
      "54745": true,
      "54750": true,
      "54753": true,
      "54759": true,
      "54760": true,
      "54763": true,
      "54764": true,
      "54765": true,
      "54766": true,
      "54767": true,
      "54769": true
    },
    "TEOLOYUCAN": {
      "54770": true,
      "54783": true,
      "54784": true,
      "54785": true,
      "54786": true,
      "54787": true,
      "54788": true
    },
    "CUAUTITLÁN": {
      "54800": true,
      "54803": true,
      "54804": true,
      "54805": true,
      "54807": true,
      "54830": true,
      "54831": true,
      "54834": true,
      "54840": true,
      "54850": true,
      "54855": true,
      "54857": true,
      "54858": true,
      "54860": true,
      "54870": true,
      "54875": true,
      "54877": true,
      "54878": true,
      "54879": true
    },
    "MELCHOR OCAMPO": {
      "54880": true,
      "54882": true,
      "54883": true,
      "54890": true,
      "54892": true,
      "54895": true
    },
    "TULTITLÁN": {
      "54900": true,
      "54910": true,
      "54913": true,
      "54914": true,
      "54915": true,
      "54916": true,
      "54918": true,
      "54920": true,
      "54924": true,
      "54925": true,
      "54926": true,
      "54927": true,
      "54929": true,
      "54930": true,
      "54932": true,
      "54933": true,
      "54934": true,
      "54935": true,
      "54938": true,
      "54939": true,
      "54940": true,
      "54942": true,
      "54943": true,
      "54944": true,
      "54945": true,
      "54946": true,
      "54947": true,
      "54948": true,
      "54949": true,
      "54950": true,
      "54954": true,
      "54955": true,
      "54957": true,
      "54958": true,
      "54959": true
    },
    "TULTEPEC": {
      "54960": true,
      "54962": true,
      "54963": true,
      "54964": true,
      "54965": true,
      "54966": true,
      "54967": true,
      "54970": true,
      "54972": true,
      "54974": true,
      "54975": true,
      "54976": true,
      "54977": true,
      "54980": true,
      "54983": true,
      "54984": true,
      "54985": true,
      "54986": true,
      "54987": true
    },
    "ECATEPEC DE MORELOS": {
      "55000": true,
      "55010": true,
      "55014": true,
      "55016": true,
      "55017": true,
      "55018": true,
      "55020": true,
      "55023": true,
      "55024": true,
      "55025": true,
      "55027": true,
      "55028": true,
      "55029": true,
      "55030": true,
      "55036": true,
      "55037": true,
      "55038": true,
      "55039": true,
      "55040": true,
      "55044": true,
      "55050": true,
      "55055": true,
      "55056": true,
      "55057": true,
      "55059": true,
      "55060": true,
      "55063": true,
      "55064": true,
      "55065": true,
      "55066": true,
      "55067": true,
      "55068": true,
      "55069": true,
      "55070": true,
      "55074": true,
      "55075": true,
      "55076": true,
      "55080": true,
      "55084": true,
      "55085": true,
      "55087": true,
      "55090": true,
      "55094": true,
      "55095": true,
      "55099": true,
      "55100": true,
      "55104": true,
      "55105": true,
      "55107": true,
      "55114": true,
      "55115": true,
      "55117": true,
      "55118": true,
      "55119": true,
      "55120": true,
      "55125": true,
      "55126": true,
      "55127": true,
      "55128": true,
      "55129": true,
      "55130": true,
      "55135": true,
      "55137": true,
      "55138": true,
      "55139": true,
      "55140": true,
      "55146": true,
      "55147": true,
      "55148": true,
      "55149": true,
      "55158": true,
      "55170": true,
      "55176": true,
      "55179": true,
      "55180": true,
      "55187": true,
      "55188": true,
      "55189": true,
      "55190": true,
      "55200": true,
      "55210": true,
      "55218": true,
      "55220": true,
      "55230": true,
      "55234": true,
      "55235": true,
      "55236": true,
      "55237": true,
      "55238": true,
      "55240": true,
      "55242": true,
      "55243": true,
      "55244": true,
      "55245": true,
      "55246": true,
      "55247": true,
      "55248": true,
      "55249": true,
      "55260": true,
      "55264": true,
      "55266": true,
      "55267": true,
      "55268": true,
      "55269": true,
      "55270": true,
      "55280": true,
      "55284": true,
      "55287": true,
      "55288": true,
      "55289": true,
      "55290": true,
      "55294": true,
      "55295": true,
      "55296": true,
      "55297": true,
      "55298": true,
      "55299": true,
      "55300": true,
      "55308": true,
      "55310": true,
      "55316": true,
      "55317": true,
      "55320": true,
      "55330": true,
      "55338": true,
      "55339": true,
      "55340": true,
      "55347": true,
      "55348": true,
      "55349": true,
      "55360": true,
      "55369": true,
      "55390": true,
      "55400": true,
      "55404": true,
      "55405": true,
      "55407": true,
      "55410": true,
      "55414": true,
      "55415": true,
      "55416": true,
      "55417": true,
      "55418": true,
      "55419": true,
      "55420": true,
      "55425": true,
      "55429": true,
      "55430": true,
      "55450": true,
      "55458": true,
      "55459": true,
      "55490": true,
      "55498": true,
      "55500": true,
      "55506": true,
      "55507": true,
      "55508": true,
      "55509": true,
      "55510": true,
      "55515": true,
      "55516": true,
      "55517": true,
      "55518": true,
      "55519": true,
      "55520": true,
      "55530": true,
      "55540": true,
      "55547": true,
      "55548": true,
      "55549": true
    },
    "APAXCO": {
      "55660": true,
      "55666": true,
      "55669": true
    },
    "COACALCO DE BERRIOZÁBAL": {
      "55700": true,
      "55705": true,
      "55707": true,
      "55708": true,
      "55709": true,
      "55710": true,
      "55712": true,
      "55713": true,
      "55714": true,
      "55715": true,
      "55716": true,
      "55717": true,
      "55718": true,
      "55719": true,
      "55720": true,
      "55726": true,
      "55728": true,
      "55729": true,
      "55730": true,
      "55736": true,
      "55737": true,
      "55738": true,
      "55739": true
    },
    "JALTENCO": {
      "55780": true,
      "55783": true,
      "55784": true
    },
    "TONANITLA": {
      "55785": true,
      "55786": true,
      "55787": true
    },
    "NEXTLALPAN": {
      "55790": true,
      "55793": true,
      "55794": true,
      "55795": true,
      "55796": true,
      "55797": true,
      "55799": true
    },
    "TEOTIHUACÁN": {
      "55800": true,
      "55803": true,
      "55805": true,
      "55810": true,
      "55812": true,
      "55813": true,
      "55814": true,
      "55815": true,
      "55817": true,
      "55821": true,
      "55822": true,
      "55823": true,
      "55825": true,
      "55826": true,
      "55829": true,
      "55831": true,
      "55833": true,
      "55837": true,
      "55838": true,
      "55842": true,
      "55844": true,
      "55847": true
    },
    "SAN MARTÍN DE LAS PIRÁMIDES": {
      "55850": true,
      "55851": true,
      "55854": true
    },
    "ACOLMAN": {
      "55870": true,
      "55873": true,
      "55876": true,
      "55877": true,
      "55879": true,
      "55882": true,
      "55883": true,
      "55885": true,
      "55887": true,
      "55888": true,
      "55893": true,
      "55896": true
    },
    "OTUMBA": {
      "55908": true,
      "55910": true,
      "55913": true,
      "55915": true,
      "55916": true,
      "55919": true,
      "55927": true,
      "55933": true,
      "55934": true,
      "55939": true
    },
    "AXAPUSCO": {
      "55943": true,
      "55950": true,
      "55951": true,
      "55954": true,
      "55956": true,
      "55960": true
    },
    "NOPALTEPEC": {
      "55974": true,
      "55977": true,
      "55978": true
    },
    "TEMASCALAPA": {
      "55980": true,
      "55983": true,
      "55985": true,
      "55988": true,
      "55989": true,
      "55990": true,
      "55995": true
    },
    "TEZOYUCA": {
      "56005": true,
      "56006": true,
      "56007": true,
      "56010": true,
      "56023": true,
      "56025": true,
      "56026": true,
      "56027": true
    },
    "CHIAUTLA": {
      "56031": true,
      "56034": true,
      "56037": true
    },
    "PAPALOTLA": {
      "56055": true,
      "56056": true,
      "56057": true
    },
    "TEPETLAOXTOC": {
      "56074": true,
      "56077": true,
      "56078": true,
      "56079": true,
      "56083": true,
      "56084": true,
      "56086": true,
      "56090": true,
      "56093": true,
      "56095": true,
      "56096": true
    },
    "TEXCOCO": {
      "56100": true,
      "56101": true,
      "56102": true,
      "56103": true,
      "56104": true,
      "56105": true,
      "56106": true,
      "56107": true,
      "56108": true,
      "56109": true,
      "56110": true,
      "56111": true,
      "56112": true,
      "56113": true,
      "56114": true,
      "56115": true,
      "56116": true,
      "56117": true,
      "56118": true,
      "56119": true,
      "56120": true,
      "56121": true,
      "56122": true,
      "56123": true,
      "56124": true,
      "56125": true,
      "56126": true,
      "56127": true,
      "56128": true,
      "56129": true,
      "56130": true,
      "56131": true,
      "56132": true,
      "56133": true,
      "56134": true,
      "56135": true,
      "56136": true,
      "56137": true,
      "56138": true,
      "56139": true,
      "56140": true,
      "56141": true,
      "56142": true,
      "56143": true,
      "56144": true,
      "56145": true,
      "56146": true,
      "56147": true,
      "56148": true,
      "56149": true,
      "56150": true,
      "56151": true,
      "56152": true,
      "56153": true,
      "56154": true,
      "56155": true,
      "56156": true,
      "56157": true,
      "56158": true,
      "56159": true,
      "56160": true,
      "56161": true,
      "56162": true,
      "56163": true,
      "56164": true,
      "56165": true,
      "56166": true,
      "56167": true,
      "56168": true,
      "56169": true,
      "56170": true,
      "56171": true,
      "56172": true,
      "56173": true,
      "56174": true,
      "56175": true,
      "56176": true,
      "56177": true,
      "56178": true,
      "56179": true,
      "56180": true,
      "56181": true,
      "56182": true,
      "56183": true,
      "56184": true,
      "56185": true,
      "56186": true,
      "56187": true,
      "56188": true,
      "56189": true,
      "56190": true,
      "56191": true,
      "56192": true,
      "56193": true,
      "56194": true,
      "56195": true,
      "56196": true,
      "56197": true,
      "56198": true,
      "56199": true,
      "56200": true,
      "56201": true,
      "56202": true,
      "56203": true,
      "56204": true,
      "56205": true,
      "56206": true,
      "56207": true,
      "56208": true,
      "56209": true,
      "56210": true,
      "56211": true,
      "56212": true,
      "56213": true,
      "56214": true,
      "56215": true,
      "56216": true,
      "56217": true,
      "56218": true,
      "56219": true,
      "56220": true,
      "56221": true,
      "56222": true,
      "56223": true,
      "56224": true,
      "56225": true,
      "56226": true,
      "56227": true,
      "56228": true,
      "56229": true,
      "56230": true,
      "56232": true,
      "56233": true,
      "56234": true,
      "56235": true,
      "56236": true,
      "56237": true,
      "56238": true,
      "56239": true,
      "56240": true,
      "56243": true,
      "56244": true,
      "56245": true,
      "56246": true,
      "56247": true,
      "56249": true,
      "56250": true,
      "56251": true,
      "56253": true,
      "56254": true,
      "56255": true,
      "56256": true,
      "56257": true,
      "56258": true,
      "56259": true,
      "56260": true,
      "56263": true,
      "56264": true,
      "56265": true,
      "56266": true,
      "56267": true,
      "56268": true,
      "56269": true
    },
    "CHICONCUAC": {
      "56270": true,
      "56272": true,
      "56273": true,
      "56274": true,
      "56280": true
    },
    "ATENCO": {
      "56301": true,
      "56303": true,
      "56305": true,
      "56306": true,
      "56307": true,
      "56313": true,
      "56320": true
    },
    "CHICOLOAPAN": {
      "56370": true,
      "56373": true,
      "56375": true,
      "56376": true,
      "56377": true,
      "56380": true,
      "56383": true,
      "56384": true,
      "56386": true,
      "56387": true,
      "56390": true,
      "56396": true
    },
    "LA PAZ": {
      "56400": true,
      "56401": true,
      "56402": true,
      "56403": true,
      "56404": true,
      "56405": true,
      "56406": true,
      "56407": true,
      "56408": true,
      "56409": true,
      "56410": true,
      "56411": true,
      "56412": true,
      "56413": true,
      "56414": true,
      "56415": true,
      "56416": true,
      "56417": true,
      "56418": true,
      "56419": true,
      "56420": true,
      "56421": true,
      "56422": true,
      "56423": true,
      "56424": true,
      "56425": true,
      "56426": true,
      "56427": true,
      "56428": true,
      "56429": true,
      "56430": true,
      "56440": true,
      "56490": true,
      "56495": true,
      "56500": true,
      "56505": true,
      "56506": true,
      "56507": true,
      "56508": true,
      "56509": true,
      "56510": true,
      "56512": true,
      "56513": true,
      "56514": true,
      "56515": true,
      "56516": true,
      "56520": true,
      "56523": true,
      "56524": true,
      "56525": true,
      "56526": true,
      "56527": true,
      "56528": true,
      "56529": true
    },
    "LOS REYES LA PAZ": {
      "56431": true,
      "56432": true,
      "56433": true,
      "56434": true,
      "56435": true,
      "56436": true,
      "56437": true,
      "56438": true,
      "56439": true,
      "56441": true,
      "56442": true,
      "56443": true,
      "56444": true,
      "56445": true,
      "56446": true,
      "56447": true,
      "56448": true,
      "56449": true,
      "56450": true,
      "56451": true,
      "56452": true,
      "56453": true,
      "56454": true,
      "56455": true,
      "56456": true,
      "56457": true,
      "56458": true,
      "56459": true,
      "56460": true,
      "56461": true,
      "56462": true,
      "56463": true,
      "56464": true,
      "56465": true,
      "56466": true,
      "56467": true,
      "56468": true,
      "56469": true,
      "56470": true,
      "56471": true,
      "56472": true,
      "56473": true,
      "56474": true,
      "56475": true,
      "56476": true,
      "56477": true,
      "56478": true,
      "56479": true,
      "56480": true,
      "56481": true,
      "56482": true,
      "56483": true,
      "56484": true,
      "56485": true,
      "56486": true,
      "56487": true,
      "56488": true,
      "56489": true,
      "56491": true,
      "56492": true,
      "56493": true,
      "56494": true,
      "56496": true,
      "56497": true,
      "56498": true,
      "56499": true,
      "56501": true,
      "56502": true,
      "56503": true,
      "56504": true,
      "56511": true,
      "56517": true,
      "56518": true,
      "56519": true,
      "56521": true,
      "56522": true
    },
    "IXTAPALUCA": {
      "56530": true,
      "56531": true,
      "56532": true,
      "56533": true,
      "56534": true,
      "56535": true,
      "56536": true,
      "56537": true,
      "56538": true,
      "56539": true,
      "56540": true,
      "56541": true,
      "56542": true,
      "56543": true,
      "56544": true,
      "56545": true,
      "56546": true,
      "56547": true,
      "56548": true,
      "56549": true,
      "56550": true,
      "56551": true,
      "56552": true,
      "56553": true,
      "56554": true,
      "56555": true,
      "56556": true,
      "56557": true,
      "56558": true,
      "56559": true,
      "56560": true,
      "56561": true,
      "56562": true,
      "56563": true,
      "56564": true,
      "56565": true,
      "56566": true,
      "56567": true,
      "56568": true,
      "56569": true,
      "56570": true,
      "56576": true,
      "56577": true,
      "56579": true,
      "56580": true,
      "56584": true,
      "56585": true,
      "56586": true,
      "56587": true,
      "56588": true,
      "56589": true
    },
    "CHALCO": {
      "56600": true,
      "56604": true,
      "56605": true,
      "56606": true,
      "56607": true,
      "56608": true,
      "56609": true,
      "56620": true,
      "56623": true,
      "56624": true,
      "56625": true,
      "56640": true,
      "56641": true,
      "56642": true,
      "56643": true,
      "56644": true,
      "56646": true,
      "56647": true
    },
    "VALLE DE CHALCO SOLIDARIDAD": {
      "56610": true,
      "56613": true,
      "56614": true,
      "56615": true,
      "56616": true,
      "56617": true,
      "56618": true,
      "56619": true
    },
    "TEMAMATLA": {
      "56653": true,
      "56654": true,
      "56656": true,
      "56657": true
    },
    "COCOTITLÁN": {
      "56684": true
    },
    "TLALMANALCO": {
      "56710": true,
      "56713": true,
      "56714": true,
      "56716": true,
      "56726": true,
      "56731": true,
      "56743": true,
      "56744": true,
      "56745": true,
      "56746": true,
      "56747": true
    },
    "AYAPANGO": {
      "56763": true,
      "56765": true,
      "56766": true,
      "56767": true,
      "56770": true,
      "56777": true
    },
    "TENANGO DEL AIRE": {
      "56783": true,
      "56784": true,
      "56785": true
    },
    "OZUMBA": {
      "56804": true,
      "56805": true,
      "56806": true,
      "56813": true,
      "56814": true,
      "56815": true,
      "56820": true
    },
    "JUCHITEPEC": {
      "56860": true,
      "56865": true,
      "56866": true,
      "56867": true
    },
    "TEPETLIXPA": {
      "56884": true,
      "56886": true,
      "56893": true,
      "56894": true,
      "56895": true
    },
    "AMECAMECA": {
      "56900": true,
      "56903": true,
      "56904": true,
      "56905": true,
      "56913": true,
      "56914": true,
      "56920": true,
      "56923": true,
      "56924": true,
      "56933": true,
      "56940": true,
      "56941": true,
      "56945": true,
      "56950": true,
      "56953": true,
      "56954": true,
      "56955": true,
      "56960": true,
      "56963": true,
      "56965": true
    },
    "ATLAUTLA": {
      "56973": true,
      "56977": true,
      "56978": true,
      "56979": true,
      "56982": true,
      "56984": true
    },
    "NEZAHUALCÓYOTL": {
      "57000": true,
      "57001": true,
      "57002": true,
      "57003": true,
      "57004": true,
      "57005": true,
      "57006": true,
      "57007": true,
      "57008": true,
      "57009": true,
      "57010": true,
      "57011": true,
      "57012": true,
      "57013": true,
      "57014": true,
      "57015": true,
      "57016": true,
      "57017": true,
      "57018": true,
      "57019": true,
      "57020": true,
      "57021": true,
      "57022": true,
      "57023": true,
      "57024": true,
      "57025": true,
      "57026": true,
      "57027": true,
      "57028": true,
      "57029": true,
      "57030": true,
      "57031": true,
      "57032": true,
      "57033": true,
      "57034": true,
      "57035": true,
      "57036": true,
      "57037": true,
      "57038": true,
      "57039": true,
      "57040": true,
      "57041": true,
      "57042": true,
      "57043": true,
      "57044": true,
      "57045": true,
      "57046": true,
      "57047": true,
      "57048": true,
      "57049": true,
      "57050": true,
      "57051": true,
      "57052": true,
      "57053": true,
      "57054": true,
      "57055": true,
      "57056": true,
      "57057": true,
      "57058": true,
      "57059": true,
      "57060": true,
      "57061": true,
      "57062": true,
      "57063": true,
      "57064": true,
      "57065": true,
      "57066": true,
      "57067": true,
      "57068": true,
      "57069": true,
      "57070": true,
      "57071": true,
      "57072": true,
      "57073": true,
      "57074": true,
      "57075": true,
      "57076": true,
      "57077": true,
      "57078": true,
      "57079": true,
      "57080": true,
      "57081": true,
      "57082": true,
      "57083": true,
      "57084": true,
      "57085": true,
      "57086": true,
      "57087": true,
      "57088": true,
      "57089": true,
      "57090": true,
      "57091": true,
      "57092": true,
      "57093": true,
      "57094": true,
      "57095": true,
      "57096": true,
      "57097": true,
      "57098": true,
      "57099": true,
      "57100": true,
      "57103": true,
      "57120": true,
      "57129": true,
      "57130": true,
      "57138": true,
      "57139": true,
      "57140": true,
      "57150": true,
      "57158": true,
      "57170": true,
      "57171": true,
      "57178": true,
      "57179": true,
      "57180": true,
      "57185": true,
      "57188": true,
      "57189": true,
      "57200": true,
      "57201": true,
      "57202": true,
      "57203": true,
      "57204": true,
      "57205": true,
      "57206": true,
      "57207": true,
      "57208": true,
      "57209": true,
      "57210": true,
      "57211": true,
      "57212": true,
      "57213": true,
      "57214": true,
      "57215": true,
      "57216": true,
      "57217": true,
      "57218": true,
      "57219": true,
      "57220": true,
      "57221": true,
      "57222": true,
      "57223": true,
      "57224": true,
      "57225": true,
      "57226": true,
      "57227": true,
      "57228": true,
      "57229": true,
      "57230": true,
      "57231": true,
      "57232": true,
      "57233": true,
      "57234": true,
      "57235": true,
      "57236": true,
      "57237": true,
      "57238": true,
      "57239": true,
      "57240": true,
      "57241": true,
      "57242": true,
      "57243": true,
      "57244": true,
      "57245": true,
      "57246": true,
      "57247": true,
      "57248": true,
      "57249": true,
      "57250": true,
      "57251": true,
      "57252": true,
      "57253": true,
      "57254": true,
      "57255": true,
      "57256": true,
      "57257": true,
      "57258": true,
      "57259": true,
      "57260": true,
      "57261": true,
      "57262": true,
      "57263": true,
      "57264": true,
      "57265": true,
      "57266": true,
      "57267": true,
      "57268": true,
      "57269": true,
      "57270": true,
      "57271": true,
      "57272": true,
      "57273": true,
      "57274": true,
      "57275": true,
      "57276": true,
      "57277": true,
      "57278": true,
      "57279": true,
      "57280": true,
      "57281": true,
      "57282": true,
      "57283": true,
      "57284": true,
      "57285": true,
      "57286": true,
      "57287": true,
      "57288": true,
      "57289": true,
      "57290": true,
      "57291": true,
      "57292": true,
      "57293": true,
      "57294": true,
      "57295": true,
      "57296": true,
      "57297": true,
      "57298": true,
      "57299": true,
      "57300": true,
      "57301": true,
      "57302": true,
      "57303": true,
      "57304": true,
      "57305": true,
      "57306": true,
      "57307": true,
      "57308": true,
      "57309": true,
      "57310": true,
      "57311": true,
      "57312": true,
      "57313": true,
      "57314": true,
      "57315": true,
      "57316": true,
      "57317": true,
      "57318": true,
      "57319": true,
      "57320": true,
      "57321": true,
      "57322": true,
      "57323": true,
      "57324": true,
      "57325": true,
      "57326": true,
      "57327": true,
      "57328": true,
      "57329": true,
      "57330": true,
      "57331": true,
      "57332": true,
      "57333": true,
      "57334": true,
      "57335": true,
      "57336": true,
      "57337": true,
      "57338": true,
      "57339": true,
      "57340": true,
      "57341": true,
      "57342": true,
      "57343": true,
      "57344": true,
      "57345": true,
      "57346": true,
      "57347": true,
      "57348": true,
      "57349": true,
      "57350": true,
      "57351": true,
      "57352": true,
      "57353": true,
      "57354": true,
      "57355": true,
      "57356": true,
      "57357": true,
      "57358": true,
      "57359": true,
      "57360": true,
      "57361": true,
      "57362": true,
      "57363": true,
      "57364": true,
      "57365": true,
      "57366": true,
      "57367": true,
      "57368": true,
      "57369": true,
      "57370": true,
      "57371": true,
      "57372": true,
      "57373": true,
      "57374": true,
      "57375": true,
      "57376": true,
      "57377": true,
      "57378": true,
      "57379": true,
      "57380": true,
      "57381": true,
      "57382": true,
      "57383": true,
      "57384": true,
      "57385": true,
      "57386": true,
      "57387": true,
      "57388": true,
      "57389": true,
      "57390": true,
      "57391": true,
      "57392": true,
      "57393": true,
      "57394": true,
      "57395": true,
      "57396": true,
      "57397": true,
      "57398": true,
      "57399": true,
      "57400": true,
      "57401": true,
      "57402": true,
      "57403": true,
      "57404": true,
      "57405": true,
      "57406": true,
      "57407": true,
      "57408": true,
      "57409": true,
      "57410": true,
      "57411": true,
      "57412": true,
      "57413": true,
      "57414": true,
      "57415": true,
      "57416": true,
      "57417": true,
      "57418": true,
      "57419": true,
      "57420": true,
      "57421": true,
      "57422": true,
      "57423": true,
      "57424": true,
      "57425": true,
      "57426": true,
      "57427": true,
      "57428": true,
      "57429": true,
      "57430": true,
      "57431": true,
      "57432": true,
      "57433": true,
      "57434": true,
      "57435": true,
      "57436": true,
      "57437": true,
      "57438": true,
      "57439": true,
      "57440": true,
      "57441": true,
      "57442": true,
      "57443": true,
      "57444": true,
      "57445": true,
      "57446": true,
      "57447": true,
      "57448": true,
      "57449": true,
      "57450": true,
      "57451": true,
      "57452": true,
      "57453": true,
      "57454": true,
      "57455": true,
      "57456": true,
      "57457": true,
      "57458": true,
      "57459": true,
      "57460": true,
      "57461": true,
      "57462": true,
      "57463": true,
      "57464": true,
      "57465": true,
      "57466": true,
      "57467": true,
      "57468": true,
      "57469": true,
      "57470": true,
      "57471": true,
      "57472": true,
      "57473": true,
      "57474": true,
      "57475": true,
      "57476": true,
      "57477": true,
      "57478": true,
      "57479": true,
      "57480": true,
      "57481": true,
      "57482": true,
      "57483": true,
      "57484": true,
      "57485": true,
      "57486": true,
      "57487": true,
      "57488": true,
      "57489": true,
      "57490": true,
      "57491": true,
      "57492": true,
      "57493": true,
      "57494": true,
      "57495": true,
      "57496": true,
      "57497": true,
      "57498": true,
      "57499": true,
      "57500": true,
      "57501": true,
      "57502": true,
      "57503": true,
      "57504": true,
      "57505": true,
      "57506": true,
      "57507": true,
      "57508": true,
      "57509": true,
      "57510": true,
      "57511": true,
      "57512": true,
      "57513": true,
      "57514": true,
      "57515": true,
      "57516": true,
      "57517": true,
      "57518": true,
      "57519": true,
      "57520": true,
      "57521": true,
      "57522": true,
      "57523": true,
      "57524": true,
      "57525": true,
      "57526": true,
      "57527": true,
      "57528": true,
      "57529": true,
      "57530": true,
      "57531": true,
      "57532": true,
      "57533": true,
      "57534": true,
      "57535": true,
      "57536": true,
      "57537": true,
      "57538": true,
      "57539": true,
      "57540": true,
      "57541": true,
      "57542": true,
      "57543": true,
      "57544": true,
      "57545": true,
      "57546": true,
      "57547": true,
      "57548": true,
      "57549": true,
      "57550": true,
      "57551": true,
      "57552": true,
      "57553": true,
      "57554": true,
      "57555": true,
      "57556": true,
      "57557": true,
      "57558": true,
      "57559": true,
      "57560": true,
      "57561": true,
      "57562": true,
      "57563": true,
      "57564": true,
      "57565": true,
      "57566": true,
      "57567": true,
      "57568": true,
      "57569": true,
      "57570": true,
      "57571": true,
      "57572": true,
      "57573": true,
      "57574": true,
      "57575": true,
      "57576": true,
      "57577": true,
      "57578": true,
      "57579": true,
      "57580": true,
      "57581": true,
      "57582": true,
      "57583": true,
      "57584": true,
      "57585": true,
      "57586": true,
      "57587": true,
      "57588": true,
      "57589": true,
      "57590": true,
      "57591": true,
      "57592": true,
      "57593": true,
      "57594": true,
      "57595": true,
      "57596": true,
      "57597": true,
      "57598": true,
      "57599": true,
      "57600": true,
      "57601": true,
      "57602": true,
      "57603": true,
      "57604": true,
      "57605": true,
      "57606": true,
      "57607": true,
      "57608": true,
      "57609": true,
      "57610": true,
      "57611": true,
      "57612": true,
      "57613": true,
      "57614": true,
      "57615": true,
      "57616": true,
      "57617": true,
      "57618": true,
      "57619": true,
      "57620": true,
      "57621": true,
      "57622": true,
      "57623": true,
      "57624": true,
      "57625": true,
      "57626": true,
      "57627": true,
      "57628": true,
      "57629": true,
      "57630": true,
      "57631": true,
      "57632": true,
      "57633": true,
      "57634": true,
      "57635": true,
      "57636": true,
      "57637": true,
      "57638": true,
      "57639": true,
      "57640": true,
      "57641": true,
      "57642": true,
      "57643": true,
      "57644": true,
      "57645": true,
      "57646": true,
      "57647": true,
      "57648": true,
      "57649": true,
      "57650": true,
      "57651": true,
      "57652": true,
      "57653": true,
      "57654": true,
      "57655": true,
      "57656": true,
      "57657": true,
      "57658": true,
      "57659": true,
      "57660": true,
      "57661": true,
      "57662": true,
      "57663": true,
      "57664": true,
      "57665": true,
      "57666": true,
      "57667": true,
      "57668": true,
      "57669": true,
      "57670": true,
      "57671": true,
      "57672": true,
      "57673": true,
      "57674": true,
      "57675": true,
      "57676": true,
      "57677": true,
      "57678": true,
      "57679": true,
      "57680": true,
      "57681": true,
      "57682": true,
      "57683": true,
      "57684": true,
      "57685": true,
      "57686": true,
      "57687": true,
      "57688": true,
      "57689": true,
      "57690": true,
      "57691": true,
      "57692": true,
      "57693": true,
      "57694": true,
      "57695": true,
      "57696": true,
      "57697": true,
      "57698": true,
      "57699": true,
      "57700": true,
      "57701": true,
      "57702": true,
      "57703": true,
      "57704": true,
      "57705": true,
      "57706": true,
      "57707": true,
      "57708": true,
      "57709": true,
      "57710": true,
      "57711": true,
      "57712": true,
      "57713": true,
      "57714": true,
      "57715": true,
      "57716": true,
      "57717": true,
      "57718": true,
      "57719": true,
      "57720": true,
      "57721": true,
      "57722": true,
      "57723": true,
      "57724": true,
      "57725": true,
      "57726": true,
      "57727": true,
      "57728": true,
      "57729": true,
      "57730": true,
      "57731": true,
      "57732": true,
      "57733": true,
      "57734": true,
      "57735": true,
      "57736": true,
      "57737": true,
      "57738": true,
      "57739": true,
      "57740": true,
      "57741": true,
      "57742": true,
      "57743": true,
      "57744": true,
      "57745": true,
      "57746": true,
      "57747": true,
      "57748": true,
      "57749": true,
      "57750": true,
      "57751": true,
      "57752": true,
      "57753": true,
      "57754": true,
      "57755": true,
      "57756": true,
      "57757": true,
      "57758": true,
      "57759": true,
      "57760": true,
      "57761": true,
      "57762": true,
      "57763": true,
      "57764": true,
      "57765": true,
      "57766": true,
      "57767": true,
      "57768": true,
      "57769": true,
      "57770": true,
      "57771": true,
      "57772": true,
      "57773": true,
      "57774": true,
      "57775": true,
      "57776": true,
      "57777": true,
      "57778": true,
      "57779": true,
      "57780": true,
      "57781": true,
      "57782": true,
      "57783": true,
      "57784": true,
      "57785": true,
      "57786": true,
      "57787": true,
      "57788": true,
      "57789": true,
      "57790": true,
      "57791": true,
      "57792": true,
      "57793": true,
      "57794": true,
      "57795": true,
      "57796": true,
      "57797": true,
      "57798": true,
      "57799": true,
      "57800": true,
      "57801": true,
      "57802": true,
      "57803": true,
      "57804": true,
      "57805": true,
      "57806": true,
      "57807": true,
      "57808": true,
      "57809": true,
      "57810": true,
      "57811": true,
      "57812": true,
      "57813": true,
      "57814": true,
      "57815": true,
      "57816": true,
      "57817": true,
      "57818": true,
      "57819": true,
      "57820": true,
      "57821": true,
      "57822": true,
      "57823": true,
      "57824": true,
      "57825": true,
      "57826": true,
      "57827": true,
      "57828": true,
      "57829": true,
      "57830": true,
      "57831": true,
      "57832": true,
      "57833": true,
      "57834": true,
      "57835": true,
      "57836": true,
      "57837": true,
      "57838": true,
      "57839": true,
      "57840": true,
      "57841": true,
      "57842": true,
      "57843": true,
      "57844": true,
      "57845": true,
      "57846": true,
      "57847": true,
      "57848": true,
      "57849": true,
      "57850": true,
      "57851": true,
      "57852": true,
      "57853": true,
      "57854": true,
      "57855": true,
      "57856": true,
      "57857": true,
      "57858": true,
      "57859": true,
      "57860": true,
      "57861": true,
      "57862": true,
      "57863": true,
      "57864": true,
      "57865": true,
      "57866": true,
      "57867": true,
      "57868": true,
      "57869": true,
      "57870": true,
      "57871": true,
      "57872": true,
      "57873": true,
      "57874": true,
      "57875": true,
      "57876": true,
      "57877": true,
      "57878": true,
      "57879": true,
      "57880": true,
      "57881": true,
      "57882": true,
      "57883": true,
      "57884": true,
      "57885": true,
      "57886": true,
      "57887": true,
      "57888": true,
      "57889": true,
      "57890": true,
      "57891": true,
      "57892": true,
      "57893": true,
      "57894": true,
      "57895": true,
      "57896": true,
      "57897": true,
      "57898": true,
      "57899": true,
      "57900": true,
      "57901": true,
      "57902": true,
      "57903": true,
      "57904": true,
      "57905": true,
      "57906": true,
      "57907": true,
      "57908": true,
      "57909": true,
      "57910": true,
      "57911": true,
      "57912": true,
      "57913": true,
      "57914": true,
      "57915": true,
      "57916": true,
      "57917": true,
      "57918": true,
      "57919": true,
      "57920": true,
      "57921": true,
      "57922": true,
      "57923": true,
      "57924": true,
      "57925": true,
      "57926": true,
      "57927": true,
      "57928": true,
      "57929": true,
      "57930": true,
      "57931": true,
      "57932": true,
      "57933": true,
      "57934": true,
      "57935": true,
      "57936": true,
      "57937": true,
      "57938": true,
      "57939": true,
      "57940": true,
      "57941": true,
      "57942": true,
      "57943": true,
      "57944": true,
      "57945": true,
      "57946": true,
      "57947": true,
      "57948": true,
      "57949": true,
      "57950": true,
      "57951": true,
      "57952": true,
      "57953": true,
      "57954": true,
      "57955": true,
      "57956": true,
      "57957": true,
      "57958": true,
      "57959": true,
      "57960": true,
      "57961": true,
      "57962": true,
      "57963": true,
      "57964": true,
      "57965": true,
      "57966": true,
      "57967": true,
      "57968": true,
      "57969": true,
      "57970": true,
      "57971": true,
      "57972": true,
      "57973": true,
      "57974": true,
      "57975": true,
      "57976": true,
      "57977": true,
      "57978": true,
      "57979": true,
      "57980": true,
      "57981": true,
      "57982": true,
      "57983": true,
      "57984": true,
      "57985": true,
      "57986": true,
      "57987": true,
      "57988": true,
      "57989": true,
      "57990": true,
      "57991": true,
      "57992": true,
      "57993": true,
      "57994": true,
      "57995": true,
      "57996": true,
      "57997": true,
      "57998": true,
      "57999": true
    },
    "TECÁMAC": {
      "55763": true,
      "55764": true
    },
    "CHIMALHUACÁN": {
      "56330": true,
      "56334": true,
      "56335": true,
      "56337": true,
      "56340": true,
      "56343": true,
      "56344": true,
      "56346": true,
      "56350": true,
      "56353": true,
      "56356": true,
      "56360": true,
      "56363": true,
      "56366": true
    }
  },
  "MICHOACÁN": {
    "MORELIA": {
      "58000": true,
      "58004": true,
      "58006": true,
      "58009": true,
      "58010": true,
      "58013": true,
      "58020": true,
      "58030": true,
      "58040": true,
      "58048": true,
      "58049": true,
      "58050": true,
      "58055": true,
      "58056": true,
      "58057": true,
      "58058": true,
      "58060": true,
      "58066": true,
      "58067": true,
      "58069": true,
      "58070": true,
      "58078": true,
      "58079": true,
      "58080": true,
      "58085": true,
      "58086": true,
      "58087": true,
      "58088": true,
      "58089": true,
      "58090": true,
      "58093": true,
      "58095": true,
      "58096": true,
      "58097": true,
      "58098": true,
      "58099": true,
      "58100": true,
      "58110": true,
      "58114": true,
      "58115": true,
      "58116": true,
      "58117": true,
      "58118": true,
      "58120": true,
      "58127": true,
      "58128": true,
      "58130": true,
      "58140": true,
      "58145": true,
      "58146": true,
      "58147": true,
      "58148": true,
      "58149": true,
      "58150": true,
      "58158": true,
      "58160": true,
      "58168": true,
      "58170": true,
      "58175": true,
      "58178": true,
      "58179": true,
      "58180": true,
      "58183": true,
      "58186": true,
      "58187": true,
      "58188": true,
      "58189": true,
      "58190": true,
      "58194": true,
      "58195": true,
      "58196": true,
      "58197": true,
      "58199": true,
      "58200": true,
      "58210": true,
      "58216": true,
      "58217": true,
      "58218": true,
      "58219": true,
      "58220": true,
      "58226": true,
      "58227": true,
      "58228": true,
      "58229": true,
      "58230": true,
      "58240": true,
      "58244": true,
      "58245": true,
      "58248": true,
      "58249": true,
      "58250": true,
      "58253": true,
      "58254": true,
      "58255": true,
      "58256": true,
      "58257": true,
      "58258": true,
      "58259": true,
      "58260": true,
      "58270": true,
      "58277": true,
      "58278": true,
      "58280": true,
      "58290": true,
      "58295": true,
      "58296": true,
      "58297": true,
      "58300": true,
      "58301": true,
      "58302": true,
      "58303": true,
      "58304": true,
      "58310": true,
      "58314": true,
      "58317": true,
      "58320": true,
      "58321": true,
      "58330": true,
      "58331": true,
      "58332": true,
      "58333": true,
      "58335": true,
      "58336": true,
      "58337": true,
      "58340": true,
      "58341": true,
      "58342": true,
      "58343": true,
      "58344": true,
      "58345": true,
      "58346": true,
      "58348": true,
      "58350": true,
      "58353": true,
      "58355": true,
      "58356": true,
      "58357": true,
      "58358": true,
      "58359": true
    },
    "HUANIQUEO": {
      "58360": true,
      "58363": true,
      "58365": true,
      "58390": true,
      "58399": true
    },
    "COENEO": {
      "58400": true,
      "58403": true,
      "58404": true,
      "58410": true,
      "58412": true,
      "58413": true,
      "58414": true,
      "58415": true,
      "58416": true
    },
    "QUIROGA": {
      "58420": true,
      "58423": true,
      "58424": true,
      "58425": true,
      "58426": true,
      "58430": true,
      "58433": true,
      "58435": true,
      "58436": true
    },
    "TZINTZUNTZAN": {
      "58440": true,
      "58442": true,
      "58443": true,
      "58444": true,
      "58446": true
    },
    "LAGUNILLAS": {
      "58450": true
    },
    "ACUITZIO": {
      "58460": true
    },
    "MADERO": {
      "58480": true,
      "58484": true,
      "58491": true
    },
    "PURUÁNDIRO": {
      "58500": true,
      "58502": true,
      "58503": true,
      "58504": true,
      "58505": true,
      "58506": true,
      "58507": true,
      "58508": true,
      "58510": true,
      "58511": true,
      "58512": true,
      "58513": true,
      "58514": true,
      "58515": true,
      "58516": true,
      "58517": true,
      "58520": true,
      "58524": true,
      "58530": true,
      "58531": true,
      "58532": true,
      "58533": true
    },
    "JOSÉ SIXTO VERDUZCO": {
      "58540": true,
      "58542": true,
      "58543": true,
      "58544": true,
      "58545": true,
      "58546": true,
      "58547": true
    },
    "ANGAMACUTIRO": {
      "58550": true,
      "58557": true,
      "58558": true,
      "58560": true,
      "58563": true,
      "58564": true
    },
    "PANINDÍCUARO": {
      "58570": true,
      "58574": true,
      "58578": true,
      "58579": true,
      "58580": true,
      "58581": true,
      "58586": true,
      "58590": true,
      "58591": true,
      "58594": true,
      "58598": true
    },
    "ZACAPU": {
      "58600": true,
      "58610": true,
      "58616": true,
      "58617": true,
      "58620": true,
      "58624": true,
      "58627": true,
      "58628": true,
      "58629": true,
      "58630": true,
      "58635": true,
      "58637": true,
      "58638": true,
      "58639": true,
      "58640": true,
      "58649": true,
      "58650": true,
      "58653": true,
      "58654": true,
      "58660": true,
      "58664": true,
      "58665": true,
      "58667": true,
      "58670": true,
      "58676": true,
      "58677": true,
      "58680": true,
      "58685": true,
      "58688": true,
      "58689": true,
      "58690": true,
      "58698": true,
      "58701": true,
      "58702": true,
      "58703": true,
      "58710": true,
      "58711": true,
      "58720": true,
      "58728": true,
      "58730": true,
      "58731": true,
      "58733": true,
      "58735": true
    },
    "TLAZAZALCA": {
      "58740": true,
      "58741": true,
      "58746": true
    },
    "PURÉPERO": {
      "58760": true,
      "58762": true,
      "58763": true,
      "58764": true,
      "58765": true,
      "58770": true
    },
    "JIMÉNEZ": {
      "58780": true,
      "58782": true,
      "58783": true,
      "58785": true,
      "58786": true,
      "58793": true,
      "58796": true
    },
    "MORELOS": {
      "58800": true,
      "58804": true,
      "58805": true,
      "58807": true
    },
    "HUANDACAREO": {
      "58820": true,
      "58825": true,
      "58827": true,
      "58830": true,
      "58833": true
    },
    "CUITZEO": {
      "58840": true,
      "58842": true,
      "58843": true,
      "58845": true,
      "58850": true,
      "58853": true,
      "58854": true,
      "58855": true
    },
    "CHUCÁNDIRO": {
      "58860": true
    },
    "COPÁNDARO": {
      "58870": true,
      "58872": true,
      "58873": true,
      "58874": true
    },
    "TARÍMBARO": {
      "58880": true,
      "58881": true,
      "58883": true,
      "58885": true,
      "58887": true,
      "58890": true,
      "58891": true,
      "58893": true,
      "58894": true,
      "58895": true,
      "58896": true
    },
    "SANTA ANA MAYA": {
      "58900": true,
      "58905": true,
      "58909": true,
      "58910": true,
      "58912": true,
      "58913": true,
      "58914": true,
      "58915": true,
      "58918": true,
      "58919": true
    },
    "ÁLVARO OBREGÓN": {
      "58920": true,
      "58923": true,
      "58924": true,
      "58925": true,
      "58926": true,
      "58927": true,
      "58928": true
    },
    "ZINAPÉCUARO": {
      "58930": true,
      "58931": true,
      "58932": true,
      "58933": true,
      "58935": true,
      "58936": true,
      "58937": true,
      "58938": true,
      "58940": true,
      "58942": true,
      "58944": true,
      "58945": true,
      "58946": true,
      "58948": true,
      "58949": true,
      "58950": true,
      "58953": true,
      "58956": true,
      "58960": true,
      "58962": true,
      "58963": true,
      "58964": true,
      "58965": true,
      "58966": true
    },
    "INDAPARAPEO": {
      "58970": true,
      "58972": true,
      "58977": true,
      "58978": true
    },
    "QUERÉNDARO": {
      "58980": true,
      "58986": true,
      "58987": true
    },
    "SAHUAYO": {
      "59000": true,
      "59010": true,
      "59012": true,
      "59013": true,
      "59014": true,
      "59015": true,
      "59020": true,
      "59023": true,
      "59026": true,
      "59027": true,
      "59028": true,
      "59030": true,
      "59033": true,
      "59034": true,
      "59035": true,
      "59036": true,
      "59040": true,
      "59043": true,
      "59044": true,
      "59045": true,
      "59050": true,
      "59057": true,
      "59058": true,
      "59100": true,
      "59102": true,
      "59103": true,
      "59104": true,
      "59105": true
    },
    "BRISEÑAS": {
      "59120": true,
      "59121": true,
      "59122": true
    },
    "COJUMATLÁN DE RÉGULES": {
      "59140": true,
      "59150": true
    },
    "VENUSTIANO CARRANZA": {
      "59160": true,
      "59163": true,
      "59165": true,
      "59167": true,
      "59168": true,
      "59170": true,
      "59173": true,
      "59175": true
    },
    "PAJACUARÁN": {
      "59180": true,
      "59183": true,
      "59184": true,
      "59190": true,
      "59193": true,
      "59194": true
    },
    "VISTA HERMOSA": {
      "59200": true,
      "59203": true,
      "59210": true,
      "59220": true
    },
    "TANHUATO": {
      "59230": true,
      "59243": true
    },
    "YURÉCUARO": {
      "59250": true,
      "59253": true,
      "59254": true,
      "59256": true,
      "59257": true,
      "59258": true,
      "59265": true,
      "59266": true
    },
    "IXTLÁN": {
      "59280": true,
      "59283": true,
      "59284": true,
      "59285": true,
      "59286": true,
      "59290": true,
      "59295": true,
      "59296": true
    },
    "LA PIEDAD": {
      "59300": true,
      "59310": true,
      "59319": true,
      "59320": true,
      "59330": true,
      "59334": true,
      "59335": true,
      "59340": true,
      "59349": true,
      "59350": true,
      "59359": true,
      "59360": true,
      "59363": true,
      "59370": true,
      "59373": true,
      "59374": true,
      "59375": true,
      "59376": true,
      "59377": true,
      "59379": true,
      "59380": true,
      "59384": true,
      "59386": true,
      "59387": true,
      "59389": true,
      "59390": true,
      "59392": true,
      "59393": true,
      "59400": true,
      "59424": true,
      "59425": true,
      "59426": true
    },
    "NUMARÁN": {
      "59430": true
    },
    "CHURINTZIO": {
      "59440": true
    },
    "ZINÁPARO": {
      "59460": true,
      "59463": true
    },
    "PENJAMILLO": {
      "59470": true,
      "59472": true,
      "59476": true,
      "59478": true,
      "59480": true,
      "59490": true
    },
    "MARCOS CASTELLANOS": {
      "59500": true,
      "59503": true,
      "59504": true,
      "59505": true,
      "59506": true,
      "59507": true
    },
    "JIQUILPAN": {
      "59510": true,
      "59512": true,
      "59513": true,
      "59514": true,
      "59515": true,
      "59516": true,
      "59517": true,
      "59518": true,
      "59520": true,
      "59523": true,
      "59526": true,
      "59527": true,
      "59530": true,
      "59531": true,
      "59532": true,
      "59533": true,
      "59546": true,
      "59547": true
    },
    "VILLAMAR": {
      "59550": true,
      "59552": true,
      "59553": true,
      "59554": true,
      "59557": true,
      "59560": true,
      "59563": true,
      "59566": true,
      "59570": true,
      "59573": true,
      "59574": true,
      "59575": true,
      "59576": true,
      "59578": true
    },
    "CHAVINDA": {
      "59580": true,
      "59590": true,
      "59593": true
    },
    "ZAMORA": {
      "59600": true,
      "59610": true,
      "59613": true,
      "59614": true,
      "59615": true,
      "59616": true,
      "59617": true,
      "59618": true,
      "59619": true,
      "59620": true,
      "59624": true,
      "59625": true,
      "59626": true,
      "59627": true,
      "59630": true,
      "59633": true,
      "59634": true,
      "59635": true,
      "59636": true,
      "59637": true,
      "59638": true,
      "59640": true,
      "59643": true,
      "59646": true,
      "59650": true,
      "59653": true,
      "59655": true,
      "59656": true,
      "59660": true,
      "59663": true,
      "59664": true,
      "59665": true,
      "59666": true,
      "59667": true,
      "59669": true,
      "59670": true,
      "59674": true,
      "59675": true,
      "59676": true,
      "59680": true,
      "59683": true,
      "59684": true,
      "59688": true,
      "59689": true,
      "59690": true,
      "59694": true,
      "59695": true,
      "59696": true,
      "59697": true,
      "59698": true,
      "59699": true,
      "59700": true,
      "59701": true,
      "59704": true,
      "59710": true,
      "59711": true,
      "59712": true,
      "59713": true,
      "59714": true,
      "59720": true,
      "59721": true,
      "59722": true,
      "59723": true,
      "59724": true,
      "59725": true
    },
    "ECUANDUREO": {
      "59730": true,
      "59732": true,
      "59734": true,
      "59737": true,
      "59740": true,
      "59745": true
    },
    "TANGANCÍCUARO": {
      "59750": true,
      "59753": true,
      "59758": true,
      "59759": true,
      "59760": true,
      "59762": true,
      "59763": true,
      "59764": true,
      "59765": true,
      "59766": true,
      "59770": true,
      "59773": true,
      "59774": true,
      "59775": true,
      "59776": true
    },
    "CHILCHOTA": {
      "59780": true,
      "59786": true,
      "59790": true,
      "59791": true,
      "59792": true,
      "59793": true,
      "59794": true,
      "59795": true,
      "59796": true,
      "59797": true
    },
    "JACONA": {
      "59800": true,
      "59810": true,
      "59813": true,
      "59816": true,
      "59817": true,
      "59820": true,
      "59823": true,
      "59824": true,
      "59828": true,
      "59830": true,
      "59833": true,
      "59834": true,
      "59835": true,
      "59836": true,
      "59840": true,
      "59843": true,
      "59844": true,
      "59845": true,
      "59850": true,
      "59853": true,
      "59854": true,
      "59855": true,
      "59856": true,
      "59857": true,
      "59860": true,
      "59863": true,
      "59864": true,
      "59865": true,
      "59870": true,
      "59873": true,
      "59874": true,
      "59875": true,
      "59880": true,
      "59884": true,
      "59885": true,
      "59890": true,
      "59893": true,
      "59894": true,
      "59900": true,
      "59904": true,
      "59905": true,
      "59906": true,
      "59908": true
    },
    "TANGAMANDAPIO": {
      "59920": true,
      "59921": true,
      "59922": true,
      "59923": true,
      "59925": true,
      "59927": true,
      "59928": true,
      "59930": true,
      "59931": true,
      "59934": true,
      "59935": true,
      "59937": true
    },
    "COTIJA": {
      "59940": true,
      "59943": true,
      "59944": true,
      "59945": true,
      "59947": true
    },
    "TOCUMBO": {
      "59960": true,
      "59963": true,
      "59964": true,
      "59965": true,
      "59967": true,
      "59970": true,
      "59972": true,
      "59973": true,
      "59975": true
    },
    "TINGÜINDÍN": {
      "59980": true,
      "59987": true,
      "59990": true,
      "59991": true,
      "59993": true,
      "59995": true
    },
    "URUAPAN": {
      "60000": true,
      "60010": true,
      "60013": true,
      "60014": true,
      "60015": true,
      "60016": true,
      "60017": true,
      "60020": true,
      "60024": true,
      "60030": true,
      "60033": true,
      "60040": true,
      "60044": true,
      "60050": true,
      "60054": true,
      "60060": true,
      "60063": true,
      "60070": true,
      "60073": true,
      "60074": true,
      "60080": true,
      "60090": true,
      "60094": true,
      "60095": true,
      "60100": true,
      "60105": true,
      "60110": true,
      "60120": true,
      "60123": true,
      "60124": true,
      "60125": true,
      "60126": true,
      "60127": true,
      "60128": true,
      "60130": true,
      "60133": true,
      "60134": true,
      "60135": true,
      "60136": true,
      "60137": true,
      "60140": true,
      "60143": true,
      "60150": true,
      "60153": true,
      "60154": true,
      "60155": true,
      "60156": true,
      "60157": true,
      "60160": true,
      "60170": true,
      "60173": true,
      "60174": true,
      "60175": true,
      "60180": true,
      "60183": true,
      "60190": true,
      "60193": true,
      "60194": true,
      "60200": true,
      "60201": true,
      "60202": true,
      "60203": true,
      "60210": true,
      "60211": true,
      "60215": true,
      "60220": true,
      "60222": true
    },
    "CHARAPAN": {
      "60240": true
    },
    "PARACHO": {
      "60250": true,
      "60251": true,
      "60252": true,
      "60254": true,
      "60255": true,
      "60256": true,
      "60257": true,
      "60258": true,
      "60259": true,
      "60260": true,
      "60262": true,
      "60264": true,
      "60266": true
    },
    "CHERÁN": {
      "60270": true
    },
    "NAHUATZEN": {
      "60280": true
    },
    "TINGAMBATO": {
      "60290": true,
      "60297": true
    },
    "LOS REYES": {
      "60300": true,
      "60320": true,
      "60322": true,
      "60324": true,
      "60330": true,
      "60340": true,
      "60350": true,
      "60360": true,
      "60364": true,
      "60365": true,
      "60370": true,
      "60373": true,
      "60374": true,
      "60376": true,
      "60377": true,
      "60378": true,
      "60379": true,
      "60380": true,
      "60384": true,
      "60385": true,
      "60390": true,
      "60393": true,
      "60394": true,
      "60400": true,
      "60420": true,
      "60432": true
    },
    "PERIBÁN": {
      "60440": true,
      "60443": true
    },
    "TANCÍTARO": {
      "60460": true,
      "60470": true,
      "60485": true
    },
    "NUEVO PARANGARICUTIRO": {
      "60490": true
    },
    "BUENAVISTA": {
      "60500": true,
      "60501": true,
      "60520": true,
      "60521": true,
      "60523": true
    },
    "TEPALCATEPEC": {
      "60540": true,
      "60542": true,
      "60554": true
    },
    "APATZINGÁN": {
      "60600": true,
      "60610": true,
      "60615": true,
      "60616": true,
      "60619": true,
      "60620": true,
      "60626": true,
      "60627": true,
      "60628": true,
      "60630": true,
      "60633": true,
      "60637": true,
      "60639": true,
      "60640": true,
      "60650": true,
      "60654": true,
      "60655": true,
      "60656": true,
      "60658": true,
      "60660": true,
      "60663": true,
      "60664": true,
      "60667": true,
      "60670": true,
      "60673": true,
      "60674": true,
      "60676": true,
      "60677": true,
      "60680": true,
      "60683": true,
      "60684": true,
      "60685": true,
      "60689": true,
      "60690": true,
      "60693": true,
      "60694": true,
      "60695": true,
      "60696": true,
      "60697": true,
      "60698": true,
      "60699": true,
      "60710": true
    },
    "PARÁCUARO": {
      "60760": true,
      "60780": true,
      "60782": true
    },
    "COAHUAYANA": {
      "60800": true,
      "60803": true,
      "60804": true,
      "60805": true,
      "60806": true,
      "60807": true
    },
    "COALCOMÁN DE VÁZQUEZ PALLARES": {
      "60840": true
    },
    "AQUILA": {
      "60870": true,
      "60873": true,
      "60876": true,
      "60877": true,
      "60880": true,
      "60883": true,
      "60885": true,
      "60895": true,
      "60896": true
    },
    "ARTEAGA": {
      "60920": true,
      "60923": true,
      "60924": true,
      "60934": true,
      "60938": true,
      "60940": true,
      "60946": true,
      "60948": true
    },
    "LÁZARO CÁRDENAS": {
      "60950": true,
      "60952": true,
      "60953": true,
      "60954": true,
      "60955": true,
      "60956": true,
      "60960": true,
      "60964": true,
      "60965": true,
      "60967": true,
      "60970": true,
      "60973": true,
      "60974": true,
      "60975": true,
      "60976": true,
      "60977": true,
      "60980": true,
      "60982": true,
      "60983": true,
      "60985": true,
      "60987": true,
      "60990": true,
      "60992": true,
      "60993": true,
      "60994": true,
      "60995": true,
      "60996": true,
      "60997": true,
      "60998": true,
      "60999": true
    },
    "EPITACIO HUERTA": {
      "61000": true,
      "61002": true,
      "61004": true,
      "61017": true
    },
    "CONTEPEC": {
      "61020": true,
      "61023": true,
      "61024": true,
      "61025": true,
      "61030": true,
      "61036": true,
      "61040": true,
      "61041": true,
      "61042": true,
      "61043": true,
      "61045": true,
      "61046": true,
      "61047": true,
      "61048": true,
      "61050": true,
      "61051": true,
      "61053": true,
      "61054": true
    },
    "TLALPUJAHUA": {
      "61060": true,
      "61062": true,
      "61067": true,
      "61070": true,
      "61075": true,
      "61080": true,
      "61082": true
    },
    "HIDALGO": {
      "61100": true,
      "61105": true,
      "61110": true,
      "61112": true,
      "61113": true,
      "61114": true,
      "61115": true,
      "61116": true,
      "61120": true,
      "61125": true,
      "61128": true,
      "61129": true,
      "61130": true,
      "61133": true,
      "61134": true,
      "61135": true,
      "61136": true,
      "61137": true,
      "61139": true,
      "61140": true,
      "61143": true,
      "61149": true,
      "61150": true,
      "61153": true,
      "61154": true,
      "61155": true,
      "61156": true,
      "61160": true,
      "61164": true,
      "61165": true,
      "61166": true,
      "61167": true,
      "61168": true,
      "61169": true,
      "61170": true,
      "61173": true,
      "61174": true,
      "61177": true,
      "61180": true,
      "61182": true,
      "61183": true,
      "61190": true,
      "61192": true,
      "61194": true,
      "61195": true,
      "61196": true,
      "61201": true,
      "61203": true,
      "61204": true,
      "61205": true,
      "61210": true,
      "61211": true,
      "61213": true,
      "61220": true,
      "61222": true,
      "61223": true,
      "61224": true,
      "61225": true,
      "61227": true,
      "61228": true,
      "61230": true,
      "61231": true,
      "61235": true,
      "61236": true,
      "61241": true,
      "61243": true,
      "61244": true,
      "61247": true,
      "61248": true
    },
    "MARAVATÍO": {
      "61250": true,
      "61252": true,
      "61253": true,
      "61254": true,
      "61255": true,
      "61256": true,
      "61258": true,
      "61259": true,
      "61260": true,
      "61261": true,
      "61262": true,
      "61263": true,
      "61264": true,
      "61270": true,
      "61273": true,
      "61274": true,
      "61275": true,
      "61276": true,
      "61277": true,
      "61279": true
    },
    "IRIMBO": {
      "61280": true,
      "61282": true,
      "61283": true,
      "61285": true,
      "61286": true,
      "61288": true
    },
    "SENGUIO": {
      "61290": true,
      "61292": true,
      "61293": true,
      "61294": true,
      "61295": true,
      "61296": true
    },
    "CHARO": {
      "61300": true,
      "61303": true,
      "61304": true,
      "61310": true,
      "61311": true,
      "61312": true,
      "61313": true,
      "61314": true,
      "61321": true,
      "61322": true,
      "61323": true
    },
    "TZITZIO": {
      "61330": true,
      "61334": true,
      "61341": true,
      "61343": true,
      "61355": true,
      "61363": true,
      "61365": true
    },
    "TIQUICHEO DE NICOLÁS ROMERO": {
      "61370": true
    },
    "APORO": {
      "61400": true
    },
    "ANGANGUEO": {
      "61410": true,
      "61413": true,
      "61415": true
    },
    "TUXPAN": {
      "61420": true,
      "61423": true,
      "61424": true,
      "61425": true,
      "61426": true,
      "61427": true,
      "61428": true,
      "61430": true,
      "61435": true,
      "61436": true,
      "61437": true,
      "61438": true,
      "61443": true,
      "61444": true,
      "61445": true
    },
    "OCAMPO": {
      "61450": true,
      "61453": true,
      "61454": true,
      "61465": true,
      "61467": true,
      "61468": true
    },
    "JUNGAPEO": {
      "61470": true,
      "61472": true,
      "61473": true,
      "61475": true,
      "61487": true,
      "61490": true,
      "61493": true,
      "61498": true
    },
    "ZITÁCUARO": {
      "61500": true,
      "61502": true,
      "61503": true,
      "61505": true,
      "61506": true,
      "61507": true,
      "61508": true,
      "61509": true,
      "61510": true,
      "61511": true,
      "61512": true,
      "61514": true,
      "61515": true,
      "61516": true,
      "61517": true,
      "61518": true,
      "61519": true,
      "61525": true,
      "61526": true,
      "61529": true,
      "61530": true,
      "61533": true,
      "61539": true
    },
    "TUZANTLA": {
      "61540": true,
      "61543": true,
      "61560": true,
      "61564": true
    },
    "JUÁREZ": {
      "61570": true,
      "61573": true,
      "61578": true,
      "61580": true,
      "61583": true
    },
    "PÁTZCUARO": {
      "61600": true,
      "61604": true,
      "61605": true,
      "61606": true,
      "61607": true,
      "61608": true,
      "61609": true,
      "61610": true,
      "61611": true,
      "61612": true,
      "61613": true,
      "61614": true,
      "61615": true,
      "61617": true,
      "61620": true
    },
    "ERONGARÍCUARO": {
      "61630": true,
      "61632": true,
      "61636": true,
      "61637": true
    },
    "HUIRAMBA": {
      "61640": true,
      "61645": true,
      "61648": true
    },
    "TACÁMBARO": {
      "61650": true,
      "61652": true,
      "61653": true,
      "61655": true,
      "61659": true,
      "61663": true,
      "61665": true,
      "61670": true,
      "61671": true,
      "61674": true
    },
    "TURICATO": {
      "61680": true,
      "61682": true,
      "61686": true,
      "61687": true,
      "61688": true,
      "61690": true
    },
    "ZIRACUARETIRO": {
      "61700": true,
      "61702": true,
      "61703": true,
      "61705": true,
      "61707": true,
      "61708": true
    },
    "TARETAN": {
      "61710": true,
      "61712": true,
      "61714": true,
      "61716": true
    },
    "GABRIEL ZAMORA": {
      "61730": true,
      "61732": true,
      "61734": true,
      "61735": true,
      "61740": true,
      "61745": true
    },
    "NUEVO URECHO": {
      "61750": true,
      "61752": true,
      "61753": true,
      "61755": true,
      "61757": true,
      "61759": true
    },
    "MÚGICA": {
      "61760": true,
      "61763": true,
      "61769": true,
      "61776": true,
      "61790": true,
      "61794": true
    },
    "SALVADOR ESCALANTE": {
      "61800": true,
      "61804": true,
      "61810": true,
      "61820": true
    },
    "ARIO": {
      "61830": true,
      "61833": true,
      "61834": true,
      "61835": true,
      "61836": true,
      "61837": true,
      "61838": true,
      "61840": true,
      "61844": true,
      "61845": true,
      "61846": true,
      "61847": true,
      "61848": true,
      "61849": true
    },
    "LA HUACANA": {
      "61850": true,
      "61854": true,
      "61858": true,
      "61860": true,
      "61863": true,
      "61864": true,
      "61865": true,
      "61866": true,
      "61873": true,
      "61874": true,
      "61878": true
    },
    "NOCUPÉTARO": {
      "61900": true,
      "61904": true,
      "61910": true,
      "61917": true
    },
    "CARÁCUARO": {
      "61920": true,
      "61930": true,
      "61931": true
    },
    "HUETAMO": {
      "61940": true,
      "61952": true,
      "61954": true,
      "61955": true,
      "61956": true,
      "61958": true,
      "61959": true,
      "61963": true,
      "61970": true,
      "61976": true
    },
    "SAN LUCAS": {
      "61980": true,
      "61985": true,
      "61991": true,
      "61992": true,
      "61993": true,
      "61994": true
    }
  },
  "MORELOS": {
    "CUERNAVACA": {
      "62000": true,
      "62010": true,
      "62017": true,
      "62018": true,
      "62019": true,
      "62020": true,
      "62028": true,
      "62029": true,
      "62030": true,
      "62040": true,
      "62050": true,
      "62057": true,
      "62059": true,
      "62060": true,
      "62070": true,
      "62076": true,
      "62080": true,
      "62083": true,
      "62084": true,
      "62100": true,
      "62103": true,
      "62115": true,
      "62116": true,
      "62117": true,
      "62120": true,
      "62130": true,
      "62136": true,
      "62137": true,
      "62139": true,
      "62140": true,
      "62143": true,
      "62144": true,
      "62145": true,
      "62150": true,
      "62154": true,
      "62156": true,
      "62157": true,
      "62159": true,
      "62160": true,
      "62165": true,
      "62166": true,
      "62170": true,
      "62173": true,
      "62175": true,
      "62179": true,
      "62180": true,
      "62190": true,
      "62193": true,
      "62200": true,
      "62203": true,
      "62210": true,
      "62215": true,
      "62218": true,
      "62226": true,
      "62227": true,
      "62228": true,
      "62229": true,
      "62230": true,
      "62233": true,
      "62237": true,
      "62239": true,
      "62240": true,
      "62243": true,
      "62245": true,
      "62247": true,
      "62248": true,
      "62249": true,
      "62250": true,
      "62253": true,
      "62260": true,
      "62269": true,
      "62270": true,
      "62280": true,
      "62283": true,
      "62284": true,
      "62285": true,
      "62290": true,
      "62293": true,
      "62294": true,
      "62295": true,
      "62296": true,
      "62303": true,
      "62304": true,
      "62305": true,
      "62306": true,
      "62309": true,
      "62320": true,
      "62323": true,
      "62324": true,
      "62325": true,
      "62326": true,
      "62330": true,
      "62334": true,
      "62335": true,
      "62340": true,
      "62343": true,
      "62345": true,
      "62350": true,
      "62360": true,
      "62363": true,
      "62370": true,
      "62373": true,
      "62374": true,
      "62375": true,
      "62376": true,
      "62380": true,
      "62382": true,
      "62384": true,
      "62385": true,
      "62388": true,
      "62389": true,
      "62390": true,
      "62398": true,
      "62399": true,
      "62400": true,
      "62409": true,
      "62410": true,
      "62420": true,
      "62428": true,
      "62430": true,
      "62433": true,
      "62440": true,
      "62445": true,
      "62446": true,
      "62447": true,
      "62448": true,
      "62450": true,
      "62460": true,
      "62466": true,
      "62469": true,
      "62470": true,
      "62473": true,
      "62474": true,
      "62475": true,
      "62480": true,
      "62490": true,
      "62493": true,
      "62494": true,
      "62496": true,
      "62497": true,
      "62498": true,
      "62499": true,
      "62508": true
    },
    "TEPOZTLÁN": {
      "62520": true,
      "62524": true,
      "62525": true,
      "62526": true,
      "62527": true,
      "62528": true,
      "62529": true
    },
    "JIUTEPEC": {
      "62553": true,
      "62554": true,
      "62555": true,
      "62560": true,
      "62563": true,
      "62564": true,
      "62565": true,
      "62566": true,
      "62570": true,
      "62576": true,
      "62577": true,
      "62578": true
    },
    "TEMIXCO": {
      "62580": true,
      "62583": true,
      "62584": true,
      "62585": true
    },
    "CUAUTLA": {
      "62740": true,
      "62742": true,
      "62743": true,
      "62744": true,
      "62746": true,
      "62747": true,
      "62748": true,
      "62755": true,
      "62756": true,
      "62757": true
    }
  },
  "NAYARIT": {
    "TEPIC": {
      "63000": true,
      "63001": true,
      "63002": true,
      "63003": true,
      "63004": true,
      "63005": true,
      "63006": true,
      "63009": true,
      "63010": true,
      "63018": true,
      "63019": true,
      "63020": true,
      "63021": true,
      "63022": true,
      "63023": true,
      "63025": true,
      "63027": true,
      "63030": true,
      "63032": true,
      "63034": true,
      "63035": true,
      "63036": true,
      "63037": true,
      "63038": true,
      "63039": true,
      "63040": true,
      "63044": true,
      "63050": true,
      "63057": true,
      "63058": true,
      "63059": true,
      "63060": true,
      "63061": true,
      "63062": true,
      "63063": true,
      "63064": true,
      "63066": true,
      "63067": true,
      "63068": true,
      "63069": true,
      "63070": true,
      "63073": true,
      "63076": true,
      "63079": true,
      "63080": true,
      "63081": true,
      "63082": true,
      "63083": true,
      "63084": true,
      "63085": true,
      "63088": true,
      "63089": true,
      "63090": true,
      "63096": true,
      "63100": true,
      "63101": true,
      "63105": true,
      "63109": true,
      "63110": true,
      "63111": true,
      "63113": true,
      "63114": true,
      "63115": true,
      "63116": true,
      "63117": true,
      "63118": true,
      "63119": true,
      "63120": true,
      "63125": true,
      "63128": true,
      "63129": true,
      "63130": true,
      "63131": true,
      "63132": true,
      "63133": true,
      "63134": true,
      "63135": true,
      "63136": true,
      "63137": true,
      "63138": true,
      "63139": true,
      "63140": true,
      "63145": true,
      "63147": true,
      "63148": true,
      "63149": true,
      "63150": true,
      "63152": true,
      "63153": true,
      "63154": true,
      "63155": true,
      "63156": true,
      "63157": true,
      "63158": true,
      "63159": true,
      "63160": true,
      "63163": true,
      "63164": true,
      "63165": true,
      "63166": true,
      "63167": true,
      "63168": true,
      "63169": true,
      "63170": true,
      "63171": true,
      "63172": true,
      "63173": true,
      "63174": true,
      "63175": true,
      "63176": true,
      "63177": true,
      "63178": true,
      "63179": true,
      "63180": true,
      "63183": true,
      "63184": true,
      "63185": true,
      "63186": true,
      "63187": true,
      "63188": true,
      "63189": true,
      "63190": true,
      "63192": true,
      "63193": true,
      "63194": true,
      "63195": true,
      "63196": true,
      "63197": true,
      "63198": true,
      "63199": true,
      "63500": true,
      "63501": true,
      "63502": true,
      "63503": true,
      "63504": true,
      "63505": true,
      "63506": true,
      "63507": true,
      "63508": true,
      "63509": true,
      "63510": true,
      "63511": true,
      "63517": true,
      "63518": true,
      "63519": true,
      "63523": true,
      "63527": true
    },
    "TUXPAN": {
      "63200": true,
      "63202": true,
      "63203": true,
      "63205": true,
      "63207": true,
      "63225": true,
      "63227": true,
      "63660": true,
      "63670": true
    },
    "SANTIAGO IXCUINTLA": {
      "63300": true,
      "63310": true,
      "63311": true,
      "63312": true,
      "63313": true,
      "63320": true,
      "63321": true,
      "63330": true,
      "63340": true,
      "63341": true,
      "63350": true,
      "63351": true,
      "63352": true,
      "63360": true,
      "63380": true,
      "63383": true,
      "63550": true,
      "63552": true,
      "63553": true,
      "63554": true,
      "63555": true,
      "63556": true,
      "63557": true,
      "63559": true,
      "63565": true,
      "63567": true,
      "63570": true,
      "63573": true,
      "63575": true,
      "63576": true,
      "63577": true,
      "63578": true,
      "63579": true
    },
    "ACAPONETA": {
      "63400": true,
      "63410": true,
      "63413": true,
      "63420": true,
      "63424": true,
      "63425": true,
      "63427": true,
      "63429": true,
      "63430": true,
      "63433": true,
      "63434": true,
      "63435": true,
      "63436": true,
      "63437": true,
      "63438": true
    },
    "TECUALA": {
      "63440": true,
      "63445": true,
      "63446": true,
      "63447": true,
      "63450": true,
      "63453": true,
      "63454": true,
      "63455": true,
      "63456": true,
      "63457": true,
      "63459": true,
      "63460": true,
      "63463": true,
      "63470": true
    },
    "HUAJICORI": {
      "63480": true
    },
    "RUÍZ": {
      "63600": true,
      "63620": true,
      "63622": true,
      "63623": true,
      "63625": true,
      "63626": true,
      "63627": true,
      "63628": true
    },
    "ROSAMORADA": {
      "63630": true,
      "63633": true,
      "63634": true,
      "63636": true,
      "63637": true,
      "63640": true,
      "63643": true,
      "63644": true,
      "63645": true,
      "63648": true
    },
    "COMPOSTELA": {
      "63700": true,
      "63702": true,
      "63703": true,
      "63704": true,
      "63705": true,
      "63706": true,
      "63707": true,
      "63708": true,
      "63709": true,
      "63710": true,
      "63715": true,
      "63717": true,
      "63720": true,
      "63722": true,
      "63723": true,
      "63724": true
    },
    "BAHÍA DE BANDERAS": {
      "63726": true,
      "63728": true,
      "63729": true,
      "63730": true,
      "63732": true,
      "63734": true,
      "63735": true,
      "63736": true,
      "63737": true,
      "63738": true,
      "63739": true
    },
    "SAN BLAS": {
      "63740": true,
      "63742": true,
      "63743": true,
      "63744": true,
      "63750": true,
      "63751": true,
      "63753": true,
      "63754": true,
      "63758": true,
      "63762": true,
      "63764": true,
      "63765": true,
      "63766": true,
      "63770": true,
      "63771": true,
      "63772": true,
      "63774": true,
      "63775": true,
      "63776": true,
      "63777": true
    },
    "XALISCO": {
      "63780": true,
      "63782": true,
      "63783": true,
      "63784": true,
      "63785": true,
      "63786": true,
      "63787": true,
      "63792": true,
      "63794": true,
      "63795": true
    },
    "SAN PEDRO LAGUNILLAS": {
      "63800": true,
      "63810": true,
      "63820": true
    },
    "SANTA MARÍA DEL ORO": {
      "63830": true,
      "63833": true,
      "63834": true,
      "63835": true,
      "63840": true,
      "63843": true,
      "63850": true,
      "63865": true,
      "63866": true,
      "63870": true
    },
    "JALA": {
      "63880": true,
      "63883": true,
      "63886": true,
      "63887": true,
      "63889": true,
      "63890": true,
      "63893": true,
      "63894": true,
      "63895": true
    },
    "AHUACATLÁN": {
      "63900": true,
      "63905": true,
      "63910": true,
      "63911": true,
      "63915": true,
      "63920": true,
      "63923": true,
      "63925": true,
      "63927": true,
      "63928": true
    },
    "IXTLÁN DEL RÍO": {
      "63940": true,
      "63944": true,
      "63950": true,
      "63953": true,
      "63954": true,
      "63955": true,
      "63956": true,
      "63957": true,
      "63958": true,
      "63959": true
    },
    "AMATLÁN DE CAÑAS": {
      "63960": true,
      "63963": true,
      "63970": true,
      "63973": true,
      "63975": true,
      "63980": true,
      "63985": true,
      "63990": true
    }
  },
  "NUEVO LEÓN": {
    "MONTERREY": {
      "64000": true,
      "64004": true,
      "64007": true,
      "64008": true,
      "64009": true,
      "64010": true,
      "64018": true,
      "64019": true,
      "64020": true,
      "64030": true,
      "64040": true,
      "64049": true,
      "64050": true,
      "64060": true,
      "64070": true,
      "64100": true,
      "64102": true,
      "64103": true,
      "64104": true,
      "64105": true,
      "64106": true,
      "64107": true,
      "64108": true,
      "64109": true,
      "64110": true,
      "64116": true,
      "64117": true,
      "64118": true,
      "64119": true,
      "64120": true,
      "64128": true,
      "64130": true,
      "64140": true,
      "64145": true,
      "64148": true,
      "64150": true,
      "64157": true,
      "64158": true,
      "64159": true,
      "64160": true,
      "64165": true,
      "64166": true,
      "64167": true,
      "64168": true,
      "64170": true,
      "64178": true,
      "64180": true,
      "64186": true,
      "64190": true,
      "64200": true,
      "64204": true,
      "64205": true,
      "64206": true,
      "64208": true,
      "64209": true,
      "64210": true,
      "64215": true,
      "64217": true,
      "64218": true,
      "64219": true,
      "64220": true,
      "64225": true,
      "64226": true,
      "64227": true,
      "64228": true,
      "64229": true,
      "64230": true,
      "64233": true,
      "64234": true,
      "64235": true,
      "64236": true,
      "64237": true,
      "64238": true,
      "64239": true,
      "64240": true,
      "64244": true,
      "64245": true,
      "64246": true,
      "64247": true,
      "64248": true,
      "64249": true,
      "64250": true,
      "64258": true,
      "64259": true,
      "64260": true,
      "64264": true,
      "64265": true,
      "64266": true,
      "64268": true,
      "64269": true,
      "64270": true,
      "64280": true,
      "64290": true,
      "64299": true,
      "64300": true,
      "64310": true,
      "64320": true,
      "64330": true,
      "64339": true,
      "64340": true,
      "64344": true,
      "64345": true,
      "64346": true,
      "64347": true,
      "64348": true,
      "64349": true,
      "64350": true,
      "64360": true,
      "64365": true,
      "64366": true,
      "64367": true,
      "64368": true,
      "64369": true,
      "64370": true,
      "64380": true,
      "64390": true,
      "64400": true,
      "64410": true,
      "64420": true,
      "64429": true,
      "64430": true,
      "64440": true,
      "64442": true,
      "64450": true,
      "64460": true,
      "64465": true,
      "64470": true,
      "64480": true,
      "64488": true,
      "64489": true,
      "64490": true,
      "64500": true,
      "64508": true,
      "64510": true,
      "64517": true,
      "64520": true,
      "64530": true,
      "64536": true,
      "64540": true,
      "64549": true,
      "64550": true,
      "64560": true,
      "64568": true,
      "64570": true,
      "64571": true,
      "64580": true,
      "64590": true,
      "64600": true,
      "64610": true,
      "64613": true,
      "64618": true,
      "64619": true,
      "64620": true,
      "64623": true,
      "64630": true,
      "64632": true,
      "64633": true,
      "64634": true,
      "64635": true,
      "64636": true,
      "64637": true,
      "64638": true,
      "64639": true,
      "64640": true,
      "64649": true,
      "64650": true,
      "64659": true,
      "64660": true,
      "64700": true,
      "64710": true,
      "64715": true,
      "64718": true,
      "64720": true,
      "64723": true,
      "64730": true,
      "64740": true,
      "64750": true,
      "64753": true,
      "64754": true,
      "64760": true,
      "64764": true,
      "64765": true,
      "64769": true,
      "64770": true,
      "64780": true,
      "64783": true,
      "64788": true,
      "64790": true,
      "64798": true,
      "64799": true,
      "64800": true,
      "64810": true,
      "64820": true,
      "64821": true,
      "64830": true,
      "64833": true,
      "64834": true,
      "64836": true,
      "64840": true,
      "64844": true,
      "64845": true,
      "64846": true,
      "64849": true,
      "64850": true,
      "64858": true,
      "64859": true,
      "64860": true,
      "64865": true,
      "64878": true,
      "64880": true,
      "64890": true,
      "64893": true,
      "64894": true,
      "64897": true,
      "64898": true,
      "64899": true,
      "64900": true,
      "64909": true,
      "64910": true,
      "64920": true,
      "64925": true,
      "64926": true,
      "64930": true,
      "64940": true,
      "64949": true,
      "64950": true,
      "64960": true,
      "64968": true,
      "64969": true,
      "64970": true,
      "64978": true,
      "64979": true,
      "64980": true,
      "64983": true,
      "64984": true,
      "64985": true,
      "64986": true,
      "64987": true,
      "64988": true,
      "64989": true,
      "64990": true,
      "64996": true,
      "64997": true
    },
    "GENERAL ESCOBEDO": {
      "66050": true,
      "66051": true,
      "66052": true,
      "66053": true,
      "66054": true,
      "66055": true,
      "66056": true,
      "66057": true,
      "66058": true,
      "66059": true,
      "66061": true,
      "66062": true,
      "66063": true,
      "66064": true,
      "66065": true,
      "66067": true,
      "66068": true,
      "66070": true,
      "66072": true,
      "66073": true,
      "66074": true,
      "66075": true,
      "66080": true,
      "66083": true,
      "66084": true,
      "66085": true
    },
    "SANTA CATARINA": {
      "66100": true,
      "66110": true,
      "66114": true,
      "66115": true,
      "66116": true,
      "66117": true,
      "66118": true,
      "66119": true,
      "66120": true,
      "66129": true,
      "66130": true,
      "66139": true,
      "66140": true,
      "66143": true,
      "66144": true,
      "66145": true,
      "66147": true,
      "66149": true,
      "66150": true,
      "66159": true,
      "66160": true,
      "66165": true,
      "66166": true,
      "66167": true,
      "66168": true,
      "66169": true,
      "66170": true,
      "66179": true,
      "66180": true,
      "66187": true,
      "66188": true,
      "66189": true,
      "66190": true,
      "66195": true,
      "66196": true,
      "66197": true,
      "66198": true,
      "66199": true,
      "66350": true,
      "66353": true,
      "66354": true,
      "66355": true,
      "66356": true,
      "66357": true,
      "66358": true,
      "66359": true,
      "66360": true,
      "66362": true,
      "66363": true,
      "66364": true,
      "66365": true,
      "66366": true,
      "66367": true,
      "66368": true,
      "66369": true,
      "66370": true,
      "66373": true,
      "66374": true,
      "66375": true,
      "66376": true,
      "66377": true,
      "66378": true,
      "66380": true,
      "66384": true,
      "66390": true
    },
    "SAN PEDRO GARZA GARCÍA": {
      "66200": true,
      "66210": true,
      "66214": true,
      "66215": true,
      "66216": true,
      "66217": true,
      "66218": true,
      "66219": true,
      "66220": true,
      "66224": true,
      "66225": true,
      "66226": true,
      "66227": true,
      "66228": true,
      "66230": true,
      "66233": true,
      "66234": true,
      "66235": true,
      "66236": true,
      "66237": true,
      "66238": true,
      "66239": true,
      "66240": true,
      "66244": true,
      "66245": true,
      "66246": true,
      "66247": true,
      "66249": true,
      "66250": true,
      "66254": true,
      "66256": true,
      "66257": true,
      "66259": true,
      "66260": true,
      "66263": true,
      "66264": true,
      "66265": true,
      "66266": true,
      "66267": true,
      "66268": true,
      "66269": true,
      "66270": true,
      "66273": true,
      "66274": true,
      "66275": true,
      "66276": true,
      "66277": true,
      "66278": true,
      "66279": true,
      "66280": true,
      "66285": true,
      "66286": true,
      "66287": true,
      "66290": true,
      "66295": true,
      "66296": true,
      "66297": true
    },
    "SAN NICOLÁS DE LOS GARZA": {
      "66400": true,
      "66409": true,
      "66410": true,
      "66412": true,
      "66413": true,
      "66414": true,
      "66415": true,
      "66417": true,
      "66418": true,
      "66420": true,
      "66422": true,
      "66423": true,
      "66424": true,
      "66425": true,
      "66427": true,
      "66428": true,
      "66430": true,
      "66434": true,
      "66435": true,
      "66436": true,
      "66437": true,
      "66438": true,
      "66440": true,
      "66444": true,
      "66445": true,
      "66446": true,
      "66447": true,
      "66448": true,
      "66449": true,
      "66450": true,
      "66452": true,
      "66455": true,
      "66456": true,
      "66457": true,
      "66458": true,
      "66459": true,
      "66460": true,
      "66463": true,
      "66464": true,
      "66465": true,
      "66466": true,
      "66467": true,
      "66468": true,
      "66469": true,
      "66470": true,
      "66473": true,
      "66474": true,
      "66475": true,
      "66476": true,
      "66477": true,
      "66478": true,
      "66479": true,
      "66480": true,
      "66482": true,
      "66484": true,
      "66485": true,
      "66486": true,
      "66488": true,
      "66489": true,
      "66490": true,
      "66492": true,
      "66493": true,
      "66494": true,
      "66495": true,
      "66496": true,
      "66499": true
    },
    "APODACA": {
      "66600": true,
      "66603": true,
      "66604": true,
      "66605": true,
      "66606": true,
      "66607": true,
      "66609": true,
      "66610": true,
      "66612": true,
      "66613": true,
      "66614": true,
      "66616": true,
      "66620": true,
      "66623": true,
      "66624": true,
      "66626": true,
      "66627": true,
      "66628": true,
      "66629": true,
      "66630": true,
      "66632": true,
      "66633": true,
      "66634": true,
      "66635": true,
      "66636": true,
      "66637": true,
      "66640": true,
      "66643": true,
      "66644": true,
      "66645": true,
      "66646": true,
      "66647": true,
      "66648": true,
      "66649": true
    },
    "GUADALUPE": {
      "67100": true,
      "67102": true,
      "67110": true,
      "67112": true,
      "67113": true,
      "67114": true,
      "67115": true,
      "67116": true,
      "67117": true,
      "67118": true,
      "67119": true,
      "67120": true,
      "67121": true,
      "67123": true,
      "67124": true,
      "67125": true,
      "67126": true,
      "67128": true,
      "67129": true,
      "67130": true,
      "67132": true,
      "67133": true,
      "67134": true,
      "67140": true,
      "67144": true,
      "67150": true,
      "67153": true,
      "67154": true,
      "67155": true,
      "67160": true,
      "67163": true,
      "67164": true,
      "67165": true,
      "67166": true,
      "67167": true,
      "67168": true,
      "67169": true,
      "67170": true,
      "67173": true,
      "67174": true,
      "67175": true,
      "67176": true,
      "67177": true,
      "67178": true,
      "67179": true,
      "67180": true,
      "67182": true,
      "67183": true,
      "67184": true,
      "67185": true,
      "67186": true,
      "67188": true,
      "67189": true,
      "67190": true,
      "67192": true,
      "67193": true,
      "67194": true,
      "67195": true,
      "67196": true,
      "67197": true,
      "67198": true,
      "67199": true,
      "67200": true,
      "67202": true,
      "67203": true,
      "67204": true,
      "67205": true
    },
    "GARCÍA": {
      "66023": true,
      "66024": true
    },
    "JUÁREZ": {
      "67258": true,
      "67287": true,
      "67288": true,
      "67289": true
    }
  },
  "OAXACA": {
    "OAXACA DE JUÁREZ": {
      "68000": true,
      "68008": true,
      "68009": true,
      "68010": true,
      "68013": true,
      "68016": true,
      "68020": true,
      "68023": true,
      "68024": true,
      "68025": true,
      "68026": true,
      "68027": true,
      "68028": true,
      "68030": true,
      "68033": true,
      "68034": true,
      "68036": true,
      "68039": true,
      "68040": true,
      "68043": true,
      "68044": true,
      "68045": true,
      "68050": true,
      "68060": true,
      "68067": true,
      "68068": true,
      "68070": true,
      "68075": true,
      "68080": true,
      "68083": true,
      "68088": true,
      "68089": true,
      "68090": true,
      "68100": true,
      "68103": true,
      "68104": true,
      "68110": true,
      "68115": true,
      "68120": true,
      "68125": true,
      "68126": true,
      "68127": true,
      "68128": true,
      "68130": true,
      "68133": true,
      "68140": true,
      "68143": true,
      "68144": true,
      "68146": true,
      "68148": true,
      "68149": true,
      "68150": true,
      "68153": true,
      "68154": true,
      "68155": true,
      "68156": true,
      "68157": true,
      "68159": true,
      "68274": true,
      "68275": true,
      "68276": true,
      "68277": true,
      "68278": true,
      "68280": true,
      "68283": true,
      "68284": true
    },
    "VILLA DE ETLA": {
      "68200": true
    },
    "SAN FRANCISCO TELIXTLAHUACA": {
      "68213": true,
      "68214": true,
      "68216": true
    },
    "SAN PABLO HUITZO": {
      "68220": true,
      "68222": true,
      "68223": true
    },
    "SAN JUAN DEL ESTADO": {
      "68224": true
    },
    "MAGDALENA APASCO": {
      "68226": true,
      "68227": true,
      "68228": true
    },
    "SANTIAGO SUCHILQUITONGO": {
      "68230": true,
      "68232": true,
      "68233": true
    },
    "SAN JUAN BAUTISTA GUELACHE": {
      "68234": true,
      "68235": true,
      "68236": true
    },
    "REYES ETLA": {
      "68237": true,
      "68238": true
    },
    "NAZARENO ETLA": {
      "68240": true
    },
    "SAN ANDRÉS ZAUTLA": {
      "68244": true
    },
    "SAN AGUSTÍN ETLA": {
      "68247": true,
      "68248": true
    },
    "SOLEDAD ETLA": {
      "68250": true
    },
    "SANTO TOMÁS MAZALTEPEC": {
      "68254": true
    },
    "GUADALUPE ETLA": {
      "68256": true,
      "68257": true
    },
    "SAN PABLO ETLA": {
      "68258": true,
      "68259": true
    },
    "SAN LORENZO CACAOTEPEC": {
      "68263": true,
      "68264": true
    },
    "TLALIXTAC DE CABRERA": {
      "68270": true,
      "68273": true
    },
    "SAN JACINTO AMILPAS": {
      "68285": true
    },
    "SAN ANDRÉS HUAYÁPAM": {
      "68287": true,
      "68288": true
    },
    "SAN AGUSTÍN YATARENI": {
      "68290": true
    },
    "SANTO DOMINGO TOMALTEPEC": {
      "68293": true
    },
    "SANTA MARÍA DEL TULE": {
      "68297": true,
      "68299": true
    },
    "SAN JUAN BAUTISTA TUXTEPEC": {
      "68300": true,
      "68310": true,
      "68313": true,
      "68314": true,
      "68320": true,
      "68322": true,
      "68323": true,
      "68324": true,
      "68325": true,
      "68326": true,
      "68330": true,
      "68333": true,
      "68334": true,
      "68335": true,
      "68336": true,
      "68337": true,
      "68340": true,
      "68345": true,
      "68347": true,
      "68350": true,
      "68353": true,
      "68360": true,
      "68363": true,
      "68364": true,
      "68365": true,
      "68370": true,
      "68373": true,
      "68374": true,
      "68375": true,
      "68376": true,
      "68440": true,
      "68442": true,
      "68443": true,
      "68444": true,
      "68445": true,
      "68446": true,
      "68447": true,
      "68448": true,
      "68449": true
    },
    "LOMA BONITA": {
      "68400": true,
      "68402": true,
      "68403": true,
      "68404": true,
      "68405": true,
      "68406": true
    },
    "ACATLÁN DE PÉREZ FIGUEROA": {
      "68420": true,
      "68422": true,
      "68424": true,
      "68425": true,
      "68426": true,
      "68427": true,
      "68428": true
    },
    "SAN MIGUEL SOYALTEPEC": {
      "68430": true,
      "68432": true,
      "68433": true,
      "68434": true
    },
    "SAN PEDRO IXCATLÁN": {
      "68450": true,
      "68451": true,
      "68452": true,
      "68455": true
    },
    "SAN JOSÉ CHILTEPEC": {
      "68456": true,
      "68457": true,
      "68458": true,
      "68459": true
    },
    "SAN FELIPE JALAPA DE DÍAZ": {
      "68460": true,
      "68462": true,
      "68463": true,
      "68464": true
    },
    "SANTA MARÍA JACATEPEC": {
      "68465": true,
      "68466": true,
      "68467": true,
      "68468": true
    },
    "SAN LUCAS OJITLÁN": {
      "68470": true,
      "68472": true,
      "68473": true,
      "68474": true,
      "68475": true,
      "68476": true,
      "68477": true,
      "68479": true
    },
    "SAN JUAN BAUTISTA VALLE NACIONAL": {
      "68480": true,
      "68482": true,
      "68483": true,
      "68484": true,
      "68485": true,
      "68486": true,
      "68487": true,
      "68488": true
    },
    "TEOTITLÁN DE FLORES MAGÓN": {
      "68540": true,
      "68542": true,
      "68543": true
    },
    "SAN JUAN BAUTISTA CUICATLÁN": {
      "68600": true,
      "68601": true,
      "68602": true,
      "68603": true,
      "68604": true,
      "68605": true,
      "68606": true,
      "68607": true,
      "68609": true
    },
    "IXTLÁN DE JUÁREZ": {
      "68725": true,
      "68726": true,
      "68727": true,
      "68728": true
    },
    "GUELATAO DE JUÁREZ": {
      "68770": true
    },
    "HEROICA CIUDAD DE HUAJUAPAN DE LEÓN": {
      "69000": true,
      "69003": true,
      "69004": true,
      "69005": true,
      "69006": true,
      "69007": true,
      "69008": true,
      "69009": true
    },
    "VILLA DE TAMAZULÁPAM DEL PROGRESO": {
      "69510": true,
      "69512": true,
      "69513": true
    },
    "SAN PEDRO NOPALA": {
      "69516": true,
      "69519": true
    },
    "ASUNCIÓN NOCHIXTLÁN": {
      "69600": true,
      "69602": true,
      "69603": true,
      "69605": true,
      "69606": true,
      "69607": true,
      "69608": true,
      "69609": true
    },
    "SAN ANDRÉS SINAXTLA": {
      "69665": true
    },
    "SANTIAGO JUXTLAHUACA": {
      "69700": true,
      "69702": true,
      "69703": true,
      "69704": true,
      "69705": true,
      "69706": true,
      "69707": true,
      "69708": true,
      "69709": true,
      "69710": true,
      "69712": true,
      "69713": true,
      "69714": true,
      "69715": true,
      "69716": true,
      "69717": true,
      "69718": true,
      "69719": true,
      "69720": true,
      "69724": true,
      "69725": true,
      "69726": true,
      "69729": true
    },
    "HEROICA CIUDAD DE TLAXIACO": {
      "69800": true,
      "69802": true,
      "69803": true,
      "69804": true,
      "69805": true,
      "69806": true
    },
    "JUCHITÁN DE ZARAGOZA": {
      "70000": true,
      "70010": true,
      "70013": true,
      "70014": true,
      "70020": true,
      "70023": true,
      "70024": true,
      "70030": true,
      "70033": true,
      "70034": true,
      "70040": true,
      "70043": true,
      "70044": true,
      "70045": true,
      "70046": true,
      "70050": true,
      "70053": true,
      "70054": true,
      "70055": true,
      "70100": true,
      "70102": true,
      "70103": true,
      "70104": true,
      "70109": true
    },
    "EL ESPINAL": {
      "70117": true
    },
    "SANTO DOMINGO INGENIO": {
      "70120": true,
      "70121": true,
      "70123": true,
      "70124": true
    },
    "SANTA MARÍA XADANI": {
      "70125": true
    },
    "ASUNCIÓN IXTALTEPEC": {
      "70140": true
    },
    "UNIÓN HIDALGO": {
      "70150": true
    },
    "REFORMA DE PINEDA": {
      "70170": true
    },
    "MATÍAS ROMERO AVENDAÑO": {
      "70300": true,
      "70304": true,
      "70305": true,
      "70306": true,
      "70307": true,
      "70308": true,
      "70309": true,
      "70310": true,
      "70312": true
    },
    "TLACOLULA DE MATAMOROS": {
      "70400": true,
      "70403": true,
      "70404": true,
      "70405": true,
      "70406": true
    },
    "VILLA DÍAZ ORDAZ": {
      "70410": true,
      "70411": true,
      "70412": true
    },
    "TEOTITLÁN DEL VALLE": {
      "70420": true,
      "70423": true
    },
    "SAN FRANCISCO LACHIGOLÓ": {
      "70424": true
    },
    "SAN SEBASTIÁN TEITIPAC": {
      "70426": true
    },
    "SANTA ANA DEL VALLE": {
      "70428": true
    },
    "SANTIAGO MATATLÁN": {
      "70440": true,
      "70442": true,
      "70445": true
    },
    "ROJAS DE CUAUHTÉMOC": {
      "70450": true
    },
    "SAN JERÓNIMO TLACOCHAHUAYA": {
      "70460": true,
      "70461": true
    },
    "SAN JUAN GUELAVÍA": {
      "70464": true
    },
    "SALINA CRUZ": {
      "70600": true,
      "70610": true,
      "70612": true,
      "70613": true,
      "70614": true,
      "70615": true,
      "70620": true,
      "70630": true,
      "70633": true,
      "70640": true,
      "70650": true,
      "70660": true,
      "70664": true,
      "70665": true,
      "70666": true,
      "70670": true,
      "70680": true,
      "70690": true,
      "70701": true,
      "70702": true,
      "70703": true,
      "70704": true
    },
    "SANTA MARÍA JALAPA DEL MARQUÉS": {
      "70710": true
    },
    "SANTO DOMINGO CHIHUITÁN": {
      "70730": true
    },
    "MAGDALENA TEQUISISTLÁN": {
      "70740": true
    },
    "SANTA MARÍA MIXTEQUILLA": {
      "70755": true,
      "70756": true
    },
    "SANTO DOMINGO TEHUANTEPEC": {
      "70760": true,
      "70762": true,
      "70763": true,
      "70764": true,
      "70765": true,
      "70766": true,
      "70767": true
    },
    "MIAHUATLÁN DE PORFIRIO DÍAZ": {
      "70800": true,
      "70802": true,
      "70803": true,
      "70805": true
    },
    "SANTA MARÍA HUATULCO": {
      "70980": true,
      "70982": true,
      "70984": true,
      "70985": true,
      "70987": true,
      "70988": true,
      "70989": true
    },
    "PUTLA VILLA DE GUERRERO": {
      "71000": true,
      "71001": true,
      "71002": true,
      "71003": true,
      "71004": true,
      "71005": true,
      "71006": true,
      "71007": true,
      "71009": true,
      "71010": true,
      "71011": true,
      "71012": true,
      "71013": true,
      "71014": true,
      "71015": true,
      "71016": true,
      "71017": true,
      "71020": true,
      "71021": true
    },
    "CONSTANCIA DEL ROSARIO": {
      "71030": true,
      "71031": true,
      "71033": true,
      "71037": true
    },
    "ZIMATLÁN DE ÁLVAREZ": {
      "71200": true,
      "71202": true,
      "71203": true,
      "71204": true,
      "71205": true,
      "71207": true
    },
    "SANTA MARÍA ATZOMPA": {
      "71220": true,
      "71222": true,
      "71223": true
    },
    "SAN ANDRÉS IXTLAHUACA": {
      "71224": true
    },
    "SANTA CRUZ AMILPAS": {
      "71226": true,
      "71227": true,
      "71228": true
    },
    "SANTA CRUZ XOXOCOTLÁN": {
      "71230": true,
      "71231": true,
      "71232": true,
      "71233": true,
      "71235": true,
      "71236": true,
      "71238": true
    },
    "SANTA LUCÍA DEL CAMINO": {
      "71240": true,
      "71242": true,
      "71243": true,
      "71244": true,
      "71245": true
    },
    "SAN PEDRO IXTLAHUACA": {
      "71246": true,
      "71247": true,
      "71248": true
    },
    "SAN ANTONIO DE LA CAL": {
      "71250": true,
      "71253": true,
      "71254": true,
      "71255": true,
      "71256": true
    },
    "SAN AGUSTÍN DE LAS JUNTAS": {
      "71260": true
    },
    "SAN PABLO HUIXTEPEC": {
      "71265": true,
      "71266": true,
      "71267": true,
      "71268": true
    },
    "ÁNIMAS TRUJANO": {
      "71270": true,
      "71273": true,
      "71274": true
    },
    "SAN RAYMUNDO JALPAN": {
      "71280": true,
      "71283": true
    },
    "TRINIDAD ZAACHILA": {
      "71284": true,
      "71286": true
    },
    "SANTA MARÍA COYOTEPEC": {
      "71290": true,
      "71292": true
    },
    "SAN BARTOLO COYOTEPEC": {
      "71294": true,
      "71295": true
    },
    "SANTA INÉS YATZECHE": {
      "71297": true
    },
    "CIÉNEGA DE ZIMATLÁN": {
      "71300": true
    },
    "VILLA DE ZAACHILA": {
      "71310": true,
      "71313": true,
      "71314": true,
      "71315": true,
      "71316": true,
      "71317": true,
      "71318": true
    },
    "SANTA CATARINA QUIANÉ": {
      "71350": true,
      "71352": true,
      "71354": true
    },
    "CUILÁPAM DE GUERRERO": {
      "71400": true,
      "71403": true,
      "71404": true,
      "71405": true,
      "71406": true,
      "71407": true,
      "71408": true,
      "71409": true
    },
    "HEROICA CIUDAD DE EJUTLA DE CRESPO": {
      "71500": true,
      "71502": true,
      "71504": true,
      "71505": true
    },
    "SAN MARTÍN TILCAJETE": {
      "71506": true
    },
    "SANTO TOMÁS JALIEZA": {
      "71507": true
    },
    "SAN JUAN CHILATECA": {
      "71508": true
    },
    "SANTIAGO APÓSTOL": {
      "71518": true
    },
    "SAN ANTONINO CASTILLO VELASCO": {
      "71520": true
    },
    "ASUNCIÓN OCOTLÁN": {
      "71523": true
    },
    "SAN PEDRO MÁRTIR": {
      "71525": true
    },
    "MAGDALENA OCOTLÁN": {
      "71529": true
    },
    "SANTA CATARINA MINAS": {
      "71534": true
    },
    "SANTIAGO PINOTEPA NACIONAL": {
      "71600": true,
      "71602": true,
      "71603": true,
      "71604": true,
      "71605": true,
      "71606": true,
      "71607": true,
      "71608": true
    },
    "SAN JUAN CACAHUATEPEC": {
      "71610": true,
      "71612": true,
      "71613": true,
      "71615": true
    },
    "SANTIAGO JAMILTEPEC": {
      "71700": true,
      "71702": true,
      "71703": true,
      "71704": true,
      "71705": true,
      "71706": true,
      "71707": true,
      "71708": true
    },
    "PINOTEPA DE DON LUIS": {
      "71750": true,
      "71757": true
    },
    "SAN ANDRÉS HUAXPALTEPEC": {
      "71770": true,
      "71771": true,
      "71777": true
    },
    "SANTA MARÍA HUAZOLOTITLÁN": {
      "71790": true,
      "71791": true,
      "71792": true,
      "71799": true
    },
    "VILLA DE TUTUTEPEC": {
      "71800": true,
      "71801": true,
      "71803": true,
      "71806": true,
      "71830": true,
      "71831": true,
      "71833": true,
      "71834": true,
      "71835": true,
      "71836": true,
      "71837": true,
      "71838": true,
      "71847": true
    },
    "SANTOS REYES NOPALA": {
      "71960": true,
      "71963": true,
      "71964": true,
      "71965": true,
      "71966": true,
      "71967": true
    },
    "SAN GABRIEL MIXTEPEC": {
      "71970": true,
      "71971": true,
      "71973": true
    },
    "SAN PEDRO MIXTEPEC -DTO. 22 -": {
      "71980": true,
      "71982": true,
      "71983": true,
      "71984": true,
      "71985": true,
      "71989": true,
      "71990": true,
      "71992": true,
      "71993": true,
      "71994": true,
      "71996": true,
      "71997": true,
      "71998": true
    }
  },
  "PUEBLA": {
    "PUEBLA": {
      "72000": true,
      "72001": true,
      "72002": true,
      "72003": true,
      "72004": true,
      "72005": true,
      "72006": true,
      "72007": true,
      "72008": true,
      "72009": true,
      "72010": true,
      "72011": true,
      "72013": true,
      "72014": true,
      "72015": true,
      "72016": true,
      "72017": true,
      "72018": true,
      "72019": true,
      "72020": true,
      "72021": true,
      "72023": true,
      "72026": true,
      "72029": true,
      "72030": true,
      "72031": true,
      "72034": true,
      "72035": true,
      "72037": true,
      "72040": true,
      "72043": true,
      "72044": true,
      "72045": true,
      "72046": true,
      "72047": true,
      "72050": true,
      "72051": true,
      "72059": true,
      "72060": true,
      "72061": true,
      "72062": true,
      "72070": true,
      "72071": true,
      "72072": true,
      "72074": true,
      "72076": true,
      "72079": true,
      "72080": true,
      "72082": true,
      "72083": true,
      "72086": true,
      "72089": true,
      "72090": true,
      "72091": true,
      "72092": true,
      "72094": true,
      "72095": true,
      "72097": true,
      "72098": true,
      "72099": true,
      "72100": true,
      "72101": true,
      "72103": true,
      "72104": true,
      "72105": true,
      "72106": true,
      "72107": true,
      "72108": true,
      "72109": true,
      "72110": true,
      "72111": true,
      "72114": true,
      "72115": true,
      "72116": true,
      "72118": true,
      "72120": true,
      "72123": true,
      "72124": true,
      "72125": true,
      "72127": true,
      "72128": true,
      "72129": true,
      "72130": true,
      "72131": true,
      "72132": true,
      "72133": true,
      "72134": true,
      "72135": true,
      "72136": true,
      "72137": true,
      "72139": true,
      "72140": true,
      "72142": true,
      "72143": true,
      "72146": true,
      "72147": true,
      "72148": true,
      "72149": true,
      "72150": true,
      "72151": true,
      "72154": true,
      "72156": true,
      "72157": true,
      "72159": true,
      "72160": true,
      "72161": true,
      "72163": true,
      "72165": true,
      "72166": true,
      "72168": true,
      "72169": true,
      "72170": true,
      "72173": true,
      "72175": true,
      "72176": true,
      "72178": true,
      "72179": true,
      "72180": true,
      "72181": true,
      "72182": true,
      "72183": true,
      "72185": true,
      "72186": true,
      "72187": true,
      "72188": true,
      "72189": true,
      "72190": true,
      "72192": true,
      "72193": true,
      "72194": true,
      "72195": true,
      "72196": true,
      "72197": true,
      "72198": true,
      "72199": true,
      "72200": true,
      "72201": true,
      "72203": true,
      "72205": true,
      "72206": true,
      "72209": true,
      "72210": true,
      "72212": true,
      "72213": true,
      "72215": true,
      "72216": true,
      "72217": true,
      "72219": true,
      "72220": true,
      "72223": true,
      "72225": true,
      "72226": true,
      "72227": true,
      "72228": true,
      "72229": true,
      "72230": true,
      "72231": true,
      "72236": true,
      "72237": true,
      "72238": true,
      "72239": true,
      "72240": true,
      "72243": true,
      "72246": true,
      "72247": true,
      "72249": true,
      "72250": true,
      "72256": true,
      "72260": true,
      "72261": true,
      "72265": true,
      "72266": true,
      "72267": true,
      "72268": true,
      "72269": true,
      "72270": true,
      "72271": true,
      "72276": true,
      "72280": true,
      "72289": true,
      "72290": true,
      "72293": true,
      "72294": true,
      "72295": true,
      "72300": true,
      "72301": true,
      "72302": true,
      "72303": true,
      "72304": true,
      "72306": true,
      "72307": true,
      "72308": true,
      "72309": true,
      "72310": true,
      "72311": true,
      "72313": true,
      "72314": true,
      "72315": true,
      "72316": true,
      "72320": true,
      "72321": true,
      "72329": true,
      "72330": true,
      "72334": true,
      "72340": true,
      "72350": true,
      "72351": true,
      "72354": true,
      "72359": true,
      "72360": true,
      "72361": true,
      "72363": true,
      "72364": true,
      "72365": true,
      "72366": true,
      "72370": true,
      "72373": true,
      "72374": true,
      "72375": true,
      "72376": true,
      "72377": true,
      "72378": true,
      "72379": true,
      "72380": true,
      "72388": true,
      "72389": true,
      "72390": true,
      "72400": true,
      "72401": true,
      "72402": true,
      "72403": true,
      "72406": true,
      "72410": true,
      "72411": true,
      "72414": true,
      "72415": true,
      "72417": true,
      "72420": true,
      "72422": true,
      "72423": true,
      "72424": true,
      "72425": true,
      "72426": true,
      "72430": true,
      "72431": true,
      "72432": true,
      "72433": true,
      "72436": true,
      "72440": true,
      "72444": true,
      "72447": true,
      "72448": true,
      "72450": true,
      "72451": true,
      "72453": true,
      "72454": true,
      "72456": true,
      "72457": true,
      "72459": true,
      "72460": true,
      "72462": true,
      "72464": true,
      "72465": true,
      "72466": true,
      "72468": true,
      "72470": true,
      "72472": true,
      "72474": true,
      "72475": true,
      "72476": true,
      "72477": true,
      "72478": true,
      "72479": true,
      "72480": true,
      "72482": true,
      "72483": true,
      "72484": true,
      "72488": true,
      "72489": true,
      "72490": true,
      "72491": true,
      "72492": true,
      "72493": true,
      "72494": true,
      "72495": true,
      "72496": true,
      "72497": true,
      "72498": true,
      "72499": true,
      "72500": true,
      "72501": true,
      "72502": true,
      "72503": true,
      "72504": true,
      "72505": true,
      "72506": true,
      "72507": true,
      "72508": true,
      "72509": true,
      "72510": true,
      "72515": true,
      "72520": true,
      "72522": true,
      "72523": true,
      "72524": true,
      "72525": true,
      "72527": true,
      "72529": true,
      "72530": true,
      "72531": true,
      "72532": true,
      "72533": true,
      "72534": true,
      "72535": true,
      "72536": true,
      "72537": true,
      "72538": true,
      "72539": true,
      "72540": true,
      "72541": true,
      "72542": true,
      "72543": true,
      "72544": true,
      "72548": true,
      "72550": true,
      "72553": true,
      "72554": true,
      "72555": true,
      "72557": true,
      "72559": true,
      "72560": true,
      "72562": true,
      "72563": true,
      "72564": true,
      "72565": true,
      "72566": true,
      "72567": true,
      "72569": true,
      "72570": true,
      "72571": true,
      "72572": true,
      "72573": true,
      "72574": true,
      "72575": true,
      "72576": true,
      "72577": true,
      "72579": true,
      "72580": true,
      "72582": true,
      "72583": true,
      "72584": true,
      "72585": true,
      "72587": true,
      "72588": true,
      "72589": true,
      "72590": true,
      "72592": true,
      "72593": true,
      "72594": true,
      "72595": true,
      "72596": true,
      "72597": true,
      "72599": true,
      "72900": true,
      "72920": true,
      "72940": true,
      "72943": true,
      "72960": true,
      "72967": true,
      "72968": true,
      "72970": true,
      "72971": true,
      "72973": true,
      "72975": true,
      "72977": true,
      "72978": true
    },
    "TLALTENANGO": {
      "72600": true,
      "72603": true
    },
    "SAN MIGUEL XOXTLA": {
      "72620": true,
      "72623": true
    },
    "JUAN C. BONILLA": {
      "72640": true,
      "72646": true,
      "72650": true,
      "72660": true,
      "72662": true,
      "72663": true,
      "72664": true,
      "72665": true,
      "72668": true,
      "72669": true
    },
    "CORONANGO": {
      "72670": true,
      "72680": true,
      "72683": true,
      "72684": true,
      "72685": true,
      "72686": true,
      "72687": true
    },
    "CUAUTLANCINGO": {
      "72700": true,
      "72702": true,
      "72703": true,
      "72704": true,
      "72705": true,
      "72706": true,
      "72707": true,
      "72708": true,
      "72710": true,
      "72712": true,
      "72713": true,
      "72720": true,
      "72723": true,
      "72724": true,
      "72725": true,
      "72729": true,
      "72730": true,
      "72732": true,
      "72733": true,
      "72735": true
    },
    "SAN PEDRO CHOLULA": {
      "72750": true,
      "72754": true,
      "72755": true,
      "72756": true,
      "72757": true,
      "72758": true,
      "72760": true,
      "72761": true,
      "72762": true,
      "72764": true,
      "72765": true,
      "72766": true,
      "72767": true,
      "72768": true,
      "72769": true,
      "72770": true,
      "72771": true,
      "72772": true,
      "72773": true,
      "72774": true,
      "72775": true,
      "72776": true,
      "72777": true,
      "72778": true,
      "72788": true
    },
    "SAN ANDRÉS CHOLULA": {
      "72803": true,
      "72805": true,
      "72810": true,
      "72812": true,
      "72813": true,
      "72814": true,
      "72815": true,
      "72817": true,
      "72819": true,
      "72820": true,
      "72821": true,
      "72823": true,
      "72824": true,
      "72825": true,
      "72826": true,
      "72828": true,
      "72830": true,
      "72833": true,
      "72835": true,
      "72836": true,
      "72837": true,
      "72840": true,
      "72843": true,
      "72844": true,
      "72845": true,
      "72846": true,
      "72848": true
    },
    "OCOYUCAN": {
      "72850": true,
      "72852": true,
      "72853": true,
      "72854": true,
      "72860": true,
      "72861": true,
      "72863": true,
      "72864": true,
      "72865": true,
      "72866": true,
      "72867": true
    },
    "AMOZOC": {
      "72980": true,
      "72983": true,
      "72984": true,
      "72985": true,
      "72986": true,
      "72987": true,
      "72988": true,
      "72989": true,
      "72990": true,
      "72991": true,
      "72992": true,
      "72993": true,
      "72994": true,
      "72995": true,
      "72996": true,
      "72997": true,
      "72998": true
    },
    "XICOTEPEC": {
      "73080": true,
      "73083": true,
      "73087": true,
      "73088": true,
      "73089": true
    },
    "HUAUCHINANGO": {
      "73160": true,
      "73161": true,
      "73162": true,
      "73163": true,
      "73164": true,
      "73165": true,
      "73166": true,
      "73167": true,
      "73168": true,
      "73169": true,
      "73170": true,
      "73172": true,
      "73173": true,
      "73174": true,
      "73175": true,
      "73176": true,
      "73177": true,
      "73178": true
    },
    "AHUAZOTEPEC": {
      "73180": true,
      "73181": true,
      "73185": true,
      "73190": true,
      "73191": true,
      "73193": true,
      "73194": true,
      "73195": true
    },
    "JUAN GALINDO": {
      "73200": true,
      "73203": true,
      "73204": true,
      "73205": true,
      "73206": true,
      "73210": true,
      "73211": true,
      "73213": true,
      "73214": true,
      "73215": true,
      "73216": true
    },
    "CHIGNAHUAPAN": {
      "73298": true,
      "73299": true,
      "73300": true,
      "73301": true,
      "73302": true,
      "73303": true,
      "73304": true,
      "73305": true,
      "73306": true,
      "73307": true,
      "73308": true,
      "73309": true
    },
    "ZACATLÁN": {
      "73310": true,
      "73312": true,
      "73313": true,
      "73314": true,
      "73315": true,
      "73316": true,
      "73317": true,
      "73318": true,
      "73319": true
    },
    "AQUIXTLA": {
      "73620": true,
      "73637": true
    },
    "TETELA DE OCAMPO": {
      "73640": true,
      "73644": true,
      "73645": true,
      "73647": true,
      "73650": true,
      "73654": true,
      "73655": true,
      "73656": true,
      "73657": true,
      "73658": true,
      "73659": true
    },
    "ZACAPOAXTLA": {
      "73680": true,
      "73681": true,
      "73682": true,
      "73683": true,
      "73684": true,
      "73685": true,
      "73686": true,
      "73687": true,
      "73688": true,
      "73689": true,
      "73690": true,
      "73691": true,
      "73692": true,
      "73693": true,
      "73694": true,
      "73697": true,
      "73698": true
    },
    "ZARAGOZA": {
      "73700": true,
      "73702": true,
      "73703": true,
      "73704": true,
      "73705": true,
      "73706": true
    },
    "LIBRES": {
      "73780": true,
      "73783": true,
      "73784": true,
      "73785": true,
      "73790": true,
      "73791": true,
      "73792": true,
      "73794": true,
      "73795": true,
      "73796": true,
      "73797": true,
      "73798": true,
      "73799": true
    },
    "TEZIUTLÁN": {
      "73800": true,
      "73801": true,
      "73802": true,
      "73803": true,
      "73805": true,
      "73808": true,
      "73810": true,
      "73811": true,
      "73815": true,
      "73816": true,
      "73817": true,
      "73820": true,
      "73821": true,
      "73825": true,
      "73829": true,
      "73830": true,
      "73831": true,
      "73840": true,
      "73841": true,
      "73850": true,
      "73860": true,
      "73863": true,
      "73867": true,
      "73870": true,
      "73880": true,
      "73881": true,
      "73885": true,
      "73886": true,
      "73887": true,
      "73890": true,
      "73895": true,
      "73898": true,
      "73899": true,
      "73960": true,
      "73965": true,
      "73966": true,
      "73967": true,
      "73968": true,
      "73969": true
    },
    "TLATLAUQUITEPEC": {
      "73900": true,
      "73903": true,
      "73904": true,
      "73905": true,
      "73906": true,
      "73907": true,
      "73909": true
    },
    "YAONÁHUAC": {
      "73910": true,
      "73913": true,
      "73914": true,
      "73915": true,
      "73916": true,
      "73917": true,
      "73918": true
    },
    "HUEYAPAN": {
      "73920": true,
      "73923": true,
      "73924": true,
      "73925": true,
      "73926": true,
      "73927": true,
      "73928": true,
      "73929": true
    },
    "TETELES DE ÁVILA CASTILLO": {
      "73930": true,
      "73933": true,
      "73934": true,
      "73935": true,
      "73937": true,
      "73938": true,
      "73939": true
    },
    "ATEMPAN": {
      "73940": true,
      "73941": true,
      "73944": true,
      "73948": true,
      "73949": true
    },
    "CHIGNAUTLA": {
      "73950": true,
      "73953": true,
      "73954": true,
      "73955": true,
      "73956": true,
      "73957": true,
      "73958": true
    },
    "XIUTETELCO": {
      "73970": true,
      "73972": true,
      "73973": true,
      "73974": true,
      "73975": true,
      "73976": true,
      "73977": true,
      "73978": true,
      "73979": true
    },
    "CUYOACO": {
      "73980": true,
      "73982": true,
      "73983": true,
      "73985": true,
      "73986": true,
      "73987": true,
      "73989": true
    },
    "SAN MARTÍN TEXMELUCAN": {
      "74000": true,
      "74001": true,
      "74009": true,
      "74010": true,
      "74013": true,
      "74016": true,
      "74020": true,
      "74021": true,
      "74030": true,
      "74031": true,
      "74036": true,
      "74040": true,
      "74041": true,
      "74042": true,
      "74043": true,
      "74047": true,
      "74048": true,
      "74050": true,
      "74053": true,
      "74058": true,
      "74059": true,
      "74060": true,
      "74064": true,
      "74068": true,
      "74069": true,
      "74070": true,
      "74074": true,
      "74075": true,
      "74078": true,
      "74079": true,
      "74080": true,
      "74088": true,
      "74089": true,
      "74090": true,
      "74093": true,
      "74099": true,
      "74120": true,
      "74122": true,
      "74125": true
    },
    "SAN MATÍAS TLALANCALECA": {
      "74110": true,
      "74113": true,
      "74114": true,
      "74115": true,
      "74116": true,
      "74117": true,
      "74119": true
    },
    "SAN SALVADOR EL VERDE": {
      "74130": true,
      "74132": true,
      "74133": true,
      "74134": true,
      "74135": true,
      "74136": true,
      "74137": true,
      "74138": true,
      "74139": true
    },
    "SAN FELIPE TEOTLALCINGO": {
      "74140": true,
      "74143": true,
      "74144": true,
      "74145": true,
      "74146": true,
      "74147": true,
      "74148": true
    },
    "CHIAUTZINGO": {
      "74150": true,
      "74155": true
    },
    "HUEJOTZINGO": {
      "74160": true,
      "74161": true,
      "74162": true,
      "74163": true,
      "74164": true,
      "74165": true,
      "74166": true,
      "74167": true,
      "74168": true,
      "74169": true
    },
    "ATLIXCO": {
      "74200": true,
      "74201": true,
      "74210": true,
      "74215": true,
      "74218": true,
      "74219": true,
      "74220": true,
      "74225": true,
      "74226": true,
      "74227": true,
      "74230": true,
      "74233": true,
      "74235": true,
      "74239": true,
      "74240": true,
      "74246": true,
      "74250": true,
      "74259": true,
      "74260": true,
      "74264": true,
      "74270": true,
      "74280": true,
      "74290": true,
      "74292": true,
      "74293": true,
      "74294": true,
      "74295": true,
      "74296": true,
      "74360": true,
      "74363": true,
      "74365": true,
      "74367": true,
      "74368": true,
      "74369": true
    },
    "SAN GREGORIO ATZOMPA": {
      "74320": true,
      "74323": true,
      "74324": true,
      "74325": true
    },
    "TIANGUISMANALCO": {
      "74340": true,
      "74342": true,
      "74343": true,
      "74344": true
    },
    "SANTA ISABEL CHOLULA": {
      "74350": true,
      "74355": true,
      "74356": true,
      "74357": true,
      "74358": true
    },
    "HUAQUECHULA": {
      "74370": true,
      "74372": true,
      "74373": true,
      "74374": true,
      "74375": true,
      "74376": true,
      "74377": true,
      "74378": true,
      "74379": true
    },
    "TEPEOJUMA": {
      "74390": true,
      "74393": true,
      "74394": true,
      "74395": true,
      "74396": true,
      "74397": true
    },
    "IZÚCAR DE MATAMOROS": {
      "74400": true,
      "74402": true,
      "74406": true,
      "74410": true,
      "74418": true,
      "74419": true,
      "74420": true,
      "74426": true,
      "74430": true,
      "74435": true,
      "74438": true,
      "74440": true,
      "74443": true,
      "74448": true,
      "74449": true,
      "74450": true,
      "74460": true,
      "74463": true,
      "74467": true,
      "74468": true,
      "74470": true,
      "74478": true,
      "74480": true,
      "74490": true,
      "74570": true,
      "74573": true,
      "74575": true,
      "74576": true,
      "74577": true,
      "74578": true
    },
    "TLAPANALÁ": {
      "74540": true,
      "74542": true,
      "74543": true,
      "74544": true,
      "74545": true,
      "74546": true,
      "74547": true,
      "74548": true,
      "74549": true
    },
    "TEPEXCO": {
      "74558": true
    },
    "TILAPA": {
      "74560": true,
      "74564": true,
      "74565": true,
      "74566": true,
      "74567": true,
      "74568": true
    },
    "CHIETLA": {
      "74580": true,
      "74582": true,
      "74584": true,
      "74585": true,
      "74586": true,
      "74587": true,
      "74588": true,
      "74589": true
    },
    "RAFAEL LARA GRAJALES": {
      "75000": true
    },
    "SAN JOSÉ CHIAPA": {
      "75010": true,
      "75012": true,
      "75013": true,
      "75014": true,
      "75015": true,
      "75016": true
    },
    "ORIENTAL": {
      "75020": true,
      "75021": true,
      "75023": true,
      "75024": true,
      "75025": true,
      "75026": true,
      "75029": true
    },
    "SAN NICOLÁS BUENOS AIRES": {
      "75030": true,
      "75032": true,
      "75033": true,
      "75034": true,
      "75035": true,
      "75036": true,
      "75037": true,
      "75038": true,
      "75039": true
    },
    "TEPATLAXCO DE HIDALGO": {
      "75100": true,
      "75103": true,
      "75104": true
    },
    "ACAJETE": {
      "75110": true,
      "75112": true,
      "75114": true,
      "75116": true
    },
    "NOPALUCAN": {
      "75120": true,
      "75125": true,
      "75126": true,
      "75127": true,
      "75128": true,
      "75129": true
    },
    "ACATZINGO": {
      "75150": true,
      "75151": true,
      "75153": true,
      "75154": true,
      "75155": true,
      "75156": true,
      "75157": true,
      "75158": true,
      "75159": true
    },
    "SAN SALVADOR EL SECO": {
      "75160": true,
      "75162": true,
      "75163": true,
      "75164": true,
      "75165": true,
      "75166": true,
      "75167": true,
      "75169": true
    },
    "GENERAL FELIPE ÁNGELES": {
      "75176": true,
      "75178": true,
      "75179": true
    },
    "SAN JUAN ATENCO": {
      "75190": true,
      "75193": true,
      "75194": true,
      "75195": true,
      "75196": true,
      "75197": true
    },
    "TEPEACA": {
      "75200": true,
      "75203": true,
      "75204": true,
      "75205": true,
      "75206": true,
      "75207": true,
      "75210": true,
      "75211": true,
      "75212": true,
      "75214": true,
      "75215": true,
      "75219": true
    },
    "CUAUTINCHÁN": {
      "75220": true,
      "75221": true,
      "75223": true,
      "75224": true,
      "75225": true,
      "75226": true,
      "75230": true,
      "75232": true,
      "75233": true,
      "75234": true,
      "75235": true,
      "75236": true,
      "75237": true,
      "75238": true
    },
    "TECALI DE HERRERA": {
      "75240": true,
      "75245": true,
      "75250": true,
      "75252": true,
      "75253": true,
      "75254": true,
      "75255": true,
      "75256": true,
      "75257": true,
      "75258": true,
      "75259": true
    },
    "MIXTLA": {
      "75260": true,
      "75263": true,
      "75264": true,
      "75265": true,
      "75270": true
    },
    "SANTO TOMÁS HUEYOTLIPAN": {
      "75280": true,
      "75290": true,
      "75293": true,
      "75294": true
    },
    "LOS REYES DE JUÁREZ": {
      "75400": true,
      "75402": true,
      "75403": true,
      "75404": true,
      "75405": true,
      "75406": true,
      "75407": true,
      "75410": true,
      "75412": true,
      "75413": true,
      "75414": true,
      "75415": true
    },
    "CUAPIAXTLA DE MADERO": {
      "75420": true,
      "75421": true,
      "75423": true,
      "75424": true,
      "75425": true
    },
    "SAN SALVADOR HUIXCOLOTLA": {
      "75440": true,
      "75443": true,
      "75444": true,
      "75445": true,
      "75446": true,
      "75447": true,
      "75448": true
    },
    "QUECHOLAC": {
      "75460": true,
      "75463": true,
      "75464": true,
      "75465": true,
      "75466": true,
      "75467": true,
      "75469": true,
      "75470": true,
      "75471": true,
      "75472": true,
      "75475": true,
      "75476": true
    },
    "TECAMACHALCO": {
      "75480": true,
      "75481": true,
      "75482": true,
      "75483": true,
      "75484": true,
      "75485": true,
      "75486": true,
      "75487": true,
      "75490": true,
      "75491": true,
      "75492": true,
      "75493": true,
      "75494": true,
      "75495": true,
      "75496": true,
      "75497": true,
      "75498": true,
      "75499": true
    },
    "PALMAR DE BRAVO": {
      "75500": true,
      "75501": true,
      "75504": true,
      "75505": true,
      "75506": true,
      "75507": true,
      "75508": true,
      "75509": true,
      "75510": true,
      "75511": true,
      "75512": true,
      "75513": true,
      "75514": true,
      "75515": true,
      "75516": true,
      "75517": true,
      "75519": true
    },
    "CHALCHICOMULA DE SESMA": {
      "75520": true,
      "75524": true,
      "75525": true,
      "75526": true,
      "75527": true,
      "75528": true,
      "75529": true,
      "75530": true,
      "75535": true,
      "75536": true,
      "75537": true,
      "75538": true,
      "75539": true
    },
    "TLANEPANTLA": {
      "75600": true,
      "75603": true
    },
    "TOCHTEPEC": {
      "75610": true,
      "75612": true,
      "75613": true,
      "75614": true,
      "75615": true,
      "75616": true,
      "75617": true,
      "75618": true,
      "75619": true
    },
    "ATOYATEMPAN": {
      "75620": true,
      "75623": true,
      "75624": true,
      "75625": true,
      "75626": true
    },
    "TEPEYAHUALCO DE CUAUHTÉMOC": {
      "75630": true,
      "75635": true
    },
    "HUITZILTEPEC": {
      "75640": true,
      "75641": true,
      "75643": true,
      "75644": true
    },
    "MOLCAXAC": {
      "75650": true,
      "75653": true,
      "75654": true,
      "75655": true,
      "75656": true,
      "75657": true,
      "75659": true
    },
    "TLACOTEPEC DE BENITO JUÁREZ": {
      "75680": true,
      "75681": true,
      "75685": true,
      "75686": true,
      "75687": true,
      "75689": true
    },
    "TEHUACÁN": {
      "75700": true,
      "75701": true,
      "75703": true,
      "75705": true,
      "75707": true,
      "75710": true,
      "75711": true,
      "75714": true,
      "75717": true,
      "75718": true,
      "75719": true,
      "75720": true,
      "75724": true,
      "75725": true,
      "75726": true,
      "75730": true,
      "75731": true,
      "75732": true,
      "75735": true,
      "75740": true,
      "75741": true,
      "75742": true,
      "75743": true,
      "75748": true,
      "75750": true,
      "75751": true,
      "75757": true,
      "75758": true,
      "75760": true,
      "75763": true,
      "75764": true,
      "75765": true,
      "75766": true,
      "75768": true,
      "75769": true,
      "75770": true,
      "75776": true,
      "75780": true,
      "75784": true,
      "75785": true,
      "75786": true,
      "75788": true,
      "75789": true,
      "75790": true,
      "75793": true,
      "75794": true,
      "75795": true,
      "75796": true,
      "75797": true,
      "75798": true,
      "75799": true,
      "75853": true,
      "75854": true,
      "75855": true,
      "75856": true,
      "75857": true,
      "75858": true,
      "75859": true
    },
    "TEPANCO DE LÓPEZ": {
      "75800": true,
      "75804": true,
      "75805": true,
      "75806": true,
      "75807": true,
      "75808": true,
      "75809": true
    },
    "CHAPULCO": {
      "75810": true,
      "75813": true,
      "75814": true
    },
    "SANTIAGO MIAHUATLÁN": {
      "75820": true,
      "75822": true,
      "75823": true,
      "75824": true,
      "75825": true,
      "75826": true,
      "75827": true,
      "75828": true
    },
    "SAN GABRIEL CHILAC": {
      "75880": true,
      "75883": true,
      "75884": true,
      "75885": true,
      "75886": true,
      "75887": true
    },
    "AJALPAN": {
      "75910": true,
      "75913": true,
      "75914": true,
      "75915": true,
      "75916": true,
      "75917": true
    },
    "ALTEPEXI": {
      "75950": true,
      "75953": true,
      "75954": true,
      "75955": true,
      "75956": true,
      "75957": true
    },
    "ZINACATEPEC": {
      "75960": true,
      "75963": true,
      "75964": true,
      "75965": true
    },
    "SAN JOSÉ MIAHUATLÁN": {
      "75970": true,
      "75972": true,
      "75973": true,
      "75974": true,
      "75975": true
    },
    "COXCATLÁN": {
      "75980": true,
      "75981": true,
      "75983": true,
      "75984": true,
      "75985": true,
      "75986": true,
      "75987": true,
      "75988": true,
      "75989": true
    }
  },
  "QUERÉTARO": {
    "QUERÉTARO": {
      "76000": true,
      "76001": true,
      "76002": true,
      "76003": true,
      "76004": true,
      "76005": true,
      "76006": true,
      "76007": true,
      "76008": true,
      "76009": true,
      "76010": true,
      "76011": true,
      "76012": true,
      "76013": true,
      "76016": true,
      "76017": true,
      "76018": true,
      "76019": true,
      "76020": true,
      "76021": true,
      "76022": true,
      "76024": true,
      "76025": true,
      "76026": true,
      "76027": true,
      "76028": true,
      "76029": true,
      "76030": true,
      "76031": true,
      "76032": true,
      "76033": true,
      "76034": true,
      "76035": true,
      "76036": true,
      "76037": true,
      "76038": true,
      "76039": true,
      "76040": true,
      "76041": true,
      "76042": true,
      "76043": true,
      "76044": true,
      "76045": true,
      "76046": true,
      "76047": true,
      "76048": true,
      "76049": true,
      "76050": true,
      "76052": true,
      "76054": true,
      "76055": true,
      "76057": true,
      "76058": true,
      "76059": true,
      "76060": true,
      "76063": true,
      "76064": true,
      "76065": true,
      "76066": true,
      "76067": true,
      "76068": true,
      "76069": true,
      "76070": true,
      "76073": true,
      "76074": true,
      "76076": true,
      "76078": true,
      "76079": true,
      "76080": true,
      "76081": true,
      "76082": true,
      "76083": true,
      "76084": true,
      "76085": true,
      "76086": true,
      "76087": true,
      "76088": true,
      "76089": true,
      "76090": true,
      "76091": true,
      "76092": true,
      "76093": true,
      "76094": true,
      "76095": true,
      "76096": true,
      "76097": true,
      "76098": true,
      "76099": true,
      "76100": true,
      "76101": true,
      "76102": true,
      "76103": true,
      "76104": true,
      "76105": true,
      "76106": true,
      "76108": true,
      "76109": true,
      "76110": true,
      "76111": true,
      "76112": true,
      "76113": true,
      "76114": true,
      "76115": true,
      "76116": true,
      "76117": true,
      "76118": true,
      "76120": true,
      "76121": true,
      "76122": true,
      "76123": true,
      "76124": true,
      "76125": true,
      "76126": true,
      "76127": true,
      "76128": true,
      "76129": true,
      "76130": true,
      "76131": true,
      "76132": true,
      "76133": true,
      "76134": true,
      "76135": true,
      "76136": true,
      "76137": true,
      "76138": true,
      "76139": true,
      "76140": true,
      "76141": true,
      "76142": true,
      "76143": true,
      "76144": true,
      "76145": true,
      "76146": true,
      "76147": true,
      "76148": true,
      "76149": true,
      "76150": true,
      "76151": true,
      "76152": true,
      "76153": true,
      "76154": true,
      "76155": true,
      "76156": true,
      "76157": true,
      "76158": true,
      "76159": true,
      "76160": true,
      "76161": true,
      "76162": true,
      "76163": true,
      "76164": true,
      "76165": true,
      "76166": true,
      "76167": true,
      "76168": true,
      "76169": true,
      "76170": true,
      "76171": true,
      "76172": true,
      "76173": true,
      "76175": true,
      "76176": true,
      "76177": true,
      "76178": true,
      "76179": true,
      "76180": true,
      "76181": true,
      "76182": true,
      "76184": true,
      "76185": true,
      "76186": true,
      "76187": true,
      "76188": true,
      "76189": true,
      "76190": true,
      "76191": true,
      "76192": true,
      "76195": true,
      "76196": true,
      "76197": true,
      "76198": true,
      "76199": true,
      "76206": true,
      "76208": true,
      "76212": true,
      "76215": true,
      "76220": true,
      "76223": true,
      "76225": true,
      "76226": true,
      "76227": true,
      "76229": true,
      "76230": true,
      "76233": true,
      "76234": true,
      "76235": true,
      "76237": true,
      "76238": true
    },
    "EL MARQUÉS": {
      "76240": true,
      "76243": true,
      "76244": true,
      "76246": true,
      "76247": true,
      "76248": true,
      "76257": true,
      "76258": true,
      "76259": true,
      "76262": true,
      "76263": true,
      "76264": true,
      "76265": true,
      "76266": true,
      "76267": true,
      "76269": true
    },
    "COLÓN": {
      "76270": true,
      "76273": true,
      "76275": true,
      "76276": true,
      "76278": true,
      "76279": true,
      "76280": true,
      "76281": true,
      "76282": true,
      "76284": true,
      "76286": true,
      "76288": true,
      "76289": true,
      "76290": true,
      "76293": true,
      "76294": true,
      "76295": true,
      "76296": true,
      "76297": true,
      "76298": true,
      "76299": true
    },
    "PINAL DE AMOLES": {
      "76300": true,
      "76303": true,
      "76304": true,
      "76310": true,
      "76313": true,
      "76314": true,
      "76315": true,
      "76316": true,
      "76317": true,
      "76320": true,
      "76321": true,
      "76326": true,
      "76327": true,
      "76333": true,
      "76337": true
    },
    "JALPAN DE SERRA": {
      "76340": true,
      "76342": true,
      "76344": true,
      "76345": true,
      "76346": true,
      "76347": true,
      "76348": true,
      "76349": true,
      "76353": true,
      "76355": true
    },
    "LANDA DE MATAMOROS": {
      "76360": true,
      "76380": true,
      "76383": true,
      "76385": true,
      "76386": true,
      "76388": true
    },
    "ARROYO SECO": {
      "76400": true,
      "76401": true,
      "76402": true,
      "76404": true,
      "76405": true,
      "76410": true,
      "76411": true,
      "76413": true,
      "76414": true,
      "76421": true,
      "76424": true,
      "76426": true,
      "76434": true,
      "76440": true
    },
    "PEÑAMILLER": {
      "76450": true,
      "76453": true,
      "76454": true,
      "76478": true,
      "76484": true,
      "76485": true,
      "76486": true,
      "76489": true,
      "76490": true,
      "76492": true,
      "76493": true,
      "76494": true,
      "76495": true,
      "76496": true,
      "76499": true
    },
    "CADEREYTA DE MONTES": {
      "76500": true,
      "76502": true,
      "76503": true,
      "76504": true,
      "76505": true,
      "76506": true,
      "76507": true,
      "76508": true,
      "76509": true,
      "76510": true,
      "76511": true,
      "76513": true,
      "76514": true,
      "76515": true,
      "76516": true,
      "76517": true,
      "76521": true,
      "76522": true,
      "76525": true,
      "76526": true,
      "76527": true,
      "76528": true,
      "76529": true,
      "76530": true,
      "76534": true,
      "76536": true,
      "76537": true,
      "76540": true,
      "76541": true,
      "76543": true,
      "76544": true,
      "76548": true
    },
    "SAN JOAQUÍN": {
      "76550": true,
      "76553": true,
      "76554": true,
      "76555": true,
      "76556": true,
      "76557": true,
      "76558": true,
      "76560": true
    },
    "TOLIMÁN": {
      "76600": true,
      "76605": true,
      "76610": true,
      "76613": true,
      "76614": true,
      "76615": true,
      "76617": true,
      "76618": true,
      "76620": true,
      "76624": true,
      "76626": true,
      "76627": true,
      "76630": true,
      "76631": true,
      "76632": true,
      "76633": true,
      "76635": true,
      "76636": true,
      "76637": true,
      "76640": true,
      "76643": true,
      "76644": true,
      "76645": true,
      "76646": true,
      "76647": true,
      "76649": true
    },
    "EZEQUIEL MONTES": {
      "76650": true,
      "76651": true,
      "76654": true,
      "76655": true,
      "76656": true,
      "76657": true,
      "76660": true,
      "76663": true,
      "76664": true,
      "76665": true,
      "76666": true,
      "76667": true,
      "76668": true,
      "76670": true,
      "76674": true,
      "76675": true,
      "76676": true,
      "76677": true,
      "76680": true,
      "76681": true,
      "76683": true,
      "76685": true,
      "76686": true,
      "76687": true,
      "76688": true,
      "76690": true,
      "76693": true,
      "76694": true,
      "76697": true,
      "76698": true
    },
    "PEDRO ESCOBEDO": {
      "76700": true,
      "76703": true,
      "76704": true,
      "76705": true,
      "76706": true,
      "76707": true,
      "76708": true,
      "76710": true,
      "76713": true,
      "76714": true,
      "76715": true,
      "76720": true,
      "76721": true,
      "76722": true,
      "76723": true,
      "76724": true,
      "76725": true,
      "76726": true,
      "76729": true,
      "76730": true,
      "76735": true,
      "76738": true,
      "76740": true,
      "76741": true,
      "76743": true
    },
    "TEQUISQUIAPAN": {
      "76750": true,
      "76753": true,
      "76754": true,
      "76755": true,
      "76756": true,
      "76757": true,
      "76770": true,
      "76773": true,
      "76774": true,
      "76775": true,
      "76776": true,
      "76780": true,
      "76781": true,
      "76783": true,
      "76785": true,
      "76786": true,
      "76790": true,
      "76791": true,
      "76794": true,
      "76795": true,
      "76796": true,
      "76799": true
    },
    "SAN JUAN DEL RÍO": {
      "76800": true,
      "76801": true,
      "76802": true,
      "76803": true,
      "76804": true,
      "76805": true,
      "76806": true,
      "76807": true,
      "76808": true,
      "76809": true,
      "76810": true,
      "76812": true,
      "76813": true,
      "76814": true,
      "76815": true,
      "76816": true,
      "76820": true,
      "76821": true,
      "76823": true,
      "76824": true,
      "76826": true,
      "76827": true,
      "76828": true,
      "76831": true,
      "76833": true,
      "76834": true,
      "76835": true,
      "76836": true,
      "76837": true,
      "76840": true,
      "76841": true,
      "76842": true,
      "76843": true,
      "76844": true,
      "76845": true
    },
    "AMEALCO DE BONFIL": {
      "76850": true,
      "76851": true,
      "76852": true,
      "76853": true,
      "76854": true,
      "76855": true,
      "76856": true,
      "76858": true,
      "76860": true,
      "76861": true,
      "76862": true,
      "76863": true,
      "76870": true,
      "76874": true,
      "76875": true,
      "76876": true,
      "76877": true,
      "76878": true,
      "76879": true,
      "76883": true,
      "76884": true,
      "76885": true,
      "76886": true,
      "76887": true,
      "76888": true,
      "76894": true,
      "76895": true,
      "76896": true,
      "76897": true
    },
    "CORREGIDORA": {
      "76900": true,
      "76902": true,
      "76903": true,
      "76904": true,
      "76905": true,
      "76906": true,
      "76907": true,
      "76908": true,
      "76910": true,
      "76912": true,
      "76913": true,
      "76914": true,
      "76915": true,
      "76920": true,
      "76921": true,
      "76922": true,
      "76923": true,
      "76926": true,
      "76927": true,
      "76928": true,
      "76930": true,
      "76940": true
    },
    "HUIMILPAN": {
      "76950": true,
      "76951": true,
      "76952": true,
      "76953": true,
      "76955": true,
      "76958": true,
      "76960": true,
      "76963": true,
      "76964": true,
      "76965": true,
      "76970": true,
      "76971": true,
      "76973": true,
      "76974": true,
      "76975": true,
      "76976": true,
      "76980": true,
      "76981": true,
      "76983": true,
      "76984": true,
      "76985": true,
      "76990": true,
      "76992": true,
      "76993": true,
      "76994": true,
      "76995": true,
      "76997": true
    }
  },
  "QUINTANA ROO": {
    "OTHÓN P. BLANCO": {
      "77000": true,
      "77008": true,
      "77009": true,
      "77010": true,
      "77011": true,
      "77012": true,
      "77013": true,
      "77014": true,
      "77015": true,
      "77016": true,
      "77017": true,
      "77018": true,
      "77019": true,
      "77020": true,
      "77023": true,
      "77024": true,
      "77025": true,
      "77026": true,
      "77027": true,
      "77028": true,
      "77029": true,
      "77030": true,
      "77034": true,
      "77035": true,
      "77036": true,
      "77037": true,
      "77038": true,
      "77039": true,
      "77040": true,
      "77041": true,
      "77048": true,
      "77049": true,
      "77050": true,
      "77053": true,
      "77059": true,
      "77060": true,
      "77070": true,
      "77079": true,
      "77080": true,
      "77082": true,
      "77083": true,
      "77084": true,
      "77085": true,
      "77086": true,
      "77087": true,
      "77090": true,
      "77098": true,
      "77099": true,
      "77950": true,
      "77953": true,
      "77954": true,
      "77960": true,
      "77963": true,
      "77965": true,
      "77966": true,
      "77970": true,
      "77976": true,
      "77977": true,
      "77980": true,
      "77983": true,
      "77984": true,
      "77985": true,
      "77986": true,
      "77987": true,
      "77990": true,
      "77992": true,
      "77994": true,
      "77995": true,
      "77997": true
    },
    "FELIPE CARRILLO PUERTO": {
      "77100": true,
      "77104": true,
      "77105": true,
      "77106": true,
      "77107": true,
      "77108": true,
      "77110": true,
      "77114": true,
      "77115": true,
      "77116": true,
      "77117": true,
      "77118": true,
      "77120": true,
      "77121": true,
      "77122": true,
      "77123": true,
      "77125": true,
      "77130": true,
      "77135": true,
      "77140": true,
      "77144": true,
      "77145": true,
      "77146": true,
      "77147": true,
      "77148": true,
      "77150": true,
      "77156": true,
      "77158": true,
      "77160": true,
      "77163": true,
      "77169": true,
      "77170": true,
      "77174": true,
      "77175": true,
      "77176": true,
      "77177": true,
      "77178": true,
      "77180": true,
      "77185": true,
      "77188": true,
      "77189": true,
      "77190": true,
      "77196": true,
      "77197": true,
      "77198": true,
      "77200": true,
      "77210": true,
      "77214": true,
      "77215": true,
      "77216": true,
      "77217": true,
      "77220": true,
      "77229": true,
      "77230": true,
      "77238": true,
      "77239": true,
      "77240": true,
      "77249": true,
      "77250": true,
      "77259": true
    },
    "LÁZARO CÁRDENAS": {
      "77300": true,
      "77302": true,
      "77303": true,
      "77304": true,
      "77305": true,
      "77306": true,
      "77307": true,
      "77310": true,
      "77320": true,
      "77330": true,
      "77333": true,
      "77350": true,
      "77355": true,
      "77360": true,
      "77366": true,
      "77367": true,
      "77368": true,
      "77369": true,
      "77370": true,
      "77376": true,
      "77377": true,
      "77378": true,
      "77380": true,
      "77384": true,
      "77385": true,
      "77386": true
    },
    "ISLA MUJERES": {
      "77400": true,
      "77402": true,
      "77403": true,
      "77404": true,
      "77406": true,
      "77407": true,
      "77408": true,
      "77409": true,
      "77410": true,
      "77412": true,
      "77420": true
    },
    "BENITO JUÁREZ": {
      "77500": true,
      "77503": true,
      "77504": true,
      "77505": true,
      "77506": true,
      "77507": true,
      "77508": true,
      "77509": true,
      "77510": true,
      "77513": true,
      "77514": true,
      "77515": true,
      "77516": true,
      "77517": true,
      "77518": true,
      "77519": true,
      "77520": true,
      "77524": true,
      "77525": true,
      "77526": true,
      "77527": true,
      "77528": true,
      "77530": true,
      "77533": true,
      "77534": true,
      "77535": true,
      "77536": true,
      "77537": true,
      "77538": true,
      "77539": true,
      "77560": true,
      "77567": true,
      "77569": true
    },
    "PUERTO MORELOS": {
      "77580": true,
      "77586": true,
      "77590": true,
      "77594": true
    },
    "COZUMEL": {
      "77600": true,
      "77609": true,
      "77610": true,
      "77613": true,
      "77620": true,
      "77622": true,
      "77645": true,
      "77660": true,
      "77664": true,
      "77665": true,
      "77666": true,
      "77667": true,
      "77670": true,
      "77673": true,
      "77675": true,
      "77676": true,
      "77689": true
    },
    "SOLIDARIDAD": {
      "77710": true,
      "77712": true,
      "77713": true,
      "77714": true,
      "77716": true,
      "77717": true,
      "77718": true,
      "77720": true,
      "77723": true,
      "77724": true,
      "77725": true,
      "77726": true,
      "77727": true,
      "77728": true,
      "77730": true,
      "77733": true,
      "77734": true,
      "77735": true,
      "77740": true
    },
    "TULUM": {
      "77760": true,
      "77762": true,
      "77764": true,
      "77766": true,
      "77768": true,
      "77772": true,
      "77774": true,
      "77776": true,
      "77785": true,
      "77786": true,
      "77793": true,
      "77794": true,
      "77795": true,
      "77796": true
    },
    "JOSÉ MARÍA MORELOS": {
      "77800": true,
      "77805": true,
      "77806": true,
      "77807": true,
      "77808": true,
      "77809": true,
      "77850": true,
      "77858": true,
      "77859": true,
      "77870": true,
      "77874": true,
      "77875": true,
      "77876": true,
      "77878": true,
      "77880": true,
      "77882": true,
      "77883": true,
      "77889": true,
      "77890": true,
      "77893": true,
      "77894": true,
      "77895": true,
      "77896": true,
      "77898": true,
      "77899": true
    },
    "BACALAR": {
      "77900": true,
      "77907": true,
      "77914": true,
      "77920": true,
      "77923": true,
      "77924": true,
      "77926": true,
      "77927": true,
      "77930": true,
      "77933": true,
      "77934": true,
      "77935": true,
      "77936": true,
      "77937": true,
      "77940": true,
      "77943": true,
      "77944": true,
      "77945": true,
      "77946": true,
      "77947": true
    }
  },
  "SAN LUIS POTOSÍ": {
    "SAN LUIS POTOSÍ": {
      "78000": true,
      "78037": true,
      "78038": true,
      "78040": true,
      "78048": true,
      "78049": true,
      "78100": true,
      "78106": true,
      "78107": true,
      "78109": true,
      "78110": true,
      "78115": true,
      "78116": true,
      "78117": true,
      "78120": true,
      "78130": true,
      "78133": true,
      "78135": true,
      "78136": true,
      "78137": true,
      "78140": true,
      "78143": true,
      "78144": true,
      "78145": true,
      "78146": true,
      "78147": true,
      "78148": true,
      "78150": true,
      "78153": true,
      "78154": true,
      "78165": true,
      "78170": true,
      "78173": true,
      "78174": true,
      "78175": true,
      "78176": true,
      "78177": true,
      "78178": true,
      "78180": true,
      "78183": true,
      "78200": true,
      "78209": true,
      "78210": true,
      "78213": true,
      "78214": true,
      "78215": true,
      "78216": true,
      "78218": true,
      "78219": true,
      "78220": true,
      "78230": true,
      "78233": true,
      "78234": true,
      "78235": true,
      "78236": true,
      "78238": true,
      "78239": true,
      "78240": true,
      "78250": true,
      "78258": true,
      "78260": true,
      "78268": true,
      "78269": true,
      "78270": true,
      "78280": true,
      "78290": true,
      "78294": true,
      "78295": true,
      "78298": true,
      "78300": true,
      "78306": true,
      "78307": true,
      "78308": true,
      "78309": true,
      "78310": true,
      "78318": true,
      "78319": true,
      "78320": true,
      "78328": true,
      "78330": true,
      "78338": true,
      "78339": true,
      "78340": true,
      "78349": true,
      "78350": true,
      "78356": true,
      "78357": true,
      "78358": true,
      "78359": true,
      "78360": true,
      "78363": true,
      "78364": true,
      "78365": true,
      "78366": true,
      "78367": true,
      "78368": true,
      "78369": true,
      "78370": true,
      "78377": true,
      "78378": true,
      "78379": true,
      "78380": true,
      "78384": true,
      "78385": true,
      "78387": true,
      "78388": true,
      "78389": true,
      "78390": true,
      "78394": true,
      "78395": true,
      "78396": true,
      "78397": true,
      "78398": true,
      "78399": true,
      "78420": true,
      "78421": true,
      "78423": true,
      "78425": true,
      "78426": true
    },
    "SOLEDAD DE GRACIANO SÁNCHEZ": {
      "78430": true,
      "78432": true,
      "78433": true,
      "78434": true,
      "78435": true,
      "78436": true,
      "78437": true,
      "78438": true,
      "78439": true
    },
    "CERRO DE SAN PEDRO": {
      "78447": true,
      "78448": true
    },
    "MATEHUALA": {
      "78700": true,
      "78710": true,
      "78712": true,
      "78715": true,
      "78716": true,
      "78717": true,
      "78720": true,
      "78721": true,
      "78722": true,
      "78723": true,
      "78724": true,
      "78725": true,
      "78726": true,
      "78730": true,
      "78740": true,
      "78745": true,
      "78746": true,
      "78747": true,
      "78750": true,
      "78759": true,
      "78760": true,
      "78769": true,
      "78770": true,
      "78779": true,
      "78780": true,
      "78783": true,
      "78784": true,
      "78785": true,
      "78786": true,
      "78788": true,
      "78789": true,
      "78790": true,
      "78792": true,
      "78793": true,
      "78796": true,
      "78797": true,
      "78798": true,
      "78799": true,
      "78802": true,
      "78804": true
    },
    "VILLA DE REYES": {
      "79500": true,
      "79506": true,
      "79510": true,
      "79523": true,
      "79524": true,
      "79526": true,
      "79530": true
    },
    "ZARAGOZA": {
      "79540": true,
      "79543": true,
      "79544": true,
      "79545": true,
      "79557": true
    },
    "SANTA MARIA DEL RIO": {
      "79560": true,
      "79563": true,
      "79565": true,
      "79588": true
    },
    "TIERRA NUEVA": {
      "79590": true,
      "79592": true,
      "79593": true,
      "79594": true,
      "79595": true,
      "79596": true
    },
    "RIO VERDE": {
      "79600": true,
      "79604": true,
      "79610": true,
      "79613": true,
      "79614": true,
      "79615": true,
      "79616": true,
      "79617": true,
      "79618": true,
      "79619": true,
      "79620": true,
      "79623": true,
      "79624": true,
      "79625": true,
      "79626": true,
      "79636": true,
      "79640": true,
      "79644": true,
      "79646": true
    },
    "CIUDAD FERNANDEZ": {
      "79650": true,
      "79653": true,
      "79654": true,
      "79655": true,
      "79656": true,
      "79657": true,
      "79660": true,
      "79663": true,
      "79664": true,
      "79665": true,
      "79670": true,
      "79673": true,
      "79674": true,
      "79675": true,
      "79676": true,
      "79677": true
    }
  },
  "SINALOA": {
    "CULIACÁN": {
      "80000": true,
      "80001": true,
      "80002": true,
      "80003": true,
      "80004": true,
      "80005": true,
      "80006": true,
      "80007": true,
      "80008": true,
      "80009": true,
      "80010": true,
      "80011": true,
      "80013": true,
      "80014": true,
      "80015": true,
      "80016": true,
      "80017": true,
      "80018": true,
      "80019": true,
      "80020": true,
      "80021": true,
      "80023": true,
      "80024": true,
      "80025": true,
      "80026": true,
      "80027": true,
      "80028": true,
      "80029": true,
      "80030": true,
      "80034": true,
      "80036": true,
      "80038": true,
      "80040": true,
      "80045": true,
      "80048": true,
      "80049": true,
      "80050": true,
      "80054": true,
      "80055": true,
      "80056": true,
      "80057": true,
      "80058": true,
      "80059": true,
      "80060": true,
      "80063": true,
      "80064": true,
      "80065": true,
      "80070": true,
      "80071": true,
      "80075": true,
      "80076": true,
      "80077": true,
      "80080": true,
      "80082": true,
      "80088": true,
      "80090": true,
      "80091": true,
      "80093": true,
      "80094": true,
      "80096": true,
      "80100": true,
      "80101": true,
      "80102": true,
      "80103": true,
      "80104": true,
      "80105": true,
      "80106": true,
      "80107": true,
      "80108": true,
      "80109": true,
      "80110": true,
      "80111": true,
      "80114": true,
      "80115": true,
      "80120": true,
      "80123": true,
      "80124": true,
      "80126": true,
      "80127": true,
      "80128": true,
      "80129": true,
      "80130": true,
      "80135": true,
      "80137": true,
      "80138": true,
      "80139": true,
      "80140": true,
      "80141": true,
      "80143": true,
      "80144": true,
      "80145": true,
      "80147": true,
      "80148": true,
      "80149": true,
      "80150": true,
      "80151": true,
      "80153": true,
      "80154": true,
      "80155": true,
      "80156": true,
      "80158": true,
      "80159": true,
      "80160": true,
      "80163": true,
      "80165": true,
      "80166": true,
      "80167": true,
      "80168": true,
      "80169": true,
      "80170": true,
      "80171": true,
      "80174": true,
      "80176": true,
      "80177": true,
      "80178": true,
      "80179": true,
      "80180": true,
      "80184": true,
      "80186": true,
      "80187": true,
      "80189": true,
      "80190": true,
      "80193": true,
      "80194": true,
      "80195": true,
      "80196": true,
      "80197": true,
      "80198": true,
      "80199": true,
      "80200": true,
      "80201": true,
      "80203": true,
      "80205": true,
      "80206": true,
      "80208": true,
      "80209": true,
      "80210": true,
      "80214": true,
      "80217": true,
      "80218": true,
      "80219": true,
      "80220": true,
      "80222": true,
      "80225": true,
      "80226": true,
      "80227": true,
      "80228": true,
      "80229": true,
      "80230": true,
      "80233": true,
      "80235": true,
      "80236": true,
      "80237": true,
      "80239": true,
      "80240": true,
      "80243": true,
      "80245": true,
      "80246": true,
      "80247": true,
      "80248": true,
      "80249": true,
      "80250": true,
      "80256": true,
      "80258": true,
      "80260": true,
      "80262": true,
      "80265": true,
      "80269": true,
      "80270": true,
      "80276": true,
      "80277": true,
      "80279": true,
      "80280": true,
      "80286": true,
      "80288": true,
      "80290": true,
      "80293": true,
      "80294": true,
      "80295": true,
      "80296": true,
      "80297": true,
      "80298": true,
      "80299": true,
      "80300": true,
      "80301": true,
      "80302": true,
      "80303": true,
      "80304": true,
      "80305": true,
      "80306": true,
      "80307": true,
      "80308": true,
      "80309": true,
      "80390": true,
      "80391": true,
      "80400": true,
      "80402": true,
      "80403": true,
      "80405": true,
      "80408": true,
      "80409": true,
      "80430": true,
      "80433": true,
      "80434": true,
      "80435": true,
      "80439": true,
      "80440": true,
      "80441": true,
      "80442": true,
      "80443": true,
      "80444": true,
      "80447": true,
      "80449": true,
      "80450": true,
      "80453": true,
      "80455": true,
      "80460": true,
      "80480": true,
      "80481": true,
      "80483": true,
      "80484": true,
      "80485": true,
      "80486": true,
      "80489": true,
      "80490": true,
      "80491": true,
      "80492": true,
      "80493": true,
      "80494": true,
      "80496": true,
      "80498": true
    },
    "NAVOLATO": {
      "80320": true,
      "80322": true,
      "80323": true,
      "80324": true,
      "80327": true,
      "80330": true,
      "80334": true,
      "80335": true,
      "80336": true,
      "80337": true,
      "80338": true,
      "80339": true,
      "80340": true,
      "80343": true,
      "80345": true,
      "80346": true,
      "80347": true,
      "80349": true,
      "80360": true,
      "80363": true,
      "80364": true,
      "80365": true,
      "80370": true,
      "80371": true,
      "80372": true,
      "80373": true,
      "80374": true,
      "80375": true,
      "80376": true,
      "80377": true,
      "80378": true,
      "80379": true
    },
    "BADIRAGUATO": {
      "80500": true,
      "80503": true,
      "80504": true,
      "80505": true
    },
    "COSALÁ": {
      "80700": true,
      "80702": true,
      "80704": true,
      "80705": true,
      "80706": true,
      "80707": true,
      "80708": true
    },
    "MOCORITO": {
      "80800": true,
      "80803": true,
      "80804": true,
      "80805": true,
      "80806": true,
      "80807": true,
      "80808": true,
      "80950": true,
      "80956": true,
      "80957": true,
      "80960": true,
      "80963": true,
      "80965": true
    },
    "GUASAVE": {
      "81000": true,
      "81001": true,
      "81002": true,
      "81003": true,
      "81007": true,
      "81010": true,
      "81011": true,
      "81014": true,
      "81015": true,
      "81016": true,
      "81017": true,
      "81018": true,
      "81019": true,
      "81020": true,
      "81022": true,
      "81023": true,
      "81028": true,
      "81029": true,
      "81030": true,
      "81040": true,
      "81042": true,
      "81043": true,
      "81044": true,
      "81045": true,
      "81048": true,
      "81049": true,
      "81050": true,
      "81055": true,
      "81056": true,
      "81060": true,
      "81065": true,
      "81066": true,
      "81070": true,
      "81075": true,
      "81077": true,
      "81080": true,
      "81083": true,
      "81084": true,
      "81088": true,
      "81090": true,
      "81095": true,
      "81100": true,
      "81101": true,
      "81102": true,
      "81103": true,
      "81104": true,
      "81105": true,
      "81106": true,
      "81107": true,
      "81108": true,
      "81110": true,
      "81113": true,
      "81117": true,
      "81118": true,
      "81119": true,
      "81120": true,
      "81121": true,
      "81122": true,
      "81123": true,
      "81124": true,
      "81127": true,
      "81128": true,
      "81130": true,
      "81131": true,
      "81132": true,
      "81133": true,
      "81134": true,
      "81135": true,
      "81136": true,
      "81140": true,
      "81141": true,
      "81142": true,
      "81143": true,
      "81144": true,
      "81147": true,
      "81148": true,
      "81149": true,
      "81160": true,
      "81161": true,
      "81162": true,
      "81163": true,
      "81164": true,
      "81165": true,
      "81166": true,
      "81167": true,
      "81170": true,
      "81173": true,
      "81174": true,
      "81175": true,
      "81176": true,
      "81177": true,
      "81178": true,
      "81180": true,
      "81181": true,
      "81183": true,
      "81186": true,
      "81189": true,
      "81190": true,
      "81193": true,
      "81194": true,
      "81197": true
    },
    "AHOME": {
      "81200": true,
      "81201": true,
      "81203": true,
      "81204": true,
      "81208": true,
      "81210": true,
      "81212": true,
      "81215": true,
      "81216": true,
      "81217": true,
      "81218": true,
      "81219": true,
      "81220": true,
      "81221": true,
      "81222": true,
      "81223": true,
      "81224": true,
      "81225": true,
      "81226": true,
      "81227": true,
      "81228": true,
      "81229": true,
      "81230": true,
      "81231": true,
      "81232": true,
      "81233": true,
      "81234": true,
      "81235": true,
      "81236": true,
      "81237": true,
      "81238": true,
      "81239": true,
      "81240": true,
      "81243": true,
      "81244": true,
      "81245": true,
      "81246": true,
      "81247": true,
      "81248": true,
      "81249": true,
      "81250": true,
      "81251": true,
      "81252": true,
      "81253": true,
      "81254": true,
      "81255": true,
      "81256": true,
      "81257": true,
      "81258": true,
      "81259": true,
      "81260": true,
      "81261": true,
      "81262": true,
      "81263": true,
      "81265": true,
      "81268": true,
      "81270": true,
      "81271": true,
      "81277": true,
      "81278": true,
      "81279": true,
      "81280": true,
      "81281": true,
      "81282": true,
      "81284": true,
      "81285": true,
      "81287": true,
      "81288": true,
      "81289": true,
      "81290": true,
      "81292": true,
      "81293": true,
      "81294": true,
      "81295": true,
      "81300": true,
      "81303": true,
      "81304": true,
      "81305": true,
      "81306": true,
      "81307": true,
      "81310": true,
      "81311": true,
      "81312": true,
      "81315": true,
      "81316": true,
      "81317": true,
      "81318": true,
      "81320": true,
      "81323": true,
      "81324": true,
      "81325": true,
      "81326": true,
      "81327": true,
      "81330": true,
      "81335": true,
      "81336": true,
      "81337": true,
      "81340": true,
      "81341": true,
      "81343": true,
      "81344": true,
      "81345": true,
      "81346": true,
      "81349": true,
      "81360": true,
      "81361": true,
      "81363": true,
      "81364": true,
      "81366": true,
      "81367": true,
      "81369": true,
      "81370": true,
      "81371": true,
      "81372": true,
      "81373": true,
      "81374": true,
      "81375": true,
      "81376": true,
      "81377": true,
      "81378": true,
      "81379": true,
      "81380": true,
      "81384": true,
      "81385": true,
      "81386": true,
      "81387": true
    },
    "SALVADOR ALVARADO": {
      "81400": true,
      "81401": true,
      "81402": true,
      "81410": true,
      "81413": true,
      "81414": true,
      "81420": true,
      "81426": true,
      "81427": true,
      "81429": true,
      "81430": true,
      "81440": true,
      "81448": true,
      "81450": true,
      "81451": true,
      "81460": true,
      "81469": true,
      "81470": true,
      "81474": true,
      "81475": true,
      "81476": true,
      "81477": true,
      "81478": true,
      "81479": true,
      "81480": true,
      "81489": true,
      "81490": true,
      "81493": true,
      "81498": true,
      "81499": true,
      "81500": true,
      "81504": true,
      "81520": true
    },
    "ANGOSTURA": {
      "81600": true,
      "81605": true,
      "81607": true,
      "81610": true,
      "81613": true,
      "81620": true,
      "81621": true,
      "81622": true,
      "81623": true,
      "81624": true,
      "81625": true,
      "81630": true,
      "81632": true,
      "81635": true,
      "81640": true,
      "81649": true,
      "81650": true,
      "81655": true,
      "81660": true,
      "81664": true,
      "81666": true,
      "81670": true,
      "81675": true,
      "81680": true,
      "81690": true
    },
    "CHOIX": {
      "81700": true,
      "81703": true,
      "81705": true,
      "81706": true,
      "81707": true,
      "81708": true,
      "81709": true
    },
    "EL FUERTE": {
      "81800": true,
      "81802": true,
      "81803": true,
      "81804": true,
      "81806": true,
      "81808": true,
      "81810": true,
      "81815": true,
      "81820": true,
      "81825": true,
      "81872": true,
      "81890": true,
      "81891": true,
      "81893": true,
      "81895": true
    },
    "SINALOA": {
      "81900": true,
      "81902": true,
      "81903": true,
      "81910": true,
      "81912": true,
      "81913": true,
      "81915": true,
      "81916": true,
      "81980": true,
      "81983": true,
      "81985": true,
      "81986": true,
      "81988": true,
      "81989": true,
      "81990": true
    },
    "MAZATLÁN": {
      "82000": true,
      "82001": true,
      "82005": true,
      "82007": true,
      "82008": true,
      "82009": true,
      "82010": true,
      "82013": true,
      "82014": true,
      "82015": true,
      "82016": true,
      "82017": true,
      "82018": true,
      "82019": true,
      "82020": true,
      "82021": true,
      "82023": true,
      "82024": true,
      "82026": true,
      "82027": true,
      "82028": true,
      "82030": true,
      "82033": true,
      "82035": true,
      "82037": true,
      "82038": true,
      "82039": true,
      "82040": true,
      "82043": true,
      "82046": true,
      "82047": true,
      "82048": true,
      "82049": true,
      "82050": true,
      "82057": true,
      "82058": true,
      "82059": true,
      "82060": true,
      "82065": true,
      "82069": true,
      "82070": true,
      "82080": true,
      "82086": true,
      "82088": true,
      "82089": true,
      "82090": true,
      "82099": true,
      "82100": true,
      "82101": true,
      "82102": true,
      "82103": true,
      "82104": true,
      "82106": true,
      "82108": true,
      "82110": true,
      "82111": true,
      "82112": true,
      "82113": true,
      "82114": true,
      "82115": true,
      "82117": true,
      "82118": true,
      "82119": true,
      "82120": true,
      "82123": true,
      "82124": true,
      "82125": true,
      "82126": true,
      "82127": true,
      "82128": true,
      "82129": true,
      "82130": true,
      "82132": true,
      "82133": true,
      "82134": true,
      "82135": true,
      "82136": true,
      "82137": true,
      "82138": true,
      "82139": true,
      "82140": true,
      "82143": true,
      "82144": true,
      "82145": true,
      "82146": true,
      "82147": true,
      "82148": true,
      "82149": true,
      "82150": true,
      "82151": true,
      "82153": true,
      "82154": true,
      "82155": true,
      "82156": true,
      "82157": true,
      "82158": true,
      "82159": true,
      "82160": true,
      "82161": true,
      "82163": true,
      "82164": true,
      "82165": true,
      "82166": true,
      "82168": true,
      "82169": true,
      "82170": true,
      "82180": true,
      "82181": true,
      "82182": true,
      "82183": true,
      "82185": true,
      "82186": true,
      "82187": true,
      "82188": true,
      "82189": true,
      "82190": true,
      "82192": true,
      "82193": true,
      "82195": true,
      "82196": true,
      "82197": true,
      "82198": true,
      "82199": true,
      "82206": true,
      "82210": true,
      "82213": true,
      "82214": true,
      "82215": true,
      "82216": true,
      "82217": true,
      "82267": true,
      "82350": true,
      "82384": true
    },
    "ESCUINAPA": {
      "82400": true,
      "82401": true,
      "82404": true,
      "82410": true,
      "82419": true,
      "82420": true,
      "82430": true,
      "82440": true,
      "82450": true,
      "82457": true,
      "82458": true,
      "82459": true,
      "82460": true,
      "82470": true,
      "82478": true,
      "82560": true
    },
    "CONCORDIA": {
      "82600": true,
      "82601": true,
      "82680": true
    },
    "ELOTA": {
      "82700": true,
      "82702": true,
      "82703": true,
      "82704": true,
      "82705": true,
      "82706": true,
      "82707": true,
      "82708": true,
      "82793": true
    },
    "ROSARIO": {
      "82800": true,
      "82802": true,
      "82803": true,
      "82804": true,
      "82805": true,
      "82806": true,
      "82807": true,
      "82808": true,
      "82809": true
    },
    "SAN IGNACIO": {
      "82910": true,
      "82912": true,
      "82913": true,
      "82916": true,
      "82917": true,
      "82918": true
    }
  },
  "SONORA": {
    "HERMOSILLO": {
      "83000": true,
      "83010": true,
      "83013": true,
      "83015": true,
      "83016": true,
      "83020": true,
      "83029": true,
      "83030": true,
      "83040": true,
      "83050": true,
      "83060": true,
      "83067": true,
      "83068": true,
      "83070": true,
      "83078": true,
      "83079": true,
      "83080": true,
      "83089": true,
      "83090": true,
      "83100": true,
      "83103": true,
      "83104": true,
      "83105": true,
      "83106": true,
      "83107": true,
      "83108": true,
      "83110": true,
      "83113": true,
      "83114": true,
      "83115": true,
      "83116": true,
      "83117": true,
      "83118": true,
      "83120": true,
      "83125": true,
      "83126": true,
      "83128": true,
      "83130": true,
      "83136": true,
      "83137": true,
      "83138": true,
      "83139": true,
      "83140": true,
      "83143": true,
      "83144": true,
      "83145": true,
      "83146": true,
      "83147": true,
      "83148": true,
      "83149": true,
      "83150": true,
      "83156": true,
      "83157": true,
      "83159": true,
      "83160": true,
      "83165": true,
      "83166": true,
      "83170": true,
      "83171": true,
      "83173": true,
      "83174": true,
      "83175": true,
      "83176": true,
      "83177": true,
      "83178": true,
      "83179": true,
      "83180": true,
      "83188": true,
      "83190": true,
      "83200": true,
      "83204": true,
      "83205": true,
      "83206": true,
      "83207": true,
      "83208": true,
      "83209": true,
      "83210": true,
      "83214": true,
      "83220": true,
      "83223": true,
      "83224": true,
      "83229": true,
      "83230": true,
      "83240": true,
      "83243": true,
      "83244": true,
      "83245": true,
      "83246": true,
      "83247": true,
      "83248": true,
      "83249": true,
      "83250": true,
      "83260": true,
      "83270": true,
      "83278": true,
      "83280": true,
      "83283": true,
      "83284": true,
      "83285": true,
      "83286": true,
      "83287": true,
      "83288": true,
      "83289": true,
      "83290": true,
      "83293": true,
      "83294": true,
      "83295": true,
      "83296": true,
      "83297": true,
      "83299": true
    },
    "SAN LUIS RÍO COLORADO": {
      "83400": true,
      "83401": true,
      "83402": true,
      "83403": true,
      "83404": true,
      "83405": true,
      "83406": true,
      "83407": true,
      "83408": true,
      "83409": true,
      "83410": true,
      "83411": true,
      "83412": true,
      "83413": true,
      "83414": true,
      "83415": true,
      "83416": true,
      "83417": true,
      "83418": true,
      "83419": true,
      "83420": true,
      "83421": true,
      "83422": true,
      "83423": true,
      "83424": true,
      "83425": true,
      "83426": true,
      "83427": true,
      "83428": true,
      "83429": true,
      "83430": true,
      "83431": true,
      "83432": true,
      "83433": true,
      "83434": true,
      "83435": true,
      "83436": true,
      "83437": true,
      "83438": true,
      "83439": true,
      "83440": true,
      "83441": true,
      "83442": true,
      "83443": true,
      "83444": true,
      "83445": true,
      "83446": true,
      "83447": true,
      "83448": true,
      "83449": true,
      "83450": true,
      "83451": true,
      "83452": true,
      "83453": true,
      "83454": true,
      "83455": true,
      "83456": true,
      "83457": true,
      "83458": true,
      "83459": true,
      "83460": true,
      "83461": true,
      "83462": true,
      "83463": true,
      "83464": true,
      "83465": true,
      "83466": true,
      "83467": true,
      "83468": true,
      "83469": true,
      "83470": true,
      "83471": true,
      "83472": true,
      "83473": true,
      "83474": true,
      "83475": true,
      "83476": true,
      "83477": true,
      "83478": true,
      "83479": true,
      "83480": true,
      "83481": true,
      "83482": true,
      "83483": true,
      "83484": true,
      "83485": true,
      "83486": true,
      "83487": true,
      "83488": true,
      "83489": true,
      "83490": true,
      "83491": true,
      "83492": true,
      "83493": true,
      "83494": true,
      "83495": true,
      "83496": true,
      "83497": true,
      "83498": true,
      "83499": true,
      "83500": true
    },
    "NOGALES": {
      "84000": true,
      "84009": true,
      "84010": true,
      "84014": true,
      "84015": true,
      "84017": true,
      "84018": true,
      "84020": true,
      "84024": true,
      "84030": true,
      "84035": true,
      "84040": true,
      "84046": true,
      "84047": true,
      "84048": true,
      "84050": true,
      "84055": true,
      "84060": true,
      "84062": true,
      "84063": true,
      "84064": true,
      "84065": true,
      "84066": true,
      "84068": true,
      "84069": true,
      "84074": true,
      "84075": true,
      "84076": true,
      "84080": true,
      "84085": true,
      "84086": true,
      "84090": true,
      "84093": true,
      "84094": true
    },
    "CAJEME": {
      "85000": true,
      "85010": true,
      "85013": true,
      "85017": true,
      "85019": true,
      "85020": true,
      "85023": true,
      "85024": true,
      "85030": true,
      "85037": true,
      "85038": true,
      "85039": true,
      "85040": true,
      "85050": true,
      "85053": true,
      "85059": true,
      "85060": true,
      "85063": true,
      "85064": true,
      "85065": true,
      "85070": true,
      "85080": true,
      "85090": true,
      "85095": true,
      "85096": true,
      "85097": true,
      "85098": true,
      "85099": true,
      "85100": true,
      "85110": true,
      "85120": true,
      "85130": true,
      "85134": true,
      "85136": true,
      "85137": true,
      "85138": true,
      "85140": true,
      "85149": true,
      "85150": true,
      "85154": true,
      "85157": true,
      "85160": true,
      "85167": true,
      "85168": true,
      "85169": true,
      "85170": true,
      "85180": true,
      "85190": true,
      "85193": true,
      "85194": true,
      "85195": true,
      "85196": true,
      "85197": true,
      "85198": true,
      "85199": true,
      "85200": true,
      "85203": true,
      "85204": true,
      "85205": true,
      "85206": true,
      "85207": true,
      "85208": true,
      "85209": true,
      "85210": true,
      "85212": true,
      "85213": true,
      "85214": true,
      "85215": true,
      "85216": true,
      "85217": true,
      "85218": true,
      "85219": true
    },
    "NAVOJOA": {
      "85220": true,
      "85222": true,
      "85223": true,
      "85224": true,
      "85225": true,
      "85226": true,
      "85227": true,
      "85228": true,
      "85229": true,
      "85230": true,
      "85232": true,
      "85233": true,
      "85234": true,
      "85235": true,
      "85236": true,
      "85237": true,
      "85238": true,
      "85239": true
    },
    "HUATABAMPO": {
      "85240": true,
      "85241": true,
      "85243": true,
      "85244": true,
      "85245": true,
      "85246": true,
      "85247": true,
      "85248": true,
      "85249": true,
      "85250": true,
      "85251": true,
      "85252": true,
      "85253": true,
      "85254": true,
      "85255": true,
      "85256": true,
      "85257": true,
      "85258": true,
      "85259": true,
      "85900": true,
      "85910": true,
      "85913": true,
      "85914": true,
      "85920": true,
      "85925": true,
      "85930": true,
      "85935": true,
      "85937": true,
      "85938": true,
      "85940": true,
      "85943": true,
      "85950": true,
      "85960": true,
      "85966": true,
      "85967": true,
      "85968": true,
      "85970": true,
      "85977": true,
      "85980": true,
      "85984": true,
      "85990": true,
      "85994": true
    },
    "ETCHOJOA": {
      "85280": true,
      "85283": true,
      "85284": true,
      "85285": true,
      "85286": true,
      "85287": true,
      "85288": true
    },
    "BENITO JUÁREZ": {
      "85290": true,
      "85293": true,
      "85294": true,
      "85295": true,
      "85296": true,
      "85297": true,
      "85298": true
    },
    "EMPALME": {
      "85300": true,
      "85310": true,
      "85319": true,
      "85320": true,
      "85330": true,
      "85338": true,
      "85339": true,
      "85340": true,
      "85347": true,
      "85349": true,
      "85350": true,
      "85360": true,
      "85370": true,
      "85385": true,
      "85386": true,
      "85388": true,
      "85389": true,
      "85390": true,
      "85397": true,
      "85398": true,
      "85399": true
    },
    "GUAYMAS": {
      "85400": true,
      "85405": true,
      "85406": true,
      "85409": true,
      "85410": true,
      "85420": true,
      "85423": true,
      "85424": true,
      "85425": true,
      "85426": true,
      "85427": true,
      "85430": true,
      "85440": true,
      "85444": true,
      "85447": true,
      "85448": true,
      "85450": true,
      "85454": true,
      "85455": true,
      "85456": true,
      "85457": true,
      "85460": true,
      "85463": true,
      "85465": true,
      "85467": true,
      "85470": true,
      "85477": true,
      "85480": true,
      "85484": true,
      "85486": true,
      "85488": true,
      "85489": true,
      "85490": true,
      "85499": true
    },
    "SAN IGNACIO RÍO MUERTO": {
      "85514": true,
      "85515": true,
      "85516": true,
      "85518": true,
      "85519": true
    },
    "ÁLAMOS": {
      "85760": true,
      "85764": true,
      "85765": true,
      "85766": true,
      "85767": true,
      "85770": true,
      "85773": true,
      "85774": true,
      "85775": true,
      "85776": true,
      "85777": true
    }
  },
  "TABASCO": {
    "CENTRO": {
      "86000": true,
      "86010": true,
      "86017": true,
      "86018": true,
      "86019": true,
      "86020": true,
      "86026": true,
      "86029": true,
      "86030": true,
      "86035": true,
      "86037": true,
      "86038": true,
      "86039": true,
      "86040": true,
      "86049": true,
      "86050": true,
      "86059": true,
      "86060": true,
      "86067": true,
      "86068": true,
      "86069": true,
      "86070": true,
      "86079": true,
      "86080": true,
      "86087": true,
      "86096": true,
      "86097": true,
      "86098": true,
      "86099": true,
      "86100": true,
      "86107": true,
      "86108": true,
      "86109": true,
      "86120": true,
      "86125": true,
      "86126": true,
      "86127": true,
      "86129": true,
      "86130": true,
      "86137": true,
      "86140": true,
      "86143": true,
      "86144": true,
      "86149": true,
      "86150": true,
      "86153": true,
      "86160": true,
      "86167": true,
      "86168": true,
      "86169": true,
      "86170": true,
      "86179": true,
      "86180": true,
      "86189": true,
      "86190": true,
      "86193": true,
      "86250": true,
      "86253": true,
      "86254": true,
      "86270": true,
      "86280": true,
      "86281": true,
      "86283": true,
      "86284": true,
      "86287": true,
      "86288": true,
      "86289": true
    },
    "JALPA DE MÉNDEZ": {
      "86200": true,
      "86203": true,
      "86205": true,
      "86206": true,
      "86207": true,
      "86208": true,
      "86209": true,
      "86214": true,
      "86215": true,
      "86216": true
    },
    "NACAJUCA": {
      "86220": true,
      "86230": true,
      "86233": true,
      "86235": true,
      "86237": true,
      "86240": true,
      "86243": true,
      "86244": true,
      "86245": true,
      "86246": true,
      "86247": true
    },
    "COMALCALCO": {
      "86300": true,
      "86320": true,
      "86323": true,
      "86324": true,
      "86325": true,
      "86330": true,
      "86340": true,
      "86350": true,
      "86357": true,
      "86360": true,
      "86369": true,
      "86370": true,
      "86380": true,
      "86388": true,
      "86389": true,
      "86630": true,
      "86640": true,
      "86643": true,
      "86644": true,
      "86645": true,
      "86650": true,
      "86652": true,
      "86654": true,
      "86655": true,
      "86657": true,
      "86658": true,
      "86670": true
    },
    "HUIMANGUILLO": {
      "86400": true,
      "86402": true,
      "86403": true,
      "86406": true,
      "86407": true,
      "86409": true
    },
    "CÁRDENAS": {
      "86460": true,
      "86461": true,
      "86473": true,
      "86500": true,
      "86520": true,
      "86523": true,
      "86527": true,
      "86528": true,
      "86529": true,
      "86530": true,
      "86533": true,
      "86534": true,
      "86535": true,
      "86540": true,
      "86543": true,
      "86544": true,
      "86545": true,
      "86546": true,
      "86550": true,
      "86554": true,
      "86555": true,
      "86556": true,
      "86560": true,
      "86564": true,
      "86570": true,
      "86573": true,
      "86574": true,
      "86576": true,
      "86577": true,
      "86580": true,
      "86583": true,
      "86590": true,
      "86596": true,
      "86597": true,
      "86598": true,
      "86599": true
    },
    "PARAÍSO": {
      "86600": true,
      "86601": true,
      "86602": true,
      "86603": true,
      "86605": true,
      "86606": true,
      "86607": true,
      "86608": true,
      "86609": true,
      "86610": true,
      "86611": true,
      "86613": true,
      "86615": true,
      "86616": true,
      "86617": true,
      "86618": true,
      "86620": true,
      "86621": true
    },
    "CUNDUACÁN": {
      "86690": true,
      "86692": true,
      "86693": true,
      "86694": true,
      "86695": true,
      "86696": true
    },
    "MACUSPANA": {
      "86700": true,
      "86702": true,
      "86703": true,
      "86704": true,
      "86705": true,
      "86706": true,
      "86707": true,
      "86708": true,
      "86709": true,
      "86711": true,
      "86720": true,
      "86724": true,
      "86726": true,
      "86727": true,
      "86730": true,
      "86732": true,
      "86733": true,
      "86740": true,
      "86745": true
    },
    "CENTLA": {
      "86750": true,
      "86753": true,
      "86761": true,
      "86762": true
    },
    "JONUTA": {
      "86780": true
    },
    "TEAPA": {
      "86800": true,
      "86802": true,
      "86803": true,
      "86807": true,
      "86820": true,
      "86823": true,
      "86825": true,
      "86826": true
    },
    "JALAPA": {
      "86830": true,
      "86834": true,
      "86835": true,
      "86837": true,
      "86840": true,
      "86843": true,
      "86844": true,
      "86845": true,
      "86846": true,
      "86850": true,
      "86853": true,
      "86854": true,
      "86855": true,
      "86860": true,
      "86863": true,
      "86864": true,
      "86865": true
    },
    "TACOTALPA": {
      "86870": true,
      "86874": true,
      "86875": true,
      "86876": true,
      "86877": true,
      "86878": true,
      "86880": true,
      "86882": true,
      "86884": true,
      "86885": true,
      "86886": true,
      "86887": true,
      "86888": true,
      "86890": true,
      "86892": true,
      "86893": true,
      "86894": true,
      "86895": true,
      "86896": true,
      "86897": true
    },
    "TENOSIQUE": {
      "86900": true,
      "86901": true,
      "86902": true,
      "86904": true,
      "86905": true,
      "86906": true,
      "86907": true,
      "86909": true,
      "86910": true,
      "86911": true,
      "86912": true,
      "86915": true,
      "86916": true,
      "86918": true,
      "86919": true,
      "86920": true,
      "86921": true,
      "86922": true,
      "86923": true,
      "86924": true,
      "86925": true,
      "86926": true,
      "86927": true,
      "86928": true
    },
    "BALANCÁN": {
      "86930": true,
      "86933": true,
      "86934": true,
      "86935": true,
      "86936": true,
      "86937": true,
      "86940": true,
      "86943": true,
      "86944": true,
      "86945": true,
      "86946": true,
      "86947": true,
      "86950": true,
      "86953": true,
      "86954": true,
      "86955": true,
      "86956": true,
      "86957": true,
      "86960": true,
      "86963": true,
      "86964": true,
      "86965": true,
      "86966": true,
      "86967": true,
      "86970": true,
      "86973": true,
      "86974": true,
      "86975": true,
      "86976": true,
      "86977": true
    },
    "EMILIANO ZAPATA": {
      "86980": true,
      "86982": true,
      "86983": true,
      "86984": true,
      "86985": true,
      "86986": true,
      "86988": true,
      "86989": true,
      "86990": true,
      "86992": true,
      "86993": true,
      "86994": true,
      "86995": true,
      "86996": true,
      "86997": true,
      "86998": true
    }
  },
  "VERACRUZ": {
    "XALAPA": {
      "91000": true,
      "91010": true,
      "91013": true,
      "91014": true,
      "91015": true,
      "91016": true,
      "91017": true,
      "91018": true,
      "91020": true,
      "91023": true,
      "91024": true,
      "91025": true,
      "91026": true,
      "91027": true,
      "91028": true,
      "91030": true,
      "91033": true,
      "91037": true,
      "91040": true,
      "91045": true,
      "91046": true,
      "91047": true,
      "91048": true,
      "91049": true,
      "91050": true,
      "91053": true,
      "91054": true,
      "91055": true,
      "91056": true,
      "91057": true,
      "91060": true,
      "91063": true,
      "91064": true,
      "91065": true,
      "91066": true,
      "91067": true,
      "91069": true,
      "91070": true,
      "91073": true,
      "91075": true,
      "91080": true,
      "91083": true,
      "91084": true,
      "91090": true,
      "91094": true,
      "91095": true,
      "91096": true,
      "91097": true,
      "91098": true,
      "91100": true,
      "91103": true,
      "91104": true,
      "91105": true,
      "91106": true,
      "91107": true,
      "91110": true,
      "91113": true,
      "91114": true,
      "91119": true,
      "91120": true,
      "91123": true,
      "91129": true,
      "91130": true,
      "91133": true,
      "91140": true,
      "91143": true,
      "91150": true,
      "91152": true,
      "91153": true,
      "91154": true,
      "91155": true,
      "91156": true,
      "91157": true,
      "91158": true,
      "91160": true,
      "91163": true,
      "91164": true,
      "91165": true,
      "91166": true,
      "91170": true,
      "91173": true,
      "91174": true,
      "91179": true,
      "91180": true,
      "91183": true,
      "91184": true,
      "91185": true,
      "91186": true,
      "91190": true,
      "91193": true,
      "91194": true,
      "91195": true,
      "91196": true,
      "91197": true,
      "91198": true,
      "91200": true,
      "91203": true,
      "91204": true,
      "91205": true,
      "91207": true,
      "91210": true,
      "91213": true,
      "91214": true,
      "91215": true,
      "91216": true,
      "91217": true,
      "91220": true,
      "91225": true,
      "91226": true,
      "91227": true
    },
    "TLALNELHUAYOCAN": {
      "91231": true,
      "91233": true,
      "91236": true,
      "91237": true
    },
    "XICO": {
      "91240": true,
      "91241": true,
      "91247": true
    },
    "PEROTE": {
      "91270": true,
      "91273": true,
      "91274": true,
      "91275": true,
      "91277": true,
      "91278": true,
      "91284": true,
      "91288": true,
      "91289": true
    },
    "BANDERILLA": {
      "91300": true,
      "91302": true,
      "91303": true,
      "91304": true,
      "91305": true,
      "91306": true,
      "91307": true,
      "91310": true,
      "91312": true
    },
    "RAFAEL LUCIO": {
      "91315": true
    },
    "LAS VIGAS DE RAMÍREZ": {
      "91330": true,
      "91336": true
    },
    "VILLA ALDAMA": {
      "91340": true,
      "91341": true,
      "91345": true,
      "91346": true
    },
    "COACOATZINTLA": {
      "91370": true,
      "91373": true
    },
    "JILOTEPEC": {
      "91380": true,
      "91382": true,
      "91383": true,
      "91384": true,
      "91385": true,
      "91387": true,
      "91389": true,
      "91390": true,
      "91393": true,
      "91394": true,
      "91396": true
    },
    "NAOLINCO": {
      "91400": true,
      "91402": true,
      "91404": true,
      "91406": true,
      "91407": true,
      "91409": true
    },
    "ACATLÁN": {
      "91420": true
    },
    "ALTO LUCERO DE GUTIÉRREZ BARRIOS": {
      "91477": true
    },
    "ACTOPAN": {
      "91481": true,
      "91488": true,
      "91489": true,
      "91490": true,
      "91495": true,
      "91496": true,
      "91498": true
    },
    "COATEPEC": {
      "91500": true,
      "91503": true,
      "91505": true,
      "91506": true,
      "91510": true,
      "91514": true,
      "91516": true,
      "91517": true,
      "91518": true,
      "91519": true,
      "91520": true,
      "91521": true,
      "91527": true,
      "91528": true,
      "91529": true,
      "91530": true,
      "91533": true,
      "91537": true,
      "91538": true,
      "91539": true,
      "91540": true,
      "91549": true,
      "91550": true,
      "91556": true,
      "91557": true,
      "91559": true,
      "91560": true,
      "91565": true,
      "91566": true,
      "91567": true,
      "91568": true,
      "91569": true,
      "91570": true,
      "91575": true,
      "91576": true,
      "91579": true,
      "91580": true,
      "91581": true,
      "91583": true,
      "91584": true,
      "91589": true,
      "91601": true,
      "91602": true,
      "91603": true,
      "91604": true,
      "91606": true,
      "91607": true,
      "91608": true,
      "91609": true,
      "91610": true,
      "91611": true,
      "91612": true
    },
    "TEOCELO": {
      "91615": true
    },
    "EMILIANO ZAPATA": {
      "91630": true,
      "91633": true,
      "91634": true,
      "91635": true,
      "91636": true,
      "91640": true
    },
    "PUENTE NACIONAL": {
      "91650": true,
      "91652": true,
      "91653": true,
      "91654": true,
      "91655": true,
      "91656": true,
      "91657": true,
      "91658": true,
      "91659": true
    },
    "URSULO GALVÁN": {
      "91660": true,
      "91663": true,
      "91664": true,
      "91666": true,
      "91667": true,
      "91668": true
    },
    "PASO DE OVEJAS": {
      "91670": true,
      "91672": true,
      "91673": true,
      "91674": true,
      "91675": true,
      "91676": true,
      "91677": true
    },
    "LA ANTIGUA": {
      "91680": true,
      "91685": true,
      "91686": true,
      "91687": true,
      "91688": true,
      "91689": true
    },
    "VERACRUZ": {
      "91690": true,
      "91693": true,
      "91694": true,
      "91696": true,
      "91697": true,
      "91698": true,
      "91699": true,
      "91700": true,
      "91708": true,
      "91709": true,
      "91710": true,
      "91712": true,
      "91713": true,
      "91714": true,
      "91715": true,
      "91716": true,
      "91717": true,
      "91718": true,
      "91720": true,
      "91726": true,
      "91727": true,
      "91728": true,
      "91729": true,
      "91730": true,
      "91739": true,
      "91740": true,
      "91749": true,
      "91750": true,
      "91755": true,
      "91756": true,
      "91757": true,
      "91758": true,
      "91759": true,
      "91760": true,
      "91769": true,
      "91770": true,
      "91777": true,
      "91778": true,
      "91779": true,
      "91780": true,
      "91788": true,
      "91789": true,
      "91790": true,
      "91799": true,
      "91800": true,
      "91807": true,
      "91808": true,
      "91809": true,
      "91810": true,
      "91817": true,
      "91820": true,
      "91826": true,
      "91829": true,
      "91840": true,
      "91841": true,
      "91850": true,
      "91855": true,
      "91859": true,
      "91860": true,
      "91870": true,
      "91880": true,
      "91890": true,
      "91891": true,
      "91897": true,
      "91898": true,
      "91899": true,
      "91900": true,
      "91910": true,
      "91916": true,
      "91918": true,
      "91919": true,
      "91920": true,
      "91928": true,
      "91930": true,
      "91936": true,
      "91938": true,
      "91940": true,
      "91947": true,
      "91948": true,
      "91960": true,
      "91963": true,
      "91965": true,
      "91966": true,
      "91968": true,
      "91969": true
    },
    "TUXPAN": {
      "92800": true,
      "92810": true,
      "92820": true,
      "92830": true,
      "92834": true,
      "92840": true,
      "92845": true,
      "92850": true,
      "92853": true,
      "92854": true,
      "92860": true,
      "92863": true,
      "92870": true,
      "92875": true,
      "92876": true,
      "92880": true,
      "92883": true,
      "92888": true,
      "92890": true,
      "92893": true,
      "92894": true,
      "92895": true
    },
    "TIHUATLÁN": {
      "92930": true,
      "92933": true,
      "92934": true,
      "92935": true,
      "92936": true,
      "92937": true
    },
    "COATZINTLA": {
      "93162": true,
      "93163": true,
      "93164": true,
      "93165": true,
      "93166": true,
      "93167": true,
      "93169": true
    },
    "POZA RICA DE HIDALGO": {
      "93210": true,
      "93213": true,
      "93220": true,
      "93230": true,
      "93236": true,
      "93240": true,
      "93248": true,
      "93249": true,
      "93250": true,
      "93260": true,
      "93269": true,
      "93270": true,
      "93276": true,
      "93279": true,
      "93280": true,
      "93290": true,
      "93294": true,
      "93295": true,
      "93300": true,
      "93305": true,
      "93306": true,
      "93308": true,
      "93310": true,
      "93319": true,
      "93320": true,
      "93327": true,
      "93330": true,
      "93340": true,
      "93360": true,
      "93367": true,
      "93368": true,
      "93369": true,
      "93370": true,
      "93380": true,
      "93384": true,
      "93386": true,
      "93387": true,
      "93388": true,
      "93389": true,
      "93390": true,
      "93393": true,
      "93396": true,
      "93398": true,
      "93399": true
    },
    "PAPANTLA": {
      "93400": true,
      "93410": true,
      "93413": true,
      "93418": true,
      "93419": true,
      "93420": true,
      "93425": true,
      "93426": true,
      "93427": true,
      "93428": true,
      "93429": true,
      "93430": true,
      "93438": true,
      "93440": true,
      "93450": true,
      "93458": true,
      "93460": true,
      "93466": true,
      "93467": true,
      "93468": true,
      "93470": true,
      "93477": true,
      "93478": true,
      "93479": true,
      "93480": true,
      "93484": true,
      "93485": true,
      "93486": true,
      "93487": true,
      "93489": true,
      "93490": true,
      "93498": true,
      "93499": true
    },
    "GUTIÉRREZ ZAMORA": {
      "93556": true,
      "93558": true,
      "93559": true,
      "93563": true
    },
    "MARTÍNEZ DE LA TORRE": {
      "93600": true,
      "93603": true,
      "93604": true,
      "93605": true,
      "93606": true,
      "93607": true,
      "93608": true,
      "93610": true,
      "93613": true,
      "93634": true,
      "93636": true,
      "93637": true,
      "93644": true,
      "93645": true,
      "93647": true
    },
    "SAN RAFAEL": {
      "93620": true,
      "93623": true,
      "93625": true,
      "93627": true,
      "93629": true
    },
    "TLAPACOYAN": {
      "93650": true,
      "93654": true,
      "93657": true
    },
    "MISANTLA": {
      "93820": true,
      "93826": true,
      "93827": true,
      "93828": true,
      "93829": true,
      "93830": true,
      "93833": true,
      "93834": true,
      "93835": true,
      "93836": true,
      "93837": true,
      "93840": true,
      "93843": true,
      "93844": true,
      "93845": true,
      "93846": true,
      "93847": true
    },
    "VEGA DE ALATORRE": {
      "93960": true,
      "93963": true,
      "93967": true,
      "93980": true,
      "93986": true
    },
    "HUATUSCO": {
      "94100": true
    },
    "CAMARÓN DE TEJEDA": {
      "94230": true,
      "94233": true,
      "94234": true,
      "94235": true,
      "94236": true
    },
    "SOLEDAD DE DOBLADO": {
      "94240": true,
      "94242": true,
      "94243": true,
      "94244": true,
      "94245": true,
      "94246": true,
      "94247": true,
      "94248": true,
      "94249": true
    },
    "MANLIO FABIO ALTAMIRANO": {
      "94250": true,
      "94253": true,
      "94254": true,
      "94255": true,
      "94256": true,
      "94258": true
    },
    "JAMAPA": {
      "94260": true,
      "94263": true,
      "94264": true,
      "94265": true,
      "94266": true,
      "94267": true
    },
    "MEDELLÍN DE BRAVO": {
      "94270": true,
      "94273": true,
      "94274": true,
      "94275": true,
      "94276": true,
      "94277": true,
      "94278": true,
      "94280": true,
      "94284": true
    },
    "BOCA DEL RÍO": {
      "94285": true,
      "94286": true,
      "94287": true,
      "94290": true,
      "94293": true,
      "94294": true,
      "94295": true,
      "94296": true,
      "94297": true,
      "94298": true,
      "94299": true
    },
    "ORIZABA": {
      "94300": true,
      "94303": true,
      "94310": true,
      "94311": true,
      "94315": true,
      "94320": true,
      "94324": true,
      "94326": true,
      "94327": true,
      "94328": true,
      "94329": true,
      "94330": true,
      "94333": true,
      "94334": true,
      "94335": true,
      "94337": true,
      "94339": true,
      "94340": true,
      "94344": true,
      "94345": true,
      "94346": true,
      "94347": true,
      "94349": true,
      "94350": true,
      "94353": true,
      "94360": true,
      "94363": true,
      "94364": true,
      "94370": true,
      "94380": true,
      "94384": true,
      "94389": true,
      "94390": true,
      "94393": true,
      "94394": true,
      "94399": true,
      "94400": true
    },
    "IXTACZOQUITLÁN": {
      "94450": true,
      "94453": true,
      "94456": true,
      "94458": true
    },
    "FORTÍN": {
      "94467": true,
      "94470": true,
      "94472": true,
      "94473": true,
      "94474": true,
      "94475": true,
      "94476": true
    },
    "CÓRDOBA": {
      "94487": true,
      "94488": true,
      "94500": true,
      "94510": true,
      "94513": true,
      "94515": true,
      "94516": true,
      "94520": true,
      "94530": true,
      "94534": true,
      "94540": true,
      "94543": true,
      "94545": true,
      "94546": true,
      "94550": true,
      "94556": true,
      "94557": true,
      "94558": true,
      "94559": true,
      "94560": true,
      "94570": true,
      "94575": true,
      "94580": true,
      "94589": true,
      "94590": true,
      "94620": true,
      "94630": true,
      "94640": true,
      "94643": true,
      "94649": true,
      "94650": true,
      "94657": true,
      "94660": true,
      "94670": true,
      "94677": true,
      "94679": true,
      "94680": true,
      "94687": true,
      "94688": true,
      "94689": true,
      "94690": true,
      "94693": true,
      "94696": true,
      "94699": true
    },
    "RÍO BLANCO": {
      "94730": true,
      "94733": true,
      "94734": true
    },
    "CAMERINO Z. MENDOZA": {
      "94740": true,
      "94743": true,
      "94744": true,
      "94745": true,
      "94746": true,
      "94748": true
    },
    "HUILOAPAN DE CUAUHTÉMOC": {
      "94780": true,
      "94782": true,
      "94783": true
    },
    "CUITLÁHUAC": {
      "94915": true
    },
    "AMATLÁN DE LOS REYES": {
      "94946": true,
      "94953": true,
      "94954": true
    },
    "PASO DEL MACHO": {
      "94970": true
    },
    "COTAXTLA": {
      "94990": true,
      "94992": true,
      "94993": true,
      "94994": true,
      "94995": true,
      "94996": true,
      "94997": true
    },
    "TIERRA BLANCA": {
      "95100": true,
      "95110": true,
      "95118": true,
      "95119": true,
      "95120": true,
      "95130": true,
      "95140": true,
      "95150": true,
      "95160": true,
      "95170": true,
      "95179": true,
      "95180": true,
      "95190": true,
      "95193": true,
      "95200": true,
      "95202": true,
      "95203": true,
      "95204": true,
      "95205": true,
      "95206": true,
      "95207": true,
      "95212": true,
      "95213": true,
      "95214": true,
      "95215": true,
      "95216": true
    },
    "TLALIXCOYAN": {
      "95220": true,
      "95223": true,
      "95224": true,
      "95225": true,
      "95226": true,
      "95227": true,
      "95230": true,
      "95233": true,
      "95234": true,
      "95235": true,
      "95236": true,
      "95237": true
    },
    "IGNACIO DE LA LLAVE": {
      "95240": true,
      "95243": true,
      "95244": true,
      "95245": true,
      "95246": true,
      "95247": true
    },
    "ALVARADO": {
      "95250": true,
      "95253": true,
      "95258": true,
      "95259": true,
      "95261": true,
      "95263": true,
      "95264": true,
      "95265": true,
      "95266": true,
      "95267": true,
      "95268": true,
      "95269": true,
      "95270": true,
      "95272": true,
      "95274": true,
      "95275": true,
      "95276": true,
      "95277": true,
      "95278": true
    },
    "LERDO DE TEJADA": {
      "95280": true,
      "95281": true,
      "95283": true,
      "95284": true,
      "95285": true,
      "95286": true,
      "95287": true,
      "95295": true
    },
    "TRES VALLES": {
      "95300": true,
      "95350": true,
      "95353": true,
      "95354": true,
      "95355": true,
      "95356": true,
      "95358": true,
      "95360": true,
      "95365": true,
      "95367": true,
      "95370": true,
      "95372": true,
      "95374": true,
      "95375": true,
      "95380": true,
      "95386": true
    },
    "CARLOS A. CARRILLO": {
      "95330": true
    },
    "COSAMALOAPAN DE CARPIO": {
      "95390": true,
      "95392": true,
      "95395": true,
      "95396": true,
      "95397": true,
      "95398": true,
      "95400": true
    },
    "TUXTILLA": {
      "95540": true
    },
    "JOSÉ AZUETA": {
      "95580": true,
      "95584": true,
      "95585": true,
      "95587": true,
      "95588": true,
      "95590": true,
      "95593": true,
      "95594": true,
      "95595": true,
      "95597": true,
      "95598": true
    },
    "PLAYA VICENTE": {
      "95600": true,
      "95603": true,
      "95604": true,
      "95605": true,
      "95606": true,
      "95607": true,
      "95609": true,
      "95614": true,
      "95618": true,
      "95619": true,
      "95620": true,
      "95623": true,
      "95624": true,
      "95625": true,
      "95627": true,
      "95628": true,
      "95629": true
    },
    "ISLA": {
      "95640": true,
      "95642": true,
      "95643": true,
      "95645": true,
      "95646": true,
      "95647": true,
      "95648": true,
      "95650": true,
      "95652": true,
      "95653": true,
      "95654": true,
      "95655": true,
      "95657": true,
      "95658": true,
      "95659": true
    },
    "JUAN RODRÍGUEZ CLARA": {
      "95670": true,
      "95672": true,
      "95673": true,
      "95674": true,
      "95675": true,
      "95676": true,
      "95677": true,
      "95679": true,
      "95680": true,
      "95682": true,
      "95683": true,
      "95684": true,
      "95685": true,
      "95686": true,
      "95687": true,
      "95689": true,
      "95690": true,
      "95693": true,
      "95694": true,
      "95695": true,
      "95696": true,
      "95697": true
    },
    "SAN ANDRÉS TUXTLA": {
      "95700": true,
      "95710": true,
      "95714": true,
      "95716": true,
      "95717": true,
      "95718": true,
      "95720": true,
      "95725": true,
      "95726": true,
      "95729": true,
      "95730": true,
      "95736": true,
      "95739": true,
      "95740": true,
      "95746": true,
      "95748": true,
      "95749": true,
      "95750": true,
      "95756": true,
      "95760": true,
      "95763": true,
      "95765": true,
      "95770": true,
      "95775": true,
      "95778": true,
      "95780": true,
      "95786": true,
      "95790": true,
      "95795": true,
      "95797": true,
      "95800": true,
      "95801": true,
      "95802": true,
      "95803": true,
      "95804": true,
      "95805": true,
      "95806": true,
      "95807": true,
      "95809": true,
      "95810": true,
      "95812": true,
      "95813": true,
      "95814": true,
      "95815": true,
      "95816": true,
      "95817": true,
      "95818": true,
      "95819": true,
      "95820": true,
      "95821": true,
      "95823": true,
      "95824": true,
      "95825": true,
      "95826": true,
      "95827": true
    },
    "SANTIAGO TUXTLA": {
      "95830": true,
      "95832": true,
      "95833": true,
      "95834": true,
      "95835": true,
      "95836": true,
      "95837": true,
      "95838": true,
      "95839": true
    },
    "ANGEL R. CABADA": {
      "95840": true,
      "95842": true,
      "95843": true,
      "95844": true,
      "95845": true,
      "95846": true,
      "95847": true,
      "95848": true
    },
    "CATEMACO": {
      "95870": true
    },
    "CHINAMECA": {
      "95980": true
    },
    "ACAYUCAN": {
      "96000": true,
      "96010": true,
      "96020": true,
      "96025": true,
      "96026": true,
      "96028": true,
      "96029": true,
      "96030": true,
      "96039": true,
      "96048": true,
      "96049": true,
      "96050": true,
      "96055": true,
      "96056": true,
      "96057": true,
      "96067": true,
      "96068": true,
      "96069": true,
      "96070": true,
      "96079": true
    },
    "OLUTA": {
      "96164": true
    },
    "SOCONUSCO": {
      "96170": true,
      "96172": true
    },
    "JÁLTIPAN": {
      "96200": true,
      "96210": true,
      "96220": true,
      "96230": true,
      "96240": true,
      "96250": true,
      "96260": true,
      "96270": true,
      "96280": true,
      "96290": true
    },
    "OTEAPAN": {
      "96330": true
    },
    "COSOLEACAQUE": {
      "96346": true,
      "96347": true,
      "96348": true,
      "96350": true,
      "96353": true,
      "96357": true,
      "96358": true
    },
    "NANCHITAL DE LÁZARO CÁRDENAS DEL RÍO": {
      "96360": true,
      "96362": true
    },
    "COATZACOALCOS": {
      "96389": true,
      "96400": true,
      "96410": true,
      "96420": true,
      "96430": true,
      "96440": true,
      "96458": true,
      "96460": true,
      "96470": true,
      "96480": true,
      "96490": true,
      "96492": true,
      "96495": true,
      "96496": true,
      "96497": true,
      "96499": true,
      "96500": true,
      "96510": true,
      "96518": true,
      "96519": true,
      "96520": true,
      "96523": true,
      "96529": true,
      "96530": true,
      "96535": true,
      "96536": true,
      "96537": true,
      "96538": true,
      "96539": true,
      "96540": true,
      "96550": true,
      "96556": true,
      "96557": true,
      "96558": true,
      "96559": true,
      "96560": true,
      "96564": true,
      "96565": true,
      "96566": true,
      "96567": true,
      "96568": true,
      "96569": true,
      "96570": true,
      "96575": true,
      "96576": true,
      "96577": true,
      "96578": true,
      "96579": true,
      "96580": true,
      "96588": true,
      "96590": true,
      "96598": true,
      "96599": true
    },
    "AGUA DULCE": {
      "96390": true,
      "96395": true,
      "96397": true,
      "96600": true,
      "96610": true,
      "96620": true,
      "96630": true,
      "96640": true,
      "96660": true,
      "96670": true,
      "96680": true,
      "96684": true,
      "96687": true,
      "96690": true
    },
    "MINATITLÁN": {
      "96716": true,
      "96717": true,
      "96719": true,
      "96720": true,
      "96728": true,
      "96729": true,
      "96730": true,
      "96734": true,
      "96735": true,
      "96736": true,
      "96737": true,
      "96739": true,
      "96740": true,
      "96750": true,
      "96757": true,
      "96760": true,
      "96770": true,
      "96773": true,
      "96780": true,
      "96790": true,
      "96798": true,
      "96799": true,
      "96840": true,
      "96848": true,
      "96849": true,
      "96850": true,
      "96858": true,
      "96860": true,
      "96870": true,
      "96873": true,
      "96879": true,
      "96880": true,
      "96890": true
    },
    "LAS CHOAPAS": {
      "96980": true
    }
  },
  "YUCATÁN": {
    "MÉRIDA": {
      "97000": true,
      "97003": true,
      "97050": true,
      "97059": true,
      "97060": true,
      "97068": true,
      "97069": true,
      "97070": true,
      "97080": true,
      "97088": true,
      "97089": true,
      "97098": true,
      "97099": true,
      "97100": true,
      "97107": true,
      "97108": true,
      "97109": true,
      "97110": true,
      "97113": true,
      "97114": true,
      "97115": true,
      "97116": true,
      "97117": true,
      "97118": true,
      "97119": true,
      "97120": true,
      "97121": true,
      "97125": true,
      "97127": true,
      "97128": true,
      "97129": true,
      "97130": true,
      "97133": true,
      "97134": true,
      "97135": true,
      "97136": true,
      "97137": true,
      "97138": true,
      "97139": true,
      "97140": true,
      "97142": true,
      "97143": true,
      "97144": true,
      "97145": true,
      "97146": true,
      "97147": true,
      "97148": true,
      "97149": true,
      "97150": true,
      "97155": true,
      "97156": true,
      "97157": true,
      "97158": true,
      "97159": true,
      "97160": true,
      "97165": true,
      "97166": true,
      "97167": true,
      "97168": true,
      "97169": true,
      "97170": true,
      "97173": true,
      "97174": true,
      "97175": true,
      "97176": true,
      "97177": true,
      "97178": true,
      "97179": true,
      "97180": true,
      "97189": true,
      "97190": true,
      "97195": true,
      "97196": true,
      "97197": true,
      "97198": true,
      "97199": true,
      "97200": true,
      "97203": true,
      "97204": true,
      "97205": true,
      "97206": true,
      "97207": true,
      "97208": true,
      "97209": true,
      "97210": true,
      "97215": true,
      "97217": true,
      "97218": true,
      "97219": true,
      "97220": true,
      "97225": true,
      "97226": true,
      "97227": true,
      "97229": true,
      "97230": true,
      "97237": true,
      "97238": true,
      "97239": true,
      "97240": true,
      "97245": true,
      "97246": true,
      "97247": true,
      "97249": true,
      "97250": true,
      "97255": true,
      "97256": true,
      "97258": true,
      "97259": true,
      "97260": true,
      "97267": true,
      "97268": true,
      "97269": true,
      "97270": true,
      "97277": true,
      "97278": true,
      "97279": true,
      "97280": true,
      "97284": true,
      "97285": true,
      "97286": true,
      "97287": true,
      "97288": true,
      "97289": true,
      "97290": true,
      "97295": true,
      "97296": true,
      "97297": true,
      "97298": true,
      "97299": true,
      "97300": true,
      "97302": true,
      "97303": true,
      "97304": true,
      "97305": true,
      "97306": true,
      "97307": true,
      "97308": true,
      "97309": true,
      "97310": true,
      "97312": true,
      "97314": true,
      "97315": true,
      "97316": true
    },
    "PROGRESO": {
      "97320": true,
      "97324": true,
      "97330": true,
      "97334": true,
      "97336": true,
      "97337": true
    },
    "CHICXULUB PUEBLO": {
      "97340": true,
      "97342": true
    },
    "IXIL": {
      "97343": true
    },
    "CONKAL": {
      "97345": true,
      "97346": true,
      "97347": true
    },
    "YAXKUKUL": {
      "97348": true
    },
    "HUNUCMÁ": {
      "97350": true,
      "97353": true,
      "97356": true
    },
    "UCÚ": {
      "97357": true
    },
    "KINCHIL": {
      "97360": true,
      "97362": true
    },
    "TETIZ": {
      "97364": true,
      "97365": true
    },
    "CELESTÚN": {
      "97367": true
    },
    "KANASÍN": {
      "97370": true,
      "97373": true,
      "97374": true,
      "97376": true
    },
    "TIMUCUY": {
      "97377": true,
      "97378": true
    },
    "ACANCEH": {
      "97380": true,
      "97382": true,
      "97383": true
    },
    "TIXPÉHUAL": {
      "97386": true,
      "97387": true,
      "97388": true,
      "97389": true
    },
    "UMÁN": {
      "97390": true,
      "97392": true,
      "97393": true,
      "97394": true,
      "97395": true,
      "97396": true,
      "97397": true
    },
    "TELCHAC PUEBLO": {
      "97400": true
    },
    "DZEMUL": {
      "97404": true,
      "97405": true,
      "97406": true
    },
    "TELCHAC PUERTO": {
      "97407": true
    },
    "CANSAHCAB": {
      "97410": true,
      "97414": true,
      "97415": true,
      "97417": true
    },
    "SINANCHÉ": {
      "97420": true,
      "97424": true
    },
    "YOBAÍN": {
      "97425": true,
      "97426": true
    },
    "MOTUL": {
      "97430": true,
      "97432": true,
      "97433": true,
      "97434": true,
      "97436": true,
      "97437": true,
      "97440": true,
      "97443": true,
      "97444": true,
      "97445": true,
      "97446": true
    },
    "BACA": {
      "97450": true,
      "97452": true,
      "97453": true
    },
    "MOCOCHÁ": {
      "97454": true,
      "97455": true,
      "97456": true
    },
    "MUXUPIP": {
      "97457": true,
      "97458": true
    },
    "CACALCHÉN": {
      "97460": true
    },
    "BOKOBÁ": {
      "97466": true
    },
    "TIXKOKOB": {
      "97470": true,
      "97473": true,
      "97474": true,
      "97475": true,
      "97476": true,
      "97477": true
    },
    "HOCTÚN": {
      "97480": true,
      "97483": true,
      "97486": true
    },
    "TAHMEK": {
      "97490": true
    },
    "DZIDZANTÚN": {
      "97500": true,
      "97504": true,
      "97506": true
    },
    "TEMAX": {
      "97510": true,
      "97513": true,
      "97515": true,
      "97516": true
    },
    "TEKANTÓ": {
      "97520": true,
      "97522": true,
      "97523": true
    },
    "TEYA": {
      "97524": true
    },
    "SUMA": {
      "97527": true
    },
    "TEPAKÁN": {
      "97530": true,
      "97532": true
    },
    "TEKAL DE VENEGAS": {
      "97535": true,
      "97536": true
    },
    "IZAMAL": {
      "97540": true,
      "97542": true,
      "97545": true,
      "97550": true,
      "97553": true,
      "97555": true,
      "97556": true,
      "97557": true
    },
    "HOCABÁ": {
      "97560": true,
      "97563": true,
      "97564": true
    },
    "XOCCHEL": {
      "97566": true
    },
    "SEYÉ": {
      "97570": true,
      "97573": true,
      "97574": true,
      "97575": true
    },
    "CUZAMÁ": {
      "97577": true,
      "97578": true,
      "97579": true
    },
    "HOMÚN": {
      "97580": true,
      "97582": true,
      "97583": true,
      "97585": true,
      "97586": true
    },
    "SANAHCAT": {
      "97587": true
    },
    "HUHÍ": {
      "97590": true,
      "97596": true
    },
    "DZILAM GONZÁLEZ": {
      "97600": true,
      "97604": true
    },
    "DZILAM DE BRAVO": {
      "97606": true,
      "97608": true,
      "97609": true
    },
    "PANABÁ": {
      "97610": true,
      "97614": true,
      "97615": true
    },
    "SAN FELIPE": {
      "97616": true
    },
    "BUCTZOTZ": {
      "97620": true,
      "97623": true,
      "97624": true,
      "97625": true,
      "97626": true,
      "97627": true
    },
    "SUCILÁ": {
      "97630": true,
      "97634": true,
      "97636": true
    },
    "CENOTILLO": {
      "97640": true,
      "97645": true
    },
    "DZONCAUICH": {
      "97646": true,
      "97647": true
    },
    "TUNKÁS": {
      "97650": true,
      "97653": true,
      "97654": true
    },
    "QUINTANA ROO": {
      "97655": true
    },
    "DZITÁS": {
      "97660": true,
      "97666": true
    },
    "KANTUNIL": {
      "97670": true,
      "97675": true
    },
    "SUDZAL": {
      "97676": true,
      "97677": true,
      "97678": true
    },
    "TEKIT": {
      "97680": true,
      "97684": true,
      "97686": true
    },
    "SOTUTA": {
      "97690": true,
      "97694": true,
      "97695": true,
      "97697": true
    },
    "TIZIMÍN": {
      "97700": true,
      "97702": true,
      "97703": true,
      "97704": true,
      "97705": true,
      "97706": true,
      "97707": true,
      "97710": true,
      "97712": true,
      "97713": true,
      "97714": true,
      "97715": true,
      "97716": true,
      "97717": true
    },
    "RÍO LAGARTOS": {
      "97720": true,
      "97723": true,
      "97726": true
    },
    "ESPITA": {
      "97730": true,
      "97733": true,
      "97734": true,
      "97739": true
    },
    "TEMOZÓN": {
      "97740": true,
      "97743": true,
      "97744": true
    },
    "CALOTMUL": {
      "97745": true,
      "97746": true,
      "97747": true,
      "97748": true
    },
    "TINUM": {
      "97750": true,
      "97751": true,
      "97753": true,
      "97754": true,
      "97755": true,
      "97756": true,
      "97757": true
    },
    "CHANKOM": {
      "97758": true,
      "97759": true
    },
    "CHICHIMILÁ": {
      "97760": true,
      "97761": true
    },
    "TIXCACALCUPUL": {
      "97762": true,
      "97763": true
    },
    "KAUA": {
      "97764": true,
      "97765": true
    },
    "CUNCUNUL": {
      "97766": true,
      "97767": true
    },
    "TEKOM": {
      "97768": true,
      "97769": true
    },
    "CHEMAX": {
      "97770": true,
      "97773": true,
      "97774": true,
      "97775": true,
      "97776": true,
      "97777": true
    },
    "VALLADOLID": {
      "97780": true,
      "97782": true,
      "97783": true,
      "97784": true,
      "97785": true,
      "97786": true,
      "97787": true,
      "97790": true,
      "97793": true,
      "97794": true,
      "97795": true
    },
    "UAYMA": {
      "97796": true,
      "97798": true,
      "97799": true
    },
    "MAXCANÚ": {
      "97800": true,
      "97803": true,
      "97804": true,
      "97805": true,
      "97806": true,
      "97807": true
    },
    "SAMAHIL": {
      "97810": true,
      "97812": true
    },
    "OPICHÉN": {
      "97813": true,
      "97814": true
    },
    "CHOCHOLÁ": {
      "97816": true
    },
    "KOPOMÁ": {
      "97818": true
    },
    "TECOH": {
      "97820": true,
      "97822": true,
      "97823": true,
      "97824": true
    },
    "ABALÁ": {
      "97825": true,
      "97826": true,
      "97827": true
    },
    "HALACHÓ": {
      "97830": true,
      "97833": true,
      "97835": true,
      "97836": true,
      "97837": true
    },
    "MUNA": {
      "97840": true,
      "97843": true,
      "97844": true
    },
    "SACALUM": {
      "97845": true,
      "97847": true,
      "97848": true
    },
    "MANÍ": {
      "97850": true,
      "97851": true
    },
    "DZAN": {
      "97854": true
    },
    "CHAPAB": {
      "97857": true,
      "97858": true
    },
    "TICUL": {
      "97860": true,
      "97862": true,
      "97863": true,
      "97864": true,
      "97870": true,
      "97873": true
    },
    "OXKUTZCAB": {
      "97880": true,
      "97882": true,
      "97883": true,
      "97884": true,
      "97885": true,
      "97886": true,
      "97887": true
    },
    "SANTA ELENA": {
      "97890": true,
      "97893": true,
      "97894": true,
      "97895": true,
      "97899": true
    },
    "MAMA": {
      "97900": true
    },
    "CHUMAYEL": {
      "97904": true
    },
    "MAYAPÁN": {
      "97908": true
    },
    "TEABO": {
      "97910": true
    },
    "CANTAMAYEC": {
      "97915": true,
      "97917": true,
      "97918": true
    },
    "YAXCABÁ": {
      "97920": true,
      "97922": true,
      "97923": true,
      "97924": true,
      "97925": true,
      "97926": true,
      "97927": true,
      "97929": true
    },
    "PETO": {
      "97930": true,
      "97932": true,
      "97933": true,
      "97934": true,
      "97935": true,
      "97936": true,
      "97937": true
    },
    "TAHDZIÚ": {
      "97945": true,
      "97947": true,
      "97948": true
    },
    "TIXMEHUAC": {
      "97950": true,
      "97953": true,
      "97954": true
    },
    "CHACSINKÍN": {
      "97955": true,
      "97956": true,
      "97957": true
    },
    "TZUCACAB": {
      "97960": true,
      "97963": true,
      "97964": true,
      "97965": true,
      "97966": true,
      "97967": true,
      "97969": true
    },
    "TEKAX": {
      "97970": true,
      "97973": true,
      "97974": true,
      "97975": true,
      "97977": true,
      "97979": true,
      "97980": true,
      "97983": true,
      "97984": true,
      "97985": true,
      "97986": true,
      "97987": true,
      "97989": true
    },
    "AKIL": {
      "97990": true
    }
  },
  "COAHUILA DE ZARAGOZA": {
    "SALTILLO": {
      "25000": true,
      "25008": true,
      "25010": true,
      "25013": true,
      "25014": true,
      "25015": true,
      "25016": true,
      "25017": true,
      "25019": true,
      "25020": true,
      "25022": true,
      "25023": true,
      "25030": true,
      "25034": true,
      "25036": true,
      "25038": true,
      "25039": true,
      "25040": true,
      "25043": true,
      "25044": true,
      "25045": true,
      "25047": true,
      "25048": true,
      "25049": true,
      "25050": true,
      "25056": true,
      "25057": true,
      "25060": true,
      "25065": true,
      "25067": true,
      "25068": true,
      "25069": true,
      "25070": true,
      "25075": true,
      "25076": true,
      "25077": true,
      "25080": true,
      "25083": true,
      "25084": true,
      "25085": true,
      "25086": true,
      "25087": true,
      "25088": true,
      "25090": true,
      "25092": true,
      "25093": true,
      "25094": true,
      "25096": true,
      "25097": true,
      "25100": true,
      "25107": true,
      "25110": true,
      "25113": true,
      "25114": true,
      "25115": true,
      "25116": true,
      "25117": true,
      "25120": true,
      "25123": true,
      "25124": true,
      "25125": true,
      "25128": true,
      "25130": true,
      "25137": true,
      "25138": true,
      "25140": true,
      "25146": true,
      "25147": true,
      "25150": true,
      "25155": true,
      "25156": true,
      "25157": true,
      "25160": true,
      "25167": true,
      "25168": true,
      "25169": true,
      "25170": true,
      "25179": true,
      "25180": true,
      "25186": true,
      "25188": true,
      "25190": true,
      "25193": true,
      "25194": true,
      "25195": true,
      "25196": true,
      "25197": true,
      "25198": true,
      "25199": true,
      "25200": true,
      "25203": true,
      "25204": true,
      "25205": true,
      "25206": true,
      "25207": true,
      "25208": true,
      "25209": true,
      "25210": true,
      "25215": true,
      "25220": true,
      "25225": true,
      "25230": true,
      "25239": true,
      "25240": true,
      "25250": true,
      "25253": true,
      "25254": true,
      "25256": true,
      "25260": true,
      "25265": true,
      "25270": true,
      "25277": true,
      "25279": true,
      "25280": true,
      "25284": true,
      "25285": true,
      "25286": true,
      "25290": true,
      "25293": true,
      "25294": true,
      "25295": true,
      "25296": true,
      "25297": true,
      "25298": true
    },
    "ARTEAGA": {
      "25350": true,
      "25352": true,
      "25353": true,
      "25354": true,
      "25355": true,
      "25356": true,
      "25369": true
    },
    "RAMOS ARIZPE": {
      "25900": true,
      "25902": true,
      "25903": true,
      "25904": true,
      "25905": true
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}